/* dashboard.widgets.js — GENERATED by scripts/build_widget_bundle.py.
   Do NOT edit by hand; edit the individual widgets and rebuild.
   Source list: templates/partials/_dashboard_widgets_src.html */

/* ==== static/js/widgets/_registry.js ==== */
;
/* static/js/widgets/_registry.js
 *
 * window.LS_WIDGETS — central registry for live dashboard v2 widgets.
 * Mirrors the static/js/sports/index.js + window.SPORT_REGISTRY pattern:
 * each widget JS file (e.g. widgets/scoreboard.js) self-registers on load.
 *
 * Registry shape per widget:
 *   {
 *     id:           'scoreboard',
 *     title:        'Scoreboard',
 *     sportScope:   '*' | ['nba','nfl'] | 'pga',     // '*' = all sports
 *     factory:      () => ({}),                       // Alpine x-data fragment merged into the cell, often {}
 *     minCells:     { w: 2, h: 2 },
 *     minWidthPx:   440,                              // optional: the width this
 *         widget's own layout needs. The tablet 2-up projection gives it a FULL
 *         row instead of a half-width column when half the grid falls below it
 *         (298px on a 1024 iPad). Only for widgets that print sentences - a KPI
 *         is fine at 298px, and making EVERYTHING full-width turned a landscape
 *         iPad into a 4,400px column (mobile audit 2026-09-12).
 *     defaultCells: { w: 4, h: 2 },
 *     densityTiers: ['hero','full','compact','mini'],
 *     opts:         { ... }                           // optional per-widget knobs, persisted
 *   }
 *
 * ──────────────────────────────────────────────────────────────────────
 *  AUTHOR CHECKLIST — read this before adding a widget
 * ──────────────────────────────────────────────────────────────────────
 * 1. Live scores: render via _fmtScore(v) (host) — NEVER a hardcoded
 *    toFixed(2). Precision follows the format's `decimals` trait (2 fantasy
 *    points, 0 single-stat count). Animated numbers: LSTween.num(fn,
 *    { decimals: _fmtDecimals }). This is what keeps single-stat integer and
 *    stops surfaces drifting back to "3.00". See [[project_dashboard_formats]].
 * 2. Inside x-data="..." use single quotes only. A " terminates the
 *    HTML attribute and dumps the rest as page text.
 * 3. x-html="fn(item.prop)" inside x-for can lock to initial eval —
 *    pre-compute to a string property on the item and bind that.
 * 4. Composition into the host controller MUST use
 *    Object.defineProperties + Object.getOwnPropertyDescriptors,
 *    never object spread (spread invokes getters and freezes them).
 *    See static/js/live_v2/index.js for the canonical example.
 * 5. Tailwind CDN injects styles AFTER style.css loads — overrides of
 *    flex / hidden / grid need ≥2 classes of specificity to win.
 * 6. New static/style.css rules require bumping ?v=N in templates/base.html.
 * 7. Brand is 'LiveSlates' (plural) in user-facing copy. Never use the
 *    word 'canonical' in new code — say 'LiveSlate' instead.
 * 8. RLS on every new Supabase table. (Widgets shouldn't need new tables;
 *    layout persists under user_settings.settings.dashboard_layout.)
 */

window.LS_WIDGETS = window.LS_WIDGETS || {};

window.LSWidgets = {
  /** Register a widget. Idempotent — later registrations replace earlier. */
  register(w) {
    if (!w || !w.id) {
      console.warn('LSWidgets.register: widget missing id', w);
      return;
    }
    window.LS_WIDGETS[w.id] = Object.assign({
      // slot defines which zone in the dashboard this widget lives in:
      //   'scoreboard' — Row 1: per-sport bespoke scoreboard. ONE active.
      //   'kpi'        — Row 2: compact info tile in the headline strip.
      //   'panel'      — Row 3+: full-size widget in the draggable grid.
      slot:         'panel',
      title:        w.id,
      sportScope:   '*',
      // regionScope: '*' (all) | ['UK'] | ['US'] — gates platform-specific
      // widgets to a DFS market, so users in the other region never see them
      // in the picker. Checked against
      // window.LIVESLATE.region.
      regionScope:  '*',
      // formatScope: '*' (all formats) | ['tiers'] | ['single_stat'] |
      // ['single_stat_hr'] — gates format-specific widgets to a scoring format,
      // so editing (or viewing) a Tiers / Single-Stat board only offers the
      // widgets that make sense there. A scope entry names a specific variant
      // ('single_stat_hr', 'tiers') OR a whole family ('single_stat' covers
      // hr/rbi/k). Checked in availableForSlot via _matchFormat against the
      // board's format_variant. Default '*' shows everywhere → existing widgets
      // are unaffected until explicitly scoped.
      formatScope:  '*',
      factory:      () => ({}),
      minCells:     { w: 2, h: 2 },
      defaultCells: { w: 4, h: 2 },
      densityTiers: ['full', 'compact', 'mini'],
      opts:         {},
    }, w);
  },

  /** Widgets visible for a given sport_id (sport-agnostic widgets always pass). */
  forSport(sport_id) {
    const sid = (sport_id || '').toLowerCase();
    return Object.values(window.LS_WIDGETS).filter(w =>
      this._matchSport(w, sid) && this._matchRegion(w));
  },

  /** Widgets matching slot AND sport AND the user's region. The picker uses
   *  this to build per-slot catalogs (KPIs picker / Panels picker / scoreboards). */
  forSlot(slot, sport_id) {
    const sid = (sport_id || '').toLowerCase();
    return Object.values(window.LS_WIDGETS).filter(w =>
      (w.slot || 'panel') === slot && this._matchSport(w, sid) && this._matchRegion(w),
    );
  },

  /** Internal: does this widget match the given sport? */
  _matchSport(w, sid) {
    if (w.sportScope === '*' || !w.sportScope) return true;
    if (Array.isArray(w.sportScope)) return w.sportScope.includes(sid);
    return w.sportScope === sid;
  },

  /** Internal: does this widget match the user's DFS region? Default '*'
   *  passes everywhere; ['UK']/['US'] gate platform-specific widgets. */
  _matchRegion(w) {
    const scope = w.regionScope;
    if (!scope || scope === '*') return true;
    const region = (window.LIVESLATE && window.LIVESLATE.region) || 'UK';
    if (Array.isArray(scope)) return scope.includes(region);
    return scope === region;
  },

  /** Internal: does this widget match the dashboard's scoring format? Default
   *  '*' passes everywhere. A scope entry can name a specific variant
   *  ('single_stat_hr', 'tiers') OR a family ('single_stat') — the widget shows
   *  if EITHER the board's variant or its family is listed. Family is resolved
   *  via LSFormat.traitsOf so we never string-match variant names. Called from
   *  availableForSlot (the Add-widget picker) with the board's format_variant. */
  _matchFormat(w, format_variant) {
    const scope = w.formatScope;
    if (!scope || scope === '*') return true;
    const list = Array.isArray(scope) ? scope : [scope];
    // Wildcard entry (string '*' or the DB default ['*']) = all formats. This
    // matters because /admin/widgets stores format_scope as a text[] whose
    // default is {*}, which _catalog.js merges onto def.formatScope.
    if (list.includes('*')) return true;
    const variant = (format_variant || '').toLowerCase();
    const family  = (window.LSFormat && window.LSFormat.traitsOf)
      ? (window.LSFormat.traitsOf(variant).family || 'standard')
      : 'standard';
    return list.includes(variant) || list.includes(family);
  },

  /** Lookup by id. */
  get(id) { return window.LS_WIDGETS[id] || null; },
};

/* ==== static/js/widgets/_catalog.js ==== */
;
/* static/js/widgets/_catalog.js — DB catalog sync for the widget registry.
 *
 * On dashboard load, fetches /api/widgets (which returns is_active=true rows
 * sorted by sort_order) and merges admin-controlled metadata into the
 * in-memory window.LS_WIDGETS map.
 *
 * Merged fields (DB wins for these):
 *   - title           (admin can rename)
 *   - sort_order      (admin orders the picker)
 *   - premium_tier_id (admin gates behind tier)
 *   - category        (admin assigns picker grouping — Phase 5)
 *   - removable       (admin marks a panel non-removable — Phase 6)
 *   - required        (admin marks a widget required for the sport — Phase 6)
 *   - has_options     (mirrors optionsPartial declaration; advisory)
 *   - default_cells / min_cells (admin can tune sizing without a code edit)
 *   - format_scope    (admin gates a widget to scoring formats — 2026-08-08)
 *
 * NOT merged (JS / registry owns):
 *   - slot, sport_scope, factory  (encode behaviour — can't change at runtime)
 *   NB: format_scope IS merged (admin-editable) even though sport_scope isn't —
 *   sport is a hard behavioural gate, format is a curation choice.
 *
 * Hidden widgets:
 *   /api/widgets only returns is_active=true rows. Any JS-registered widget
 *   whose DB row is_active=false simply isn't returned, so the picker (which
 *   later filters by is_db_active) hides it.
 *
 * Widgets registered in JS but absent from DB are kept as-is — useful
 * during local dev when you've added a widget file but haven't run the
 * startup sync yet.
 *
 * Anonymous users / network failure / 401 → silently skip (the JS
 * registry is the fallback source of truth).
 */
(function () {
  'use strict';

  // Track widgets that the DB DOES know about. Picker hides any JS
  // widget whose id is in the DB returned set with is_active=false —
  // but since /api/widgets already filters is_active=true, this set
  // simply marks "DB has it active". Anything not in the set is either
  // unknown to DB (fine — local dev) or known but inactive (also hide).
  window.LSWidgetCatalog = {
    loaded:  false,
    _byId:   {},

    async load() {
      try {
        const r = await fetch('/api/widgets', { credentials: 'same-origin' });
        if (!r.ok) {
          // 401 (anon) or 5xx — keep JS registry as-is.
          this.loaded = true;
          return;
        }
        const rows = await r.json();
        if (!Array.isArray(rows)) { this.loaded = true; return; }
        for (const row of rows) {
          this._byId[row.id] = row;
          const def = window.LS_WIDGETS && window.LS_WIDGETS[row.id];
          if (!def) continue;
          // DB-merged fields. Null in DB → keep the JS default (don't
          // wipe a sensible code value with NULL).
          if (row.title)                def.title           = row.title;
          if (row.sort_order != null)   def.sort_order      = row.sort_order;
          if (row.premium_tier_id)      def.premium_tier_id = row.premium_tier_id;
          if (row.category)             def.category        = row.category;
          if (typeof row.removable === 'boolean')   def.removable    = row.removable;
          if (typeof row.required  === 'boolean')   def.required     = row.required;
          if (typeof row.has_options === 'boolean') def.hasOptionsDB = row.has_options;
          if (row.default_cells && typeof row.default_cells === 'object') {
            def.defaultCells = row.default_cells;
          }
          if (row.min_cells && typeof row.min_cells === 'object') {
            def.minCells = row.min_cells;
          }
          // max_rows — content cap for list/feed widgets that grow with
          // data (Matches, Vidi, Top 10s). Null → no cap (legacy). Read
          // by the host to stamp --ls-max-rows on the cell; per-widget
          // CSS does the row-height math. (Xav 2026-05-30.)
          if (row.max_rows != null) def.maxRows = row.max_rows;
          // Requirements + scale hint (Xav 2026-05-27 — drives picker
          // pills + on-tile ⓘ for scale mismatch / unmet prereqs).
          if (Array.isArray(row.requires)) def.requires = row.requires;
          if (typeof row.best_at === 'string') def.bestAt = row.best_at;
          // format_scope — admin-editable format gate (text[], e.g. ['tiers']).
          // UNLIKE sport_scope (JS-owned, never merged), this IS merged so
          // /admin/widgets edits take effect at runtime. The picker's
          // _matchFormat treats ['*'] as all-formats.
          if (Array.isArray(row.format_scope)) def.formatScope = row.format_scope;
          // Description — one-line user-facing prose. Picker shows it
          // under the title; live tile uses it as the title= tooltip.
          if (row.description) def.description = row.description;
          // is_db_active drives the picker's active filter (availableForSlot).
          // /api/widgets now returns ALL rows incl. is_active=false, so an
          // admin-DEACTIVATED widget arrives with is_active=false → hidden.
          // (P1 allocation audit — deactivation was previously a no-op because
          // inactive rows dropped out of the response and defaulted to shown.)
          def.is_db_active = (row.is_active !== false);
        }
        // Widgets registered in JS but with NO DB row at all (local dev before
        // the startup sync) stay visible — default the flag true so they show.
        // A DB-known-but-inactive widget already has is_db_active=false above,
        // so this only affects genuinely-unknown widgets.
        for (const id of Object.keys(window.LS_WIDGETS || {})) {
          const def = window.LS_WIDGETS[id];
          if (def.is_db_active === undefined) def.is_db_active = true;
        }
        this.loaded = true;
      } catch (_) {
        this.loaded = true;   // never let a network blip break the dashboard
      }
    },

    /** Lookup the DB row for a widget id (or null). */
    get(id) { return this._byId[id] || null; },
  };

  // ── Patch LSWidgets.forSlot to honour sort_order ────────────────────
  // The existing helper returns Object.values() which is insertion-order.
  // After catalog load, we want pickers ordered by sort_order so admin
  // tweaks take effect. Idempotent — wraps the original method once.
  if (window.LSWidgets && window.LSWidgets.forSlot && !window.LSWidgets._sortPatched) {
    const _orig = window.LSWidgets.forSlot.bind(window.LSWidgets);
    window.LSWidgets.forSlot = function (slot, sport_id) {
      const rows = _orig(slot, sport_id);
      return rows.slice().sort((a, b) =>
        (a.sort_order ?? 100) - (b.sort_order ?? 100),
      );
    };
    window.LSWidgets._sortPatched = true;
  }
})();

/* ==== static/js/widgets/scoreboard.js ==== */
;
/* widgets/scoreboard.js — wraps the existing dash_matches_duel.html partial.
 *
 * Phase A approach: the partial keeps its own x-data block (Alpine binds it
 * in place when the cell renders). Parent dashboard() state (preGames,
 * slate_phase, sport_type, etc.) is read via the Alpine prototype chain.
 * No widget-local state is needed here — factory returns {}.
 *
 * In a later phase we'll extract the partial's x-data into this factory so
 * the widget is self-contained and live.js loses the matchup-strip code.
 */
window.LSWidgets.register({
  id:           'scoreboard',
  description: 'Generic top-of-dashboard scoreboard for any sport without a bespoke design.',
  // Promoted from 'panel' to 'scoreboard' so the headline-zone dispatcher
  // (activeScoreboardId getter in live_v2/index.js) selects this as the
  // WILDCARD fallback for any sport without a bespoke scoreboard. The
  // partial it renders is templates/partials/dash_matches_duel.html.
  slot:         'scoreboard',
  title:        'Scoreboard',
  sportScope:   '*',
  factory:      () => ({}),
  optionsPartial: 'widgets/scoreboard_options.html',
});

/* ==== static/js/widgets/scoreboard_mlb.js ==== */
;
/* widgets/scoreboard_mlb.js — bespoke MLB scoreboard registration.
 *
 * Renders templates/widgets/scoreboard_mlb.html in the headline zone
 * when an MLB slate is selected. Dispatch is driven by the host's
 * activeScoreboardId getter which prefers sport-specific scoreboards
 * over the wildcard ('scoreboard' widget) when both are registered
 * for the current sport.
 *
 * Data: reads parent dashboard()'s allGames; each game's live_state
 * sub-dict (balls/strikes/outs/bases/batter/pitcher) is populated
 * by sports/mlb.py's linescore fan-out on every poll.
 */
window.LSWidgets.register({
  id:         'scoreboard_mlb',
  description: 'Premium MLB scoreboard with the diamond, base runners, count, outs, and inning grid.',
  slot:       'scoreboard',
  title:      'MLB Scoreboard',
  sportScope: ['mlb'],
  factory:    () => ({}),
  optionsPartial: 'widgets/scoreboard_options.html',
});

/* ==== static/js/widgets/scoreboard_basketball.js ==== */
;
/* widgets/scoreboard_basketball.js — bespoke basketball scoreboard (NBA +
 * WNBA + Euroleague), Xav 2026-06-15. Renders templates/widgets/scoreboard_basketball.html
 * in the headline zone when an NBA/WNBA slate is selected (dispatch via the
 * host's activeScoreboardId getter, which prefers a sport-specific scoreboard
 * over the wildcard).
 *
 * The look: a physical gym scoreboard — amber DSEG LED digits (self-hosted)
 * for scores + clock + quarter, on a dark bezel. Full view drops the live
 * on-court 5 per team with pts·reb·ast (your rostered players starred).
 *
 * Data (all already on the frontend):
 *   games  — g.period, g.clock_secs, g.halftime, g.home_score/away_score,
 *            g.status (1 soon / 2 live / 3 final), team abbr/name/logo.
 *   players — allSlatePlayers carry game_id, team, is_on_court, stats{pts,
 *            reb,ast}, live_fpts. _inCountMap gives roster ownership.
 */
window.LSWidgets.register({
  id:         'scoreboard_basketball',
  description: 'Premium basketball scoreboard (NBA + WNBA) — LED scores & clock, with the live on-court 5 and pts·reb·ast in the full view.',
  slot:       'scoreboard',
  title:      'Basketball Scoreboard',
  sportScope: ['nba', 'wnba', 'euroleague'],
  factory:    () => ({}),
  optionsPartial: 'widgets/scoreboard_options.html',
});

/* ==== static/js/widgets/scoreboard_nfl.js ==== */
;
/* widgets/scoreboard_nfl.js — bespoke NFL scoreboard. Renders
 * templates/widgets/scoreboard_nfl.html in the headline zone for NFL slates
 * (dispatch via the host's activeScoreboardId getter, which prefers a
 * sport-specific scoreboard over the wildcard).
 *
 * The look (Xav-approved mock, 2026-07-11): a stadium LED board — DSEG segment
 * digits for scores + game clock, real team colours, the LiveSlates emerald
 * live-dot. Full view drops the quarter-by-quarter line score; compact is the
 * scorebug + clock only (the _sbCompact density pattern).
 *
 * Data (all already on the frontend, from the demo engine / live poller):
 *   games — g.status (1 soon / 2 live / 3 final), g.period (quarter, 5=OT),
 *           g.clock_secs, g.home_score/away_score, team abbr/name/logo,
 *           g.live_state.quarters ([{n,a,h}] per-quarter line score).
 */
window.LSWidgets.register({
  id:         'scoreboard_nfl',
  description: 'Premium NFL scoreboard — LED scores & game clock on a stadium board, with the quarter-by-quarter line score in the full view.',
  slot:       'scoreboard',
  title:      'NFL Scoreboard',
  sportScope: ['nfl'],
  factory:    () => ({}),
  optionsPartial: 'widgets/scoreboard_options.html',
});

/* ==== static/js/widgets/scoreboard_nhl.js ==== */
;
/* widgets/scoreboard_nhl.js — bespoke NHL scoreboard: the rink board. Renders
 * templates/widgets/scoreboard_nhl.html in the headline zone for NHL slates
 * (dispatch via the host's activeScoreboardId getter, which prefers a
 * sport-specific scoreboard over the wildcard).
 *
 * The look (Xav-approved mock, 2026-09-28): the centre-hung board over the ice
 * — DSEG score + clock with the dead segments showing, SHOTS and a penalty box
 * per team, power play / empty net on the status strip, and the goal lamp.
 *
 * Data: g.status / period / clock_secs / scores / team abbr + logo, and
 * g.live_state from sports/nhl.py _live_state (sog, pp_team, pp_secs, en_team,
 * pen_away / pen_home, quarters, so, intermission).
 */
window.LSWidgets.register({
  id:         'scoreboard_nhl',
  description: 'The rink board — LED score and game clock, shots, penalty boxes, power play and empty net, with the goal lamp.',
  slot:       'scoreboard',
  title:      'NHL Scoreboard',
  sportScope: ['nhl'],
  factory:    () => ({}),
  optionsPartial: 'widgets/scoreboard_options.html',
});

/* ==== static/js/widgets/top10.js ==== */
;
/* widgets/top10.js — top 10 slate players by live FPts.
 *
 * Phase B "real port": the _top10 getter that used to live inline in
 * partials/dash_top_row.html (~line 229) moves onto the widget factory.
 * Source array (allSlatePlayers) still lives on parent dashboard() — the
 * widget reads it via Alpine's prototype chain (this.allSlatePlayers
 * walks up to the host scope). Sport-agnostic — sort by live_fpts works
 * for every sport.
 *
 * Rank-movement arrows (Xav 2026-06-06): _diffRanks snapshots the
 * leaderboard order on every poll tick ($watch on lastUpdated) and
 * marks each row up / down / new-entrant. The first snapshot after
 * mount seeds silently so a page load doesn't show 10 green arrows.
 *
 * When live.js is decomposed in Phase E, allSlatePlayers will move onto
 * a smaller player-store module that widgets import; this widget won't
 * need to change.
 */
window.LSWidgets.register({
  id:           'top10',
  description: 'The top scoring players on the slate right now.',
  slot:        'panel',
  title:        'Slate Top Players',
  sportScope:   '*',
  factory:      () => ({
    /** Pre-slate = nothing has scored yet. The leaderboard ranks by
     *  projection instead so the panel is a "who to watch" board
     *  rather than ten dead 0.00 rows (Xav 2026-06-12). */
    get _preSlate() {
      return !(this.allSlatePlayers || []).some(p => (p.live_fpts || 0) > 0);
    },
    get _top10() {
      const pool = [...(this.allSlatePlayers || [])];
      const key  = this._preSlate ? (p => p.proj || 0) : (p => p.live_fpts || 0);
      // Desktop shows the deep field (up to 50, scrollable in-card); a phone
      // wants a true glance, so cap to the top 10 there — no endless scroll.
      return pool.sort((a, b) => key(b) - key(a)).slice(0, this.mobile ? 10 : 50);
    },
    /** DK Tiers: the pool carries a per-player tier, so ranking flat is
     *  meaningless (you pick one PER tier). Auto-switch to a grouped view. */
    get _tierMode() {
      return (this.allSlatePlayers || []).some(p => p.tier != null);
    },
    /** Players grouped by tier (Tier 1 first), ranked within each tier. The
     *  leader of each tier is the optimal pick for it (= the Dream Team). */
    get _topByTier() {
      const key = this._preSlate ? (p => p.proj || 0) : (p => p.live_fpts || 0);
      const groups = {};
      for (const p of (this.allSlatePlayers || [])) {
        if (p.tier == null) continue;
        (groups[p.tier] = groups[p.tier] || []).push(p);
      }
      return Object.keys(groups).map(Number).sort((a, b) => a - b).map(tier => ({
        tier,
        players: groups[tier].slice().sort((a, b) => key(b) - key(a)),
      }));
    },
    /** How many of my (stake-filtered) lineups hold this player. */
    _ownCount(p) {
      return (this._inCountMap || {})[String(p.player_id || p.external_player_id || '')] || 0;
    },
    _rankMoves: {},
    _prevRanks: null,
    _rkey(p)  { return window.LSModelUtil.pid(p); },
    _move(p)  { return this._rankMoves[this._rkey(p)] || ''; },
    _diffRanks() {
      const ranks = {};
      this._top10.forEach((p, i) => { ranks[this._rkey(p)] = i; });
      if (this._prevRanks) {
        const moves = {};
        for (const k in ranks) {
          const prev = this._prevRanks[k];
          if (prev === undefined)   moves[k] = 'up';      // new entrant
          else if (ranks[k] < prev) moves[k] = 'up';
          else if (ranks[k] > prev) moves[k] = 'down';
        }
        this._rankMoves = moves;
      }
      this._prevRanks = ranks;
    },
    init() {
      this.$nextTick(() => this._diffRanks());            // silent seed
      this.$watch('lastUpdated', () => this._diffRanks());
    },
  }),
  minCells:     { w: 3, h: 3 },
  defaultCells: { w: 4, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/top10_my_players.js ==== */
;
/* widgets/top10_my_players.js — top 10 players across the user's lineups.
 *
 * Mirror of top10.js (slate-wide) but scoped to the user's own roster.
 * Dedup by player_id so a player in three lineups counts once. Sort by
 * live_fpts desc, take 10. Sport-agnostic — works for every sport whose
 * slate carries live_fpts on players (i.e. all of them).
 *
 * Rank-movement arrows mirror top10.js — see the comment there.
 * Drills into the My Players widget via expand_modal='my_players_modal'.
 */
window.LSWidgets.register({
  id:           'top10_my_players',
  description: 'Your top scoring players across all your lineups.',
  slot:        'panel',
  title:        'My Top Players',
  sportScope:   '*',
  factory:      () => ({
    /** Pre-slate = none of my players have scored yet — rank by
     *  projection so the board shows who to watch (Xav 2026-06-12). */
    get _preSlate() {
      return !(this.lineupRows || []).some(lu =>
        (lu.players || []).some(p => (p.live_fpts || 0) > 0));
    },
    get _top10Mine() {
      const seen = new Set();
      const pool = [];
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const k = String(p.player_id || p.external_player_id || '');
          if (!k || seen.has(k)) continue;
          seen.add(k);
          pool.push(p);
        }
      }
      const key = this._preSlate ? (p => p.proj || 0) : (p => p.live_fpts || 0);
      return pool.sort((a, b) => key(b) - key(a)).slice(0, 50);
    },
    /** How many of my (stake-filtered) lineups hold this player. */
    _ownCount(p) {
      return (this._inCountMap || {})[String(p.player_id || p.external_player_id || '')] || 0;
    },
    _rankMoves: {},
    _prevRanks: null,
    _rkey(p)  { return window.LSModelUtil.pid(p); },
    _move(p)  { return this._rankMoves[this._rkey(p)] || ''; },
    _diffRanks() {
      const ranks = {};
      this._top10Mine.forEach((p, i) => { ranks[this._rkey(p)] = i; });
      if (this._prevRanks) {
        const moves = {};
        for (const k in ranks) {
          const prev = this._prevRanks[k];
          if (prev === undefined)   moves[k] = 'up';      // new entrant
          else if (ranks[k] < prev) moves[k] = 'up';
          else if (ranks[k] > prev) moves[k] = 'down';
        }
        this._rankMoves = moves;
      }
      this._prevRanks = ranks;
    },
    init() {
      this.$nextTick(() => this._diffRanks());            // silent seed
      this.$watch('lastUpdated', () => this._diffRanks());
    },
  }),
  minCells:     { w: 3, h: 3 },
  defaultCells: { w: 4, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/top10_my_lineups.js ==== */
;
/* widgets/top10_my_lineups.js — "My Top Lineups" — your lineups ranked
 * by live total, as a scrolling card list (Xav 2026-06-14 redesign).
 *
 * Was a fixed "Top 10" rank table, but a user might have 1 lineup or
 * 150 — "10" is a false promise. Now it's individual cards (like Home
 * Run Watch) in a scroll area, so the panel shows as many as fit.
 * Capped at 50 for render safety — the top entries are what matter.
 *
 * Reads parent dashboard's lineupRows. Pre-slate ranks by projection so
 * the board is meaningful before first pitch. Rank-movement arrows diff
 * each poll — lineup rank changes are THE mid-slate sweat signal.
 * Sport-agnostic.
 */
window.LSWidgets.register({
  id:           'top10_my_lineups',
  description: 'Your lineups ranked by live total — the leaderboard for your own entries.',
  slot:        'panel',
  title:        'My Top Lineups',
  sportScope:   '*',
  factory:      () => ({
    get _preSlate() {
      return !(this.lineupRows || []).some(lu => (lu.live_total || 0) > 0);
    },
    get _myLineups() {
      const key = this._preSlate ? (lu => lu.proj_total || 0) : (lu => lu.live_total || 0);
      return [...(this.lineupRows || [])].sort((a, b) => key(b) - key(a)).slice(0, 50);
    },
    /* The hot/cold badge needs the same minimum-progress floor the lineup
       cards and the players themselves get (core.tracker.CLOCKLESS_MIN_FRAC):
       under a quarter of the lineup's projected output, live vs paced is
       noise, and before lock it called every projected lineup cold.
       pace_frac is shipped by the server; the fallback covers payloads that
       predate it. */
    _lineupJudged(lu) {
      if (!((lu.paced_proj || 0) > 0)) return false;
      const frac = lu.pace_frac != null
        ? lu.pace_frac
        : ((lu.proj_total || 0) > 0 ? (lu.paced_proj || 0) / lu.proj_total : 0);
      return frac >= 0.25;
    },
    _rankMoves: {},
    _prevRanks: null,
    _rkey(lu) { return String(lu.id || lu.lineup_name || ''); },
    _move(lu) { return this._rankMoves[this._rkey(lu)] || ''; },
    _diffRanks() {
      const ranks = {};
      this._myLineups.forEach((lu, i) => { ranks[this._rkey(lu)] = i; });
      if (this._prevRanks) {
        const moves = {};
        for (const k in ranks) {
          const prev = this._prevRanks[k];
          if (prev === undefined)   moves[k] = 'up';      // new entrant
          else if (ranks[k] < prev) moves[k] = 'up';
          else if (ranks[k] > prev) moves[k] = 'down';
        }
        this._rankMoves = moves;
      }
      this._prevRanks = ranks;
    },
    init() {
      this.$nextTick(() => this._diffRanks());            // silent seed
      this.$watch('lastUpdated', () => this._diffRanks());
    },
  }),
  minCells:     { w: 3, h: 3 },
  defaultCells: { w: 4, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/vidi.js ==== */
;
/* widgets/vidi.js — vidiprinter event ticker.
 *
 * Markup wrap: vidiScope / vidiDir / vidiEvents / newestVidiIds /
 * _teamLogos all stay on parent dashboard(). Lifting vidiScope onto the
 * widget would break the upstream feed-builder in live.js (line 2977)
 * which decides which players' events to emit based on this.vidiScope.
 * Once live.js is decomposed in Phase E, the feed-builder + scope will
 * move into a shared module and the widget can own the toggle.
 */
window.LSWidgets.register({
  id:             'vidi',
  description: 'Live event ticker - scoring plays, big moments, and lineup-relevant updates.',
  slot:          'panel',
  title:          'Vidiprinter',
  sportScope:     '*',
  factory:        () => ({}),
  minCells:       { w: 3, h: 3 },
  // A play card prints a whole sentence; below ~440px it loses words.
  minWidthPx:     440,
  defaultCells:   { w: 4, h: 4 },
  densityTiers:   ['full', 'compact'],
  // Declares a cog icon in panel chrome (always visible on hover, even
  // outside edit mode — widget config is distinct from layout editing).
  // Options persist via getOpt/setOpt → layout.panels[i].opts.
  optionsPartial: 'widgets/vidi_options.html',
});

/* ==== static/js/widgets/vidi_wire.js ==== */
;
/* widgets/vidi_wire.js — "The Wire" lane as a standalone widget (Vidi split).
 *
 * Renders only the wire lane (every event, terse one-liners) via the shared
 * VidiFeed renderer (host mounts it through _vidiWireMount). All feed state
 * (vidiScope / vidiDensity / vidiStream / _teamLogos) stays on parent
 * dashboard() — the widget contributes no x-data of its own. Sibling widget:
 * vidi_moments. The combined `vidi` widget still exists (both lanes in one
 * panel); see widgets/vidi.js.
 */
window.LSWidgets.register({
  id:             'vidi_wire',
  description: 'The Wire — every live event, a terse one-line ticker of the whole slate.',
  slot:          'panel',
  title:          'Vidiprinter — Wire',
  sportScope:     '*',
  factory:        () => ({}),
  minCells:       { w: 3, h: 2 },
  // A play card prints a whole sentence; below ~440px it loses words.
  minWidthPx:     440,
  defaultCells:   { w: 6, h: 4 },
  densityTiers:   ['full', 'compact'],
  // The wire is the firehose, so it carries the feed cog (routine plays,
  // min-FPts, score bands). Options persist via getOpt/setOpt.
  optionsPartial: 'widgets/vidi_options.html',
});

/* ==== static/js/widgets/vidi_moments.js ==== */
;
/* widgets/vidi_moments.js — "Moments" lane as a standalone widget (Vidi split).
 *
 * Renders only the moments lane (key plays — home runs, big scoring; richer
 * cards that linger) via the shared VidiFeed renderer (host mounts it through
 * _vidiMomentsMount). Feed state stays on parent dashboard(); no x-data of its
 * own. Sibling widget: vidi_wire. No cog — the feed config lives on the Wire.
 */
window.LSWidgets.register({
  id:             'vidi_moments',
  // Broadcast's dock: quiet until the first key play.
  // On a short board (a 1280x800 laptop) it waits there with its count, a
  // click away: across the bottom it left the Wire 253px - one or two rows
  // (audit v2 run 3, WIRE-9 at 1280).
  quiet:          (s) => {
    if (s.vidiMomentsEmpty) return s._slateFinal ? 'None recorded on this slate' : 'No big moments yet';
    if ((window.innerHeight || 0) >= 860) return '';
    const n = ((s._vidiLanes().moments) || []).length;
    return n + ' so far';
  },

  description: 'Moments — the key plays only (home runs, big scoring), richer cards that linger.',
  slot:          'panel',
  title:          'Vidiprinter — Moments',
  sportScope:     '*',
  factory:        () => ({}),
  minCells:       { w: 3, h: 2 },
  // A play card prints a whole sentence; below ~440px it loses words.
  minWidthPx:     440,
  defaultCells:   { w: 6, h: 3 },
  densityTiers:   ['full', 'compact'],
});

/* ==== static/js/widgets/dreamteam.js ==== */
;
/* widgets/dreamteam.js — ILP-computed Dream Team for the slate.
 *
 * Reads parent: dreamTeam, sortedDreamTeam, dreamTeamScore. ILP runs
 * server-side; the array is pushed in via SSE/poll updates handled by
 * dashboard(). Sport-agnostic.
 *
 * Ownership context (Xav 2026-06-06): _ownCount / _dtOwnedCount answer
 * "how much of the Dream Team do I actually hold?" — the headline
 * DFS question this widget exists for. Reads parent's _inCountMap
 * (stake-filter aware) via the prototype chain.
 */
window.LSWidgets.register({
  id:           'dreamteam',
  description: "Today's Dream Team based on live projections - what perfection looks like.",
  slot:        'panel',
  title:        'Dream Team',
  sportScope:   '*',
  factory:      () => ({
    /** A Dream Team worth showing: before anyone scores the optimiser still
     *  returns nine players at 0.00 - an arbitrary team printed as a fact
     *  (Broadcast audit v2, LIVE-4 / NUMBERS-10). */
    get _dtShow() { return (this.dreamTeam || []).length > 0 && (Number(this.dreamTeamScore) || 0) > 0; },
    /** How many of my (stake-filtered) lineups hold this player. */
    _ownCount(p) {
      return (this._inCountMap || {})[String(p.player_id || p.external_player_id || '')] || 0;
    },
    /** How many Dream Team players appear in at least one of my lineups. */
    get _dtOwnedCount() {
      return (this.dreamTeam || []).filter(p => this._ownCount(p) > 0).length;
    },
  }),
  minCells:     { w: 3, h: 3 },
  defaultCells: { w: 4, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/my_players.js ==== */
;
/* widgets/my_players.js — "My Players" widget (was Summary tab).
 * Reads parent dashboard() for sortedPlayers, spSearch, spPosFilter,
 * spShowNS/Live/Done, spPositions, filteredPlayersCount, spPage, setSort.
 */
window.LSWidgets.register({
  id:           'my_players',
  description: 'Every player across your lineups, with live points and a per-game-state view.',
  slot:        'panel',
  title:        'My Players',
  sportScope:   '*',
  factory:      () => ({}),
  minCells:     { w: 4, h: 4 },
  defaultCells: { w: 12, h: 6 },
  densityTiers: ['full', 'compact'],
  // Cog popover holds the shared player/form legend (migrated out of
  // the Settings menu 2026-06-06). See widgets/my_players_options.html.
  optionsPartial: 'widgets/my_players_options.html',
});

/* ==== static/js/widgets/my_lineups.js ==== */
;
/* widgets/my_lineups.js — "My Lineups" widget (was Lineups tab).
 * Reads parent dashboard() for activeLineupRows, lineupRows, luSortKey,
 * luSortDir, luSearch, luShowNS/Live/Done, setLuSort, theme, showEst.
 */
window.LSWidgets.register({
  id:           'my_lineups',
  description: 'Each of your lineups with its live total, projected pace, and ranking.',
  slot:        'panel',
  title:        'My Lineups',
  sportScope:   '*',
  factory:      () => ({}),
  minCells:     { w: 4, h: 4 },
  defaultCells: { w: 12, h: 6 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/all_players.js ==== */
;
/* widgets/all_players.js — "All Players" widget (was All Players tab).
 * Reads parent dashboard() for sortedAllPlayers, apSearch, apPosFilter,
 * apShowNS/Live/Done, apPositions, apPage, setApSort.
 */
window.LSWidgets.register({
  id:           'all_players',
  description: 'Every player available on this slate, sortable and filterable.',
  slot:        'panel',
  title:        'All Players',
  sportScope:   '*',
  factory:      () => ({}),
  minCells:     { w: 4, h: 4 },
  defaultCells: { w: 12, h: 6 },
  densityTiers: ['full', 'compact'],
  // Cog popover holds the shared player/form legend (migrated out of
  // the Settings menu 2026-06-06). See widgets/all_players_options.html.
  optionsPartial: 'widgets/all_players_options.html',
});

/* ==== static/js/widgets/lineup_race.js ==== */
;
/* widgets/lineup_race.js — "Trajectory" (Xav 2026-06-20 Lab rebuild).
 * Hero panel: top 5 lineups' cumulative live points + gold dashed
 * DREAM TEAM "OPTIMAL" ceiling line. The gap between your leader and
 * the ceiling is the story (how much you're leaving on the table).
 *
 * Monochrome system: leader = emerald-500 bold (with soft area wash),
 * ranks 2–5 = graduated slate-500/400/300 thin crisp lines. Only the
 * gold OPTIMAL line breaks the palette — reserved for the ceiling.
 *
 * Smooth updates: setOption with replaceMerge:['series'] so ticks
 * animate from the previous frame instead of clearing + redrawing.
 */
window.LSWidgets.register({
  id:           'lineup_race',
  description: 'Top 5 lineups accumulating live vs the Dream Team ceiling — who is closing on optimal.',
  help:         'Your top 5 entries climbing through the night. The gold dashed line is the live optimal — the perfect lineup. The gap between your leader and that line is the points you left on the table.',
  bestAt:       'multi',
  slot:         'panel',
  title:        'Trajectory',
  sportScope:   '*',
  factory:      () => ({
    ...LSChart.panelBase(),
    /** Dream Team's live total = the optimal achievable right now. */
    _dtTotal() {
      return (this.dreamTeam || []).reduce(
        (s, p) => s + (p.live_fpts || 0) * (p.role_mult || p.multiplier || 1), 0);
    },
    _option() {
      const isDark = LSChart.isDark();
      // Format-aware score display (host getters): 2 decimals + no unit for
      // fantasy points, 0 decimals + " HR"/" RBI"/" K" for single-stat.
      const fs  = (v) => this._fmtScore(v);
      const sfx = this._scoreUnitSfx;
      const rows = this.lineupRows || [];
      const top = [...rows]
        .map((lu, i) => ({ lu, i }))
        .sort((a, b) => (b.lu.live_total || 0) - (a.lu.live_total || 0))
        .slice(0, 5);

      // Prefer the server-reconstructed trajectory (real, from slate start,
      // survives F5 / slate-hop) — fall back to the session sample, then to a
      // synthesised start→now line when neither has ≥2 points yet.
      const serverHist = this.lineupHistory || [];
      let frames = serverHist.length >= 2 ? serverHist : (this._lineupHistory || []);
      // Real trajectory (server or session) carries a per-frame timestamp `t`
      // (ISO string from the server, epoch-ms from the session sampler) → plot on
      // a true TIME axis so a quiet stretch reads flat-and-wide and a scoring
      // burst reads steep. Only the "no history yet" synthesised 2-point line
      // lacks `t`; it stays on the simple start→now category axis.
      const useTime = frames.length >= 2 && frames.every(f => f && f.t != null);
      if (frames.length < 2) {
        const zero = {}, now = {};
        for (const { lu } of top) { zero[String(lu.id)] = 0; now[String(lu.id)] = +(lu.live_total || 0); }
        frames = [{ totals: zero }, { totals: now }];
      }
      const N = frames.length;
      const xLabels = frames.map((_, i) => (i === 0 ? 'start' : i === N - 1 ? 'now' : ''));
      // The demo's frames carry SECONDS INTO THE REPLAY, not epoch time: read
      // as epoch-ms they all fell in the first second of 1970 and every tick
      // said "01:00:00" (audit run 2, LIVE-12 / NUM-18). Those are plotted as
      // elapsed time and labelled m:ss.
      const elapsed = useTime && typeof frames[frames.length - 1].t === 'number' && frames[frames.length - 1].t < 1e9;
      const toMs = (t) => (typeof t === 'number' ? (elapsed ? t * 1000 : t) : Date.parse(t));
      // A night that spans under ~15 minutes (a slate's first poll) put
      // "01:00" on every tick (audit run 1, NUM-18): show seconds then.
      const span = useTime ? toMs(frames[frames.length - 1].t) - toMs(frames[0].t) : 0;
      const withSecs = useTime && span < 15 * 60e3;
      const clockFmt = (ms) => {
        const two = (n) => String(n).padStart(2, '0');
        if (elapsed) { const sec = Math.round(ms / 1000); return Math.floor(sec / 60) + ':' + two(sec % 60); }
        const d = new Date(ms);
        return two(d.getHours()) + ':' + two(d.getMinutes()) + (withSecs ? ':' + two(d.getSeconds()) : '');
      };

      // Monochrome palette: leader emerald, then graduated greys so the
      // leader actually leads visually instead of competing with 4 equally
      // saturated lines. (Was: rainbow per-lineup color.)
      const acc = LSChart.cssVar('--ls-accent', '#10b981');   // leader = brand emerald token
      const palette = isDark
        ? [acc, '#94a3b8', '#64748b', '#475569', '#334155']
        : [acc, '#64748b', '#94a3b8', '#cbd5e1', '#e2e8f0'];
      const leaderColor = palette[0];

      const series = top.map(({ lu, i }, rank) => {
        const id = String(lu.id);
        const color = palette[rank] || palette[palette.length - 1];
        const leader = rank === 0;
        return {
          name: lu.lineup_name || ('Lineup ' + (i + 1)),
          type: 'line', smooth: true, symbol: 'none', connectNulls: true,
          z: leader ? 4 : 2, emphasis: { focus: 'series' },
          lineStyle: {
            width: leader ? 3 : 1.5, color,
            shadowBlur: leader ? 14 : 0,
            shadowColor: leader ? color + '88' : 'transparent',
          },
          ...(leader ? {
            areaStyle: {
              opacity: 0.18,
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: color + 'cc' },
                  { offset: 1, color: color + '00' },
                ],
              },
            },
          } : {}),
          data: useTime
            ? frames.filter(f => id in (f.totals || {})).map(f => [toMs(f.t), +f.totals[id]])
            : frames.map(f => (id in f.totals ? f.totals[id] : null)),
        };
      });

      // Gold DREAM TEAM "OPTIMAL" benchmark — the only non-monochrome element.
      // Single-sourced star/gold token, matching the #1/owned gold elsewhere.
      // The board's gold where it has one (--bc-gold flips per theme on
      // Broadcast): the site's #fcd34d read 1.4:1 on a white panel (audit run 2,
      // COLOUR-2n).
      const gold = LSChart.cssVar('--bc-gold', '') || LSChart.cssVar('--ls-star-hi', '#fcd34d');
      // When the server ships a real dream trajectory (frame.dream), draw it as
      // a RISING dashed line — the optimal climbing through the night, so the
      // gap to your leader is visible at every point, not just now.
      const dreamData = useTime
        ? frames.filter(f => typeof f.dream === 'number').map(f => [toMs(f.t), +(+f.dream).toFixed(2)])
        : frames.map(f => (typeof f.dream === 'number' ? +(+f.dream).toFixed(2) : null));
      const hasDreamSeries = useTime
        ? dreamData.some(p => p[1] > 0)
        : dreamData.some(v => v != null && v > 0);
      if (hasDreamSeries) {
        series.push({
          name: 'Dream Team', type: 'line', smooth: true, symbol: 'none',
          connectNulls: true, z: 3, silent: true,
          lineStyle: { color: gold, type: 'dashed', width: 2, opacity: 0.95 },
          itemStyle: { color: gold },   // the legend swatch too - it fell back to the palette's green (COLOUR-4)
          // Cap the line end with the gold ★ — the same Dream Team marker used
          // across the app — instead of a wide "OPTIMAL" label that clipped at
          // the grid edge. The legend already spells out "Dream Team".
          endLabel: { show: true, formatter: '★', color: gold,
                      fontSize: 15, fontWeight: 400, offset: [1, 0] },
          data: dreamData,
        });
      } else {
        // Fallback (no recorded history yet): flat ceiling at the current optimal.
        const dt = this._dtTotal();
        if (series.length && dt > 0) {
          series[0] = {
            ...series[0],
            markLine: {
              silent: true, symbol: 'none', animation: false,
              lineStyle: { color: gold, type: 'dashed', width: 2, opacity: 0.95 },
              label: {
                // Same gold ★ cap as the real climbing benchmark, so the flat
                // pre-history ceiling reads identically. Value is in the header
                // copy / KPIs; the line just needs the marker.
                formatter: '★', position: 'end',
                color: gold, fontSize: 15, fontWeight: 400, padding: [0, 2],
              },
              data: [{ yAxis: +dt.toFixed(2) }],
            },
          };
        }
      }

      // Y-axis ceiling — the optimal/dream line is ALWAYS the highest value, but
      // in the markLine fallback it doesn't count toward auto-scale, and even as a
      // series ECharts' auto-max let it drift off the top over time. Pin the max to
      // the real peak (lineups + dream + current ceiling) with headroom so the gold
      // line always stays on screen.
      let _peak = 0;
      for (const f of frames) {
        if (f && f.totals) for (const k in f.totals) { const v = +f.totals[k]; if (v > _peak) _peak = v; }
        if (f && typeof f.dream === 'number' && f.dream > _peak) _peak = f.dream;
      }
      _peak = Math.max(_peak, this._dtTotal());
      const yMax = _peak > 0 ? Math.ceil((_peak * 1.08) / 10) * 10 : null;

      const t = LSChart.theme();

      // Rich hover: each lineup ranked with its live total AND its gap to the
      // optimal at that instant (the "points left on the table" told point-by-
      // point, not just now), then the OPTIMAL ceiling itself. Gap only when the
      // real climbing benchmark exists — a flat current-ceiling would overstate
      // the gap at past timestamps.
      const gapMuted = t.labelDim || '#94a3b8';
      const rule = t.splitLine || 'rgba(148,163,184,.25)';
      const valOf = (p) => {
        const v = Array.isArray(p.value) ? p.value[1] : p.value;
        return (v == null || Number.isNaN(+v)) ? null : +v;
      };
      const tooltipFmt = (params) => {
        const arr = Array.isArray(params) ? params : [params];
        if (!arr.length) return '';
        const head = useTime ? clockFmt(arr[0].axisValue)
                             : (arr[0].axisValueLabel || arr[0].name || '');
        let opt = null;
        for (const p of arr) {
          if (p.seriesName === 'Dream Team') { const v = valOf(p); if (v != null) opt = v; }
        }
        const lines = arr.filter(p => p.seriesName !== 'Dream Team' && valOf(p) != null)
                         .sort((a, b) => valOf(b) - valOf(a));
        const rows = lines.map(p => {
          const v = valOf(p);
          let gap = '';
          if (opt != null) {
            const d = opt - v;
            gap = d <= 0.05
              ? `<span style="color:${gold};font-weight:700;">&nbsp;·&nbsp;at optimal</span>`
              : `<span style="color:${gapMuted};">&nbsp;·&nbsp;−${d.toFixed(1)} to opt</span>`;
          }
          return `<div style="display:flex;align-items:center;white-space:nowrap;line-height:1.55;">`
               + `${p.marker}<span style="flex:1;padding-right:12px;">${p.seriesName}</span>`
               + `<b style="font-variant-numeric:tabular-nums;">${fs(v)}${sfx}</b>${gap}</div>`;
        }).join('');
        const optRow = opt == null ? ''
          : `<div style="display:flex;align-items:center;white-space:nowrap;line-height:1.55;`
          + `margin-top:4px;padding-top:4px;border-top:1px solid ${rule};">`
          + `<span style="width:11px;margin-right:5px;border-top:2px dashed ${gold};display:inline-block;"></span>`
          + `<span style="flex:1;padding-right:12px;color:${gold};font-weight:700;">OPTIMAL</span>`
          + `<b style="font-variant-numeric:tabular-nums;color:${gold};">${fs(opt)}${sfx}</b></div>`;
        return `<div style="font-weight:700;margin-bottom:2px;">${head}</div>${rows}${optRow}`;
      };

      return {
        backgroundColor: 'transparent',
        color: palette,
        grid: { left: 8, right: 22, top: 34, bottom: 22, containLabel: true },
        legend: {
          top: 0, type: 'scroll', icon: 'roundRect', itemWidth: 11, itemHeight: 4,
          // a long name ellipsizes; it was cut mid-word under the 1/3 pager at
          // 1280 ("T3 Mi", "Comeback K" - audit run 3, SPACE-3 / FIT-20)
          textStyle: { color: t.labelDim, fontSize: 11, fontWeight: 600, width: 96, overflow: 'truncate' },
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: t.tooltip.backgroundColor, borderColor: t.tooltip.borderColor,
          borderWidth: 1, textStyle: t.tooltip.textStyle, extraCssText: t.tooltip.extraCssText,
          formatter: tooltipFmt,
          ...(useTime ? { axisPointer: { label: { formatter: (o) => clockFmt(o.value) } } } : {}),
        },
        xAxis: useTime ? {
          // True time axis — tick spacing is real elapsed time, so the curve's
          // shape is honest (flat = quiet, steep = a burst). Labels = HH:MM.
          type: 'time', boundaryGap: false,
          axisLabel: { color: t.axisLabel, fontSize: 10, hideOverlap: true,
                       formatter: (val) => clockFmt(val) },
          axisLine: { lineStyle: { color: t.axisLine } }, axisTick: { show: false },
        } : {
          type: 'category', boundaryGap: false, data: xLabels,
          axisLabel: { color: t.axisLabel, fontSize: 10, hideOverlap: true,
                       alignMinLabel: 'left', alignMaxLabel: 'right' },
          axisLine: { lineStyle: { color: t.axisLine } }, axisTick: { show: false },
        },
        // three steps and no overlap: in a 113px chart at 1280 the five
        // labels sat on each other (audit run 3, SPACE-3 / TYPE-9)
        yAxis: {
          // from zero, or just under a lineup that went negative: the auto
          // scale ran to -100 for a -9.10 (audit v2 run 3, PREM-14)
          type: 'value', splitNumber: 3, min: (v) => (v.min < 0 ? Math.floor(v.min / 10) * 10 : 0),
          splitLine: { lineStyle: { color: t.splitLine } },
          axisLabel: { color: t.axisLabel, fontSize: 10, hideOverlap: true },
        },
        animationDuration: 700, animationDurationUpdate: 700, animationEasing: 'cubicOut',
        series,
      };
    },
  }),
  minCells:     { w: 4, h: 3 },
  defaultCells: { w: 12, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/player_heatmap.js ==== */
;
/* widgets/player_heatmap.js — "Exposure Heatmap" (Xav 2026-06-14).
 * Players (rows) × lineups (columns), each cell shaded by that player's
 * live FPts in that lineup — the MME exposure grid. Hot names + heavy
 * exposure jump out. Reads parent's graphPlayerHeatmap (LSGraphs.heatmap).
 * Sport-agnostic. Built on the shared LSChart/ECharts layer.
 */
window.LSWidgets.register({
  id:           'player_heatmap',
  description: 'Players × lineups grid shaded by live FPts — your exposure at a glance.',
  slot:        'panel',
  title:        'Exposure Heatmap',
  sportScope:   '*',
  factory:      () => ({
    ...LSChart.panelBase(),
    _option() {
      const t = LSChart.theme();
      const cellBorder = LSChart.isDark() ? '#0f172a' : '#ffffff';
      // Format-aware score display (host getters): 2 decimals + no unit for
      // fantasy points, 0 decimals + " HR"/" RBI"/" K" for single-stat.
      const fs  = (v) => this._fmtScore(v);
      const sfx = this._scoreUnitSfx;
      const hm = this.graphPlayerHeatmap || { players: [], lineups: [], peak: 0 };
      const players = (hm.players || []).slice(0, 80);     // all; y-axis windows + scrolls
      const lineups = (hm.lineups || []).slice(0, 50);     // full MME spread
      const pNames = players.map(p => p.name);
      const lNames = lineups.map((l, i) => l.lineup_name || ('L' + (i + 1)));
      const peak = Math.max(1, +(hm.peak || 0));
      const data = [];
      players.forEach((p, yi) => {
        lineups.forEach((l, xi) => {
          const v = (p.cells || [])[xi];
          if (v != null) data.push([xi, yi, +(+v).toFixed(2)]);
        });
      });
      return {
        backgroundColor: 'transparent',
        grid: { left: 4, right: 10, top: 8, bottom: 56, containLabel: true },
        tooltip: {
          position: 'top',
          backgroundColor: t.tooltip.backgroundColor, borderColor: t.tooltip.borderColor,
          borderWidth: 1, textStyle: t.tooltip.textStyle, extraCssText: t.tooltip.extraCssText,
          formatter: (p) => {
            const pl = players[p.value[1]] || {};
            const sub = [pl.team].filter(Boolean).join('');
            return `<b>${pNames[p.value[1]]}</b>${sub ? ` <span style="color:#94a3b8">${sub}</span>` : ''}<br/>`
              + `${lNames[p.value[0]]}<br/>`
              + `<span style="color:${t.emeraldDim}">${fs(+p.value[2])}${sfx}</span>`;
          },
        },
        xAxis: {
          type: 'category', data: lNames, splitArea: { show: true },
          axisLabel: { color: t.axisLabel, fontSize: 9, interval: 0,
                       rotate: lNames.length > 8 ? 45 : 0, width: 56, overflow: 'truncate' },
          axisLine: { show: false }, axisTick: { show: false },
        },
        yAxis: {
          type: 'category', data: pNames, inverse: true, splitArea: { show: true },
          axisLabel: { color: t.label, fontSize: 10, fontWeight: 600 },
          axisLine: { show: false }, axisTick: { show: false },
        },
        visualMap: {
          min: 0, max: Math.ceil(peak), calculable: true,
          orient: 'horizontal', left: 'center', bottom: 4,
          itemWidth: 12, itemHeight: 110,
          inRange: { color: t.heat },     // cool→hot multi-hue (blue→…→red)
          textStyle: { color: t.axisLabel, fontSize: 10 },
        },
        animationDuration: 700,
        dataZoom: LSChart.vScroll(18),   // top ~18 players fit; scroll for the rest
        series: [{
          name: 'FPts', type: 'heatmap', data,
          itemStyle: { borderRadius: 3, borderColor: cellBorder, borderWidth: 2 },
          emphasis: { itemStyle: { shadowBlur: 8, shadowColor: 'rgba(16,185,129,0.5)' } },
        }],
      };
    },
  }),
  minCells:     { w: 4, h: 3 },
  defaultCells: { w: 12, h: 5 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/lineup_scores.js ==== */
;
/* widgets/lineup_scores.js — "Lineup Scores" (Xav 2026-06-20 Lab rebuild).
 * Horizontal bars of each lineup's LIVE total, ranked best-first.
 * Monochrome emerald gradient (top = brightest, lower ranks fade) so the
 * leader visibly leads instead of competing with rainbow per-row colors.
 *
 * Optional dashed projection marker — only renders when projections OR
 * a platform baseline_total exist. Without either, the bars stand alone
 * (no misleading dependency on user-pasted data).
 */
window.LSWidgets.register({
  id:           'lineup_scores',
  description: "Your lineups ranked by live total, with an optional 'expected' marker (projection or platform baseline).",
  help:         'Every entry ranked best-first by live points. The faint tick is your “expected” mark — your projection if you pasted one, otherwise the platform’s season average. Bar past the tick = beating expectations.',
  bestAt:       'multi',
  slot:         'panel',
  title:        'Lineup Scores',
  sportScope:   '*',
  factory:      () => ({
    ...LSChart.panelBase(),
    _option() {
      const t = LSChart.theme();
      const isDark = LSChart.isDark();
      const rows = (this.lineupRows || [])
        .map(lu => ({
          name:     lu.lineup_name || 'Lineup',
          live:     +(lu.live_total || 0),
          // Prefer user proj if pasted; fall back to platform baseline_total
          // so the marker appears even when projections are absent (and
          // disappears entirely when neither is available).
          expected: +(lu.proj_total || lu.baseline_total || 0),
        }))
        .sort((a, b) => b.live - a.live)
        .slice(0, 10);                 // top 10 fit elegantly; rest off-panel

      if (!rows.length) {
        return { backgroundColor: 'transparent',
                 xAxis: { type: 'value', show: false },
                 yAxis: { type: 'category', show: false },
                 series: [] };
      }

      const names = rows.map(r => r.name);
      // The projection/baseline "expected" tick only means something where
      // projections apply (the `projections` trait). Single-stat scores a raw
      // count, so the tick would be meaningless — suppress it. (_formatVariant
      // via host; window.LSFormat present on the live page.)
      const noProj = window.LSFormat ? !window.LSFormat.traitsOf(this._formatVariant || '').projections : false;
      const haveExpected = !noProj && rows.some(r => r.expected > 0);
      // Score display routes through the host _fmtScore (format decimals trait):
      // 2 for fantasy points, 0 for a single-stat count.
      const fs  = (v) => this._fmtScore(v);
      const sfx = this._scoreUnitSfx;   // " HR" for single-stat, "" for standard
      const expPts = haveExpected
        ? rows.map((r, i) => (r.expected > 0 ? [r.expected, i] : null)).filter(Boolean)
        : [];
      const maxV = Math.ceil(Math.max(1, ...rows.map(r => Math.max(r.live, r.expected))) * 1.14);

      // Monochrome emerald gradient by RANK — leader brightest, rank 9
      // faded to slate. (Was: rainbow palette per-row.) Keeps the brand
      // tight; the leader is visually the leader.
      const pos = LSChart.cssVar('--ls-accent-hi', '#34d399');
      const neg = LSChart.cssVar('--ls-danger-hi', '#f87171');
      const rankColor = this._rankColorFn(isDark);

      return {
        backgroundColor: 'transparent',
        grid: { left: 8, right: 46, top: 8, bottom: 4, containLabel: true },
        tooltip: {
          trigger: 'axis', axisPointer: { type: 'shadow' },
          backgroundColor: t.tooltip.backgroundColor, borderColor: t.tooltip.borderColor,
          borderWidth: 1, textStyle: t.tooltip.textStyle, extraCssText: t.tooltip.extraCssText,
          formatter: (ps) => {
            if (!ps || !ps.length) return '';
            const r = rows[ps[0].dataIndex];
            const d = r.expected > 0 ? r.live - r.expected : null;
            const dc = d === null ? t.labelDim : d >= 0 ? pos : neg;
            const dl = d === null ? '' : `<br/><span style="color:${dc}">${d >= 0 ? '+' : ''}${fs(d)} vs expected</span>`;
            const el = r.expected > 0
              ? `<br/><span style="color:${t.labelDim}">Expected</span> ${fs(r.expected)}`
              : '';
            return `<b>${r.name}</b><br/>`
              + `<span style="color:${t.emeraldDim}">Live</span> ${fs(r.live)}${sfx}`
              + el + dl;
          },
        },
        xAxis: {
          show: true, type: 'value', max: maxV,
          splitLine: { lineStyle: { color: t.splitLine } },
          axisLabel: { color: t.axisLabel, fontSize: 10 },
          axisLine: { show: false }, axisTick: { show: false },
        },
        yAxis: {
          show: true, type: 'category', data: names, inverse: true,
          axisLabel: { color: t.label, fontSize: 11, fontWeight: 600, width: 130, overflow: 'truncate' },
          axisLine: { show: false }, axisTick: { show: false },
        },
        animationDuration: 750, animationDurationUpdate: 0, animationEasing: 'cubicOut',
        series: [
          {
            name: 'Live', type: 'bar', barMaxWidth: 26, z: 2,
            label: {
              show: true, position: 'right', color: t.label,
              fontSize: 11, fontWeight: 800,
              formatter: (p) => fs(p.value || 0) + sfx,
            },
            data: rows.map((r, i) => {
              const c = rankColor(i, rows.length);
              return {
                value: r.live,
                itemStyle: {
                  color: t.barGrad ? t.barGrad(c) : c,
                  borderRadius: [0, 7, 7, 0],
                  shadowBlur: i === 0 ? 8 : 0,
                  shadowColor: i === 0 ? c + '55' : 'transparent',
                },
              };
            }),
          },
          // Optional thin dashed marker — present only when we have an
          // expected value (user proj OR platform baseline_total).
          ...(haveExpected ? [{
            name: 'Expected', type: 'scatter', symbol: 'rect',
            symbolSize: [2, 22], z: 3,
            itemStyle: { color: t.labelDim, opacity: 0.6 },
            tooltip: { show: false }, data: expPts,
          }] : []),
        ],
      };
    },
  }),
  minCells:     { w: 3, h: 2 },
  defaultCells: { w: 6, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/pace_tracker.js ==== */
;
/* widgets/pace_tracker.js — "Pace tracker", rebuilt on ECharts
 * (Xav 2026-06-14). Diverging horizontal bars of each lineup's delta vs
 * its EXPECTED pace right now: ahead = emerald to the right, behind = red
 * to the left, the dashed zero line = exactly on pace. Reads the parent's
 * memoised graphPaceData (LSGraphs.paceData). Sport-agnostic.
 */
window.LSWidgets.register({
  id:           'pace_tracker',
  description: 'How far ahead or behind expected pace each lineup is right now.',
  slot:        'panel',
  title:        'Pace tracker',
  sportScope:   '*',
  factory:      () => ({
    ...LSChart.panelBase(),
    _option() {
      const t = LSChart.theme();
      // Status colours single-sourced from the tokens (chart JS can't use var()
      // in an echarts colour string, so read them via getComputedStyle).
      const red = LSChart.cssVar('--ls-danger', '#ef4444');
      const pos = LSChart.cssVar('--ls-accent-hi', '#34d399');
      const neg = LSChart.cssVar('--ls-danger-hi', '#f87171');
      // Format-aware score display (host getters): 2 decimals + no unit for
      // fantasy points, 0 decimals + " HR"/" RBI"/" K" for single-stat. The
      // Live total carries the unit suffix; Expected + deltas use fs alone
      // (matching Lineup Scores' tooltip convention).
      const fs  = (v) => this._fmtScore(v);
      const sfx = this._scoreUnitSfx;
      const rows = [...(this.graphPaceData || [])]
        .map(p => ({ name: p.name, live: +p.live, exp: +p.expectedNow,
                     delta: +(((+p.live) - (+p.expectedNow)).toFixed(2)) }))
        .sort((a, b) => b.delta - a.delta)
        .slice(0, 50);                 // all lineups; panel windows + scrolls
      const names  = rows.map(r => r.name);
      const maxAbs = Math.ceil(Math.max(1, ...rows.map(r => Math.abs(r.delta))) * 1.25);
      const redGrad = new echarts.graphic.LinearGradient(1, 0, 0, 0, [
        { offset: 0, color: red + 'cc' }, { offset: 1, color: red },
      ]);
      return {
        backgroundColor: 'transparent',
        grid: { left: 4, right: 14, top: 8, bottom: 4, containLabel: true },
        tooltip: {
          trigger: 'axis', axisPointer: { type: 'shadow' },
          backgroundColor: t.tooltip.backgroundColor, borderColor: t.tooltip.borderColor,
          borderWidth: 1, textStyle: t.tooltip.textStyle, extraCssText: t.tooltip.extraCssText,
          formatter: (ps) => {
            if (!ps || !ps.length) return '';
            const r = rows[ps[0].dataIndex];
            const dc = r.delta >= 0 ? pos : neg;
            return `<b>${r.name}</b><br/>`
              + `Live ${fs(r.live)}${sfx} · Expected ${fs(r.exp)}<br/>`
              + `<span style="color:${dc}">${r.delta >= 0 ? '+' : ''}${fs(r.delta)} `
              + `${r.delta >= 0 ? 'ahead of' : 'behind'} pace</span>`;
          },
        },
        xAxis: {
          type: 'value', min: -maxAbs, max: maxAbs,
          splitLine: { lineStyle: { color: t.splitLine } },
          axisLabel: { color: t.axisLabel, fontSize: 10,
                       formatter: (v) => (v > 0 ? '+' : '') + v },
          axisLine: { show: false }, axisTick: { show: false },
        },
        yAxis: {
          type: 'category', data: names, inverse: true,
          axisLabel: { color: t.label, fontSize: 11, fontWeight: 600 },
          axisLine: { show: false }, axisTick: { show: false },
        },
        animationDuration: 750, animationDurationUpdate: 0, animationEasing: 'cubicOut',
        dataZoom: LSChart.vScroll(12),   // top ~12 fit; scroll for the rest
        series: [{
          type: 'bar', barWidth: 13,
          data: rows.map(r => ({
            value: r.delta,
            itemStyle: {
              borderRadius: r.delta >= 0 ? [0, 7, 7, 0] : [7, 0, 0, 7],
              color: r.delta >= 0 ? t.barGrad(t.emerald) : redGrad,
              shadowBlur: 10,
              shadowColor: r.delta >= 0 ? 'rgba(16,185,129,0.28)' : 'rgba(239,68,68,0.28)',
            },
          })),
          label: {
            show: true, position: 'right', fontSize: 10, fontWeight: 800,
            color: t.labelDim,
            formatter: (p) => (p.value >= 0 ? '+' : '') + fs(p.value),
          },
          markLine: {
            silent: true, symbol: 'none',
            lineStyle: { color: t.axisLine, type: 'dashed', width: 1 },
            label: { show: false }, data: [{ xAxis: 0 }],
          },
        }],
      };
    },
  }),
  minCells:     { w: 3, h: 2 },
  defaultCells: { w: 6, h: 3 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/player_contributions.js ==== */
;
/* widgets/player_contributions.js — "Top Contributors"
 * (Xav 2026-06-20 Lab rebuild). Aggregate top-contributor bars across
 * ALL your lineups — each unique player's live FPts and how many of
 * your lineups they appear in.
 *
 * Monochrome emerald gradient by rank (top brightest, lower ranks fade
 * toward slate). Replaces the rainbow per-row palette. Labels are
 * INLINE in human terms — "39.25 · in 9 of 11 lineups" — instead of a
 * naked "9%" that requires the user to remember what the percent is of.
 */
window.LSWidgets.register({
  id:           'player_contributions',
  description: "Your top contributors — each player's live points and how many of your lineups they appear in.",
  help:         'Who is actually scoring your points, pooled across every entry. The “in 9/11” count is how many of your lineups own them — high exposure means your night leans on them.',
  bestAt:       'multi',
  slot:         'panel',
  title:        'Top Contributors',
  sportScope:   '*',
  factory:      () => ({
    ...LSChart.panelBase(),
    _option() {
      const t = LSChart.theme();
      const isDark = LSChart.isDark();
      // Ranked by what each brings across your lineups (own points x lineups
      // held), the same "carrying" as the KPI and the takeaway above it, so
      // the headline names the first bar (audit run 1, NUM-11). As many as
      // the panel can label - every bar gets its name (PREM-9).
      const fit = Math.max(3, Math.min(10, Math.floor((((this.$el && this.$el.clientHeight) || 300) - 96) / 22)));
      const rows = ((this.graphPlayerContributions || {}).players || [])
        .filter(p => (p.total || 0) > 0)
        .sort((a, b) => (b.total * Math.max(1, b.lineupCount)) - (a.total * Math.max(1, a.lineupCount)) || b.total - a.total)
        .slice(0, fit);
      // Format-aware score display (host getters): 2 decimals + no unit for
      // fantasy points, 0 decimals + " HR"/" RBI"/" K" for single-stat.
      const fs  = (v) => this._fmtScore(v);
      const sfx = this._scoreUnitSfx;

      if (!rows.length) {
        return { backgroundColor: 'transparent',
                 xAxis: { type: 'value', show: false },
                 yAxis: { type: 'category', show: false },
                 series: [] };
      }

      const totalLineups = Math.max(1, (this.lineupRows || []).length);
      const names = rows.map(r => r.name);
      // The bar is the player's SHARE of all your lineups' points (own points
      // x lineups held, over the sum of your lineup totals) - the same
      // quantity the rows are ranked by, so the bars step down in order. Bars
      // of own points under a by-share order jumped about (Lamb's 44.30 the
      // longest bar in fifth place - audit run 2, NUM-23 / PREM-10). The label
      // still says own points + "in N/M", plus the share; no axis numbers, so
      // nothing reads as points x lineups.
      const pool = (this.lineupRows || []).reduce((t, lu) => t + (+lu.live_total || 0), 0)
        || rows.reduce((t, r) => t + (r.total || 0) * Math.max(1, r.lineupCount), 0) || 1;
      // unrounded: the label rounds once (rounded to 0.1 first, 4.45 read 5% - audit v2 run 3, NUMBERS-13)
      const shares = rows.map(r => ((r.total || 0) * Math.max(1, r.lineupCount)) / pool * 100);
      const totals = shares;
      const maxV = Math.max(1, ...shares) * 1.6;   // room for the label

      // Monochrome rank gradient — same logic as Lineup Scores.
      const rankColor = this._rankColorFn(isDark);

      return {
        backgroundColor: 'transparent',
        grid: { left: 8, right: 92, top: 8, bottom: 4, containLabel: true },
        tooltip: {
          trigger: 'axis', axisPointer: { type: 'shadow' },
          backgroundColor: t.tooltip.backgroundColor, borderColor: t.tooltip.borderColor,
          borderWidth: 1, textStyle: t.tooltip.textStyle, extraCssText: t.tooltip.extraCssText,
          formatter: (ps) => {
            if (!ps || !ps.length) return '';
            const r = rows[ps[0].dataIndex];
            const sub = [r.team, r.pos].filter(Boolean).join(' · ');
            return `<b>${r.name}</b>${sub ? ` <span style="color:${t.labelDim}">${sub}</span>` : ''}<br/>`
              + `<span style="color:${t.emeraldDim}">${fs(r.total || 0)}${sfx}</span>`
              + ` · in ${r.lineupCount} of ${totalLineups} lineups`;
          },
        },
        xAxis: { show: false, type: 'value', max: maxV },
        yAxis: {
          show: true, type: 'category', data: names, inverse: true,
          axisLabel: { color: t.label, fontSize: 11, fontWeight: 600, width: 130, overflow: 'truncate', interval: 0 },
          axisLine: { show: false }, axisTick: { show: false },
        },
        animationDuration: 750, animationDurationUpdate: 0, animationEasing: 'cubicOut',
        series: [{
          name: 'Live points', type: 'bar', barMaxWidth: 24,
          label: {
            show: true, position: 'right', fontSize: 10.5, fontWeight: 700,
            color: t.label,
            // Inline human-readable label — "39.25 · in 9 of 11"
            formatter: (p) => {
              const r = rows[p.dataIndex];
              return `${fs(r.total || 0)}${sfx}  ·  in ${r.lineupCount}/${totalLineups}  ·  ${Math.round(p.value || 0)}%`;
            },
          },
          data: totals.map((v, i) => {
            const c = rankColor(i, rows.length);
            return {
              value: v,
              itemStyle: {
                color: t.barGrad ? t.barGrad(c) : c,
                borderRadius: [0, 7, 7, 0],
                shadowBlur: i === 0 ? 7 : 0,
                shadowColor: i === 0 ? c + '55' : 'transparent',
              },
            };
          }),
        }],
      };
    },
  }),
  minCells:     { w: 4, h: 3 },
  defaultCells: { w: 6, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/tier_breakdown.js ==== */
;
/* widgets/tier_breakdown.js — "Tier Breakdown" (DK Tiers).
 *
 * The tier analog of Position Breakdown: one row per tier showing the LEADER
 * (the optimal pick = the Dream Team member) next to YOUR pick in that tier,
 * and the gap. Answers the whole tiers question — did you draft the right
 * player in each tier?
 *
 * Reads parent allSlatePlayers (leaders) + lineupRows (your unique picks). Only
 * meaningful on a tiers slate (players carry a `tier`); empty elsewhere.
 */
window.LSWidgets.register({
  id:           'tier_breakdown',
  description: 'Your pick vs the leader in each tier — did you draft the right player per tier?',
  help:         'For each DK tier: the top scorer (the optimal pick) beside your own pick, with the gap. ★ = you hold the tier leader.',
  slot:         'panel',
  title:        'Tier Breakdown',
  sportScope:   '*',
  formatScope:  ['tiers'],   // tier construct only exists on DK Tiers slates
  factory: () => ({
    _key(p) { return window.LSModelUtil.pid(p); },
    /** One row per tier: leader (max live_fpts in the tier) + your best pick in
     *  that tier (unique across your lineups) + the gap to the leader. */
    get _tierRows() {
      const leaders = {};
      for (const p of (this.allSlatePlayers || [])) {
        if (p.tier == null) continue;
        if (!leaders[p.tier] || (p.live_fpts || 0) > (leaders[p.tier].live_fpts || 0)) leaders[p.tier] = p;
      }
      const mine = {}, seen = new Set();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          if (p.tier == null) continue;
          const k = this._key(p);
          if (seen.has(k)) continue;
          seen.add(k);
          if (!mine[p.tier] || (p.live_fpts || 0) > (mine[p.tier].live_fpts || 0)) mine[p.tier] = p;
        }
      }
      return Object.keys(leaders).map(Number).sort((a, b) => a - b).map(tier => {
        const leader = leaders[tier];
        const pick   = mine[tier] || null;
        const hasLeader = !!(pick && leader && this._key(pick) === this._key(leader));
        const gap = pick ? Math.max(0, (leader.live_fpts || 0) - (pick.live_fpts || 0)) : null;
        return { tier, leader, pick, hasLeader, gap };
      });
    },
  }),
  minCells:     { w: 3, h: 2 },
  defaultCells: { w: 4, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/stack_performance.js ==== */
;
/* widgets/stack_performance.js — "Stack Performance"
 * (Xav 2026-06-20 Lab rebuild). Live FPts grouped by TEAM across your
 * unique-player pool — which team stacks paid off tonight. A natural
 * answer to "did my Lakers stack hit?" without needing to scroll
 * through 8 lineups to add things up.
 *
 * Aggregates UNIQUE players (same dedup as Top Contributors) so a
 * star in 20 lineups doesn't 20x his team. Monochrome emerald-fade.
 */
window.LSWidgets.register({
  id:           'stack_performance',
  description: "Live FPts grouped by team across your unique players — which team stacks are paying off.",
  help:         'Did your stacks hit? Live points pooled by team across your unique players. A team running away at the top means a correlated stack is paying off; quiet teams are dragging.',
  bestAt:       'multi',
  slot:         'panel',
  title:        'Stack Performance',
  sportScope:   '*',
  factory:      () => ({
    ...LSChart.panelBase(),
    /** Aggregate live FPts by team across unique players. */
    _aggregate() {
      const lineups = this.lineupRows || [];
      const seen = new Set();
      const buckets = new Map();         // team -> { pts, players: Set }
      for (const lu of lineups) {
        for (const p of (lu.players || [])) {
          const pid = String(p.player_id || p.external_player_id || '');
          if (seen.has(pid)) continue;
          seen.add(pid);
          const team = (p.team || '–').toUpperCase();
          const b = buckets.get(team) || { pts: 0, players: new Set() };
          b.pts += (p.live_fpts || 0);
          b.players.add(pid);
          buckets.set(team, b);
        }
      }
      return [...buckets.entries()]
        .map(([team, b]) => ({ team, pts: +b.pts.toFixed(2), n: b.players.size }))
        .filter(r => r.pts > 0)
        .sort((a, b) => b.pts - a.pts)
        .slice(0, 10);
    },
    _option() {
      const t = LSChart.theme();
      const isDark = LSChart.isDark();
      // As many teams as the panel can label, each bar with its name (audit run 1, PREM-9).
      const fit = Math.max(3, Math.min(10, Math.floor((((this.$el && this.$el.clientHeight) || 300) - 96) / 22)));
      const rows = this._aggregate().slice(0, fit);
      // Format-aware score display (host getters): 2 decimals + no unit for
      // fantasy points, 0 decimals + " HR"/" RBI"/" K" for single-stat.
      const fs  = (v) => this._fmtScore(v);
      const sfx = this._scoreUnitSfx;

      if (!rows.length) {
        return { backgroundColor: 'transparent',
                 xAxis: { type: 'value', show: false },
                 yAxis: { type: 'category', show: false },
                 series: [] };
      }

      const names = rows.map(r => r.team);
      const vals  = rows.map(r => r.pts);
      // a round end tick ("137" read as a number, not a scale - audit run 3, NUM-37)
      const nice  = window.LSModelUtil && window.LSModelUtil.niceAxis ? window.LSModelUtil.niceAxis(Math.max(1, ...vals) * 1.12, 4) : null;
      const maxV  = nice ? nice.max : Math.ceil(Math.max(1, ...vals) * 1.2);
      const unit  = this._scoreUnitSfx || ' pts';   // the slate's unit (HR / K on a single-stat slate)

      const rankColor = this._rankColorFn(isDark);

      return {
        backgroundColor: 'transparent',
        grid: { left: 8, right: 60, top: 8, bottom: 4, containLabel: true },
        tooltip: {
          trigger: 'axis', axisPointer: { type: 'shadow' },
          backgroundColor: t.tooltip.backgroundColor, borderColor: t.tooltip.borderColor,
          borderWidth: 1, textStyle: t.tooltip.textStyle, extraCssText: t.tooltip.extraCssText,
          formatter: (ps) => {
            const r = rows[ps[0].dataIndex];
            return `<b>${r.team}</b><br/>`
              + `<span style="color:${t.emeraldDim}">${fs(r.pts)}${sfx}</span>`
              + ` · ${r.n} player${r.n === 1 ? '' : 's'}`;
          },
        },
        xAxis: {
          show: true, type: 'value', max: maxV, ...(nice ? { interval: nice.interval } : {}),
          splitLine: { lineStyle: { color: t.splitLine } },
          // the last tick carries the unit ("100 pts") - the axis read as a bare count
          axisLabel: { color: t.axisLabel, fontSize: 10, hideOverlap: true, formatter: (v) => (v === maxV ? v + unit : String(v)) },
          axisLine: { show: false }, axisTick: { show: false },
        },
        yAxis: {
          show: true, type: 'category', data: names, inverse: true,
          axisLabel: { color: t.label, fontSize: 11, fontWeight: 700, width: 112, overflow: 'truncate', interval: 0 },
          axisLine: { show: false }, axisTick: { show: false },
        },
        animationDuration: 750, animationDurationUpdate: 0, animationEasing: 'cubicOut',
        series: [{
          name: 'Live FPts', type: 'bar', barMaxWidth: 22,
          label: {
            show: true, position: 'right', color: t.label,
            fontSize: 11, fontWeight: 700,
            formatter: (p) => fs(p.value || 0) + sfx,
          },
          data: vals.map((v, i) => {
            const c = rankColor(i, rows.length);
            return {
              value: v,
              itemStyle: {
                color: t.barGrad ? t.barGrad(c) : c,
                borderRadius: [0, 7, 7, 0],
                shadowBlur: i === 0 ? 7 : 0,
                shadowColor: i === 0 ? c + '55' : 'transparent',
              },
            };
          }),
        }],
      };
    },
  }),
  minCells:     { w: 3, h: 2 },
  defaultCells: { w: 4, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/red_zone.js ==== */
;
/* widgets/red_zone.js — NFL Red Zone.
 *
 * The single most valuable live moment in football DFS: a team is inside the
 * 20 and about to score, and you want to know — instantly — whether that's
 * YOUR players about to get six points or the defense you rostered about to
 * concede them.
 *
 * Built on live_state.red_zone / possession / down_distance, which only became
 * available when the NFL provider started emitting drive situation
 * (2026-08-13). Before that, football's live layer had nothing equivalent to
 * MLB's bases-and-outs.
 *
 * Two lists per game, because both sides matter to a DFS player:
 *   · ATTACKING — your skill players on the team with the ball
 *   · DEFENDING — your D/ST on the other side (about to concede)
 * A game with none of your players still shows, greyed, as slate context.
 */
window.LSWidgets.register({
  id:          'red_zone',
  description: 'Live red-zone alerts — who is inside the 20 and which of your players are involved.',
  help:        'Every drive currently inside the opponent 20. Your attacking players are listed under the team with the ball; your D/ST appears on the other side, because a red-zone trip is exactly when a defense bleeds points. Empty most of the time — that is the point: when it fills, look up.',
  slot:        'panel',
  title:       'Red Zone',
  sportScope:  ['nfl', 'cfb'],
  factory:     () => ({
    /** Live games whose current drive is inside the 20. */
    get _rzGames() {
      return (this.allGames || []).filter(g => {
        const ls = g.live_state || {};
        return (this.effStatus ? this.effStatus(g) : g.status) === 2 && ls.red_zone;
      });
    },

    /** My players on a given team abbrev (unique by player_id).
     *  Team matched via the pool rows' own team string — these come from the
     *  same slate pool the lineups are built from, so no cross-source drift. */
    _mine(teamAbbr, wantDst) {
      const t = String(teamAbbr || '').toUpperCase();
      if (!t) return [];
      const seen = new Set();
      const out = [];
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const key = window.LSModelUtil.pid(p);
          if (seen.has(key)) continue;
          if (String(p.team || '').toUpperCase() !== t) continue;
          const isDst = String(p.pos || '').toUpperCase() === 'DST';
          if (isDst !== !!wantDst) continue;
          seen.add(key);
          out.push(p);
        }
      }
      return out.sort((a, b) => (b.live_fpts || 0) - (a.live_fpts || 0));
    },

    /** One row per red-zone drive: who's attacking, who's defending, and
     *  which of my players sit on each side. */
    get _rows() {
      return this._rzGames.map(g => {
        const ls = g.live_state || {};
        const att = String(ls.possession || '').toUpperCase();
        const home = String(g.home_team || '').toUpperCase();
        const away = String(g.away_team || '').toUpperCase();
        const def = att === home ? away : att === away ? home : '';
        const attackers = this._mine(att, false);
        const defenders = this._mine(def, true);
        return {
          game_id: g.game_id,
          att, def,
          matchup: away + ' @ ' + home,
          drive: [ls.down_distance || '', ls.yardline || ''].filter(Boolean).join(' · '),
          clock: this._rzClock(g),
          attackers, defenders,
          involved: attackers.length + defenders.length,
        };
      // Games where you have skin in the game first.
      }).sort((a, b) => b.involved - a.involved);
    },

    _rzClock(g) {
      const p = g.period || 0;
      const q = p <= 4 ? 'Q' + (p || 1) : 'OT';
      const s = Math.max(0, Math.floor(g.clock_secs || 0));
      return q + ' ' + Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
    },

    /** Total of my players currently in a red-zone situation — the foot line. */
    get _totalInvolved() {
      return this._rows.reduce((n, r) => n + r.involved, 0);
    },
  }),
});

/* ==== static/js/widgets/model_util.js ==== */
;
/* widgets/model_util.js — the small helpers every Broadcast brain shares
 * (race_model, squad_model, podium_model, lab_tools_model, lab_takeaways,
 * lab_charts, score_wire).
 *
 * Each of them used to carry its own copy - num ×7, pid ×6, isDst ×6,
 * full ×6, andList ×5 - and the copies had drifted: The Race wrote a
 * defence as "LAR D/ST" while the other panels wrote "Los Angeles Rams D/ST"
 * for the same player (Broadcast audit run 1, CODE-12 / NUM-15). One copy
 * now, loaded before them. Pure: no DOM, no Alpine. */
window.LSModelUtil = (function () {
  const num = (v) => { const n = Number(v); return isFinite(n) ? n : 0; };
  /** Players join by id, never by name. */
  const pid = (p) => String((p && (p.player_id || p.external_player_id)) || '');
  /** Football defences only - a hockey 'D' is a defenceman, not a team. */
  const isDst = (p) => ['DST', 'DEF', 'D/ST'].includes(String((p && (p.pos || p.position)) || '').toUpperCase());
  const SUFFIX = /^(jr\.?|sr\.?|ii|iii|iv|v)$/i;
  /** A last name for a chip or a headline, or "NYJ D/ST". */
  function short(p) {
    if (!p) return '';
    if (isDst(p) && p.team) return String(p.team).toUpperCase() + ' D/ST';
    const w = String(p.name || '').trim().split(/\s+/).filter(x => !SUFFIX.test(x));
    return w.length ? w[w.length - 1] : String(p.name || '');
  }
  /** The full name - a defence is always "TEAM D/ST", whatever the platform calls it. */
  const full = (p) => (p && isDst(p) && p.team ? String(p.team).toUpperCase() + ' D/ST' : String((p && p.name) || ''));
  /** "A and B", "A, B and C" - every name, never "+ 1". */
  const andList = (xs) => (xs.length <= 1 ? (xs[0] || '') : xs.slice(0, -1).join(', ') + ' and ' + xs[xs.length - 1]);
  const nameOf = (lu, i) => lu.lineup_name || ('Lineup ' + (i + 1));
  const toMs = (t) => (typeof t === 'number' ? t : Date.parse(t));
  /** A chart axis that ends on a round step: { max, interval } with about
   *  `steps` intervals - axes ended on "$9.464k", "53", "137" (audit run 3,
   *  NUM-37 / PREM-7). */
  function niceAxis(v, steps) {
    const n = Math.max(1, steps || 4), raw = Math.max(1e-9, Number(v) || 0) / n;
    const mag = Math.pow(10, Math.floor(Math.log10(raw)));
    const step = [1, 2, 2.5, 5, 10].map(k => k * mag).find(s => s >= raw) || 10 * mag;
    return { max: Math.ceil((Number(v) || 0) / step) * step || step, interval: step };
  }
  /** The board's one sentence form for lineup share: "in 3 of your 5
   *  lineups", "in each of your 5 lineups" - never "both" or "2 of your 2"
   *  (audit run 3, NUM-29). The compact form is "3/5". */
  const inLineups = (n, total) => (n >= total ? 'in each of your ' + total + ' lineups' : 'in ' + n + ' of your ' + total + ' lineups');
  /** Points with 2 decimals and a true minus ("−2.40"); sign adds "+". */
  const pts = (v, sign) => {
    const n = num(v), a = Math.abs(n).toFixed(2), neg = n < 0 && +a !== 0;
    return (neg ? '−' : (sign ? '+' : '')) + a;
  };
  /** The last name from a name string ("Kenneth Walker III" -> "Walker"). */
  const lastName = (s) => short({ name: s });
  /** A player's pace (Xav 2026-10-07): what he was expected to have by now
   *  and where he is heading. The expectation is your projection, else the
   *  DraftKings average (`baseline`); "by now" scales it by how far through
   *  his game he is (finished = all of it, not started = none). null when
   *  there is nothing to measure against.
   *  { src: 'proj'|'avg', base, frac, expNow, delta, est } */
  function pace(p) {
    if (!p) return null;
    const proj = num(p.proj), avg = num(p.baseline);
    const base = proj > 0 ? proj : avg;
    if (base <= 0) return null;
    const ph = p.game_phase;
    const frac = ph === 'finished' ? 1 : (ph === 'not_started' ? 0 : Math.max(0, Math.min(1, num(p.elapsed_frac))));
    const live = num(p.live_fpts), expNow = base * frac;
    return { src: proj > 0 ? 'proj' : 'avg', base, frac, expNow, delta: live - expNow, est: live + base * (1 - frac) };
  }
  /** The same for a lineup: summed over its players that can be measured;
   *  src 'proj' when any player carries your projection. */
  function lineupPace(players) {
    let expNow = 0, est = 0, live = 0, any = false, proj = false;
    for (const p of (players || [])) {
      const k = pace(p);
      live += num(p.live_fpts);
      if (!k) { est += num(p.live_fpts); continue; }
      any = true; if (k.src === 'proj') proj = true;
      expNow += k.expNow; est += k.est;
    }
    if (!any) return null;
    return { src: proj ? 'proj' : 'avg', expNow, delta: live - expNow, est };
  }
  /** Your average lineup over the night, from the scoring history frames
   *  ({ t, totals: { lineupId: score } }): [[ms, avg]], oldest first - the
   *  average, never points x lineups. The demo's frames carry seconds into
   *  the replay, not epoch time: `elapsed` says so and ms counts from 0. */
  function avgSeries(lineups, frames) {
    const ids = (lineups || []).map(l => String(l.id));
    const fr = (frames || []).filter(f => f && f.t != null && f.totals);
    if (!ids.length || !fr.length) return { pts: [], elapsed: false };
    const last = fr[fr.length - 1].t;
    const elapsed = typeof last === 'number' && last < 1e9;
    const ms = (t) => (typeof t === 'number' ? (elapsed ? t * 1000 : t) : Date.parse(t));
    const pts = [];
    for (const f of fr) {
      let sum = 0, n = 0;
      for (const id of ids) if (id in f.totals) { sum += num(f.totals[id]); n++; }
      const t = ms(f.t);
      if (n && isFinite(t)) pts.push([t, sum / n]);
    }
    return { pts, elapsed };
  }
  /** The sport's word for the start of a game: "kick-off" was on the NHL,
   *  NBA and MLB boards too (Broadcast audit v2, SPORT-2 / UX-9). Static
   *  vocabulary, not data. */
  const START = { nba: 'tip-off', wnba: 'tip-off', cbb: 'tip-off', nhl: 'puck drop', mlb: 'first pitch' };
  const startWord = (sport) => START[String(sport || '').toLowerCase()] || 'kick-off';
  /** "First tip-off", "First puck drop" - MLB's is just "First pitch". */
  const firstStart = (sport) => { const w = startWord(sport); return w === 'first pitch' ? 'First pitch' : 'First ' + w; };
  /** Bonus Watch, grouped by bonus (Xav 2026-10-12: "categorise per bonus
   *  type, not all thrown together"). rows: [{group, title, sub, state:
   *  'chase'|'banked'|'missed', togo, have, ...}] -> [{key, title, sub, rows,
   *  chasing, banked, missed}] - each group's chases closest first, then
   *  banked, then missed; groups with a live chase first, the nearest chase
   *  leading. Pure (tested). */
  const bonusGroups = (rows) => {
    const by = new Map();
    for (const r of rows || []) {
      let g = by.get(r.group);
      if (!g) { g = { key: r.group, title: r.title, sub: r.sub || '', rows: [], chasing: 0, banked: 0, missed: 0 }; by.set(r.group, g); }
      g.rows.push(r);
      g[r.state === 'banked' ? 'banked' : r.state === 'missed' ? 'missed' : 'chasing'] += 1;
    }
    const rank = (r) => (r.state === 'chase' ? 0 : r.state === 'banked' ? 1 : 2);
    const out = [...by.values()];
    for (const g of out) g.rows.sort((a, b) => (rank(a) - rank(b)) || (a.togo - b.togo) || (b.have - a.have));
    const lead = (g) => (g.chasing ? g.rows[0].togo / Math.max(1, g.rows[0].at || 1) : 9 + (g.banked ? 0 : 1));
    return out.sort((a, b) => lead(a) - lead(b));
  };
  /** The groups as one list, the first row of each carrying its group as
   *  `head` (the template draws the header inside that row, so fitting never
   *  leaves a header with no row under it). */
  const bonusFlat = (rows) => bonusGroups(rows).flatMap(g => g.rows.map((r, i) => ({ ...r, head: i === 0 ? g : null })));
  /** "3 chasing · 1 banked" over every group. */
  const bonusCounts = (rows) => {
    const n = { chase: 0, banked: 0, missed: 0 };
    for (const r of rows || []) n[r.state] = (n[r.state] || 0) + 1;
    return [[n.chase, 'chasing'], [n.banked, 'banked'], [n.missed, 'missed']].filter(x => x[0]).map(x => x[0] + ' ' + x[1]).join(' · ');
  };
  return { num, pid, isDst, short, full, andList, nameOf, toMs, niceAxis, inLineups, pts, lastName, pace, lineupPace, avgSeries, startWord, firstStart, bonusGroups, bonusFlat, bonusCounts };
})();

/* ==== static/js/widgets/director_scenes.js ==== */
;
/* widgets/director_scenes.js — the Director's brain (Xav 2026-09-30:
 * "it has to surprise the user, it can't be too predictable and repetitive").
 *
 * Pure functions, no DOM, no Alpine: `scenes(ctx, mem)` lists every story the
 * night can tell right now, `decide(cur, cands, mem, now, rnd)` picks what is
 * on stage. static/js/widgets/director.js builds `ctx` from the dashboard and
 * runs both on a 1s tick. tests/js/director_scenes.test.js drives them in Node.
 *
 * THREE TIERS
 *   breaking  cuts in at once, once: your big play, a game going final, a bonus
 *             banked, crossing 80% of the Dream Team, the halfway report, the wrap.
 *   live      holds the stage while it lasts: your batter up, your power play.
 *   story     everything else, rotated like a TV rundown.
 *
 * WHY IT DOES NOT FEEL LIKE A CAROUSEL
 *   - a story is weighted by how much it matters NOW (a 2x-projection night
 *     outranks a 1.3x one; a bonus 1 shot away outranks one 3 away);
 *   - a story already told is heavily discounted until its numbers change
 *     (`sig`) - Sale's line comes back when he adds strikeouts, not before;
 *   - the same KIND never runs twice in a row, and recent kinds are damped;
 *   - the pick is a weighted draw, not an argmax, and time on stage varies;
 *   - headlines have several phrasings, fixed per story so a refresh never
 *     rewrites the words under you;
 *   - the night has phases (pre / early / mid / late / final) and each brings
 *     its own stories: first pitch, the halfway report, the final stretch,
 *     the wrap.
 *
 * Joins are by player id / team id / game id, never by name. */
(function () {
  const MIN_HOLD   = 6000;     // nothing but breaking news cuts a scene younger than this
  const FRESH_MS   = 90000;    // a Moment is news for 90s
  const FINAL_MS   = 180000;   // a game that just went final is news for 3 min

  // Gold is for winners only - the Dream Team, the podium, a decided result,
  // the player of the night (Xav 2026-10-06). Your big plays, bonuses and
  // chases are yours: green.
  // ── small helpers ──────────────────────────────────────────────────────
  // shared helpers (model_util.js) - this file kept its own copies (audit run 3, CODE-12)
  const { num, pid, pts, lastName: last } = window.LSModelUtil;
  const plural = (n, one, many) => n + ' ' + (n === 1 ? one : (many || one + 's'));
  // A stable pick from a list of phrasings: same story, same words.
  const hash = (s) => { let h = 0; for (const ch of String(s)) h = (h * 31 + ch.charCodeAt(0)) | 0; return Math.abs(h); };
  const vary = (key, list) => list[hash(key) % list.length];
  // Name the players, never "Volpe + 1" (Xav): one, two or three by name,
  // four or more as a count - "Four of yours".
  const WORDS = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten'];
  const names = (ps) => {
    const n = ps.map(x => last((x.p || x).name));      // a player, or one of own()'s {p, n}
    return n.length <= 1 ? (n[0] || '') : n.slice(0, -1).join(', ') + ' and ' + n[n.length - 1];
  };
  const crew = (ps, tail) => (ps.length >= 4 ? (WORDS[ps.length] || ps.length) + ' of yours' : names(ps)) + tail;
  /* The podium's stat menu, per sport: the live stat key and how to say it.
     Static display vocabulary (like the scoring labels), not data - a new stat
     is a code change anyway, because something has to say what it means. */
  const hits = (st) => num(st.single) + num(st.double) + num(st.triple) + num(st.hr);
  const SPORT_STATS = {
    mlb: [{ id: 'hr', label: 'home runs', bats: true }, { id: 'hits', label: 'hits', bats: true, get: hits },
          { id: 'rbi', label: 'RBI', bats: true }, { id: 'r', label: 'runs scored', bats: true },
          { id: 'tb', label: 'total bases', bats: true }, { id: 'sb', label: 'stolen bases', bats: true },
          { id: 'so', label: 'strikeouts', arms: true }],
    nhl: [{ id: 'goal', label: 'goals' }, { id: 'assist', label: 'assists' }, { id: 'sog', label: 'shots on goal' },
          { id: 'blk', label: 'blocked shots' }, { id: 'hits', label: 'hits' }, { id: 'save', label: 'saves', keeper: true }],
    nfl: [{ id: 'pass_yds', label: 'passing yards' }, { id: 'rush_yds', label: 'rushing yards' },
          { id: 'rec_yds', label: 'receiving yards' }, { id: 'rec', label: 'catches' }],
    nba: [{ id: 'pts', label: 'points' }, { id: 'reb', label: 'rebounds' }, { id: 'ast', label: 'assists' },
          { id: 'stl', label: 'steals' }, { id: 'blk', label: 'blocks' }],
  };
  SPORT_STATS.cfb = SPORT_STATS.nfl;
  SPORT_STATS.wnba = SPORT_STATS.cbb = SPORT_STATS.euroleague = SPORT_STATS.nba;
  /* Xav: "if you say '4 players coming up' and then only show 3" - a count in
     a headline must match what is on screen. A list shows everyone it can
     (up to `cap`); when it has to cut, its label SAYS so ("Top 4 of 6"). */
  const ROSTER_CAP = 8, STRIP_CAP = 4;
  const cutLabel = (label, shown, all, where) => (shown < all ? 'Top ' + shown + ' of ' + all + (where || '') : label);
  // a player's own position - never a lineup slot (FLEX / UTIL / CPT ...)
  const realPos = (p) => { const v = String((p && p.pos) || '').toUpperCase(); return /^(FLEX|UTIL|CPT|MVP|STAR|PRO|SUPERFLEX|SFLEX|G\/F|F\/C)$/.test(v) || !v ? '' : v; };
  const isPitcher = (p) => ['SP', 'RP', 'P'].includes(String(p.pos || '').toUpperCase());
  const isKey = (e) => e && (e.event_type === 'big_play' || e.event_type === 'achievement');
  const BASKETBALL = new Set(['nba', 'wnba']);
  const PERIODS = { mlb: 9, nhl: 3, nfl: 4, cfb: 4, nba: 4, wnba: 4, cbb: 2, soccer: 2 };

  // ── what I own ─────────────────────────────────────────────────────────
  function own(ctx) {
    const m = new Map();
    for (const lu of (ctx.lineups || [])) {
      const seen = new Set();
      for (const p of (lu.players || [])) {
        const k = pid(p);
        if (!k || seen.has(k)) continue;
        seen.add(k);
        const e = m.get(k);
        if (e) e.n += 1; else m.set(k, { p, n: 1 });
      }
    }
    return m;
  }
  function gameOf(ctx, p) {
    return (ctx.games || []).find(g => String(g.game_id) === String(p.game_id)) || null;
  }
  function plate(g) {
    return { a: g.away_team, h: g.home_team, as: g.away_score ?? 0, hs: g.home_score ?? 0,
             ac: g.away_primary || '#2a3440', hc: g.home_primary || '#2a3440',
             state: String(g.status_text || '').trim() };
  }
  function diamond(ls) {
    if (!ls || (ls.balls == null && ls.outs == null && !ls.bases)) return { bases: null, outs: null };
    const b = ls.bases || {};
    return { bases: { first: !!b.first, second: !!b.second, third: !!b.third },
             balls: ls.balls || 0, strikes: ls.strikes || 0, outs: ls.outs || 0 };
  }
  function bestLineup(ctx) {
    let best = null;
    for (const lu of (ctx.lineups || [])) if (!best || num(lu.live_total) > num(best.live_total)) best = lu;
    return best;
  }
  const luName = (ctx, lu) => (lu && lu.lineup_name) || ((ctx.lineups || []).length > 1 ? 'Your best lineup' : 'Your lineup');

  /* How far through the night: finals count 1, a live game its period share. */
  function progress(ctx) {
    const games = ctx.games || [];
    if (!games.length) return { frac: 0, live: 0, final: 0, pre: 0, total: 0 };
    let done = 0, live = 0, final = 0, pre = 0;
    const per = PERIODS[ctx.sport] || 4;
    for (const g of games) {
      const st = ctx.eff(g);
      if (st === 3) { done += 1; final += 1; }
      else if (st === 2) { live += 1; done += Math.min(0.95, Math.max(0.05, (num(g.period) || 1) / per - 0.5 / per)); }
      else pre += 1;
    }
    return { frac: done / games.length, live, final, pre, total: games.length };
  }
  function phase(ctx) {
    const pr = progress(ctx);
    if (!pr.total || (!pr.live && !pr.final)) return 'pre';
    if (!pr.live && !pr.pre) return 'final';
    if (pr.frac < 0.2) return 'early';
    if (pr.frac > 0.7 || (pr.live + pr.pre) <= 1) return 'late';
    return 'mid';
  }

  /* A small race chart: my best lineup against the Dream Team, from the
     server's score history ({t, totals: {lineup_id}, dream}). */
  function race(ctx, lu) {
    const fr = (ctx.history || []).filter(f => f && f.t);
    if (fr.length < 2) return null;
    const mine = lu ? fr.map(f => num((f.totals || {})[lu.id])) : null;
    const dream = fr.map(f => (f.dream == null ? null : num(f.dream)));
    const vals = [...(mine || []), ...dream.filter(v => v != null)];
    const max = Math.max(1, ...vals);
    const W = 320, H = 120, n = fr.length;
    const xy = (v, i) => [(i / (n - 1)) * W, H - 4 - (v / max) * (H - 12)];
    const path = (arr) => arr.map((v, i) => (v == null ? null : xy(v, i))).filter(Boolean)
      .map((q, i) => (i ? 'L' : 'M') + q[0].toFixed(1) + ' ' + q[1].toFixed(1)).join(' ');
    const m = mine ? path(mine) : '';
    return { mine: m, area: m ? m + ' L' + W + ' ' + H + ' L0 ' + H + ' Z' : '', dream: path(dream) };
  }
  /* Points my best lineup scored in the last `mins` minutes, from the same log. */
  function recent(ctx, lu, mins, now) {
    const fr = (ctx.history || []).filter(f => f && f.t);
    if (!lu || fr.length < 2) return null;
    const cut = now - mins * 60000;
    const at = (f) => new Date(f.t).getTime();
    let before = null;
    for (const f of fr) { if (at(f) <= cut) before = f; else break; }
    if (!before) return null;                     // the log does not reach back that far
    const lastF = fr[fr.length - 1];
    let lastMove = null;                          // when this lineup last scored
    for (let i = fr.length - 1; i > 0; i--) {
      if (num((fr[i].totals || {})[lu.id]) !== num((fr[i - 1].totals || {})[lu.id])) { lastMove = at(fr[i]); break; }
    }
    return { delta: num((lastF.totals || {})[lu.id]) - num((before.totals || {})[lu.id]), lastMove };
  }

  // ── the scenes ─────────────────────────────────────────────────────────
  function scenes(ctx, mem) {
    const now = ctx.now;
    const mine = own(ctx);
    const total = (ctx.lineups || []).length;
    const spectator = total === 0;
    const games = ctx.games || [];
    const live = games.filter(g => ctx.eff(g) === 2);
    const ph = phase(ctx);
    const best = bestLineup(ctx);
    const stakeN = (n) => (spectator || !n ? ''
      : total === 1 ? 'In your lineup'
      : n === total ? 'In all ' + total + ' of your lineups'
      : 'In ' + n + ' of your ' + total + ' lineups');
    const mineIn = (g) => [...mine.values()].filter(x => String(x.p.game_id) === String(g.game_id));
    const stakeIn = (g) => (ctx.lineups || []).filter(lu => (lu.players || []).some(p => String(p.game_id) === String(g.game_id))).length;
    // Players named in the last few cuts: a story that CAN name someone else, does.
    const lately = new Set((mem.subj || []).slice(0, 4).flat());
    const freshFirst = (a, b) => (lately.has(pid(a.p)) ? 1 : 0) - (lately.has(pid(b.p)) ? 1 : 0);
    const out = [];
    const push = (c) => out.push(Object.assign({ facts: [], worth: [], stake: '', tone: 'green', bases: null, outs: null }, c));

    // Remember what the feed already held when the page opened: not news.
    const seen = mem.seen || (mem.seen = {});
    for (const e of (ctx.stream || [])) {
      if (isKey(e) && seen[e.id] == null) seen[e.id] = mem.primed ? now : 0;
    }
    const finals = mem.finals || (mem.finals = {});
    for (const g of games) {
      if (ctx.eff(g) === 3 && finals[g.game_id] == null) finals[g.game_id] = mem.primed ? now : 0;
    }

    // ── BREAKING ───────────────────────────────────────────────────────
    // A Moment by one of mine (anyone's, for a spectator).
    for (const e of (ctx.stream || [])) {
      if (!isKey(e)) continue;
      const first = seen[e.id];
      if (!first || now - first > FRESH_MS) continue;
      const o = mine.get(String(e._pid || e.player_id || ''));
      if (!spectator && !o) continue;
      const n = o ? o.n : 0, g = games.find(x => String(x.game_id) === String(e.game_id));
      const gs = e.game_state;
      push({
        key: 'm:' + e.id, kind: 'moment', tier: 'breaking', subjects: [String(e._pid || e.player_id || '')], weight: 1 + num(e.fpts) / 100, dwell: 25000,
        tag: e.label || 'Big play', tone: 'green', stake: stakeN(n),
        headline: e.name || 'Big play',
        // the feed's play text without its parentheticals: "19 Yd pass from
        // Matt Ryan (Matt Bryant Kick)" read as raw data (audit run 3, PREM-4)
        facts: [e.desc && e.desc !== e.label ? String(e.desc).replace(/\s*\([^)]*\)/g, '').trim() : '', e.gameTime || ''].filter(Boolean),
        game: g ? plate(g) : (gs ? { a: gs.a, h: gs.h, as: gs.as, hs: gs.hs, ac: '#2a3440', hc: '#2a3440', state: gs.inn || '' } : null),
        worthLabel: 'What it did for you',
        worth: [
          { what: 'This play', pts: pts(e.fpts, true), sub: n ? 'per lineup' : '', tone: 'green' },
          // How many lineups it lands in - never the play's points multiplied by them
          // (Xav: with 150 lineups that "sum" means nothing).
          n > 1 ? { what: 'In your lineups', pts: n + ' of ' + total, sub: 'lineups', tone: 'green' } : null,
          e.total != null ? { what: 'Night so far', pts: pts(e.total), sub: last(e.name) + ' · live FPts', tone: 'ink' } : null,
        ].filter(Boolean),
        sig: e.id,
      });
    }

    // A game of mine just went final: what it gave me.
    for (const g of games) {
      const at = finals[g.game_id];
      if (at == null || ctx.eff(g) !== 3) continue;
      const here = mineIn(g);
      if (!spectator && !here.length) continue;
      const fresh = at > 0 && now - at <= FINAL_MS;      // final before I opened = a recap, never news
        const top = [...here].sort((a, b) => num(b.p.live_fpts) - num(a.p.live_fpts))[0];
      const pl = plate(g);
      const winner = num(pl.as) === num(pl.hs) ? '' : (num(pl.as) > num(pl.hs) ? pl.a : pl.h);
      push({
        key: 'f:' + g.game_id, kind: 'final', tier: fresh ? 'breaking' : 'story', weight: fresh ? 0.9 : 0.22, dwell: 18000,
        tag: 'Final', tone: 'green', stake: here.length ? plural(here.length, 'of yours', 'of yours') + ' played in it' : '',
        headline: here.length
          ? vary('f' + g.game_id, [pl.a + '–' + pl.h + ' is in the books', 'That one is over', winner ? winner + ' win it' : 'All square at the end'])
          : pl.a + ' at ' + pl.h + ', final',
        game: Object.assign(pl, { state: 'Final' }),
        facts: top ? [last(top.p.name) + ' led your players there with ' + pts(top.p.live_fpts)] : [],
        worthLabel: here.length ? 'What it gave you' : '',
        worth: here.length ? [
          // How many of your lineups rode on it - never a sum of players from
          // different lineups, a figure no lineup scored (audit run 1, NUM-2).
          { what: 'Your lineups in it', pts: stakeIn(g) + ' of ' + total, sub: plural(here.length, 'player') + ' of yours', tone: 'green' },
          ...here.sort((a, b) => num(b.p.live_fpts) - num(a.p.live_fpts)).slice(0, 2)
            .map(y => ({ what: y.p.name, pts: pts(y.p.live_fpts), sub: 'in ' + plural(y.n, 'lineup'), tone: 'ink' })),
        ] : [],
        sig: 'final',
      });
    }

    // Crossing 80% of the Dream Team: the rough "you might be cashing" line.
    if (!spectator && best && num(ctx.dreamScore) > 0 && ph !== 'pre') {
      const pct = num(best.live_total) / num(ctx.dreamScore) * 100;
      const was = mem.dreamPct;
      mem.dreamPct = pct;
      if (was != null && was < 80 && pct >= 80) mem.dreamCross = now;
      if (mem.dreamCross && now - mem.dreamCross < 120000 && pct >= 80) {
        push({
          key: 'x:dream80', kind: 'cross', tier: 'breaking', weight: 0.85, dwell: 18000,
          tag: 'Near perfect', tone: 'green', stake: 'A rough guide, not contest standings',
          alts: ['Into the cash zone', 'Now we are talking', luName(ctx, best) + ' is flying'],
          stat: { value: Math.round(pct) + '%', label: 'of the Dream Team', sub: pts(best.live_total) + ' of ' + pts(ctx.dreamScore) },
          worthLabel: 'Where you stand',
          worth: [{ what: luName(ctx, best), pts: pts(best.live_total), sub: 'live', tone: 'green' },
                  { what: 'Dream Team', pts: pts(ctx.dreamScore), sub: 'the perfect lineup', tone: 'ink' }],
          sig: 'x',
        });
      }
    }

    // A bonus banked by one of mine (NFL yardage / NHL +3s), while I watch.
    const bank = mem.bank || (mem.bank = {});
    for (const b of bonuses(ctx, mine)) {
      const k = b.key;
      const had = bank[k];
      bank[k] = b.earned ? (had || (mem.primed ? now : -1)) : 0;
      if (b.earned && bank[k] > 0 && now - bank[k] < 120000) {
        push({
          key: 'bk:' + k, kind: 'banked', tier: 'breaking', subjects: [pid(b.p)], weight: 0.8, dwell: 16000,
          tag: 'Bonus banked', tone: 'green', stake: stakeN(b.n),
          alts: [last(b.p.name) + ' cashes the bonus', b.label + ' for ' + last(b.p.name), last(b.p.name) + ' gets there'],
          meter: { have: b.have, at: b.at, label: b.label, pips: b.at <= 6 ? b.at : 0, pct: 100, done: true },
          worthLabel: 'What it did for you',
          worth: [{ what: 'Bonus', pts: pts(b.pts, true), sub: 'per lineup', tone: 'green' },
                  b.n > 1 ? { what: 'In your lineups', pts: b.n + ' of ' + total, sub: 'lineups', tone: 'green' } : null,
                  { what: last(b.p.name) + ' tonight', pts: pts(b.p.live_fpts), sub: 'live FPts', tone: 'ink' }].filter(Boolean),
          sig: 'banked',
        });
      }
    }

    // The halfway report, once - only if I watched the night cross it.
    const frac = progress(ctx).frac, wasFrac = mem.lastFrac;
    mem.lastFrac = frac;
    if (!spectator && best && ph !== 'pre' && wasFrac != null && wasFrac < 0.5 && frac >= 0.5 && !mem.halfDoneAt) mem.halfDoneAt = now;
    if (!spectator && best && mem.halfDoneAt && now - mem.halfDoneAt < 60000) {
      const proj = num(best.proj_total);
      push({
        key: 'half', kind: 'half', tier: 'breaking', weight: 0.75, dwell: 18000,
        tag: 'Halfway', tone: 'green', stake: plural(progress(ctx).final, 'game') + ' final, ' + progress(ctx).live + ' live',
        alts: ['The halfway report', 'Half the night gone', 'Halfway home'],
        stat: proj > 0
          ? { value: Math.round(num(best.live_total) / proj * 100) + '%', label: 'of your projection', sub: pts(best.live_total) + ' of ' + pts(proj) }
          : { value: pts(best.live_total), label: luName(ctx, best), sub: num(ctx.dreamScore) ? 'Dream Team ' + pts(ctx.dreamScore) : '' },
        chart: race(ctx, best),
        worthLabel: 'At the half',
        worth: [{ what: luName(ctx, best), pts: pts(best.live_total), sub: 'live', tone: 'green' },
                num(ctx.dreamScore) ? { what: 'Dream Team', pts: pts(ctx.dreamScore), sub: 'the perfect lineup', tone: 'ink' } : null].filter(Boolean),
        sig: 'half',
      });
    }

    // The wrap: every game final.
    if (ph === 'final' && best) {
      const potn = [...mine.values()].sort((a, b) => num(b.p.live_fpts) - num(a.p.live_fpts))[0];
      push({
        key: 'wrap', kind: 'wrap', tier: mem.wrapShown ? 'story' : 'breaking', weight: 0.6, dwell: 22000,
        // green, not gold: an ending is not a winner (Xav P3; audit run 2, COLOUR-3n)
        // the rail already says every game is final (PREM-2)
        tag: "That's a wrap", tone: 'green', stake: 'The night in review',
        // every alternate is a fact about the night, never filler ("The night
        // in one number", "Lights out" - audit run 3, PREM-4)
        // Every headline is about the LINEUP, as the big number under it is:
        // "Draisaitl was your top scorer" sat over "93.30 · Lineup 2", and over
        // a tile saying the same name again (audit v2 run 3, NUMBERS-8 /
        // PREM-2). The top scorer has the tile to himself.
        alts: [luName(ctx, best) + ' finished on ' + pts(best.live_total),
               luName(ctx, best) + ' won your night',
               num(ctx.dreamScore) ? luName(ctx, best) + ' made ' + Math.round(num(best.live_total) / num(ctx.dreamScore) * 100) + '% of perfect' : luName(ctx, best) + ' won your night'],
        stat: { value: pts(best.live_total), label: luName(ctx, best), sub: num(ctx.dreamScore) ? Math.round(num(best.live_total) / num(ctx.dreamScore) * 100) + '% of the Dream Team' : '' },
        chart: race(ctx, best),
        worthLabel: 'Your night',
        // Only what the ticker's recap under the board does not already say:
        // it carries the Dream Team and the slate's top scorer, and the wrap
        // printed both again (Broadcast audit v2, PREM-2 / NUMBERS-15). Your
        // top scorer stays when he is not the slate's.
        worth: [
          // his name first: in a tight stage the sub-line goes, and "Your top
          // scorer 37.50" was left without a subject (PREM-2)
          // always now: the ticker's recap no longer names the slate's top
          // scorer (closest finish / biggest win), so he is not said twice
          potn ? { what: potn.p.name, pts: pts(potn.p.live_fpts), sub: 'your top scorer', tone: 'gold' } : null,
        ].filter(Boolean),   // "Lineups 5 · played tonight" only repeated the slate header (PREM-4)
        sig: 'wrap',
      });
    }

    // ── LIVE ───────────────────────────────────────────────────────────
    // MLB: one of mine at the plate.
    for (const g of live) {
      const ls = g.live_state || {};
      const who = String(ls.batter_uuid || '');
      if (!who) continue;
      const x = mineIn(g).find(y => pid(y.p) === who);
      if (!x) continue;
      const b = ls.bases || {};
      const on = (b.first ? 1 : 0) + (b.second ? 1 : 0) + (b.third ? 1 : 0);
      const hr = 10 + 2 + 2 * (on + 1);                       // DK: HR 10, R 2, RBI 2 each
      const single = 3 + 2 * ((b.third ? 1 : 0) + (b.second ? 1 : 0));
      const nm = last(x.p.name);
      push({
        key: 'ab:' + g.game_id + ':' + who, kind: 'atbat', tier: 'live', subjects: [who], weight: 0.7 + x.n * 0.05 + on * 0.05,
        tag: on === 3 ? 'Bases loaded' : on ? on + ' on' : 'At bat', tone: 'green', stake: stakeN(x.n),
        headline: on === 3 ? 'Bases loaded for ' + nm : on ? nm + ' up, ' + on + ' on' : nm + ' at the plate',
        game: plate(g), facts: [ls.pitcher ? 'Pitching · ' + ls.pitcher : ''].filter(Boolean),
        worthLabel: 'What this at-bat is worth to you',
        worth: [
          { what: on === 3 ? 'Grand slam' : on ? on + 1 + '-run homer' : 'Solo homer', pts: pts(hr, true), sub: 'per lineup', tone: 'green' },
          { what: 'Single', pts: pts(single, true), sub: on ? 'runners in scoring position score' : 'per lineup', tone: 'green' },
          { what: 'Out', pts: '0.00', sub: '', tone: 'dim' },
        ],
        ...diamond(ls), sig: 'ab',
      });
    }
    // NHL: a power play for a team I have skaters on (side from the server).
    for (const g of live) {
      const ls = g.live_state || {};
      if (!ls.pp_side) continue;
      const tid = ls.pp_side === 'home' ? g.home_team_id : g.away_team_id;
      const up = mineIn(g).filter(y => tid != null && String(y.p.team_id) === String(tid) && !/^G/i.test(String(y.p.pos || '')));
      if (!up.length) continue;
      const team = ls.pp_side === 'home' ? g.home_team : g.away_team;
      const t = [...up].sort((a, b) => b.n - a.n);
      push({
        key: 'pp:' + g.game_id, kind: 'pp', tier: 'live', weight: 0.65 + up.length * 0.03,
        tag: 'Power play · ' + team, tone: 'green', stake: stakeN(Math.max(...up.map(y => y.n))),
        headline: crew(t, ' with the extra man'),
        subjects: t.length <= 3 ? t.map(y => pid(y.p)) : [],
        game: plate(g),
        facts: [ls.pp_secs ? Math.floor(ls.pp_secs / 60) + ':' + String(ls.pp_secs % 60).padStart(2, '0') + ' left' : ''].filter(Boolean),
        worthLabel: cutLabel('Yours on the ice', Math.min(STRIP_CAP, t.length), t.length, ' on the ice'),
        worth: t.slice(0, STRIP_CAP).map(y => ({ what: y.p.name, pts: pts(y.p.live_fpts), sub: 'in ' + plural(y.n, 'lineup'), tone: 'ink' })),
        sig: 'pp',
      });
    }

    // Basketball: crunch time - Q4 or overtime, 5:00 or less, a one- or
    // two-possession game, with yours in it. Holds the stage like an at-bat:
    // this is where a night is won or lost.
    if (BASKETBALL.has(ctx.sport)) {
      for (const g of live) {
        const here = mineIn(g);
        if (!here.length || g.halftime) continue;
        const per = num(g.period), secs = num(g.clock_secs);
        const margin = Math.abs(num(g.home_score) - num(g.away_score));
        if (per < 4 || secs > 300 || (per === 4 && secs <= 0) || margin > 8) continue;
        const pl = plate(g);
        const clock = Math.floor(secs / 60) + ':' + String(Math.floor(secs % 60)).padStart(2, '0');
        const when = (per > 4 ? (per - 4 > 1 ? 'OT' + (per - 4) : 'OT') : 'Q4') + ' · ' + clock + ' left';
        const shown = here.sort((a, b) => num(b.p.live_fpts) - num(a.p.live_fpts));
        push({
          key: 'clutch:' + g.game_id, kind: 'clutch', tier: 'live', subjects: [],
          weight: 0.6 + (8 - margin) * 0.02 + here.length * 0.03,
          tag: per > 4 ? 'Overtime' : 'Crunch time', tone: 'green', stake: when,
          headline: margin === 0 ? 'All square, ' + clock + ' to go'
            : margin <= 3 ? 'One-possession game'
            : 'Crunch time in ' + pl.a + '–' + pl.h,
          game: pl,
          worthLabel: cutLabel('Yours in it', Math.min(STRIP_CAP, shown.length), shown.length, ' of yours here'),
          worth: shown.slice(0, STRIP_CAP).map(y => ({ what: y.p.name, pts: pts(y.p.live_fpts),
            sub: y.p.is_on_court ? 'on the floor' : 'on the bench', tone: y.p.is_on_court ? 'green' : 'ink' })),
          sig: 'clutch',
        });
      }
    }

    // ── STORIES ────────────────────────────────────────────────────────
    const liveMine = [...mine.values()].filter(x => { const g = gameOf(ctx, x.p); return g && ctx.eff(g) === 2; });
    const playedMine = [...mine.values()].filter(x => { const g = gameOf(ctx, x.p); return g && ctx.eff(g) >= 2; });

    // Each live game with mine in it (any live game for a spectator).
    for (const g of live) {
      const here = mineIn(g);
      const slots = here.reduce((t, y) => t + y.n, 0);
      if (!spectator && !slots) continue;
      const ls = g.live_state || {}, pl = plate(g);
      const named = [...here].sort((a, b) => freshFirst(a, b) || b.n - a.n || num(b.p.live_fpts) - num(a.p.live_fpts));
      const lead = named[0];
      const pre = /pre|warm|delay|sched/i.test(pl.state);
      const deck = ls.on_deck_uuid ? here.find(y => pid(y.p) === String(ls.on_deck_uuid)) : null;
      push({
        key: 'g:' + g.game_id, kind: 'game', tier: 'story',
        weight: 0.22 + (spectator ? 0.1 : Math.min(0.3, slots / Math.max(1, total * 3))) + (deck ? 0.35 : 0) + (ls.red_zone ? 0.3 : 0),
        tag: deck ? 'On deck' : ls.red_zone ? 'Red zone' : spectator ? 'Live' : 'Your game', tone: 'green',
        // the stake says how many LINEUPS ride on it - the headline already
        // counts players; "9 lineup slots" over "six of yours" read as two
        // answers to one question (run 2, UX-4 / PREM-18)
        stake: spectator ? '' : (() => { const k = (ctx.lineups || []).filter(lu => (lu.players || []).some(q => here.some(y => pid(y.p) === pid(q)))).length;
          return 'In ' + k + ' of your ' + plural((ctx.lineups || []).length, 'lineup'); })(),
        headline: spectator || !lead ? pl.a + ' at ' + pl.h
          : deck ? last(deck.p.name) + ' on deck'
          : named.length === 1 ? last(lead.p.name) + (pre ? "'s game starts soon" : "'s game")
          : crew(named, pre ? ', starting soon' : ' in this game'),
        subjects: spectator ? [] : deck ? [pid(deck.p)] : named.length <= 3 ? named.map(y => pid(y.p)) : [],
        onDeck: !!deck,
        game: pre ? Object.assign({}, pl, { as: '-', hs: '-' }) : pl,     // DSEG7 has '-', not '–'
        facts: [ls.batter ? 'At bat · ' + ls.batter : '', ls.pitcher ? 'Pitching · ' + ls.pitcher : '',
                ls.down_distance ? ls.down_distance + (ls.yardline ? ' · ' + ls.yardline : '') : ''].filter(Boolean),
        worthLabel: spectator ? '' : cutLabel('Your players in this game', Math.min(STRIP_CAP, here.length), here.length, ' of yours here'),
        worth: here.sort((a, b) => num(b.p.live_fpts) - num(a.p.live_fpts)).slice(0, STRIP_CAP)
          .map(y => ({ what: y.p.name, pts: pts(y.p.live_fpts), sub: 'in ' + plural(y.n, 'lineup'), tone: 'ink' })),
        ...(pre ? {} : diamond(ls)),
        sig: pl.as + '-' + pl.hs + ':' + (deck ? 'd' : ''),
      });
    }

    // My night against the Dream Team - the rough "am I cashing?" read.
    if (!spectator && best && num(ctx.dreamScore) > 0 && ph !== 'pre') {
      const pct = num(best.live_total) / num(ctx.dreamScore) * 100;
      const band = pct >= 90 ? 'hot' : pct >= 80 ? 'zone' : pct >= 60 ? 'close' : 'chase';
      push({
        key: 'dream', kind: 'dream', tier: 'story', weight: 0.4 + (band === 'hot' ? 0.25 : band === 'zone' ? 0.15 : 0),
        tag: 'You vs perfect', tone: 'green',
        stake: 'A rough guide, not contest standings',
        alts: {
          hot:   ['Chasing perfection', luName(ctx, best) + ' is nearly perfect', 'This is a special night'],
          // no "cash zone": the board has no contest standings to say so (PREM beyond-8)
          zone:  ['Close to perfect', 'Looking good tonight', luName(ctx, best) + ' is right there'],
          close: ['Within touching distance', 'Still in this', 'Work to do, but close'],
          chase: ['The chase is on', 'Plenty of night left', 'Needs a big finish'],
        }[band],
        stat: { value: Math.round(pct) + '%', label: 'of the Dream Team', sub: '' },
        chart: race(ctx, best),
        worthLabel: 'The gap',
        worth: [{ what: luName(ctx, best), pts: pts(best.live_total), sub: 'live', tone: 'green' },
                { what: 'Dream Team', pts: pts(ctx.dreamScore), sub: 'the perfect lineup', tone: 'ink' },
                { what: 'Behind', pts: pts(Math.max(0, num(ctx.dreamScore) - num(best.live_total))), sub: 'to perfect', tone: 'dim' }],
        sig: Math.round(pct / 5),
      });
    }

    // The one that got away: the Dream Team's best player I don't have.
    if (!spectator && ph !== 'pre') {
      const dt = (ctx.dream || []).filter(p => pid(p) && !mine.has(pid(p)) && num(p.live_fpts) > 0)
        .sort((a, b) => num(b.live_fpts) - num(a.live_fpts));
      const x = dt[0];
      if (x) {
        const vpk = num(x.salary) > 0 ? num(x.live_fpts) / (num(x.salary) / 1000) : 0;
        push({
          key: 'away:' + pid(x), kind: 'away', tier: 'story', subjects: [pid(x)], weight: 0.3 + Math.min(0.35, num(x.live_fpts) / 80),
          tag: 'Not in your lineups', tone: 'green', stake: 'He is in the Dream Team',
          // past tense once the night is over: "is killing it" on an all-final
          // board (audit run 3, PREM-4)
          alts: ph === 'final'
            ? ['The one that got away', last(x.name) + ' scored ' + pts(x.live_fpts) + ' without you', 'Nobody told you about ' + last(x.name)]
            : ['The one that got away', last(x.name) + ' is killing it without you', 'Nobody told you about ' + last(x.name)],
          // his position, not the Dream Team slot he fills: "L. Karlsson ·
          // VAN · FLEX" read as a position nobody plays (Xav 2026-10-10)
          facts: [x.name + (x.team ? ' · ' + x.team : '') + (realPos(x) ? ' · ' + realPos(x) : '')],
          stat: { value: pts(x.live_fpts), label: 'points, none of them yours', sub: '' },
          worthLabel: 'What he is doing',
          worth: [vpk ? { what: 'Value', pts: vpk.toFixed(2), sub: 'pts/$1K', tone: 'ink' } : null,
                  num(x.salary) ? { what: 'Salary', pts: '$' + (num(x.salary) / 1000).toFixed(1) + 'K', sub: 'on this slate', tone: 'dim' } : null].filter(Boolean),
          sig: Math.round(num(x.live_fpts) / 3),
        });
      }
    }

    // Hot and cold: mine against projection (needs a projection to mean it).
    const judged = playedMine.filter(x => num(x.p.proj) > 0 && (x.p.status === 'hot' || x.p.status === 'cold'));
    for (const x of judged.sort((a, b) => Math.abs(num(b.p.live_fpts) / num(b.p.proj) - 1) - Math.abs(num(a.p.live_fpts) / num(a.p.proj) - 1)).slice(0, 2)) {
      const p = x.p, hot = p.status === 'hot', ratio = num(p.live_fpts) / num(p.proj);
      const est = num(p.est_final) && num(p.est_final) !== num(p.proj) ? num(p.est_final) : 0;
      push({
        key: (hot ? 'hot:' : 'cold:') + pid(p), kind: hot ? 'hot' : 'cold', tier: 'story', subjects: [pid(p)],
        weight: 0.35 + Math.min(0.35, Math.abs(ratio - 1) * 0.3) + x.n * 0.02,
        tag: hot ? 'Heating up' : 'Gone cold', tone: hot ? 'green' : 'blue', stake: stakeN(x.n),
        alts: hot
          ? [last(p.name) + ' is on fire', last(p.name) + ' cannot miss', 'Somebody stop ' + last(p.name)]
          : [last(p.name) + ' has gone quiet', 'Where is ' + last(p.name) + '?', last(p.name) + ' needs to wake up'],
        facts: [p.name + (p.team ? ' · ' + p.team : ''), p.game_status_text || ''].filter(Boolean),
        stat: hot ? { value: ratio.toFixed(1) + 'x', label: 'his projection', sub: '' }
                  : { value: Math.round(ratio * 100) + '%', label: 'of his projection', sub: '' },
        worthLabel: 'Against his projection',
        worth: [{ what: 'Live', pts: pts(p.live_fpts), sub: 'FPts', tone: hot ? 'green' : 'ink' },
                { what: 'Projected', pts: pts(p.proj), sub: 'for the night', tone: 'dim' },
                est ? { what: 'On pace for', pts: pts(est), sub: 'at this rate', tone: hot ? 'green' : 'ink' } : null].filter(Boolean),
        sig: Math.round(ratio * 4),
      });
    }

    const shown = mem.shown || {};
    const facet = (key, list) => list[(hash(key) + (shown[key] || 0)) % list.length];

    // THE PODIUMS (Xav: "on each stat, talk about the guys in 2nd and 3rd -
    // very varied"). Every stat worth ranking - fantasy points, value, share of
    // your best lineup, reach across lineups, against projection, and the
    // sport's own (home runs, shots, yards...) - ranks your players, and ANY of
    // the top three can be the story: the leader, the one chasing him, the one
    // sneaking onto the podium. Weighted down as a family so a podium is one
    // flavour of the night, not all of it.
    if (!spectator && ph !== 'pre') {
      const menu = [
        { id: 'fp', label: 'fantasy points', get: (x) => num(x.p.live_fpts), fmt: (v) => pts(v), w: 0.30 },
        { id: 'value', label: 'value per $1K', get: (x) => (num(x.p.salary) > 0 ? num(x.p.live_fpts) / (num(x.p.salary) / 1000) : null), fmt: (v) => v.toFixed(2), w: 0.28 },
        { id: 'proj', label: 'beating projection', get: (x) => (num(x.p.proj) > 0 ? num(x.p.live_fpts) / num(x.p.proj) : null), fmt: (v) => v.toFixed(1) + 'x', w: 0.26 },
        best && num(best.live_total) > 0 ? { id: 'share', label: 'share of ' + luName(ctx, best) + "'s points", w: 0.24,
          get: (x) => ((best.players || []).some(q => pid(q) === pid(x.p)) ? num(x.p.live_fpts) / num(best.live_total) * 100 : null),
          fmt: (v) => Math.round(v) + '%' } : null,
        ...(SPORT_STATS[ctx.sport] || []).map(d => ({ id: d.id, label: d.label, w: 0.26, count: true,
          get: (x) => {
            if (d.bats && isPitcher(x.p)) return null;
            if (d.arms && !isPitcher(x.p)) return null;
            const st = x.p.stats || {};
            return d.get ? d.get(st) : (st[d.id] == null ? null : num(st[d.id]));
          },
          fmt: (v) => String(Math.round(v)) })),
      ].filter(Boolean);
      const boards = [];
      for (const m of menu) {
        const ranked = playedMine.map(x => ({ x, v: m.get(x) })).filter(r => r.v != null && r.v > 0)
          .sort((a, b) => b.v - a.v).slice(0, 3);
        if (ranked.length >= 2) boards.push({ m, ranked });
      }
      const damp = Math.min(1, 5 / Math.max(1, boards.length * 2));   // the podium family's share of the night
      for (const { m, ranked } of boards) {
        ranked.forEach((r, i) => {
          const A = last(ranked[0].x.p.name), me = last(r.x.p.name), up = ranked[i - 1], down = ranked[i + 1];
          const gapUp = up ? up.v - r.v : 0, gapDown = down ? r.v - down.v : 0;
          push({
            key: 'pod:' + m.id + ':' + pid(r.x.p), kind: 'podium', tier: 'story', subjects: [pid(r.x.p)],
            weight: (m.w - i * 0.04 + (i === 0 && gapDown > 0 && gapDown < r.v * 0.1 ? 0.08 : 0)) * damp,   // a tight race at the top is a better story
            tag: i === 0 ? 'Top of the podium' : i === 1 ? 'Second place' : 'Third place',
            tone: i === 0 ? 'gold' : 'green',
            stake: 'Your players, ranked by ' + m.label,
            alts: i === 0 ? [me + ' leads on ' + m.label, 'Nobody tops ' + me + ' on ' + m.label, me + ' out in front on ' + m.label]
                : i === 1 ? [me + ' chasing ' + A + ' on ' + m.label, me + ' second on ' + m.label, A + ' and ' + me + ', the ' + m.label + ' race']
                :           [me + ' sneaks onto the ' + m.label + ' podium', me + ' third on ' + m.label, me + ' rounds out the ' + m.label + ' top three'],
            facts: [r.x.p.name + (r.x.p.team ? ' · ' + r.x.p.team : ''), r.x.p.game_status_text || ''].filter(Boolean),
            podium: { label: m.label, rows: ranked.map((q, j) => {
              // ties share a place, "T1" (NUMBERS-9)
              const f = m.fmt(q.v), at = ranked.findIndex(o => m.fmt(o.v) === f), tied = ranked.filter(o => m.fmt(o.v) === f).length > 1;
              return { rank: j + 1, place: (tied ? 'T' : '') + (at + 1), name: q.x.p.name, value: f, focus: j === i };
            }) },
            worthLabel: 'The race',
            worth: [
              up ? { what: 'Behind ' + last(up.x.p.name), pts: m.fmt(gapUp), sub: m.label, tone: 'ink' } : null,
              down ? { what: 'Ahead of ' + last(down.x.p.name), pts: m.fmt(gapDown), sub: m.label, tone: i === 0 ? 'gold' : 'green' } : null,
              m.id !== 'fp' ? { what: me + ' tonight', pts: pts(r.x.p.live_fpts), sub: 'fantasy points', tone: 'ink' } : null,
            ].filter(Boolean),
            sig: ranked.map(q => pid(q.x.p) + '=' + m.fmt(q.v)).join(','),
          });
        });
      }
    }

    // MLB: my pitcher's night, while he is out there (or just done).
    if (ctx.sport === 'mlb') {
      const arms = playedMine.filter(x => isPitcher(x.p) && num((x.p.stats || {}).ip) > 0)
        .sort((a, b) => (b.p.oncourt ? 1 : 0) - (a.p.oncourt ? 1 : 0) || num(b.p.live_fpts) - num(a.p.live_fpts));
      arms.slice(0, 3).forEach((x, r) => {
        const p = x.p, st = p.stats || {}, k = num(st.so), ip = num(st.ip);
        const f = facet('arm:' + pid(p), [{ value: String(k), label: 'strikeouts' }, { value: pts(p.live_fpts), label: 'live FPts' },
                                         { value: String(ip), label: 'innings pitched' }]);
        push({
          key: 'arm:' + pid(p), kind: 'arm', tier: 'story', subjects: [pid(p)],
          weight: 0.35 - r * 0.08 + (p.oncourt ? 0.15 : 0) + Math.min(0.25, k * 0.025),
          stat: { value: f.value, label: f.label, sub: '' },
          tag: p.oncourt ? 'On the mound' : 'His line', tone: 'green', stake: stakeN(x.n),
          alts: [last(p.name) + ': ' + k + ' K through ' + ip, last(p.name) + ' is dealing', k + ' strikeouts for ' + last(p.name)],
          game: gameOf(ctx, p) ? plate(gameOf(ctx, p)) : null,
          facts: [plural(num(st.er), 'earned run'), plural(num(st.h), 'hit'), num(st.bb) ? plural(num(st.bb), 'walk') : ''].filter(Boolean),
          worthLabel: 'His night',
          worth: [{ what: 'Live', pts: pts(p.live_fpts), sub: 'FPts', tone: 'green' },
                  { what: 'Strikeouts', pts: String(k), sub: 'tonight', tone: 'green' },
                  { what: 'Innings', pts: String(ip), sub: st.quality_start ? 'quality start' : 'pitched', tone: 'ink' }],
          sig: k + ':' + ip,
        });
      });
    }

    // Bonus chases: a +3 you can feel coming.
    for (const b of bonuses(ctx, mine)) {
      if (b.earned || !b.live) continue;
      const frac = b.have / b.at;
      if (frac < 0.5) continue;
      push({
        key: 'bo:' + b.key, kind: 'bonus', tier: 'story', subjects: [pid(b.p)], weight: 0.35 + frac * 0.4,
        tag: 'Bonus watch', tone: 'green', stake: stakeN(b.n),
        alts: [last(b.p.name) + ', ' + b.togo + ' ' + b.unit + ' from ' + pts(b.pts, true),
                                      b.togo + ' more for ' + last(b.p.name), last(b.p.name) + ' is closing in'],
        meter: { have: b.have, at: b.at, label: b.label, pips: b.at <= 6 ? b.at : 0, pct: Math.min(100, frac * 100), done: false },
        worthLabel: 'What it is worth',
        worth: [{ what: b.label, pts: pts(b.pts, true), sub: 'per lineup', tone: 'green' },
                b.n > 1 ? { what: 'In your lineups', pts: b.n + ' of ' + total, sub: 'lineups', tone: 'green' } : null,
                { what: 'To go', pts: String(b.togo), sub: b.unit, tone: 'ink' }].filter(Boolean),
        sig: b.have,
      });
    }

    // Momentum: what the last 15 minutes did (or did not do).
    if (!spectator && best && live.length) {
      const r = recent(ctx, best, 15, now);
      if (r && r.delta >= Math.max(5, num(best.live_total) * 0.08)) {
        push({
          key: 'mo:run', kind: 'momentum', tier: 'story', weight: 0.4 + Math.min(0.3, r.delta / 60),
          tag: 'Momentum', tone: 'green', stake: luName(ctx, best),
          alts: [pts(r.delta, true) + ' in 15 minutes', 'You are on a run', 'The points are pouring in'],
          stat: { value: pts(r.delta, true), label: 'in the last 15 minutes', sub: 'now ' + pts(best.live_total) },
          chart: race(ctx, best),
          worthLabel: 'The run', worth: [{ what: luName(ctx, best), pts: pts(best.live_total), sub: 'live', tone: 'green' }],
          sig: Math.round(r.delta / 3),
        });
      } else if (r && r.lastMove && now - r.lastMove > 25 * 60000) {
        const mins = Math.round((now - r.lastMove) / 60000);
        push({
          key: 'mo:dry', kind: 'momentum', tier: 'story', weight: 0.25,
          tag: 'Quiet spell', tone: 'blue', stake: luName(ctx, best),
          alts: ['Nothing for ' + mins + ' minutes', 'A quiet spell', 'Waiting for the next one'],
          stat: { value: mins + 'm', label: 'since your last points', sub: 'now ' + pts(best.live_total) },
          chart: race(ctx, best),
          worthLabel: '', worth: [],
          sig: Math.round(mins / 10),
        });
      }
    }

    // Basketball: MINUTES. In the NBA minutes are points, and two things take
    // them away. Foul trouble (six is out): a story at 4 fouls (3 in the first
    // half), BREAKING the moment a 5th lands or he fouls out while I watch.
    // A blowout (starters sit when a game is decided, whichever side leads):
    // a story with my players in that game and their minutes.
    if (BASKETBALL.has(ctx.sport) && !spectator) {
      mem.pf = mem.pf || {};
      mem.pfAt = mem.pfAt || {};
      for (const x of liveMine) {
        const p = x.p, id = pid(p), pf = num((p.stats || {}).pf), g = gameOf(ctx, p) || {};
        const was = mem.pf[id];
        mem.pf[id] = pf;
        if (mem.primed && was != null && ((was < 5 && pf >= 5) || (was < 6 && pf >= 6))) mem.pfAt[id] = now;
        const per = num(g.period);
        if (!(pf >= 4 || (pf >= 3 && per <= 2 && !g.halftime))) continue;
        const nm = last(p.name);
        const fresh = mem.pfAt[id] && now - mem.pfAt[id] < 90000;
        push({
          key: 'pf:' + id + ':' + Math.min(pf, 6), kind: 'fouls', tier: fresh ? 'breaking' : 'story', subjects: [id],
          weight: fresh ? 0.9 : 0.32 + (pf - 3) * 0.08 + x.n * 0.02, dwell: 16000,
          tag: pf >= 6 ? 'Fouled out' : 'Foul trouble', tone: 'blue', stake: stakeN(x.n),
          alts: pf >= 6 ? [nm + ' has fouled out', 'Six fouls: ' + nm + ' is done', nm + ' is out of the game']
              : pf >= 5 ? [nm + ': five fouls, one from out', 'One more and ' + nm + ' is done', nm + ' on the edge']
              : [nm + ' in foul trouble', nm + ' picks up foul ' + pf, nm + ' has to be careful now'],
          facts: [p.name + (p.team ? ' · ' + p.team : ''), g.status_text || ''].filter(Boolean),
          stat: { value: String(pf), label: 'personal fouls', sub: pf >= 6 ? 'out of the game' : 'six and he is out' },
          worthLabel: 'His night so far',
          worth: [{ what: 'Live', pts: pts(p.live_fpts), sub: 'FPts', tone: 'ink' },
                  { what: 'Minutes', pts: String(Math.round(num((p.stats || {}).min))), sub: 'played', tone: 'dim' }],
          sig: pf,
        });
      }
      for (const g of live) {
        const here = mineIn(g);
        if (!here.length) continue;
        const per = num(g.period), secs = num(g.clock_secs);
        const margin = Math.abs(num(g.home_score) - num(g.away_score));
        if (!((per >= 4 && margin >= 20) || (per === 3 && secs <= 360 && margin >= 25))) continue;
        const pl = plate(g);
        const shown = [...here].sort((a, b) => num(b.p.live_fpts) - num(a.p.live_fpts));
        push({
          key: 'blowout:' + g.game_id, kind: 'blowout', tier: 'story', subjects: [],
          weight: 0.42 + Math.min(0.15, (margin - 20) * 0.01) + here.length * 0.02,
          tag: 'Blowout', tone: 'blue', stake: 'Starters usually sit in a decided game',
          alts: ['Blowout in ' + pl.a + '–' + pl.h, margin + ' points in it: the starters may sit', 'Garbage time looms in ' + pl.a + '–' + pl.h],
          game: pl,
          worthLabel: cutLabel('Yours in it', Math.min(STRIP_CAP, shown.length), shown.length, ' of yours here'),
          worth: shown.slice(0, STRIP_CAP).map(y => ({ what: y.p.name, pts: pts(y.p.live_fpts),
            sub: Math.round(num((y.p.stats || {}).min)) + ' min', tone: 'ink' })),
          sig: Math.floor(margin / 5) + ':' + per,
        });
      }
    }

    // Basketball: who is on the floor right now. The headline's count is the
    // roster's length - the board lists every one of them.
    if (BASKETBALL.has(ctx.sport) && !spectator) {
      const floor = liveMine.filter(x => x.p.is_on_court)
        .sort((a, b) => num(b.p.live_fpts) - num(a.p.live_fpts));
      if (floor.length >= 2) push({
        key: 'floor', kind: 'floor', tier: 'story', subjects: floor.length <= 3 ? floor.map(x => pid(x.p)) : [],
        weight: 0.26 + Math.min(0.2, floor.length * 0.03),
        tag: 'On the floor', tone: 'green', stake: plural(liveMine.length, 'of yours') + ' in live games',
        alts: [crew(floor, ' on the floor'), crew(floor, floor.length === 1 ? ' is out there' : ' are out there'),
               (WORDS[floor.length] || floor.length) + ' of yours playing right now'],
        roster: { label: cutLabel('On the floor now', Math.min(ROSTER_CAP, floor.length), floor.length),
                  rows: floor.slice(0, ROSTER_CAP).map(x => ({ name: x.p.name, value: pts(x.p.live_fpts),
                    sub: (gameOf(ctx, x.p) || {}).status_text || '' })) },
        worthLabel: '', worth: [],
        sig: floor.map(x => pid(x.p)).join(','),
      });
    }

    // Still to play: late in the night, who the rest rides on.
    const waiting = [...mine.values()].filter(x => { const g = gameOf(ctx, x.p); return g && ctx.eff(g) !== 3; });
    if (!spectator && (ph === 'late' || ph === 'mid') && waiting.length && playedMine.length) {
      const w = [...waiting].sort((a, b) => b.n - a.n || num(b.p.proj) - num(a.p.proj));
      const notYet = w.filter(y => { const g = gameOf(ctx, y.p); return g && ctx.eff(g) === 1; }).length;
      push({
        key: 'rest', kind: 'rest', tier: 'story', subjects: waiting.length === 1 ? [pid(waiting[0].p)] : [], weight: ph === 'late' ? 0.55 : 0.2,
        tag: ph === 'late' ? 'Final stretch' : 'Still to come', tone: 'green',
        stake: best ? luName(ctx, best) + ' · ' + pts(best.live_total) + ' so far' : '',
        roster: { label: cutLabel('Still to finish', Math.min(ROSTER_CAP, w.length), w.length),
                  rows: w.slice(0, ROSTER_CAP).map(y => { const g = gameOf(ctx, y.p);
                    return { name: y.p.name, value: pts(y.p.live_fpts),
                             sub: g ? (ctx.eff(g) === 2 ? (g.status_text || 'Live') : 'Not started') : '' }; }) },
        alts: waiting.length === 1
          ? ['It all rides on ' + last(w[0].p.name), last(w[0].p.name) + ' is your last hope', 'One left: ' + last(w[0].p.name)]
          : ['Your night rides on ' + waiting.length, waiting.length + ' still out there', 'It comes down to ' + waiting.length],
        worthLabel: 'Still in play',
        worth: [notYet ? { what: 'Not started yet', pts: String(notYet), sub: 'of them', tone: 'ink' } : null,
                best ? { what: luName(ctx, best), pts: pts(best.live_total), sub: 'so far', tone: 'green' } : null].filter(Boolean),
        sig: waiting.length,
      });
    }

    // ── PRE-GAME ───────────────────────────────────────────────────────
    if (ph === 'pre') {
      const up = games.filter(g => ctx.eff(g) === 1 && g.game_time_utc)
        .map(g => ({ g, t: new Date(g.game_time_utc).getTime() })).filter(x => !isNaN(x.t)).sort((a, b) => a.t - b.t);
      if (up.length) {
        const ms = up[0].t - now, h = Math.floor(ms / 3600000), m = Math.max(0, Math.floor((ms % 3600000) / 60000));
        const when = ms <= 60000 ? 'any moment' : h >= 24
          ? new Date(up[0].t).toLocaleString([], { weekday: 'short', hour: '2-digit', minute: '2-digit' })
          : (h ? h + 'h ' + m + 'm' : m + 'm');
        const top = [...mine.values()].sort((a, b) => b.n - a.n).slice(0, 3);
        push({
          key: 'pre', kind: 'pre', tier: 'story', weight: 0.5,
          tag: 'Up next', tone: 'green', stake: plural(up.length, 'game') + ' to come',
          headline: 'First game in ' + when,
          game: Object.assign(plate(up[0].g), { as: '-', hs: '-', state: new Date(up[0].t).toLocaleString([], { weekday: 'short', hour: '2-digit', minute: '2-digit' }) }),   // the day: a midnight start read "00:00" like an expired clock (LIVE-15)
          worthLabel: top.length ? 'Your night rides on' : '',
          worth: top.map(y => ({ what: y.p.name, pts: String(y.n), sub: 'of your lineups', tone: 'ink' })),
          sig: 'pre',
        });
        // The first game's players of mine.
        const first = mineIn(up[0].g);
        if (first.length) push({
          key: 'pre:first', kind: 'prefirst', tier: 'story', weight: 0.35,
          tag: 'First up', tone: 'green', stake: 'Starts in ' + when,
          alts: [crew(first, first.length === 1 ? ' opens your night' : ' open your night'), 'First up: ' + crew(first, '')],
          game: Object.assign(plate(up[0].g), { as: '-', hs: '-', state: 'Next' }),
          roster: { label: cutLabel('Yours in the first game', Math.min(ROSTER_CAP, first.length), first.length),
                    rows: first.slice(0, ROSTER_CAP).map(y => ({ name: y.p.name, value: String(y.n), sub: plural(y.n, 'lineup') })) },
          worthLabel: '', worth: [],
          sig: 'pf',
        });
      }
      // The team I lean on most (a stack), by team id.
      const teams = new Map();
      for (const x of mine.values()) {
        const k = x.p.team_id != null ? String(x.p.team_id) : '';
        if (!k) continue;
        const e = teams.get(k) || { team: x.p.team || '', slots: 0, players: [] };
        e.slots += x.n; e.players.push(x); teams.set(k, e);
      }
      const stack = [...teams.values()].sort((a, b) => b.slots - a.slots)[0];
      if (stack && stack.players.length >= 3) push({
        key: 'pre:stack', kind: 'prestack', tier: 'story', weight: 0.3 + stack.players.length * 0.03,
        tag: 'Your stack', tone: 'green', stake: plural(stack.slots, 'lineup slot') + ' on one team',
        alts: [stack.players.length + ' ' + stack.team + ' bats in your night', 'All in on ' + stack.team, 'Leaning on ' + stack.team],
        roster: { label: cutLabel('The stack', Math.min(ROSTER_CAP, stack.players.length), stack.players.length),
                  rows: stack.players.sort((a, b) => b.n - a.n).slice(0, ROSTER_CAP).map(y => ({ name: y.p.name, value: String(y.n), sub: plural(y.n, 'lineup') })) },
        worthLabel: '', worth: [],
        sig: 'st',
      });
    }

    // A spectator's stories: the slate itself.
    if (spectator && ph !== 'pre') {
      const top = (ctx.slatePlayers || []).filter(p => num(p.live_fpts) > 0).sort((a, b) => num(b.live_fpts) - num(a.live_fpts))[0];
      if (top) push({
        key: 'slate:top:' + pid(top), kind: 'lead', tier: 'story', weight: 0.4,
        tag: 'Top of the slate', tone: 'gold',
        // past tense once every game is over (audit v2 run 3, LIVE-2)
        alts: ph === 'final' ? [last(top.name) + ' topped the slate', 'Nobody caught ' + last(top.name)]
                             : [last(top.name) + ' leads the slate', 'Nobody is catching ' + last(top.name)],
        facts: [top.name + (top.team ? ' · ' + top.team : '')],
        worthLabel: 'His night', worth: [{ what: 'Live', pts: pts(top.live_fpts), sub: 'FPts', tone: 'gold' }],
        sig: Math.round(num(top.live_fpts) / 3),
      });
      if (num(ctx.dreamScore) > 0) push({
        key: 'slate:dream', kind: 'dream', tier: 'story', weight: 0.35,
        tag: 'The perfect lineup', tone: 'green',
        headline: 'The Dream Team: ' + pts(ctx.dreamScore),
        stat: { value: pts(ctx.dreamScore), label: ph === 'final' ? 'the perfect lineup' : 'the perfect lineup so far', sub: '' },
        chart: race(ctx, null),
        worthLabel: 'Its best', worth: (ctx.dream || []).slice().sort((a, b) => num(b.live_fpts) - num(a.live_fpts)).slice(0, 3)
          .map(p => ({ what: p.name, pts: pts(p.live_fpts), sub: p.role || '', tone: 'ink' })),
        sig: Math.round(num(ctx.dreamScore) / 5),
      });
    }

    // Words: the same story told again comes back in different words.
    for (const c of out) if (c.alts && c.alts.length) c.headline = c.alts[(hash(c.key) + (shown[c.key] || 0)) % c.alts.length];
    mem.primed = true;
    // Every game final: the wrap, and only the wrap, on every sport - the
    // stage kept cutting to bonus and "nobody told you" scenes, so NBA / NHL
    // never read as finished (Broadcast audit v2 run 2, PREM-3 / UX-3).
    if (ph === 'final') { const w = out.filter(c => c.key === 'wrap' || c.kind === 'final'); if (w.some(c => c.key === 'wrap')) return w; }
    // ...and with no lineup there is no wrap: the slate's own night - its top
    // scorer and the perfect lineup - not one game's final picked at random
    // over an empty stage (audit v2 run 3, UX-2)
    if (ph === 'final' && spectator) { const s = out.filter(c => String(c.key).startsWith('slate:')); if (s.length) return s; }
    return out;
  }

  /* Bonus chases for my players: NHL from the slate's own +3 rules (LSNhl),
     NFL from the yardage-bonus rules when the platform pays them. */
  function bonuses(ctx, mine) {
    const out = [];
    // Basketball doubles: 10+ in two (double-double) or three (triple-double)
    // of pts/reb/ast/stl/blk. A chase is only a story when ONE category is
    // missing (the meter can say "2 rebounds"); the Double Watch panel covers
    // the rest. Priced from the slate's rules: FanDuel pays none, so nothing.
    if (BASKETBALL.has(ctx.sport)) {
      let dd = 0, td = 0;
      for (const grp of Object.values(ctx.rules || {})) {
        if (grp && typeof grp === 'object') { dd = dd || num(grp.dd_bonus); td = td || num(grp.td_bonus); }
      }
      const CATS = [['pts', 'points'], ['reb', 'rebounds'], ['ast', 'assists'], ['stl', 'steals'], ['blk', 'blocks']];
      for (const x of mine.values()) {
        const g = gameOf(ctx, x.p), liveG = !!g && ctx.eff(g) === 2, st = x.p.stats || {};
        const line = CATS.map(([k, long]) => ({ long, v: num(st[k]) })).sort((a, b) => b.v - a.v);
        const tens = line.filter(c => c.v >= 10).length;
        for (const [kind, want, w, label] of [['dd', 2, dd, 'Double-double'], ['td', 3, td, 'Triple-double']]) {
          if (!w) continue;
          const earned = tens >= want;
          const gap = line[want - 1];                     // the category that would complete it
          if (!earned && tens !== want - 1) continue;     // more than one category short: the panel's job
          out.push({ key: pid(x.p) + ':' + kind, p: x.p, n: x.n, label, unit: gap.long,
                     have: earned ? 10 : gap.v, at: 10, togo: earned ? 0 : 10 - gap.v,
                     pts: w, earned, live: liveG });
        }
      }
    }
    if (ctx.sport === 'nhl' && ctx.nhl) {
      const defs = ctx.nhl.bonusDefs(ctx.host);
      for (const x of mine.values()) {
        const g = gameOf(ctx, x.p), liveG = !!g && ctx.eff(g) === 2, goalie = ctx.nhl.isGoalie(x.p);
        for (const d of defs) {
          if ((d.grp === 'goalie') !== goalie) continue;
          const have = ctx.nhl.count(x.p, d.stat), earned = !!(x.p.stats || {})[d.key];
          out.push({ key: pid(x.p) + ':' + d.key, p: x.p, n: x.n, label: d.label, unit: d.label.toLowerCase(),
                     have, at: d.at, togo: Math.max(0, d.at - have), pts: d.pts, earned, live: liveG });
        }
      }
    }
    if (ctx.sport === 'nfl' || ctx.sport === 'cfb') {
      const rules = ctx.rules || {};
      const pay = (k) => { for (const grp of Object.values(rules)) if (grp && grp[k]) return num(grp[k]); return 0; };
      const defs = [{ stat: 'rush_yds', at: 100, flag: 'rush_100_bonus', label: '100 rushing yards' },
                    { stat: 'rec_yds',  at: 100, flag: 'rec_100_bonus',  label: '100 receiving yards' },
                    { stat: 'pass_yds', at: 300, flag: 'pass_300_bonus', label: '300 passing yards' }];
      for (const x of mine.values()) {
        const g = gameOf(ctx, x.p), liveG = !!g && ctx.eff(g) === 2, st = x.p.stats || {};
        for (const d of defs) {
          const w = pay(d.flag);
          if (!w) continue;                              // this platform pays no such bonus
          const have = num(st[d.stat]);
          out.push({ key: pid(x.p) + ':' + d.flag, p: x.p, n: x.n, label: d.label, unit: 'yards',
                     have, at: d.at, togo: Math.max(0, d.at - have), pts: w,
                     // over the line is banked, flag or not - the stage said "0 yards from
                     // +3.00" at 349/300 (audit run 2, NUM-22; Bonus Watch had the fix)
                     earned: !!st[d.flag] || have >= d.at, live: liveG });
        }
      }
    }
    return out;
  }

  // ── the director's cut ─────────────────────────────────────────────────
  /* Returns the scene to put (or keep) on stage. `mem` carries the memory
     between ticks: since, dwell, told (key -> sig last shown), kinds (recent). */
  function decide(cur, cands, mem, now, rnd) {
    rnd = rnd || Math.random;
    mem.told = mem.told || {};
    mem.kinds = mem.kinds || [];
    const byKey = new Map(cands.map(c => [c.key, c]));
    const curC = cur ? byKey.get(cur.key) : null;
    const age = now - (mem.since || 0);
    mem.shown = mem.shown || {};
    mem.subj = mem.subj || [];
    const cut = (c, dwell) => {
      mem.subj = [(c.subjects || []).filter(Boolean), ...mem.subj].slice(0, 6);
      mem.since = now;
      mem.dwell = dwell;
      mem.told[c.key] = c.sig;
      mem.shown[c.key] = c.key in mem.shown ? mem.shown[c.key] + 1 : 0;
      if (c.alts && c.alts.length) c.headline = c.alts[(hash(c.key) + mem.shown[c.key]) % c.alts.length];
      mem.kinds = [c.kind, ...mem.kinds].slice(0, 4);
      if (c.kind === 'wrap') mem.wrapShown = true;
      return c;
    };

    // 1 · breaking news not yet told cuts in (another breaking story waits its turn).
    const news = cands.filter(c => c.tier === 'breaking' && !(c.key in mem.told)).sort((a, b) => b.weight - a.weight)[0];
    if (news && (!curC || curC.tier !== 'breaking' || age >= (mem.dwell || 0))) return cut(news, news.dwell || 18000);
    if (curC && curC.tier === 'breaking' && age < (mem.dwell || 0)) return curC;

    // 2 · a live situation holds the stage while it lasts.
    const live = cands.filter(c => c.tier === 'live').sort((a, b) => b.weight - a.weight)[0];
    if (live) {
      if (curC && curC.key === live.key) return curC;
      if (!curC || curC.tier === 'live' || age >= MIN_HOLD) return cut(live, 0);
      return curC;
    }

    // 3 · a story, until its time is up.
    if (curC && age < (mem.dwell || 0)) return curC;
    let pool = cands.filter(c => c.tier !== 'live' && (!curC || c.key !== curC.key));
    if (!pool.length) return curC || cands[0] || null;
    // No player may headline more than 2 of any 5 stories in a row (Xav:
    // "Sale is dominating this slate, his name is coming up on every slide").
    const times = (id) => mem.subj.slice(0, 4).filter(a => a.includes(id)).length;
    const capped = pool.filter(c => !(c.subjects || []).some(id => times(id) >= 2));
    if (capped.length) pool = capped;
    // ...and never the same kind twice in a row.
    const otherKind = pool.filter(c => c.kind !== mem.kinds[0]);
    if (otherKind.length) pool = otherKind;
    const lastKind = mem.kinds[0];
    const scored = pool.map(c => {
      let s = c.weight;
      // Told already: fades further each retelling with nothing new; told but moved: nearly fresh.
      if (c.key in mem.told) s *= (mem.told[c.key] === c.sig ? 0.12 / (1 + (mem.shown[c.key] || 0)) : 0.75);
      for (const id of (c.subjects || [])) {                                  // named a moment ago: someone else first
        const at = mem.subj.findIndex(a => a.includes(id));
        if (at === 0 || at === 1) s *= 0.08; else if (at >= 2) s *= 0.4;
      }
      if (c.kind === lastKind) s *= 0.15;
      else if (mem.kinds.includes(c.kind)) s *= 0.6;
      s *= 0.75 + rnd() * 0.5;                                                 // the unpredictable part
      return { c, s: Math.max(0.0001, s) };
    }).sort((a, b) => b.s - a.s).slice(0, 5);
    // A weighted draw from the best few, not the single best.
    const sum = scored.reduce((t, x) => t + x.s * x.s, 0);
    let r = rnd() * sum, pick = scored[0].c;
    for (const x of scored) { r -= x.s * x.s; if (r <= 0) { pick = x.c; break; } }
    // Nothing new to say: hold the shot longer, as a director does on a slow stretch.
    const stale = pick.key in mem.told && mem.told[pick.key] === pick.sig;
    return cut(pick, (stale ? 20000 : 12000) + Math.floor(rnd() * (stale ? 10000 : 8000)));
  }

  window.LSDirector = { scenes, decide, phase, progress, own, race, recent, SPORT_STATS, _vary: vary };
})();

/* ==== static/js/widgets/director.js ==== */
;
/* widgets/director.js — The Director (Broadcast board, Xav 2026-09-30).
 *
 * One stage that shows whatever matters most to YOU right now, like a TV
 * director cutting between cameras, instead of several half-empty panels.
 *
 * The brain lives in widgets/director_scenes.js (LSDirector): scenes() lists
 * every story the night can tell right now - your big plays, a game going
 * final, a bonus banked, your batter up, a power play, you against the Dream
 * Team, the one that got away, who is hot and who is cold, your pitcher's
 * line, a bonus chase, your momentum, the final stretch, the wrap - and
 * decide() cuts between them so it never plays like a carousel.
 *
 * This file is the shell: it hands the dashboard to the brain on a 1s tick
 * (never inside a getter: writing state from a getter loops Alpine) and
 * flashes a number when it moves while its scene is on. The template only
 * reads `_cur`.
 *
 * Joins: my players by player id; games by game id; the MLB batter and
 * on-deck hitter by the server-resolved live_state.batter_uuid /
 * on_deck_uuid, never by name. */
(function () {
  const FLASH_MS = 1600;
  const _num = (s) => Number(String(s == null ? '' : s).replace('−', '-').replace(/[^0-9.\-]/g, ''));
  const _isKey = (e) => e && (e.event_type === 'big_play' || e.event_type === 'achievement');
  const { pts: _pts, lastName: _last } = window.LSModelUtil;   // shared (model_util.js; audit run 3, CODE-12)

  window.LSWidgets.register({
    id:          'director',
    slot:        'panel',
    title:       'The Director',
    description: 'One stage showing what matters most to you right now - a big play, your batter up, a bonus chase, your night against the Dream Team - and it keeps cutting all night.',
    help:        'Picks the live situation with the most at stake for your lineups and cuts to a big play the moment one lands. Between the big moments it tells the stories of your night - who is hot, who is cold, the one that got away, your momentum, the final stretch - never in the same order twice. Underneath: the last few big plays by your players.',
    sportScope:  '*',
    minCells:    { w: 6, h: 5 },
    defaultCells:{ w: 8, h: 8 },
    factory:     () => ({
      _cur:   null,      // the scene on stage
      _dwell: 0,         // how long it stays (story scenes; drives the clock bar)
      _flash: {},        // "sceneKey|i" -> { dir, until }
      _mem:   {},        // the brain's memory between ticks
      _t:     null,
      _sig:   '',        // the last scene, serialised

      init()    { this._tick(); this._t = setInterval(() => this._tick(), 1000); },
      destroy() { if (this._t) clearInterval(this._t); },

      _ctx(now) {
        const sl = this.selectedSlate || {};
        return {
          now, host: this,
          sport:        String(sl.sport_id || (sl.sport && sl.sport.id) || '').toLowerCase(),
          lineups:      this.lineupRows || [],
          games:        this.allGames || [],
          eff:          (g) => this.effStatus(g),
          stream:       this.vidiStream || [],
          dream:        this.dreamTeam || [],
          dreamScore:   this.dreamTeamScore || 0,
          history:      this.lineupHistory || [],
          slatePlayers: this.players || [],
          allPlayers:   this.allSlatePlayers || [],   // the whole pool: the slate's top scorer
          rules:        this.scoringRulesByPos || {},
          nhl:          window.LSNhl || null,
        };
      },

      _tick() {
        const D = window.LSDirector;
        if (!D) return;
        const now = Date.now();
        const cands = D.scenes(this._ctx(now), this._mem);
        const prev = this._cur;
        let next = D.decide(prev, cands, this._mem, now);
        if (!next) { this._cur = null; return; }
        // Same scene, fresh numbers: flash the ones that moved.
        if (prev && prev.key === next.key) {
          const fl = { ...this._flash };
          (next.worth || []).forEach((w, i) => {
            const o = (prev.worth || [])[i];
            if (!o || o.what !== w.what) return;
            const a = _num(o.pts), b = _num(w.pts);
            if (!isNaN(a) && !isNaN(b) && a !== b) fl[next.key + '|' + i] = { dir: b > a ? 'up' : 'down', until: now + FLASH_MS };
          });
          this._flash = fl;
        } else {
          this._dwell = this._mem.dwell || 0;
          this._flash = {};
        }
        next = { ...next, worth: (next.worth || []).map((w, i) => {
          const f = this._flash[next.key + '|' + i];
          return f && f.until > now ? { ...w, flash: f.dir } : w;
        }) };
        // an identical tick is not written: Alpine rewrote the stage every
        // second on a finished slate (audit run 2, CODE-21)
        const sig = JSON.stringify(next);
        if (sig === this._sig) return;
        this._sig = sig;
        this._cur = next;
      },

      /* ── underneath the stage ───────────────────────────────────── */
      get _recent() {
        const own = window.LSDirector ? window.LSDirector.own({ lineups: this.lineupRows || [] }) : new Map();
        const mineGame = (this.lineupRows || []).length > 0;
        const cur = this._cur && this._cur.key;
        // a stat correction is not a big play (vidiStream marks them - NUM-9)
        return (this.vidiStream || []).filter(e => _isKey(e) && !e.is_correction && ('m:' + e.id) !== cur
            && (!mineGame || own.has(String(e._pid || e.player_id || ''))))
          .slice(0, 3)
          .map(e => ({ id: e.id, when: e.gameTime || e.localTime || '', what: e.name + ' · ' + (e.label || 'big play').toLowerCase(),
                       pts: _pts(e.fpts, true) }));
      },
      get _next() {
        const own = window.LSDirector ? window.LSDirector.own({ lineups: this.lineupRows || [] }) : new Map();
        if (!own.size) return '';
        for (const g of (this.allGames || [])) {
          if (this.effStatus(g) !== 2) continue;
          const who = String((g.live_state || {}).on_deck_uuid || '');
          if (!who) continue;
          const x = own.get(who);
          if (x && String(x.p.game_id) === String(g.game_id)) return _last(x.p.name) + ' on deck · ' + x.n + ' lineup' + (x.n === 1 ? '' : 's');
        }
        return '';
      },
    }),
  });
})();

/* ==== static/js/widgets/race_model.js ==== */
;
/* widgets/race_model.js — the brain of The Race (Broadcast ▸ My Lineups).
 *
 * Pure: build(ctx) takes the dashboard's lineups, their history, the Dream
 * Team and the Wire, and returns everything the panel draws. No DOM, so the
 * rules are unit-tested (tests/js/race_model.test.js).
 *
 * What it says, in Xav's terms: a headline that names names (never "+ 1"),
 * the lineups as lanes that overtake each other, who is still to play in each,
 * the play that last moved each lineup, and what separates first from second.
 * A count on screen always matches what is shown: when the lanes are capped,
 * the label says "Top N of M".
 *
 * Joins are by player id (player_id, else external_player_id) - never by name. */
window.LSRace = (function () {
  const MAX_LANES = 10;          // lanes drawn; the rest are counted, never hidden silently
  const MOVE_WINDOW_MS = 15 * 60 * 1000;   // "since" for the rank arrows and the lead change
  const SPARK_W = 120, SPARK_H = 28;

  const { num, pid, isDst, full, short, andList, nameOf, toMs } = window.LSModelUtil;   // shared helpers (model_util.js)
  const pts = window.LSModelUtil.pts;   // shared (audit run 3, CODE-12)
  /** short() made unambiguous across a set of players: two of your players
   *  with one surname read "G. Wilson" / "E. Wilson", never "Wilson" twice
   *  (Broadcast audit run 1, NUM-15). Returns a namer for any of them. */
  function namer(list) {
    const ids = new Map();   // short name -> Set of player ids
    for (const p of list || []) {
      const s = short(p);
      if (!ids.has(s)) ids.set(s, new Set());
      ids.get(s).add(pid(p) || String(p.name || ''));
    }
    return (p) => {
      const s = short(p);
      if (isDst(p) || !ids.has(s) || ids.get(s).size < 2) return s;
      const first = String(p.name || '').trim().charAt(0);
      return first ? first.toUpperCase() + '. ' + s : s;
    };
  }
  const phaseOf = (p) => (p.game_phase === 'finished' ? 'done' : p.game_phase === 'playing' ? 'on' : 'wait');
  /** "A and B", "A, B and C" - every name, never "+ 1". */


  /** The history frame nearest to `at` (frames carry t + totals by lineup id). */
  function frameAt(history, at) {
    let best = null, bd = Infinity;
    for (const f of history || []) {
      if (!f || f.t == null || !f.totals) continue;
      const d = Math.abs(toMs(f.t) - at);
      if (d < bd) { bd = d; best = f; }
    }
    return best;
  }

  function ranksOf(totals, ids) {
    const order = ids.filter(id => id in totals).sort((a, b) => num(totals[b]) - num(totals[a]));
    const r = {};
    order.forEach((id, i) => { r[id] = i + 1; });
    return r;
  }

  /** One lineup's line through the night, on a shared y scale so slopes compare. */
  function spark(history, id, yMax) {
    const pts_ = (history || []).filter(f => f && f.totals && id in f.totals && f.t != null)
      .map(f => [toMs(f.t), num(f.totals[id])]);
    if (pts_.length < 2 || yMax <= 0) return '';
    const t0 = pts_[0][0], t1 = pts_[pts_.length - 1][0], span = Math.max(1, t1 - t0);
    return pts_.map(([t, v], i) => (i ? 'L' : 'M')
      + ((t - t0) / span * SPARK_W).toFixed(1) + ',' + (SPARK_H - v / yMax * SPARK_H).toFixed(1)).join(' ');
  }

  function build(ctx) {
    const now = num(ctx.now) || Date.now();
    const fmt = typeof ctx.fmt === 'function' ? ctx.fmt : (v) => pts(v);
    const all = (ctx.lineups || []).map((lu, i) => {
      // pace against your projections, else the DK average (model_util.lineupPace)
      const pc = window.LSModelUtil.lineupPace(lu.players);
      return { lu, i, id: String(lu.id), name: nameOf(lu, i), live: num(lu.live_total),
               est: pc ? pc.est : num(lu.est_total), pace: pc };
    });
    const total = all.length;
    if (!total) return { empty: true, headline: '', sub: '', lanes: [], label: '', core: null, dream: null, scale: 1 };

    // Ties keep the order the lineups arrived in, so lanes don't flicker.
    const ranked = [...all].sort((a, b) => (b.live - a.live) || (a.i - b.i));
    ranked.forEach((r, k) => { r.rank = k + 1; });
    // The lanes' ORDER follows the switch (Xav 2026-10-07): Live (points,
    // the default), Pace (furthest ahead of expected first) or Est (highest
    // estimated final). The headline always speaks about the live race.
    const sortBy = ctx.sort === 'pace' || ctx.sort === 'est' ? ctx.sort : 'live';
    const key = (r) => (sortBy === 'pace' ? (r.pace ? r.pace.delta : -Infinity) : sortBy === 'est' ? r.est : r.live);
    const ordered = sortBy === 'live' ? ranked : [...all].sort((a, b) => (key(b) - key(a)) || (b.live - a.live) || (a.i - b.i));
    const pos = new Map(ordered.map((r, k) => [r.id, k + 1]));
    // ctx.max: how many lanes the panel asked for (it grows by MAX_LANES on "show more").
    const shown = ordered.slice(0, Math.max(1, num(ctx.max) || MAX_LANES));
    const ids = all.map(r => r.id);

    // Where everyone stood a while ago: rank arrows and a lead change.
    const history = ctx.history || [];
    const then = frameAt(history, now - MOVE_WINDOW_MS);
    const thenAge = then ? now - toMs(then.t) : 0;
    const usable = then && thenAge >= MOVE_WINDOW_MS / 3;   // a frame from 30s ago is not "a while ago"
    const thenRank = usable ? ranksOf(then.totals, ids) : {};

    // Phases for every player of every lineup.
    const players = (lu) => (lu.players || []);
    const nm = namer(all.flatMap(r => players(r.lu)));
    const phases = { done: 0, on: 0, wait: 0 };
    for (const r of all) for (const p of players(r.lu)) phases[phaseOf(p)] += 1;
    const allWait = phases.on === 0 && phases.done === 0;
    const allDone = phases.on === 0 && phases.wait === 0;

    // The play that last moved each lineup: newest Wire event with points by one of its players.
    // a stat correction is not "the play that last moved" a lineup (NUM-9)
    const stream = (ctx.stream || []).filter(e => e && !e.is_correction && num(e.fpts) !== 0 && (e._pid || e.player_id));
    const lastFor = (lu) => {
      const mine = new Set(players(lu).map(pid));
      const e = stream.find(x => mine.has(String(x._pid || x.player_id)));
      if (!e) return null;
      const p = players(lu).find(x => pid(x) === String(e._pid || e.player_id)) || { name: e.name };
      return { who: nm(p), pts: pts(e.fpts, true), what: String(e.label || '').toLowerCase(), up: num(e.fpts) > 0 };
    };

    // One scale for every lane: the Dream Team (the best anyone could have now),
    // else the leader. Live against live - an estimated FINISH on the same bar
    // made every lane look empty early in the night.
    const dreamScore = num(ctx.dreamScore);
    const top = Math.max(dreamScore, ...all.map(r => r.live), 1);
    const scale = top * 1.04;
    let yMax = 1;
    for (const f of history) for (const v of Object.values((f && f.totals) || {})) yMax = Math.max(yMax, num(v));

    const lead = ranked[0], second = ranked[1] || null;
    const lanes = shown.map(r => {
      const ps = players(r.lu).map(p => ({ id: pid(p), name: nm(p), full: full(p), ph: phaseOf(p), pts: fmt(num(p.live_fpts)), raw: num(p.live_fpts) }));
      // Top scorers first, still-to-play last: in slot order the winning lane
      // hid Lamb 44.30 and Collins 33.80 behind "+6" (audit run 2, NUM-24).
      ps.sort((a, b) => ((a.ph === 'wait') - (b.ph === 'wait')) || (b.raw - a.raw));
      const c = { done: 0, on: 0, wait: 0 };
      ps.forEach(p => { c[p.ph] += 1; });
      const was = thenRank[r.id];
      return {
        id: r.id, rank: pos.get(r.id), name: r.name,
        live: fmt(r.live), est: r.est > r.live + 0.005 ? fmt(r.est) : '',   // an estimate equal to the score says nothing
        // pace: "+18.40" ahead of / behind what it was expected to have by now
        pace: r.pace && (r.pace.expNow > 0 || r.pace.delta !== 0) ? pts(r.pace.delta, true) : '',
        paceUp: r.pace ? r.pace.delta >= 0 : true,
        paceSrc: r.pace ? r.pace.src : '',
        expPct: r.pace && r.pace.expNow > 0 ? Math.min(100, r.pace.expNow / scale * 100) : null,
        behind: r === lead ? '' : '−' + pts(lead.live - r.live),
        livePct: Math.min(100, r.live / scale * 100),
        move: sortBy === 'live' && was ? was - r.rank : 0,   // the arrows are about the live race
        players: ps, count: c,
        state: c.wait === ps.length ? 'To play: all ' + ps.length
          : [c.on ? c.on + ' playing' : '', c.wait ? c.wait + ' to play' : '', c.done ? c.done + ' done' : ''].filter(Boolean).join(' · '),
        last: allDone ? null : lastFor(r.lu),   // the last play is live news; a finished lane has none (LIVE-12)
        spark: spark(history, r.id, yMax),
      };
    });

    // ── the headline: the one thing worth saying about the race ──────────
    let headline, sub = '', tone = 'green';
    const wasLeader = usable ? Object.keys(thenRank).find(id => thenRank[id] === 1) : null;
    const gap = second ? lead.live - second.live : 0;
    // What separates first from second: the players only the leader has, and what they scored.
    let edge = null;
    if (second) {
      const theirs = new Set(players(second.lu).map(pid));
      const only = players(lead.lu).filter(p => !theirs.has(pid(p)) && num(p.live_fpts) > 0)
        .sort((a, b) => num(b.live_fpts) - num(a.live_fpts)).slice(0, 3);
      if (only.length) edge = only.map(p => full(p) + ' ' + pts(p.live_fpts));   // his own points, not a gain (NUMBERS-7)
    }
    if (allWait) {
      headline = total === 1 ? lead.name + ' is on the grid' : (total === 2 ? 'Both' : 'All ' + total) + ' lineups on the grid';
      sub = 'Nobody has played yet. The lanes fill as the games start.';
    } else if (allDone) {
      headline = total === 1 ? lead.name + ' finished on ' + fmt(lead.live) : lead.name + ' won your night';
      // "only in": the leader's own players and their points - not a net
      // swap against the runner-up's picks (audit run 1, NUM-12).
      sub = second ? 'By ' + pts(gap) + ' over ' + second.name + (edge ? ' · only in ' + lead.name + ': ' + andList(edge) : '') : '';
      tone = 'gold';
    } else if (total === 1) {
      headline = lead.name + ' on ' + fmt(lead.live);
      sub = dreamScore > 0 ? Math.round(lead.live / dreamScore * 100) + '% of the Dream Team (' + fmt(dreamScore) + ')' : '';
    } else if (wasLeader && wasLeader !== lead.id) {
      const prev = all.find(r => r.id === wasLeader);
      headline = lead.name + ' takes the lead';
      sub = 'Past ' + (prev ? prev.name : 'the old leader') + (edge ? ' · ' + andList(edge) : '');
      tone = 'gold';
    } else if (gap < 2) {
      headline = lead.name + ' and ' + second.name + ', neck and neck';
      sub = pts(gap) + ' between them' + (edge ? ' · ' + lead.name + ' has ' + andList(edge) : '');
    } else {
      headline = lead.name + ' leads by ' + pts(gap);
      sub = edge ? 'The difference: ' + andList(edge) + ', only in ' + lead.name : 'Over ' + second.name;
    }

    // The core: the players every lineup rides on (or, failing that, the most used).
    const use = new Map();
    for (const r of all) {
      const seen = new Set();
      for (const p of players(r.lu)) {
        const k = pid(p);
        if (!k || seen.has(k)) continue;
        seen.add(k);
        const u = use.get(k);
        if (u) u.n += 1; else use.set(k, { p, n: 1 });
      }
    }
    let core = null;
    if (total > 1) {
      const everyone = [...use.values()].filter(u => u.n === total);
      const pick = everyone.length ? everyone : [...use.values()].filter(u => u.n > 1).sort((a, b) => b.n - a.n);
      const top3 = pick.slice().sort((a, b) => (b.n - a.n) || (num(b.p.live_fpts) - num(a.p.live_fpts))).slice(0, 4);
      if (top3.length) {
        const all_ = everyone.length;
        core = {
          label: all_ ? (top3.length < all_ ? 'Top ' + top3.length + ' of ' + all_ + ' in every lineup' : 'In all ' + total + ' lineups')
            : 'Your most used',
          rows: top3.map(u => ({ id: pid(u.p), name: full(u.p), n: u.n + '/' + total, ph: phaseOf(u.p),
                               pts: phaseOf(u.p) === 'wait' ? 'to play' : fmt(num(u.p.live_fpts)) })),
        };
      }
    }

    return {
      empty: false, tone, headline, sub,
      label: shown.length < total ? 'Top ' + shown.length + ' of ' + total + ' lineups' : (total === 1 ? 'Your lineup' : 'All ' + total + ' lineups'),
      lanes, scale, core, total,
      dream: dreamScore > 0 ? { pts: fmt(dreamScore), pct: Math.min(100, dreamScore / scale * 100) } : null,
      phases,
    };
  }

  return { build, short, namer, MAX_LANES };
})();

/* ==== static/js/widgets/bc_race.js ==== */
;
/* widgets/bc_race.js — The Race (Broadcast ▸ My Lineups, Xav 2026-10-04).
 *
 * Your lineups as lanes that overtake each other through the night: a
 * headline that names who leads and why, each lineup's live score against
 * the Dream Team, who in it is still to play, and the play that last moved
 * it. Click a lane and it opens into that lineup's full player table - the
 * same breakdown My Lineups shows (Xav: "merge the 2"), so this tab needs
 * nothing else.
 *
 * The brain is widgets/race_model.js (LSRace); this shell runs it on a 1s tick
 * (never from a getter - a write inside a getter loops Alpine). Lanes are
 * placed by CSS `order` = rank in a fixed DOM order, and when the order changes
 * each lane slides from where it was (FLIP), whatever height an open lane has. */
(function () {
  const SLIDE_MS = 700;
  // 112: two or three lanes left half a tall panel empty at 84 (audit run 1, SPACE-4).
  const LANE_MAX = 150, LANE_MIN = 58;   // 150: two or three lanes fill more of a tall panel (audit run 2, SPACE-4)

  window.LSWidgets.register({
    id:          'bc_race',
    slot:        'panel',
    title:       'The Race',
    description: 'Your lineups as lanes that overtake each other: who leads and why, who is still to play, and the play that last moved each one. Open a lane for its full player table.',
    help:        'Each lane is one lineup: the bar is its live score, the gold tick the Dream Team. Arrows show places gained or lost in the last 15 minutes. The chips are its players - lit while they play, grey when done, outlined while still to come. Click a lane to open its full player table. The headline names what separates first from second.',
    sportScope:  '*',
    minCells:    { w: 8, h: 5 },
    defaultCells:{ w: 12, h: 8 },
    factory:     () => ({
      _m: null,
      _t: null,
      _open: {},          // lineup id -> true while its table is open
      _userOpened: false, // the viewer opened or closed a lane: the auto-open stands down
      _spare: 0,          // the panel's height left under the lanes
      _max: 10,           // lanes asked of the brain; "show more" adds 10
      _laneH: LANE_MAX,   // one lane's height, fitted to the panel
      _sig: '',           // the last model, serialised (skip identical ticks)
      _focusRank: 1,      // the lane Tab lands on (roving focus by rank)
      // Lane order: 'live' | 'pace' | 'est' (Xav 2026-10-07), remembered on
      // this device like the scoreboard's Cards / Wire
      _laneSort: (function () { try { return localStorage.getItem('ls-race-sort') || 'live'; } catch (_) { return 'live'; } })(),
      setLaneSort(v) {   // not setSort: the open lane's player table uses the host's
        this._laneSort = v; this._sig = '';
        try { localStorage.setItem('ls-race-sort', v); } catch (_) {}
        this._tick();
      },
      _moveFocus(rank, step, el) {
        const lanes = el.closest('.ls-race-lanes');
        const next = lanes && [...lanes.querySelectorAll('.ls-race-lane')].find(x => +x.style.order === rank + step);
        const row = next && next.querySelector('.ls-race-row');
        if (row) { this._focusRank = rank + step; this.$nextTick(() => row.focus()); }
      },

      init() {
        this._tick(); this._t = setInterval(() => this._tick(), 1000);
        // Refit the moment the panel gets its size - showing the tab, a
        // resize - not on the next 1 s tick: the lanes drew at the 150 px
        // ceiling and then snapped to their fitted height a beat later, so
        // the whole tab jumped on every visit (Xav 2026-10-07).
        if (window.ResizeObserver) { this._ro = new ResizeObserver(() => this._fit()); this._ro.observe(this.$el.closest('.ls-cell') || this.$el); }
      },
      destroy() { if (this._t) clearInterval(this._t); if (this._ro) this._ro.disconnect(); },

      _tick() {
        if (!window.LSRace) return;
        const serverHist = this.lineupHistory || [];
        const next = window.LSRace.build({
          now:        Date.now(),
          max:        this._max,
          sort:       this._slateFinal ? 'live' : this._laneSort,   // final: the final order (no toggle then)
          lineups:    this.lineupRows || [],
          history:    serverHist.length >= 2 ? serverHist : (this._lineupHistory || []),
          dreamScore: this.dreamTeamScore || 0,
          stream:     this.vidiStream || [],
          fmt:        (v) => (typeof this._fmtScore === 'function' ? this._fmtScore(v) : (+v || 0).toFixed(2)),
        });
        // Nothing changed since the last tick: keep the model, so Alpine has
        // nothing to rewrite (a finished board rewrote its lanes every second
        // - audit run 2, CODE-21).
        const sig = JSON.stringify(next);
        if (sig === this._sig) { this._fit(); return; }
        this._sig = sig;
        const order = (m) => ((m && m.lanes) || []).map(l => l.id + ':' + l.rank).join('|');
        const moved = this._m && order(this._m) !== order(next);
        const before = moved ? this._laneTops() : null;
        this._m = next;
        this._fit();
        if (before) this.$nextTick(() => this._slide(before));
      },

      /** Each lane's top edge, by lineup id. */
      _laneTops() {
        const out = {};
        (this.$el.querySelectorAll('[data-lane]') || []).forEach(el => { out[el.dataset.lane] = el.getBoundingClientRect().top; });
        return out;
      },
      /** FLIP: start each lane where it was and let it travel to its new place. */
      _slide(before) {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        (this.$el.querySelectorAll('[data-lane]') || []).forEach(el => {
          const was = before[el.dataset.lane];
          if (was == null) return;
          const dy = was - el.getBoundingClientRect().top;
          if (Math.abs(dy) < 1 || !el.animate) return;
          el.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'none' }],
                     { duration: SLIDE_MS, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
        });
      },
      /** Share the panel's height between the lanes, between a floor and a ceiling. */
      _fit() {
        const host = this.$root || this.$el;   // $el is the caller's element under x-init
        const root = host.querySelector('.ls-race-show');
        const top = host.querySelector('.ls-race-top');
        const n = ((this._m && this._m.lanes) || []).length;
        // a hidden tab measures 0: keep the last fit rather than the floor
        if (!root || !top || !n || !root.clientHeight) return;
        const avail = root.clientHeight - top.offsetHeight - 24;
        // slim lanes carry no chips, so they can go shorter before they scroll
        const floor = (typeof this.getOpt === 'function' && this.getOpt('bc_race', 'slim', false)) ? 44 : LANE_MIN;
        const h = Math.max(floor, Math.min(LANE_MAX, Math.floor(avail / n)));
        if (h !== this._laneH) this._laneH = h;
        // Two or three lineups left half the panel empty under their lanes
        // (audit v2 run 3, PREM-3 / FIT-8 / SPACE-3). With room for it, the
        // leader's player table opens there - scrolling inside that room -
        // until the viewer opens or closes a lane himself.
        const spare = Math.max(0, avail - n * h);
        if (spare !== this._spare) this._spare = spare;
        if (!this._userOpened) {
          const lead = this._m.lanes[0] && this._m.lanes[0].id;
          const want = n <= 3 && spare >= 120 && lead != null;
          const now = Object.keys(this._open).filter(k => this._open[k]);
          if (want && !(now.length === 1 && String(now[0]) === String(lead))) this._open = { [lead]: true };
          else if (!want && now.length) this._open = {};
        }
      },

      toggle(id) { this._userOpened = true; this._open = { ...this._open, [id]: !this._open[id] }; },
      isOpen(id) { return !!this._open[id]; },
      showMore() { this._max += 10; this._tick(); },
      /** The lineup row behind a lane (the full players, for its table). */
      _lu(id) { return (this.lineupRows || []).find(x => String(x.id) === String(id)) || { players: [] }; },
    }),
  });
})();

/* ==== static/js/widgets/podium_model.js ==== */
;
/* widgets/podium_model.js — the brain of The Podium (Broadcast ▸ The Podium).
 *
 * Pure: build(ctx) takes the whole slate's players, your lineups and the
 * sport's stat list, and returns what the panel draws - the slate's top three
 * on gold / silver / bronze steps, the chasing pack, and a podium for each of
 * the sport's key stats (Xav: "talk about the guys in 2nd and 3rd"). Every
 * name is named; whose they are is said ("In 3 of your 5").
 *
 * Joins by player id (player_id, else external_player_id). No DOM - tested in
 * tests/js/podium_model.test.js. */
window.LSPodium = (function () {
  const PACK = 3;                 // the chasing pack named under the podium (4th-6th)
  const CATS = 4;                 // stat podiums shown
  const { num, pid, isDst, full, short, andList, nameOf, toMs } = window.LSModelUtil;   // shared helpers (model_util.js)
  const isPitcher = (p) => ['SP', 'RP', 'P'].includes(String(p.pos || '').toUpperCase());
  const ord = (n) => n + (n % 100 >= 11 && n % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' })[n % 10] || 'th');

  function build(ctx) {
    const fmt = typeof ctx.fmt === 'function' ? ctx.fmt : (v) => num(v).toFixed(2);
    const total = (ctx.lineups || []).length;
    // How many of my lineups hold each player.
    const owned = {};
    for (const lu of ctx.lineups || []) {
      const seen = new Set();
      for (const p of lu.players || []) {
        const k = pid(p);
        if (!k || seen.has(k)) continue;
        seen.add(k);
        owned[k] = (owned[k] || 0) + 1;
      }
    }
    const ownLabel = (p) => {
      const n = owned[pid(p)] || 0;
      if (!total) return '';
      if (!n) return 'Not yours';
      return total === 1 ? 'Yours' : 'In ' + n + '/' + total;   // the compact form (NUM-29)
    };

    // One row per player (the pool can list a player twice), best score kept.
    const byId = new Map();
    for (const p of ctx.players || []) {
      const k = pid(p);
      if (!k) continue;
      const cur = byId.get(k);
      if (!cur || num(p.live_fpts) > num(cur.live_fpts)) byId.set(k, p);
    }
    const pool = [...byId.values()];
    const ranked = pool.filter(p => num(p.live_fpts) > 0)
      .sort((a, b) => (num(b.live_fpts) - num(a.live_fpts)) || String(a.name).localeCompare(String(b.name)));

    // A tie is a tie: equal points share a place, shown "T1" - three players
    // on 21.00 were ranked 1, 2, 3 by their names (Broadcast audit v2,
    // NUMBERS-9). `rank` stays the step a row stands on; `place` is said.
    const place = (vals, i) => {
      const v = vals[i], first = vals.indexOf(v), tied = vals.filter(x => x === v).length > 1;
      return (tied ? 'T' : '') + (first + 1);
    };
    const ptsVals = ranked.map(p => num(p.live_fpts).toFixed(2));
    const row = (p, i) => ({
      id: pid(p), rank: i + 1, place: place(ptsVals, i), name: full(p), team: String(p.team || '').toUpperCase(), pos: String(p.pos || ''),
      pts: fmt(num(p.live_fpts)), own: ownLabel(p), mine: !!owned[pid(p)], playing: p.game_phase === 'playing',
    });
    const top = ranked.slice(0, 3).map(row);
    const pack = ranked.slice(3, 3 + PACK).map((p, i) => row(p, i + 3));   // 4th, 5th, 6th - not 1, 2, 3 again

    // ── the headline ─────────────────────────────────────────────────────
    let headline, sub = '', tone = 'gold';
    // the night is over: it topped the slate, it does not top it (audit v2
    // run 3, LIVE-2)
    const tops = ctx.final ? ' topped the slate' : ' tops the slate';
    if (!top.length) {
      headline = 'The podium is waiting';
      sub = 'Nobody on the slate has scored yet.';
      tone = 'green';
    } else if (!total) {
      headline = top[0].name + tops;
      sub = top.length > 1 ? 'Ahead of ' + andList(top.slice(1).map(r => r.name + ' (' + r.pts + ')')) : '';
    } else {
      const mineOnPodium = top.filter(r => r.mine);
      if (top[0].mine) {
        headline = top[0].name + tops;
        sub = 'Yours: ' + (total === 1 ? 'in your lineup' : window.LSModelUtil.inLineups(owned[top[0].id] || 0, total)) + ' · ' + top[0].pts + ' points';
      } else if (mineOnPodium.length) {
        headline = andList(mineOnPodium.map(r => r.name)) + ' on the podium for you';
        sub = top[0].name + (ctx.final ? ' topped the slate with ' : ' leads the slate with ') + top[0].pts + ' - not one of yours';
      } else {
        const best = ranked.findIndex(p => owned[pid(p)]);
        headline = ctx.final ? 'None of yours made the podium' : 'None of yours on the podium';
        sub = best >= 0 ? 'Your best is ' + full(ranked[best]) + ', ' + ord(best + 1) + ' on the slate with ' + fmt(num(ranked[best].live_fpts))
          : 'None of your players has scored yet.';
        tone = 'green';
      }
    }

    // ── a podium for each of the sport's key stats ────────────────────────
    const cats = [];
    for (const d of ctx.stats || []) {
      const vals = pool.map(p => {
        if (d.bats && isPitcher(p)) return null;
        if (d.arms && !isPitcher(p)) return null;
        const st = p.stats || {};
        const v = d.get ? d.get(st) : (st[d.id] == null ? null : num(st[d.id]));
        return v != null && v > 0 ? { p, v } : null;
      }).filter(Boolean).sort((a, b) => (b.v - a.v) || String(a.p.name).localeCompare(String(b.p.name)));
      if (vals.length < 2) continue;
      cats.push({
        id: d.id, label: d.label.charAt(0).toUpperCase() + d.label.slice(1), keeper: !!(d.arms || d.keeper),
        rows: vals.slice(0, 3).map((x, i) => ({ id: pid(x.p), rank: i + 1, place: place(vals.map(y => Math.round(y.v)), i), name: full(x.p), team: String(x.p.team || '').toUpperCase(),
                                                 value: String(Math.round(x.v)), mine: !!owned[pid(x.p)] })),
      });
    }
    // the arms' podium (MLB strikeouts, NHL saves) always has a place: it came
    // last in the list and never showed (audit v2 run 3, SPORT-5)
    const keep = cats.filter(c => c.keeper).slice(0, 1);
    const shown = cats.filter(c => !c.keeper).slice(0, CATS - keep.length).concat(keep);
    cats.length = 0; cats.push(...shown);

    return { empty: !top.length, tone, headline, sub, top, pack, cats, spectator: !total,
             packLabel: ctx.final ? 'Next best' : 'Chasing' };
  }

  return { build };
})();

/* ==== static/js/widgets/bc_podium.js ==== */
;
/* widgets/bc_podium.js — The Podium (Broadcast ▸ The Podium, Xav 2026-10-04).
 *
 * The slate's top three on gold / silver / bronze steps with whose they are,
 * the chasing pack, and a podium for each of the sport's key stats. The brain
 * is widgets/podium_model.js (LSPodium); the stat list is the Director's
 * (LSDirector.SPORT_STATS), so both say the same things the same way.
 * Run on a 1s tick - never from a getter (a write inside a getter loops Alpine). */
(function () {
  window.LSWidgets.register({
    id:          'bc_podium',
    slot:        'panel',
    title:       'The Podium',
    description: "The slate's top three on the podium, who is chasing them, and the top three on each key stat - with which of them are yours.",
    help:        'Gold, silver and bronze are the three best scorers on the whole slate right now, each marked with how many of your lineups hold them. Underneath, the next three. On the right, the top three on each of the sport\'s key stats. Your players are lit.',
    sportScope:  '*',
    minCells:    { w: 8, h: 5 },
    defaultCells:{ w: 12, h: 6 },
    factory:     () => ({
      _m: null,
      _t: null,
      _sig: '',   // the last model, serialised - declared HERE so it is this panel's own; undeclared, Alpine wrote it to the board's root scope and two panels reset each other every tick (audit run 3, CODE-26)
      init()    { this._tick(); this._t = setInterval(() => this._tick(), 1000); },
      destroy() { if (this._t) clearInterval(this._t); },
      _tick() {
        if (!window.LSPodium) return;
        const sl = this.selectedSlate || {};
        const sport = String(sl.sport_id || (sl.sport && sl.sport.id) || '').toLowerCase();
        const D = window.LSDirector;
        const _next = window.LSPodium.build({
          players: this.allSlatePlayers || [],
          lineups: this.activeLineupRows || this.lineupRows || [],
          stats:   (D && D.SPORT_STATS && D.SPORT_STATS[sport]) || [],
          // every game over: the podium is the final one (past tense, no "Chasing")
          final:   !!((this.allGames || []).length && (this.allGames || []).every(g => this.effStatus(g) >= 3)),
          fmt:     (v) => (typeof this._fmtScore === 'function' ? this._fmtScore(v) : (+v || 0).toFixed(2)),
        });
        // identical to the last tick: keep it - Alpine then has nothing to rewrite
        // (a finished board rebuilt this every second - audit run 2, CODE-21)
        { const _s = JSON.stringify(_next); if (_s !== this._sig) { this._sig = _s; this._m = _next; } }
      },
      /** Steps in podium order: silver, gold, bronze. */
      get _steps() {
        const t = (this._m && this._m.top) || [];
        return [t[1], t[0], t[2]].filter(Boolean);
      },
    }),
  });
})();

/* ==== static/js/widgets/squad_model.js ==== */
;
/* widgets/squad_model.js — the brain of Your Players (Broadcast ▸ My Players).
 *
 * Pure: build(ctx) takes your players (one row each, with in_count = how many
 * of your lineups hold them), the Wire and a formatter, and returns your
 * players in three columns - playing now, still to play, done - each card
 * saying how much of your night rides on them, what they have scored, whether
 * they are running hot or cold, and the play that last moved them.
 *
 * Who is "carrying" you weighs points by exposure (10 points in all five
 * lineups outweighs 30 in one), but the sentence only ever shows the player's
 * own points and their lineup count - never the two multiplied. Names, never
 * "+ 1". Joins by player id. No DOM - tests in tests/js/squad_model.test.js. */
window.LSSquad = (function () {
  const { num, pid, isDst, full, short, andList, nameOf, toMs } = window.LSModelUtil;   // shared helpers (model_util.js)
  const phaseOf = (p) => (p.game_phase === 'finished' ? 'done' : p.game_phase === 'playing' ? 'on' : 'wait');
  /** A player who did not play (the server's `dnp`): said in words, not as a
   *  played zero with a pace against his average (v2 run 1, NUMBERS-20). */
  const dnpWord = (p) => (p.dnp === 'dns' ? 'Did not start'
    : (['SP', 'RP', 'P'].some(x => String(p.pos || '').toUpperCase().split('/').includes(x)) ? 'Did not pitch' : 'Did not play'));
  const pts = window.LSModelUtil.pts;   // shared (audit run 3, CODE-12)

  function build(ctx) {
    const fmt = typeof ctx.fmt === 'function' ? ctx.fmt : (v) => num(v).toFixed(2);
    const total = Math.max(0, num(ctx.total));
    const players = (ctx.players || []).filter(p => pid(p));
    if (!players.length) return { empty: true, headline: '', sub: '', cols: [], summary: '' };

    const stream = (ctx.stream || []).filter(e => e && !e.is_correction && num(e.fpts) !== 0 && (e._pid || e.player_id));
    const lastOf = (id) => {
      const e = stream.find(x => String(x._pid || x.player_id) === id);
      return e ? { pts: pts(e.fpts, true), what: String(e.label || '').toLowerCase(), up: num(e.fpts) > 0 } : null;
    };

    // How many lineups hold each player, counted from the lineups themselves
    // when they are given - the same count the Carrying KPI and Top
    // Contributors use. in_count (from the feed) said 1 of 2 where the
    // lineups said 2 of 2 on the demo (Broadcast audit run 2, PREM-4).
    const held = new Map();
    for (const lu of (ctx.lineups || [])) {
      const seen = new Set();
      for (const q of (lu.players || [])) {
        const k = pid(q);
        if (!k || seen.has(k)) continue;
        seen.add(k); held.set(k, (held.get(k) || 0) + 1);
      }
    }
    const cards = players.map(p => {
      const id = pid(p), n = Math.max(1, held.get(id) || num(p.in_count) || 1), live = num(p.live_fpts), proj = num(p.proj);
      const ph = phaseOf(p);
      return {
        id, name: full(p), team: String(p.team || '').toUpperCase(), pos: String(p.pos || ''),
        ph, n, own: total > 1 ? n + '/' + total : '', ownPct: total > 0 ? Math.min(100, n / total * 100) : 100,
        live, pts: fmt(live), weighted: live * n,
        proj: proj > 0 ? fmt(proj) : '',
        form: ph === 'on' && (p.status === 'hot' || p.status === 'cold') ? p.status : '',
        last: ph === 'wait' ? null : lastOf(id),
        // pace (Xav 2026-10-07): ahead / behind what he was expected to have
        // by now - your projection, else his DK average - and his estimate
        ...(() => {
          const k = p.dnp ? null : window.LSModelUtil.pace(p);
          if (!k || ph === 'wait') return { pace: '', paceUp: true, paceSrc: '', paceRaw: null, paceFill: 0, paceTick: 0 };
          // The pace bar: his points against his whole expectation (or his
          // points, once past it), the tick where he was expected to be by now.
          const scale = Math.max(k.base, live) || 1;
          return { pace: pts(k.delta, true), paceUp: k.delta >= 0, paceSrc: k.src, paceRaw: k.delta,
                   paceFill: Math.min(100, Math.max(0, live / scale * 100)), paceTick: Math.min(100, k.expNow / scale * 100) };
        })(),
        // the card: stat line and clock (crest and club colour went 2026-10-07)
        line: ph === 'wait' || p.dnp ? '' : (ctx.lineOf ? ctx.lineOf(p) : ''),
        clock: ph === 'on' ? String((ctx.clockOf && ctx.clockOf(p)) || p.game_status_text || '') : (ph === 'done' ? (p.dnp ? dnpWord(p) : 'Final') : String(p.game_status_text || '')),
      };
    });

    // The order follows the switch (Xav 2026-10-07): Owned (the players your
    // night rides on first - the default), Points or Pace (hottest first,
    // coldest last; not-yet-rated last). Every column, Done included. No Est:
    // a player's estimate is his points plus the rest of his projection - an
    // order by the number you typed in (Xav 2026-10-07).
    const byName = (a, b) => a.name.localeCompare(b.name);
    const cmp = {
      owned:  (a, b) => (b.n - a.n) || (b.live - a.live) || byName(a, b),
      points: (a, b) => (b.live - a.live) || (b.n - a.n) || byName(a, b),
      pace:   (a, b) => ((b.paceRaw === null ? -Infinity : b.paceRaw) - (a.paceRaw === null ? -Infinity : a.paceRaw)) || (b.live - a.live) || byName(a, b),
    };
    const sortBy = cmp[ctx.sort] ? ctx.sort : 'owned';
    const order = cmp[sortBy];
    const on = cards.filter(c => c.ph === 'on').sort(order);
    const wait = cards.filter(c => c.ph === 'wait').sort(order);
    const done = cards.filter(c => c.ph === 'done').sort(order);
    const cols = [
      { id: 'on', label: 'Playing now', cards: on },
      { id: 'wait', label: 'Still to play', cards: wait },
      { id: 'done', label: 'Done', cards: done },
    ];

    // ── the headline: who your night rides on ────────────────────────────
    const lineups = (n) => window.LSModelUtil.inLineups(n, total);
    let headline, sub = '', tone = 'green';
    const scored = cards.filter(c => c.live > 0).sort((a, b) => (b.weighted - a.weighted) || a.name.localeCompare(b.name));
    if (!scored.length) {
      headline = on.length ? 'Your players are on, nobody has scored yet' : 'Nobody of yours has played yet';
    } else {
      const top = scored[0];
      if (total > 1) {
        // past tense once everyone has played (audit run 2, LIVE-7)
        headline = top.name + (on.length || wait.length ? ' is carrying you' : ' carried you');
        // The player's own points and how many lineups hold them - never the
        // points multiplied by the lineups (Xav: with 150 lineups that "sum"
        // would read 5,085). Exposure only decides WHO is named.
        // ...and the basis he was named on: his share of all your lineups'
        // points, the Top Contributors figure - "carried you" beside the
        // Podium's top score read as two answers (audit v2 run 3, UX-4)
        const all = cards.reduce((s, c) => s + (c.weighted > 0 ? c.weighted : 0), 0);
        sub = top.pts + ' points, ' + lineups(top.n) + (all > 0 ? ' · ' + Math.round(top.weighted / all * 100) + '% of your points' : '');
      } else {
        headline = top.name + ' leads your lineup';
        sub = top.pts + ' points';
      }
      // gold once it is decided, like the Race and Paths: a live "is carrying
      // you" in gold beside an ink "leads by" read as two rules (audit run 3, TYPE-18)
      tone = (on.length || wait.length) ? 'green' : 'gold';
    }
    // What is still to come, by exposure: the players most of your night waits on.
    if (wait.length && total > 0) {
      // Every name when they fit; past four, a count led by the biggest names - never "+ 1 more".
      const most = wait[0].n;
      const tier = wait.filter(c => c.n === most);
      const where = total > 1 ? ', ' + lineups(most) : '';
      const tail = tier.length <= 4
        ? 'Still to come: ' + andList(tier.map(c => c.name)) + where
        : 'Still to come: ' + tier.length + ' players' + where + ', led by ' + andList(tier.slice(0, 3).map(c => c.name));
      sub = sub ? sub + ' · ' + tail : tail;
    }

    const summary = [on.length ? on.length + ' playing' : '', wait.length ? wait.length + ' to play' : '', done.length ? done.length + ' done' : '']
      .filter(Boolean).join(' · ');
    // The player the headline names opens his column when nobody chose an
    // order: under "Walker carried you" the cards opened on Smith-Njigba
    // 12.60 (audit v2 run 3, UX-7 / PREM-9)
    if (ctx.pinHero && scored.length) {
      const hero = scored[0];
      for (const c of cols) {
        const i = c.cards.indexOf(hero);
        if (i > 0) { c.cards.splice(i, 1); c.cards.unshift(hero); }
      }
    }
    return { empty: false, tone, headline, sub, cols, summary, count: cards.length };
  }

  return { build };
})();

/* ==== static/js/widgets/bc_squad.js ==== */
;
/* widgets/bc_squad.js — Your Players (Broadcast ▸ My Players, Xav 2026-10-04).
 *
 * Your players in three columns - playing now, still to play, done - each
 * card saying how much of your night rides on them (n of your lineups), what
 * they have scored, hot or cold, and the play that last moved them. The
 * headline names who is carrying you, weighing points by exposure. A Table
 * switch shows the full sortable player table (the same one My Players uses),
 * so this tab needs nothing else - as The Race does for My Lineups.
 * Brain: widgets/squad_model.js (LSSquad). 1s tick, never from a getter. */
(function () {
  window.LSWidgets.register({
    id:          'bc_squad',
    slot:        'panel',
    title:       'Your Players',
    description: 'Your players in three columns - playing now, still to play, done - with how many of your lineups ride on each, and who is carrying you. Switch to the full table any time.',
    help:        'Cards are sorted by how many of your lineups hold the player, then by points. The headline names who is carrying you, weighing points by how many of your lineups hold them, and shows their own points and that count. Hot and cold show while a player is on. Table shows every stat, sortable.',
    sportScope:  '*',
    minCells:    { w: 8, h: 5 },
    defaultCells:{ w: 12, h: 11 },
    factory:     () => ({
      _m: null,
      _t: null,
      _sig: '',   // the last model, serialised - declared HERE so it is this panel's own; undeclared, Alpine wrote it to the board's root scope and two panels reset each other every tick (audit run 3, CODE-26)
      _view: 'board',
      // Card order: 'owned' | 'points' | 'pace' | 'est' (Xav 2026-10-07),
      // remembered on this device
      _cardSort: (function () { try { const v = localStorage.getItem('ls-squad-sort'); return ['owned', 'points', 'pace'].includes(v) ? v : 'owned'; } catch (_) { return 'owned'; } })(),
      // not setSort: the Table view's player_grid calls the host's setSort
      // an order the viewer picked (now or on an earlier visit) is theirs; only
      // the default pins the headline's player first
      _cardSortChosen: (function () { try { return !!localStorage.getItem('ls-squad-sort'); } catch (_) { return false; } })(),
      setCardSort(v) {
        this._cardSort = v; this._sig = ''; this._cardSortChosen = true;
        try { localStorage.setItem('ls-squad-sort', v); } catch (_) {}
        this._tick();
      },
      /** Pace is a live order - a finished game has no pace to sort by, so the
       *  button goes and Pace reads as Points (audit v2 run 3, LIVE-12). */
      get _cardSortNow() { return (this._slateFinal && this._cardSort === 'pace') ? 'points' : this._cardSort; },
      /** Columns to draw: all three while anything can still move between
       *  them, otherwise only the ones holding players (pre-game: Still to
       *  play; final: Done). */
      get _cols() {
        const cols = (this._m && this._m.cols) || [];
        const has = (id) => cols.some(c => c.id === id && c.cards.length);
        // Before kick-off only "Still to play", after the final whistle only
        // "Done". In between an empty column stays only if it can refill:
        // "Done" can, "Still to play" cannot - once everyone has started its
        // narrow strip only took width from Playing now (Xav 2026-10-07).
        const kept = (!has('on') && (!has('wait') || !has('done'))) ? cols.filter(c => c.cards.length)
          : cols.filter(c => c.id !== 'wait' || c.cards.length);
        return kept.length ? kept : cols;
      },
      /** Simple's one screen: a single row, most used first (option `strip`). */
      get _strip() { return typeof this.getOpt === 'function' && !!this.getOpt('bc_squad', 'strip', false); },
      get _stripCards() {
        const own = (c) => parseInt(String(c.own || '0'), 10) || 0;
        const cards = [];
        for (const col of ((this._m && this._m.cols) || [])) cards.push(...col.cards);
        return cards.sort((a, b) => own(b) - own(a) || (parseFloat(b.pts) || 0) - (parseFloat(a.pts) || 0));
      },
      init()    { this._tick(); this._t = setInterval(() => this._tick(), 1000); },
      destroy() { if (this._t) clearInterval(this._t); },
      get _sqSport() { const sl = this.selectedSlate || {}; return String(sl.sport_id || (sl.sport && sl.sport.id) || '').toLowerCase(); },
      _tick() {
        if (!window.LSSquad) return;
        const _next = window.LSSquad.build({
          players: this.players || [],
          total:   (this.activeLineupRows || this.lineupRows || []).length,
          lineups: this.activeLineupRows || this.lineupRows || [],
          stream:  this.vidiStream || [],
          fmt:     (v) => (typeof this._fmtScore === 'function' ? this._fmtScore(v) : (+v || 0).toFixed(2)),
          sort:    this._cardSortNow,
          pinHero: !this._cardSortChosen,
          // the card's stat line (no crest or club colour: Xav 2026-10-07)
          lineOf:  (p) => (window.SportRegistry && window.SportRegistry.statLine ? window.SportRegistry.statLine(this._sqSport, p) : ''),
          // the clock from his GAME: the player rows lose game_status_text to
          // the payload trim, so real slates' "Playing now" cards had none
          // (Broadcast audit v2, LIVE-10). Games joined by game_id.
          clockOf: (p) => { const g = (this.allGames || []).find(x => String(x.game_id) === String(p.game_id)); return g ? String(g.status_text || '') : ''; },
        });
        // identical to the last tick: keep it - Alpine then has nothing to rewrite
        // (a finished board rebuilt this every second - audit run 2, CODE-21)
        { const _s = JSON.stringify(_next); if (_s !== this._sig) { this._sig = _s; this._m = _next; } }
      },
    }),
  });
})();

/* ==== static/js/widgets/lab_takeaways.js ==== */
;
/* widgets/lab_takeaways.js — one line under each chart in The Lab (Broadcast).
 *
 * Xav: "add a one-line takeaway on each one". The Lab's charts are shared with
 * Analytical, so the line only speaks on the Broadcast board (it returns ''
 * anywhere else, and the caption it replaces stays put there).
 *
 * says(id, ctx) is pure - ctx holds lineups, history, dreamScore, now, fmt -
 * and is tested in tests/js/lab_takeaways.test.js. take(id, host) is what the
 * templates call. Every sentence names names; joins are by player id. */
window.LSLab = (function () {
  const { num, pid, isDst, full, short, andList, nameOf, toMs } = window.LSModelUtil;   // shared helpers (model_util.js)
  const last = short;   // the shared last-name helper (audit run 3, CODE-12)
  const WINDOW_MS = 30 * 60 * 1000;

  function says(id, ctx) {
    const fmt = typeof ctx.fmt === 'function' ? ctx.fmt : (v) => num(v).toFixed(2);
    const lus = (ctx.lineups || []).map((lu, i) => ({ lu, name: lu.lineup_name || 'Lineup ' + (i + 1), live: num(lu.live_total) }));
    if (!lus.length) return '';
    const all = [];                      // every lineup slot, so a player in 3 lineups counts 3 times
    lus.forEach(x => (x.lu.players || []).forEach(p => all.push(p)));
    const totalPts = all.reduce((s, p) => s + num(p.live_fpts), 0);
    if (totalPts <= 0) return '';
    const ranked = [...lus].sort((a, b) => b.live - a.live);

    if (id === 'lineup_race') {
      // Who climbed fastest in the last half hour, from the trajectory itself.
      const hist = (ctx.history || []).filter(f => f && f.t != null && f.totals);
      const now = num(ctx.now) || Date.now();
      let then = null, bd = Infinity;
      for (const f of hist) { const d = Math.abs(toMs(f.t) - (now - WINDOW_MS)); if (d < bd) { bd = d; then = f; } }
      // ...only while it is live: a finished night said "in the last 803
      // minutes" (run 2, NUMBERS-12 / LIVE-6) - and its lead is past tense
      // Finished: what the trajectory alone can tell - how often the lead
      // changed hands. The final margin is My Lineups' headline; saying it
      // again here was the same fact on two tabs (audit v2 run 3, NUMBERS-5).
      if (ctx.final) {
        if (ranked.length < 2 || !hist.length) return '';
        const ids = new Set(lus.map(x => String(x.lu.id)));
        let leader = null, changes = 0;
        for (const f of hist.slice().sort((a, b) => toMs(a.t) - toMs(b.t))) {
          let best = null, bv = -Infinity;
          for (const [k, v] of Object.entries(f.totals)) if (ids.has(k) && num(v) > bv) { bv = num(v); best = k; }
          if (best == null || bv <= 0) continue;
          if (leader != null && best !== leader) changes += 1;
          leader = best;
        }
        return changes === 0 ? ranked[0].name + ' led from its first points to the end'
          : 'The lead changed hands ' + changes + (changes === 1 ? ' time' : ' times') + ' before ' + ranked[0].name + ' finished on top';
      }
      if (then && now - toMs(then.t) >= WINDOW_MS / 2) {
        const gains = lus.map(x => ({ x, g: x.live - num(then.totals[String(x.lu.id)]) })).sort((a, b) => b.g - a.g);
        const mins = Math.round((now - toMs(then.t)) / 60000);
        if (gains[0].g > 0) return gains[0].x.name + ' climbed ' + fmt(gains[0].g) + ' in the last ' + mins + ' minutes' + (lus.length > 1 ? ', the fastest of your lineups' : '');
      }
      // Not "% of the Dream Team": the VS DREAM TEAM tile above says it
      // (Xav 2026-10-06, the Lab's strip is drawn now). The lead instead.
      return ranked.length > 1 ? ranked[0].name + ' leads ' + ranked[1].name + ' by ' + fmt(ranked[0].live - ranked[1].live) : '';
    }

    if (id === 'lineup_scores') {
      if (ranked.length === 1) return ranked[0].name + ' on ' + fmt(ranked[0].live);
      const a = ranked[0], b = ranked[1], z = ranked[ranked.length - 1];
      return a.name + (ctx.final ? ' finished ' + fmt(a.live - b.live) + ' ahead of ' + b.name : ' leads ' + b.name + ' by ' + fmt(a.live - b.live))
        + (ranked.length > 2 ? '; ' + fmt(a.live - z.live) + ' from best to worst' : '');
    }

    if (id === 'player_contributions') {
      const by = new Map();
      for (const p of all) {
        const k = pid(p);
        if (!k) continue;
        const e = by.get(k) || { p, pts: 0, n: 0 };
        e.pts += num(p.live_fpts); e.n += 1;
        by.set(k, e);
      }
      // Ranked by what they bring across your lineups (that is the chart), but
      // said as their own points and lineup count - never points x lineups.
      // The top three's share, not the top player's line: the CARRYING tile
      // above names him (Xav 2026-10-06).
      const tops = [...by.values()].sort((a, b) => b.pts - a.pts).slice(0, 3).filter(e => e.pts > 0);
      if (!tops.length) return '';
      const share = Math.round(tops.reduce((t, e) => t + e.pts, 0) / totalPts * 100);
      return (tops.length === 1 ? last(tops[0].p) + ' brings ' : 'Your top ' + (tops.length === 2 ? 'two' : 'three') + ' bring ')
        + share + '% of your points' + (tops.length > 1 ? ': ' + andList(tops.map(e => last(e.p))) : '');
    }

    if (id === 'stack_performance') {
      // Each player once (their own points, no multiplier): a team's players
      // are not worth more for sitting in more lineups. Named, never "+ 1".
      const by = {}, seen = new Set();
      for (const p of all) {
        const t = String(p.team || '').toUpperCase(), k = pid(p);
        if (!t || !k || seen.has(k)) continue;
        seen.add(k);
        const e = by[t] || (by[t] = { pts: 0, who: [] });
        e.pts += num(p.live_fpts) / (num(p.multiplier) || 1);
        e.who.push(p);
      }
      const teams = Object.entries(by).sort((a, b) => b[1].pts - a[1].pts);
      if (!teams.length || teams[0][1].pts <= 0) return '';
      const [team, e] = teams[0];
      const names = e.who.sort((a, b) => num(b.live_fpts) - num(a.live_fpts)).map(last);
      const named = names.length <= 3 ? andList(names) : names.length + ' players, led by ' + andList(names.slice(0, 2));
      // exposure, not a lineup score: each of your players counted once,
      // never times the lineups holding him (Xav 2026-10-06, run-3 NUM-26)
      return fmt(e.pts) + ' points from your ' + team + ' players, each counted once: ' + named
        + (teams[1] && teams[1][1].pts > 0 ? '. Next: ' + teams[1][0] + ' (' + fmt(teams[1][1].pts) + ')' : '');
    }

    if (id === 'score_distribution') {
      // The Ladder (2026-10-16): where your best is heading - the trail the
      // chart draws. Not its % of the Dream now: VS DREAM TEAM says that. A
      // finished night has nowhere left to head, so it says how close the
      // field got instead.
      const best = ranked[0];
      const pc = window.LSModelUtil.lineupPace(best.lu.players || []);
      const est = Math.max(best.live, pc ? pc.est : num(best.lu.est_total));
      const dream = num(ctx.dreamScore);
      if (!ctx.final && est > best.live + 0.005) {
        // the Dream Team is the best lineup on points so far, the heading an
        // end-of-night estimate - a % of one over the other said "173% of the
        // Dream Team", so the two are said side by side instead
        return best.name + ' is heading for ' + fmt(est) + (dream > 0 ? ' - the Dream Team stands at ' + fmt(dream) : '');
      }
      if (dream > 0 && lus.length > 1) {
        const half = lus.filter(x => x.live >= dream / 2).length;
        return half + ' of your ' + lus.length + ' lineups ' + (ctx.final ? 'finished' : 'are') + ' past half the Dream Team';
      }
      return '';
    }

    if (id === 'value_map') {
      const seen = new Set(), vals = [];
      for (const p of all) {
        const k = pid(p), sal = num(p.salary);
        if (!k || seen.has(k) || sal <= 0) continue;
        seen.add(k);
        vals.push({ p, sal, v: num(p.live_fpts) / (sal >= 1000 ? sal / 1000 : sal) });
      }
      const top = vals.sort((a, b) => b.v - a.v)[0];
      if (!top || top.v <= 0) return '';
      const dollars = top.sal >= 1000;
      // The map's own question - how many beat the value lines - not "X is
      // your best value", which The Podium's My Best Value tile already says
      // (Broadcast audit v2, PREM-1 / NUMBERS-15).
      if (id === 'value_map' && dollars) {
        const line = [4, 3, 2].find(x => vals.some(o => o.v >= x)) || 0;
        const n = vals.filter(o => o.v >= line).length;
        if (line) return n + ' of your ' + vals.length + ' players beat ' + line + ' pts/$1K';
        return 'None of your ' + vals.length + ' players reached 2 pts/$1K';
      }
      return full(top.p) + ' is your best value: ' + top.v.toFixed(2) + (dollars ? ' pts/$1K at $' + Math.round(top.sal).toLocaleString('en-US') : ' a price point at ' + top.sal);
    }
    return '';
  }

  /** What a Lab template calls: '' off the Broadcast board. The board is
   *  read off the host (its activeSkin), not the DOM, and a failure says so
   *  once in the console instead of rendering as a silently missing line
   *  (audit run 1, CODE-18). */
  const warned = new Set();
  function take(id, host) {
    try {
      if (!host || host.activeSkin !== 'broadcast') return '';
      const hist = (host.lineupHistory && host.lineupHistory.length >= 2) ? host.lineupHistory : (host._lineupHistory || []);
      return says(id, { lineups: host.lineupRows || [], history: hist, dreamScore: host.dreamTeamScore || 0, now: Date.now(), sport: host._sportId, final: !!host._slateFinal,
                        fmt: (v) => (typeof host._fmtScore === 'function' ? host._fmtScore(v) : num(v).toFixed(2)) });
    } catch (e) {
      if (!warned.has(id)) { warned.add(id); try { console.warn('LSLab.take(' + id + ') failed:', e); } catch (_) {} }
      return '';
    }
  }

  return { says, take };
})();

/* ==== static/js/widgets/lab_tools_model.js ==== */
;
/* widgets/lab_tools_model.js — the brain of a Lab panel (Broadcast ▸ The Lab).
 *
 * paths(ctx): PATHS TO THE TOP. For each lineup behind your leader: how far
 *   back it is, what its players still to come are expected to add against
 *   what the leader's are, and so whether it is on course to pass or what it
 *   needs - named ("Jaxon Smith-Njigba beating expectations by 8.20 would do it").
 *   "Expected" is the user's own projection, else the platform average
 *   (DK's AvgPointsPerGame), for the part of the game not yet played - and the
 *   panel says which one it used. Never a claim that a lineup is beaten.
 *
 * Pure, joins by player id; tests in tests/js/lab_tools_model.test.js. */
window.LSLabTools = (function () {
  const { num, pid, isDst, full, short, andList, nameOf, toMs } = window.LSModelUtil;   // shared helpers (model_util.js)
  const MAX = 6;

  /** What a player is still expected to add, and on what basis. */
  function still(p) {
    if (p.game_phase === 'finished') return { pts: 0, basis: '' };
    const frac = p.game_phase === 'playing' ? Math.min(1, Math.max(0, num(p.elapsed_frac))) : 0;
    const proj = num(p.proj), avg = num(p.baseline);
    const per = proj > 0 ? proj : avg;
    return { pts: per * (1 - frac), basis: proj > 0 ? 'proj' : (avg > 0 ? 'avg' : '') };
  }

  function paths(ctx) {
    const fmt = typeof ctx.fmt === 'function' ? ctx.fmt : (v) => num(v).toFixed(2);
    const lus = (ctx.lineups || []).map((lu, i) => ({ lu, i, id: String(lu.id), name: nameOf(lu, i), live: num(lu.live_total) }))
      .sort((a, b) => (b.live - a.live) || (a.i - b.i));
    if (lus.length < 2) return { empty: true, headline: lus.length ? 'One lineup: nobody to chase' : '', rows: [] };
    const lead = lus[0];
    const rest = (x) => (x.lu.players || []).map(p => ({ p, ...still(p) }));
    const leadRest = rest(lead);
    const leadMore = leadRest.reduce((s, r) => s + r.pts, 0);
    const bases = new Set();
    leadRest.forEach(r => r.basis && bases.add(r.basis));

    const leadLeft = leadRest.filter(r => r.p.game_phase !== 'finished');
    const rows = lus.slice(1, 1 + MAX).map(x => {
      const mine = rest(x);
      mine.forEach(r => r.basis && bases.add(r.basis));
      const more = mine.reduce((s, r) => s + r.pts, 0);
      const gap = lead.live - x.live;
      const left = mine.filter(r => r.p.game_phase !== 'finished');
      const leadIds = new Set((lead.lu.players || []).map(pid));
      // The players who can swing it: still to come, and not also in the leader.
      const swing = left.filter(r => !leadIds.has(pid(r.p))).sort((a, b) => b.pts - a.pts);
      // Expectation only when every player still to come - here and in the leader -
      // has one (a projection or a DK average). Otherwise: counts and names, no maths.
      const known = left.every(r => r.basis) && leadLeft.every(r => r.basis);
      const net = gap + leadMore - more;              // > 0: what it needs beyond expectation
      let state, text;
      if (!left.length) {
        state = 'done'; text = 'All played: finishes ' + fmt(gap) + ' back';
      } else if (!known) {
        state = 'chase';
        // Name everyone up to four; past that, a count led by names - never "and 2 others".
        const who = swing.length ? swing : left;
        const names = who.length <= 4 ? andList(who.map(r => full(r.p)))
          : who.length + ' players, led by ' + andList(who.slice(0, 3).map(r => full(r.p)));
        text = left.length + ' still to play against ' + leadLeft.length + ' for ' + lead.name
          + (who.length ? (swing.length ? '. Only here: ' : ': ') + names : '');
      } else if (net <= 0) {
        state = 'on'; text = 'On course to pass by ' + fmt(-net);
      } else if (swing.length) {
        state = 'needs';
        text = 'Needs ' + fmt(net) + ' more than expected: ' + full(swing[0].p) + ' beating expectations by that would do it';
      } else {
        state = 'needs';
        text = 'Needs ' + fmt(net) + ' more than expected, and every player still to come is also in ' + lead.name;
      }
      return {
        id: x.id, name: x.name, gap: fmt(gap), more: known ? fmt(more) : '', state, text,
        left: left.length, swing: swing.slice(0, 3).map(r => full(r.p)),
        // the bar: how far back it is vs what it has still to come
        gapPct: 0, morePct: 0, _gap: gap, _more: more,
      };
    });
    rows.forEach(r => { if (!r.more) r._more = 0; });
    const scale = Math.max(1, ...rows.map(r => Math.max(r._gap, r._more)));
    rows.forEach(r => { r.gapPct = r._gap / scale * 100; r.morePct = r._more / scale * 100; delete r._gap; delete r._more; });

    const on = rows.filter(r => r.state === 'on');
    let headline, decided = false;
    if (on.length) headline = andList(on.map(r => r.name)) + (on.length === 1 ? ' is' : ' are') + ' on course to catch ' + lead.name;
    else if (rows.every(r => r.state === 'done')) { headline = lead.name + ' has it: every lineup behind has played out'; decided = true; }
    else if (!bases.size) headline = lead.name + ' leads; ' + andList(rows.filter(r => r.state !== 'done').slice(0, 2).map(r => r.name)) + ' still have players to come';
    else headline = lead.name + ' is on course to hold on';
    const basis = bases.has('proj') && bases.has('avg') ? 'your projections, else the DK average'
      : bases.has('proj') ? 'your projections' : bases.has('avg') ? 'the DK average' : '';
    return {
      empty: false, headline, decided, rows, lead: { name: lead.name, live: fmt(lead.live), more: bases.size ? fmt(leadMore) : '', left: leadLeft.length },
      basis: basis ? 'Expected = ' + basis + ', for the part of each game still to play' : '',
      label: rows.length < lus.length - 1 ? 'Top ' + rows.length + ' of ' + (lus.length - 1) + ' chasing' : '',
    };
  }

  return { paths, still };
})();

/* ==== static/js/widgets/bc_lab_tools.js ==== */
;
/* widgets/bc_lab_tools.js — Paths to the Top, a Lab panel for the Broadcast
 * board (Xav 2026-10-04). Brain: widgets/lab_tools_model.js (LSLabTools).
 * Runs on a 1s tick - never from a getter. (Best Swap was pulled 2026-10-05:
 * hindsight read as "I told you so".) */
(function () {
  const fmtOf = (host) => (v) => (typeof host._fmtScore === 'function' ? host._fmtScore(v) : (+v || 0).toFixed(2));

  window.LSWidgets.register({
    id:          'bc_paths',
    slot:        'panel',
    title:       'Paths to the Top',
    description: 'For each lineup behind your leader: how far back it is, what its players still to come are expected to add, and whether that is enough - named.',
    help:        'Back = how far behind your leading lineup. To come = what its players still to play are expected to add (your projection, else the DK average, for the part of each game left). If that beats what the leader still has to come by more than the gap, it is on course to pass; if not, it says how much more it needs, and from whom.',
    sportScope:  '*',
    minCells:    { w: 5, h: 4 },
    defaultCells:{ w: 6, h: 5 },
    factory:     () => ({
      _m: null, _t: null,
      _sig: '',   // the last model, serialised - declared HERE so it is this panel's own; undeclared, Alpine wrote it to the board's root scope and two panels reset each other every tick (audit run 3, CODE-26)
      init()    { this._tick(); this._t = setInterval(() => this._tick(), 1000); },
      destroy() { if (this._t) clearInterval(this._t); },
      _tick() {
        if (!window.LSLabTools) return;
        const _next = window.LSLabTools.paths({ lineups: this.activeLineupRows || this.lineupRows || [], fmt: fmtOf(this) });
        // identical to the last tick: keep it - Alpine then has nothing to rewrite
        // (a finished board rebuilt this every second - audit run 2, CODE-21)
        { const _s = JSON.stringify(_next); if (_s !== this._sig) { this._sig = _s; this._m = _next; } }

      },
    }),
  });

})();

/* ==== static/js/widgets/score_wire.js ==== */
;
/* widgets/score_wire.js — the Score Wire (Broadcast scoreboard, Xav 2026-10-05).
 *
 * The scoreboard's second view: every score on the slate as a wire, newest
 * first, each saying what it was (TOUCHDOWN · KC), the new line with the
 * scoring side lit, the clock, and what it did to the game - a lead change, a
 * tie, a run ("KC: 17 unanswered"), a final. ALL or MINE (games with your
 * players). A thin strip of the live games sits on top.
 *
 * Its rows are the poller's score bands (event_type 'score' in the scorer
 * feed: the new line, the side, the points and their name - core/score_band.py),
 * read from the raw feed so the Wire's own score-band switch can't hide them.
 * Basketball has bands too since 2026-10-17 (Xav: "why not just show every
 * score change?") - a 10-0 run, a lead change, every basket. A game without
 * bands (an older replay) still gets the lead changes and ties the Score Wire
 * writes itself from the scoreboard while you watch. Finals are stamped too.
 *
 * Shown as a TIMELINE (Xav 2026-10-13, mock H2): a NOW marker, a line down
 * the panel, newest on top. With several games the rows group by the clock
 * (Just now, 8:30 PM...) and each carries its own game; pick a game (or a
 * one-game slate) and they group by period - innings, quarters, periods.
 * LSScoreWire.group() does that grouping.
 *
 * LSScoreWire.build(ctx) is pure (tests/js/score_wire.test.js); LSScoreWireCmp
 * is the Alpine component, ticking at 1s - never writing from a getter.
 * Joins by game_id, never by team abbreviation. */
window.LSScoreWire = (function () {
  const { num, pid, isDst, full, short, andList, nameOf, toMs } = window.LSModelUtil;   // shared helpers (model_util.js)
  const RUN_AT = { nfl: 14, cfb: 14, nhl: 3, soccer: 3, mlb: 5, nba: 8, wnba: 8, cbb: 8 };
  const UNIT = { nfl: 'points', cfb: 'points', nhl: 'goals', soccer: 'goals', mlb: 'runs' };
  const BASKETBALL = new Set(['nba', 'wnba', 'cbb', 'euroleague']);
  const take = (abbr) => abbr + ' take the lead';

  /** One score band, plus what it did to the game. prevLine: [a, h] before it (or null). */
  function moment(ev, prevLine) {
    const a = num(ev.away_score), h = num(ev.home_score);
    if (!prevLine) return '';
    const before = Math.sign(prevLine[0] - prevLine[1]), after = Math.sign(a - h);
    const who = after > 0 ? ev.away_abbr : ev.home_abbr;
    if (after === 0) return 'Tied ' + a + '–' + h;
    if (before === 0) return who + (prevLine[0] + prevLine[1] === 0 ? ' open the scoring' : ' go ahead');
    if (before !== after) return take(who);
    return '';
  }

  function build(ctx) {
    const sport = String(ctx.sport || '').toLowerCase();
    const games = ctx.games || [];
    const owned = ctx.owned || {};
    const mineOnly = ctx.scope === 'mine';
    const seenAt = ctx.seenAt || {};
    const gameOf = (id) => games.find(g => String(g.game_id) === String(id)) || null;

    // Bands, newest first as the feed holds them; one per id.
    const ids = new Set();
    const bands = (ctx.events || []).filter(e => e && e.event_type === 'score' && !ids.has(e.id) && ids.add(e.id));

    // Per game, oldest first: the line before each band, and the run it is part of.
    const byGame = {};
    bands.forEach((e, i) => { (byGame[e.game_id] = byGame[e.game_id] || []).push({ e, i }); });
    const extra = {};
    for (const gid of Object.keys(byGame)) {
      const seq = byGame[gid].slice().reverse();
      let runSide = null, runPts = 0;
      seq.forEach(({ e }, k) => {
        const side = e.score_side === 'home' ? 'home' : 'away';
        const pts = e.points != null ? num(e.points) : null;
        const older = seq[k - 1] ? seq[k - 1].e : null;
        let prev = null;
        if (pts != null) prev = side === 'away' ? [num(e.away_score) - pts, num(e.home_score)] : [num(e.away_score), num(e.home_score) - pts];
        else if (older) prev = [num(older.away_score), num(older.home_score)];
        const add = pts != null ? pts : (prev ? (side === 'away' ? num(e.away_score) - prev[0] : num(e.home_score) - prev[1]) : 0);
        if (runSide === side) runPts += add; else { runSide = side; runPts = add; }
        const at = RUN_AT[sport];
        const abbr = side === 'away' ? e.away_abbr : e.home_abbr;
        let m = moment(e, prev);
        if (!m && at && runPts >= at && k > 0) m = abbr + ': ' + runPts + ' unanswered';
        extra[e.id] = { moment: m, team: abbr, side };
      });
    }

    const row = (e) => {
      const g = gameOf(e.game_id) || {};
      const x = extra[e.id] || {};
      return {
        id: e.id, game_id: String(e.game_id), kind: 'score',
        tag: String(e.headline || 'SCORE').toUpperCase(), team: x.team || '', side: x.side || 'away',
        a: e.away_abbr || g.away_team || '', h: e.home_abbr || g.home_team || '',
        al: e.away_logo || g.away_logo || '', hl: e.home_logo || g.home_logo || '',
        as: num(e.away_score), hs: num(e.home_score),
        clock: String(e.gameTime || (e.game_state && e.game_state.inn) || ''),
        per: String((e.game_state && e.game_state.inn) || ''),
        pts: e.points != null ? num(e.points) : null,
        moment: x.moment || '', mine: owned[String(e.game_id)] || 0,
        at: seenAt[e.id] || 0,
        // when it happened (the band's own stamp, seconds) - the clock groups
        ts: e.ts ? Math.round(num(e.ts) * 1000) : (seenAt[e.id] || 0),
      };
    };
    let rows = bands.map(row);
    // The ones the wire writes itself (basketball leads / ties, finals), newest first.
    // ...but not a lead change or tie for a game whose bands already say it
    const banded = new Set(bands.map(e => String(e.game_id)));
    rows = rows.concat((ctx.synth || []).filter(s => !((s.kind === 'lead' || s.kind === 'tie') && banded.has(String(s.game_id))))
      .map(s => ({ ...s, mine: owned[String(s.game_id)] || 0 })));
    // Every final, not only the ones that ended while you watched: opened on a
    // finished 12-game slate the wire said "Every score on the slate lands
    // here." over an empty card (Broadcast audit run 1, PREM-11).
    const stamped = new Set(rows.filter(r => r.kind === 'final').map(r => String(r.game_id)));
    for (const g of games) {
      const id = String(g.game_id);
      if (stamped.has(id) || (ctx.eff ? ctx.eff(g) : num(g.status)) < 3) continue;
      const a = num(g.away_score), h = num(g.home_score);
      const lead = a === h ? '' : (a > h ? g.away_team : g.home_team);
      rows.push({ id: 'final-' + id, game_id: id, kind: 'final', tag: 'FINAL', team: lead, side: a > h ? 'away' : 'home',
                  a: g.away_team || '', h: g.home_team || '', al: g.away_logo || '', hl: g.home_logo || '', as: a, hs: h,
                  clock: '', at: 0, mine: owned[id] || 0,
                  moment: lead ? lead + ' win ' + Math.max(a, h) + '–' + Math.min(a, h) : 'Ends level' });
    }
    // Newest first: anything seen while watching by when it arrived; the rest keep the feed's order.
    rows = rows.map((r, i) => ({ r, i })).sort((x, y) => (y.r.at - x.r.at) || (x.i - y.i)).map(x => x.r);
    if (mineOnly) rows = rows.filter(r => r.mine > 0);

    const live = games.filter(g => ctx.eff ? ctx.eff(g) === 2 : num(g.status) === 2)
      .filter(g => !mineOnly || owned[String(g.game_id)])
      .map(g => ({ id: String(g.game_id), a: g.away_team || '', h: g.home_team || '', as: num(g.away_score), hs: num(g.home_score),
                   clock: String(g.status_text || g.clock || ''), mine: owned[String(g.game_id)] || 0 }));

    const empty = !rows.length
      ? (mineOnly ? 'No scores yet in games with your players.' : 'Every score on the slate lands here.')
      : '';
    return { rows, live, empty, unit: UNIT[sport] || 'points' };
  }

  /** "B5" -> {key: '5', long: '5th inning', short: 'bot 5th'}; Q3, P2, H1, OT, SO likewise. */
  function period(code, sport) {
    const c = String(code || '').toUpperCase();
    const ord = (n) => n + (['th', 'st', 'nd', 'rd'][(n % 100 - 20) % 10] || ['th', 'st', 'nd', 'rd'][n % 100] || 'th');
    let m = c.match(/^([TB])(\d+)$/);
    if (m) { const n = +m[2]; return { key: 'i' + n, long: ord(n) + ' inning', short: (m[1] === 'T' ? 'top ' : 'bot ') + ord(n) }; }
    m = c.match(/^([QPH])(\d+)$/);
    if (m) {
      const n = +m[2], word = { Q: 'quarter', P: 'period', H: 'half' }[m[1]];
      return { key: m[1] + n, long: ord(n) + ' ' + word, short: ord(n) + ' ' + (m[1] === 'Q' ? 'qtr' : word) };
    }
    if (c === 'OT' || /^\dOT$/.test(c)) return { key: c, long: c === 'OT' ? 'Overtime' : c[0] + 'x overtime', short: c };
    if (c === 'SO') return { key: 'SO', long: 'Shootout', short: 'shootout' };
    if (c === 'ET') return { key: 'ET', long: 'Extra time', short: 'extra time' };
    return { key: c || '-', long: c || '', short: c };
  }

  /** The timeline's groups, newest first. byPeriod (one game): one group per
   *  period, in the order the rows arrive. Otherwise by the clock: "Just now"
   *  (the last 3 minutes), then quarter-hours, then the finals. */
  function group(rows, opts) {
    const o = opts || {}, now = o.now || Date.now(), out = [], at = {};
    const add = (key, label, r) => {
      if (at[key] == null) { at[key] = out.length; out.push({ key, label, rows: [] }); }
      out[at[key]].rows.push(r);
    };
    for (const r of rows || []) {
      if (o.byPeriod) {
        if (r.kind === 'final') { add('final', 'Final', r); continue; }
        const p = period(r.per || r.clock, o.sport);
        add(p.key, p.long, r);
        continue;
      }
      if (r.kind === 'final' && !r.ts) { add('final', 'Finished', r); continue; }
      const t = r.ts || r.at || 0;
      // no time on it (a replay's bands): no clock header to put it under
      if (!t) { add('untimed', '', r); continue; }
      if (now - t < 3 * 60000) { add('now', 'Just now', r); continue; }
      const q = new Date(t); q.setMinutes(Math.floor(q.getMinutes() / 15) * 15, 0, 0);
      const label = q.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
      add('q' + q.getTime(), label, r);
    }
    return out;
  }

  /** Session-only events from the scoreboard: basketball lead changes / ties, and finals. */
  function watch(mem, games, sport, eff, now) {
    const out = [];
    const bb = BASKETBALL.has(String(sport || '').toLowerCase());
    for (const g of games || []) {
      const id = String(g.game_id), st = eff ? eff(g) : num(g.status);
      const a = num(g.away_score), h = num(g.home_score);
      const was = mem[id];
      mem[id] = { a, h, st };
      if (!was) continue;                                  // first sight is not news
      const base = { game_id: id, a: g.away_team || '', h: g.home_team || '', al: g.away_logo || '', hl: g.home_logo || '',
                     as: a, hs: h, clock: String(g.status_text || ''), at: now };
      if (st >= 3 && was.st < 3) {
        const lead = a === h ? '' : (a > h ? g.away_team : g.home_team);
        out.push({ ...base, id: 'final-' + id, kind: 'final', tag: 'FINAL', team: lead, side: a > h ? 'away' : 'home',
                   moment: lead ? lead + ' win ' + Math.max(a, h) + '–' + Math.min(a, h) : 'Ends level' });
        continue;
      }
      if (!bb || st !== 2 || (a === was.a && h === was.h)) continue;
      const before = Math.sign(was.a - was.h), after = Math.sign(a - h);
      if (after === 0 && before !== 0) {
        out.push({ ...base, id: 'tie-' + id + '-' + a + '-' + h, kind: 'tie', tag: 'TIED', team: '', side: 'away', moment: 'Tied ' + a + '–' + h });
      } else if (after !== 0 && before !== after) {
        const who = after > 0 ? g.away_team : g.home_team;
        out.push({ ...base, id: 'lead-' + id + '-' + a + '-' + h, kind: 'lead', tag: 'LEAD CHANGE', team: who, side: after > 0 ? 'away' : 'home',
                   moment: before === 0 ? who + ' go ahead' : take(who) });
      }
    }
    return out;
  }

  return { build, watch, moment, period, group };
})();

/** The Alpine component behind partials/_score_wire.html. Reads the host board
 *  through Alpine's scope (feed, allGames, lineupRows, effStatus, selectedSlate). */
window.LSScoreWireCmp = function () {
  const SYNTH_CAP = 60;
  return {
    _sw: { rows: [], live: [], empty: '', items: [], chips: [], now: '' },
    _swGame: null,   // a picked game (its id), or null = every game
    /** A row's line: what it did ("LAD go ahead"), else who scored, with
     *  "· Tied" when it levelled the game. */
    swTitle(r) {
      if (r.kind === 'final' || r.kind === 'lead') return r.moment || r.tag;
      if (r.kind === 'tie') return 'Tied ' + r.as + '–' + r.hs;
      const tied = /^Tied/.test(r.moment || '');
      if (r.moment && !tied) return r.moment;
      return (r.team ? r.team + ' score' : 'Score') + (tied ? ' · Tied' : '');
    },
    swPick(id) { this._swGame = (this._swGame === id ? null : id); this._sig = ''; this._swTick(); },
    _sig: '',   // the last model, serialised - declared HERE so it is this panel's own; undeclared, Alpine wrote it to the board's root scope and two panels reset each other every tick (audit run 3, CODE-26)
    _swMem: {}, _swSynth: [], _swSeen: {}, _swPrimed: false, _swT: null,
    /** "in 4/5": how many of your lineups have a stake in the row's game, as
     *  the Cards foot says it (sbMine); one lineup: "yours". */
    _swStake(r) {
      const g = (this.allGames || []).find(x => String(x.game_id) === String(r.game_id || r.id));
      const m = g && typeof this.sbMine === 'function' ? this.sbMine(g) : null;
      return m && m.stake ? m.stake + ' lineups' : (r.mine ? 'yours' : '');
    },
    init() { this._swTick(); this._swT = setInterval(() => this._swTick(), 1000); },
    destroy() { if (this._swT) clearInterval(this._swT); },
    _swTick() {
      const W = window.LSScoreWire;
      if (!W) return;
      const now = Date.now();
      const sl = this.selectedSlate || {};
      const sport = String(sl.sport_id || (sl.sport && sl.sport.id) || '').toLowerCase();
      const eff = (g) => (typeof this.effStatus === 'function' ? this.effStatus(g) : g.status);
      const fresh = W.watch(this._swMem, this.allGames || [], sport, eff, now);
      if (fresh.length) this._swSynth = fresh.concat(this._swSynth).slice(0, SYNTH_CAP);
      // A band already in the feed when the page opened is history: it keeps the
      // feed's order. One that arrives while you watch is stamped, so it rises.
      const seen = this._swSeen;
      for (const e of (this.feed || [])) if (e && e.event_type === 'score' && seen[e.id] == null) seen[e.id] = this._swPrimed ? now : 0;
      this._swPrimed = true;
      // Mine: how many of my players are in each game (unique, by player id).
      const owned = {}, counted = new Set();
      for (const lu of (this.lineupRows || [])) for (const p of (lu.players || [])) {
        const k = window.LSModelUtil.pid(p);
        if (!k || counted.has(k) || p.game_id == null) continue;
        counted.add(k);
        owned[String(p.game_id)] = (owned[String(p.game_id)] || 0) + 1;
      }
      // ...and the stored Wire's bands behind the live ones, so a reload
      // mid-slate keeps the scores that came before it (build dedups by id)
      const _evs = (this.feed || []).concat((this._wireSeed || []).filter(e => e && e.event_type === 'score'));
      const _next = W.build({ sport, games: this.allGames || [], eff, events: _evs, synth: this._swSynth,
                           owned, scope: this.sbWireScope, seenAt: seen });
      // The timeline (Xav 2026-10-13): game chips when there is more than one
      // game; a picked game - or a one-game slate - groups by period, every
      // game together groups by the clock. One flat list of headers and rows,
      // so LSFit.rows trims whole lines from the oldest end.
      const games = this.allGames || [];
      if (this._swGame && !games.some(g => String(g.game_id) === this._swGame)) this._swGame = null;
      const one = games.length === 1 ? String(games[0].game_id) : this._swGame;
      const rows = one ? _next.rows.filter(r => String(r.game_id) === one) : _next.rows;
      const items = [];
      for (const gp of W.group(rows, { byPeriod: !!one, sport, now })) {
        if (gp.label) items.push({ id: 'h-' + gp.key, head: gp.label });
        for (const r of gp.rows) items.push({ ...r, sub: W.period(r.per || r.clock, sport).short, latest: !items.some(x => !x.head) });
      }
      const live = games.filter(g => eff(g) === 2);
      _next.items = items;
      _next.chips = games.length > 1
        ? games.filter(g => eff(g) >= 2 || _next.rows.some(r => String(r.game_id) === String(g.game_id)))
               .map(g => ({ id: String(g.game_id), a: g.away_team || '', h: g.home_team || '', live: eff(g) === 2,
                            line: (g.away_team || '') + ' ' + (+g.away_score || 0) + '–' + (+g.home_score || 0) + ' ' + (g.home_team || '')
                                  + (g.status_text ? ' · ' + g.status_text : '') }))
        : [];
      const g1 = one ? games.find(g => String(g.game_id) === one) : null;
      _next.now = g1 ? (eff(g1) >= 3 ? 'Final' : eff(g1) === 2 ? 'Now · ' + (g1.status_text || 'live') : '')
                     : (live.length ? 'Now · ' + live.length + ' live' : '');
        // identical to the last tick: keep it - Alpine then has nothing to rewrite
        // (a finished board rebuilt this every second - audit run 2, CODE-21)
        { const _s = JSON.stringify(_next); if (_s !== this._sig) { this._sig = _s; this._sw = _next; } }
    },
  };
};

/* ==== static/js/widgets/stack_model.js ==== */
;
/* widgets/stack_model.js — stacks, slate-wide and in your lineups
 * (The Slate's Stacks panel, The Podium's Your Stacks; Xav 2026-10-07).
 *
 * What a stack is depends on the sport (docs/broadcast_runbook.md, section 5):
 *   NFL  a quarterback plus his own team's WR / TE / RB (Xav: "WR + TE + RB",
 *        the same mates the Best QB + Receiver tile uses); a k-man stack is
 *        the QB and his k-1 best mates.
 *   NHL  teammates - any skaters, the goalie excluded (Xav 2026-10-07); a
 *        k-man stack is the team's k best skaters. Lines are not in any feed
 *        we have, so stacks are by team.
 *   NBA  teammates, any position (Xav 2026-10-08); a k-man stack is the
 *        team's k best. A guard listed "G" is not a goalie.
 *   MLB  teammate hitters, pitchers never (Xav 2026-10-08); batting order
 *        is not needed to read it.
 * bestGame(): the best k players from one GAME, both sides (The Slate's NBA
 * tile, Xav 2026-10-08) - joined by game_id.
 * Teams group by team_id, else the slate's own team code - never matched
 * against another source. Players join by id. The leader of a stack (`qb`)
 * is the QB on NFL and the top skater on NHL.
 * Pure: no DOM, no Alpine. Tests: tests/js/stack_model.test.js. */
window.LSStacks = (function () {
  const { num, pid } = window.LSModelUtil;
  const SIZES = [2, 3, 4, 5];
  const MATE = ['WR', 'TE', 'RB'];
  const POS = (p) => String((p && (p.pos || p.position)) || '').toUpperCase();
  const teamKey = (p) => String((p && (p.team_id || p.team)) || '');
  const teamCode = (p) => String((p && p.team) || '').toUpperCase();
  const byPts = (a, b) => num(b.live_fpts) - num(a.live_fpts);
  const anchored = (sport) => !sport || sport === 'nfl' || sport === 'cfb';
  const isGoalie = (p) => ['G', 'GK'].includes(POS(p));
  const isPitcher = (p) => ['P', 'SP', 'RP'].includes(POS(p));
  // NHL: the goalie is not in a stack; MLB: nor is a pitcher
  const benched = (p, sport) => (sport === 'nhl' && isGoalie(p)) || (sport === 'mlb' && isPitcher(p));

  /** The best k-man stack in one group of players (a slate, or one lineup):
   *  { [k]: { total, qb, mates, team } } for each k the group can make. */
  function stacksIn(players, sport) {
    const out = {};
    const keep = (k, total, lead, mates) => { if (!out[k] || total > out[k].total) out[k] = { total, qb: lead, mates, team: teamCode(lead) }; };
    if (anchored(sport)) {
      for (const q of players.filter(p => POS(p) === 'QB' && teamKey(p))) {
        const mates = players.filter(m => m !== q && teamKey(m) === teamKey(q) && MATE.includes(POS(m))).sort(byPts);
        for (const k of SIZES) {
          if (mates.length < k - 1) continue;
          const use = mates.slice(0, k - 1);
          keep(k, num(q.live_fpts) + use.reduce((s, m) => s + num(m.live_fpts), 0), q, use);
        }
      }
      return out;
    }
    const teams = new Map();
    for (const p of players) {
      if (benched(p, sport) || !teamKey(p)) continue;
      if (!teams.has(teamKey(p))) teams.set(teamKey(p), []);
      teams.get(teamKey(p)).push(p);
    }
    for (const sk of teams.values()) {
      sk.sort(byPts);
      for (const k of SIZES) {
        if (sk.length < k) continue;
        const use = sk.slice(0, k);
        keep(k, use.reduce((s, m) => s + num(m.live_fpts), 0), use[0], use.slice(1));
      }
    }
    return out;
  }

  /** Slate-wide, one row per team and its best 2..5-man stacks, best 3-man
   *  first; each column's leader is flagged. On NFL the team's stack is led
   *  by the QB who scored most (a backup with 0 is not the team's stack). */
  function byTeam(players, sport) {
    const teams = new Map();
    for (const p of (players || [])) {
      const k = teamKey(p);
      if (!k) continue;
      if (!teams.has(k)) teams.set(k, []);
      teams.get(k).push(p);
    }
    const rows = [];
    for (const ps of teams.values()) {
      let s;
      if (anchored(sport)) {
        const qb = ps.filter(p => POS(p) === 'QB').sort(byPts)[0];
        if (!qb) continue;
        s = stacksIn([qb, ...ps.filter(p => POS(p) !== 'QB')], sport);
      } else {
        s = stacksIn(ps, sport);
      }
      if (!s[2]) continue;
      rows.push({ team: s[2].team, qb: s[2].qb, s });
    }
    rows.sort((a, b) => num((b.s[3] || b.s[2]).total) - num((a.s[3] || a.s[2]).total) || a.team.localeCompare(b.team));
    const best = {};
    for (const k of SIZES) best[k] = Math.max(0, ...rows.map(r => (r.s[k] ? r.s[k].total : 0)));
    for (const r of rows) r.lead = Object.fromEntries(SIZES.map(k => [k, !!r.s[k] && r.s[k].total > 0 && r.s[k].total === best[k]]));
    return rows;
  }

  /** Your stacks: per size, your best k-man stack (which lineup holds it)
   *  and how many of your lineups ran one; the slate's best as the ceiling. */
  function yours(lineups, slatePlayers, sport) {
    const lus = lineups || [];
    const slate = {};
    for (const r of byTeam(slatePlayers, sport)) for (const k of SIZES) {
      if (r.s[k] && (!slate[k] || r.s[k].total > slate[k].total)) slate[k] = r.s[k];
    }
    return SIZES.map(k => {
      let best = null, n = 0;
      lus.forEach((lu, i) => {
        const s = stacksIn(lu.players || [], sport)[k];
        if (!s) return;
        n++;
        if (!best || s.total > best.total) best = { ...s, lineup: window.LSModelUtil.nameOf(lu, i) };
      });
      return { k, best, n, of: lus.length, slate: slate[k] || null };
    });
  }

  /** The best k players from one game, both teams: { total, players, game_id }
   *  or null. Players join their game by game_id. */
  function bestGame(players, k = 3) {
    const games = new Map();
    for (const p of (players || [])) {
      if (p.game_id == null) continue;
      const g = String(p.game_id);
      if (!games.has(g)) games.set(g, []);
      games.get(g).push(p);
    }
    let best = null;
    for (const [g, ps] of games) {
      if (ps.length < k) continue;
      const use = ps.slice().sort(byPts).slice(0, k);
      const total = use.reduce((s, m) => s + num(m.live_fpts), 0);
      if (!best || total > best.total) best = { total, players: use, game_id: g };
    }
    return best;
  }

  return { SIZES, stacksIn, byTeam, yours, bestGame, pid };
})();

/* ==== static/js/widgets/slate_panels.js ==== */
;
/* widgets/slate_panels.js — The Slate tab's panels and The Podium's Your
 * Stacks (Xav 2026-10-07, the sixth tab: everything about the slate that is
 * not about you).
 *
 *   slate_games   every game by the fantasy points it produced (all sports)
 *   slate_stacks  each team's best 2/3/4/5-man stack (NFL, NHL, NBA, MLB)
 *   my_stacks     your best 2/3/4/5-man stacks against the slate's
 *
 * Players join games by game_id and lineups by player id; stacks come from
 * widgets/stack_model.js. */
(function () {
  const num = (v) => { const n = Number(v); return isFinite(n) ? n : 0; };
  const short = (p) => window.LSModelUtil.short(p);

  window.LSWidgets.register({
    id: 'slate_games', slot: 'panel', title: 'Games', sportScope: '*',
    description: 'Every game on the slate by the fantasy points it produced - where the points came from.',
    help: "Each game's fantasy points: every player in it, both teams, added up. The bar compares games; live games update as they play.",
    factory: () => ({
      get _games() {
        const by = new Map();
        for (const p of (this.allSlatePlayers || [])) {
          if (p.game_id == null) continue;
          const k = String(p.game_id);
          by.set(k, (by.get(k) || 0) + num(p.live_fpts));
        }
        const rows = (this.allGames || []).map(g => {
          const st = typeof this.effStatus === 'function' ? this.effStatus(g) : num(g.status);
          const pts = by.get(String(g.game_id)) || 0;
          const t = g.game_time_utc ? new Date(g.game_time_utc) : null;
          return {
            id: String(g.game_id),
            label: String(g.away_team || '').toUpperCase() + ' @ ' + String(g.home_team || '').toUpperCase(),
            st, pts,
            // to come: the day and time ("0:00" alone read like a clock run out)
            score: st >= 2 ? num(g.away_score) + '-' + num(g.home_score) : (t && !isNaN(t) ? t.toLocaleString([], { weekday: 'short', hour: '2-digit', minute: '2-digit' }) : ''),
            t: t && !isNaN(t) ? t.getTime() : 0,
          };
        });
        const max = Math.max(1, ...rows.map(r => r.pts));
        rows.forEach(r => { r.pct = Math.round(r.pts / max * 100); });
        return rows.sort((a, b) => (b.pts - a.pts) || (a.t - b.t) || a.label.localeCompare(b.label));
      },
    }),
  });

  window.LSWidgets.register({
    id: 'slate_stacks', slot: 'panel', title: 'Stacks', sportScope: ['nfl', 'cfb', 'nhl', 'nba', 'mlb'],
    description: "Each team's best 2, 3, 4 and 5-man stack (NFL: a quarterback and his best receivers, tight ends and backs; NHL skaters, NBA any players, MLB hitters).",
    help: "A stack is teammates in one lineup. Each column is the best stack of that size the team produced; the slate's best in each column is gold. Hover a number for the players.",
    // what a stack is, sport by sport (the admin copy is one text for all)
    descriptionBySport: {
      nfl: "Each team's best 2, 3, 4 and 5-man stack: a quarterback and his best receivers, tight ends and backs.",
      cfb: "Each team's best 2, 3, 4 and 5-man stack: a quarterback and his best receivers, tight ends and backs.",
      nhl: "Each team's best 2, 3, 4 and 5-man stack of skaters.",
      nba: "Each team's best 2, 3, 4 and 5-man stack.",
      mlb: "Each team's best 2, 3, 4 and 5-man stack of hitters.",
    },
    helpBySport: {
      nfl: "A stack is a quarterback plus his own receivers, tight ends and backs in one lineup. Each column is the best stack of that size the team produced, built on the QB named beside the team; the slate's best in each column is gold. Hover a number for the players.",
      cfb: "A stack is a quarterback plus his own receivers, tight ends and backs in one lineup. Each column is the best stack of that size the team produced, built on the QB named beside the team; the slate's best in each column is gold. Hover a number for the players.",
      nhl: "A stack is skaters from one team in one lineup - goals and assists come in lines, so teammates score together. The goalie is not part of it. Each column is the best stack of that size the team produced; the slate's best in each column is gold. Hover a number for the players.",
      nba: "A stack is players from one team in one lineup. Each column is the best stack of that size the team produced; the slate's best in each column is gold. Hover a number for the players.",
      mlb: "A stack is hitters from one team in one lineup - runs come in bunches, so a lineup's order scores together. Pitchers are not part of it. Each column is the best stack of that size the team produced; the slate's best in each column is gold. Hover a number for the players.",
    },
    factory: () => ({
      // the QB a football stack is built on, beside the team; elsewhere the
      // "anchor" was just the team's top scorer, and read as a QB slot
      get _stShowQb() { return ['nfl', 'cfb'].includes(String(this._sportId || '').toLowerCase()); },
      get _rows() {
        const rows = window.LSStacks.byTeam(this.allSlatePlayers || [], this._sportId);
        // before anyone scores every stack is 0.00: say so instead of a table of zeros
        if (!rows.some(r => r.s[2] && r.s[2].total > 0)) return [];
        return rows.map(r => ({
          team: r.team, qb: short(r.qb), id: r.team + ':' + window.LSStacks.pid(r.qb),
          cells: window.LSStacks.SIZES.map(k => ({
            k, lead: r.lead[k],
            v: r.s[k] ? this._fmtScore(r.s[k].total) : '–',
            who: r.s[k] ? [r.s[k].qb, ...r.s[k].mates].map(short).join(' + ') : 'not enough players',
          })),
        }));
      },
    }),
  });

  window.LSWidgets.register({
    id: 'best_stacks', slot: 'panel', title: 'Best Stacks', sportScope: ['nfl', 'cfb', 'nhl', 'nba', 'mlb'],
    description: "The slate's best stacks of one size, team by team, every player named.",
    help: "The four best teams at one stack size (switch 2 to 5), every player with his points. With lineups, your best stack of that size underneath.",
    helpBySport: {
      nfl: "A stack is a quarterback plus his own receivers, tight ends and backs in one lineup. The four best teams at one size (switch 2 to 5), every player with his points. With lineups, your best stack of that size underneath.",
      cfb: "A stack is a quarterback plus his own receivers, tight ends and backs in one lineup. The four best teams at one size (switch 2 to 5), every player with his points. With lineups, your best stack of that size underneath.",
      nhl: "A stack is skaters from one team in one lineup (not the goalie). The four best teams at one size (switch 2 to 5), every player with his points. With lineups, your best stack of that size underneath.",
      nba: "A stack is players from one team in one lineup. The four best teams at one size (switch 2 to 5), every player with his points. With lineups, your best stack of that size underneath.",
      mlb: "A stack is hitters from one team in one lineup (not the pitchers). The four best teams at one size (switch 2 to 5), every player with his points. With lineups, your best stack of that size underneath.",
    },
    factory: () => ({
      // one size across teams, not four sizes of one team: on every slate we
      // checked a single team was best at all four (Xav 2026-10-10)
      _bsPick: null,
      get _bsSize() { return this._bsPick || ({ nfl: 3, cfb: 3, nhl: 3, nba: 2, mlb: 4 })[this._sportId] || 3; },
      get _bsWhat() {
        const k = this._bsSize, s = this._sportId;
        return k + '-man · ' + (s === 'nfl' || s === 'cfb' ? 'QB + ' + (k - 1) + ' of his own' : (s === 'mlb' ? 'teammate hitters' : (s === 'nhl' ? 'teammate skaters' : 'teammates')));
      },
      get _bsRows() {
        const k = this._bsSize, own = this._inCountMap || {}, mine = !!this.hasLineup;
        const rows = window.LSStacks.byTeam(this.allSlatePlayers || [], this._sportId).filter(r => r.s[k] && r.s[k].total > 0)
          .sort((a, b) => b.s[k].total - a.s[k].total).slice(0, 4);
        const ord = ['1st', '2nd', '3rd', '4th'];
        return rows.map((r, i) => ({
          key: r.team + ':' + k, rank: ord[i], team: r.team, v: this._fmtScore(r.s[k].total), top: i === 0,
          players: [r.s[k].qb, ...r.s[k].mates].map(p => ({ id: window.LSStacks.pid(p), name: p.name || '', short: window.LSModelUtil.short(p), pts: this._fmtScore(p.live_fpts),
                                                           mine: mine && !!own[window.LSStacks.pid(p)] })),
        }));
      },
      get _bsYours() {
        if (!this.hasLineup) return null;
        const c = window.LSStacks.yours(this.lineupRows || [], this.allSlatePlayers || [], this._sportId).find(x => x.k === this._bsSize);
        if (!c || !c.best || !(c.best.total > 0)) return { none: true };
        return { v: this._fmtScore(c.best.total), team: c.best.team, lineup: c.best.lineup,
                 names: [c.best.qb, ...c.best.mates].map(p => window.LSModelUtil.short(p)).join(' + ') };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'my_stacks', slot: 'panel', title: 'Your Stacks', sportScope: ['nfl', 'cfb', 'nhl', 'nba', 'mlb'],
    description: 'Your best 2, 3, 4 and 5-man stacks, which lineup holds each, and the slate\'s best as the ceiling.',
    help: "A stack is teammates in the same lineup - on NFL a quarterback plus his own receivers, tight ends and backs; on NHL skaters, NBA any players, MLB hitters. For each size: your best, the lineup it is in, how many of your lineups ran one, and the slate's best underneath.",
    factory: () => ({
      get _cols() {
        return window.LSStacks.yours(this.lineupRows || [], this.allSlatePlayers || [], this._sportId).map(c => ({
          k: c.k, n: c.n, of: c.of,
          best: c.best ? {
            // before it scores a stack has no value yet: "–", not 0.00 (NUMBERS-10)
            v: c.best.total > 0 ? this._fmtScore(c.best.total) : '–', team: c.best.team, lineup: c.best.lineup,
            players: [c.best.qb, ...c.best.mates].map(p => ({ id: window.LSStacks.pid(p), name: short(p), pos: String(p.pos || ''), pts: this._fmtScore(p.live_fpts) })),
          } : null,
          slate: c.slate ? { v: this._fmtScore(c.slate.total), who: c.slate.team + ' ' + [c.slate.qb, ...c.slate.mates].map(short).join(' + ') } : null,
        }));
      },
    }),
  });
})();

/* ==== static/js/widgets/preslate.js ==== */
;
/* widgets/preslate.js — Pre-Slate in the Broadcast look (Xav 2026-10-07:
 * "the first page anybody sees when they open a slate").
 *
 * ONE FRAME FOR EVERY VIEW. A game strip (All games + every game), four
 * tiles, a big panel on the left, News over Flagged on the right - every
 * panel a fixed size. Picking a game (the strip, a window, a Brief line)
 * changes only what is inside the panels:
 *
 *              All games                         One game
 *   tiles      the slate / your night            the game
 *   big panel  Vegas + weather lines, windows     line, expected points,
 *                                                 weather, players to know
 *   right      News and Flagged, slate-wide      News and Flagged, that game
 *
 * The scope (null = all games, else a game_id) is the host's `_scope`, the
 * same one the old Pre-Slate used, so its loaders (/api/slate-brief, odds,
 * weather) are shared. Players join games by game_id through the pool and
 * lineups by player id - never by name or team code.
 *
 * Mounted as x-data="LSPreSlate.scope()" inside the host; getters read the
 * host through Alpine's scope chain like every widget does. */
window.LSPreSlate = (function () {
  const num = (v) => { const n = Number(v); return isFinite(n) ? n : 0; };
  const pid = (p) => String((p && (p.player_id || p.external_player_id)) || '');
  const FLAG = { injured: 'OUT', doubtful: 'DOUBT', possible: 'Q' };
  const FLAG_ORDER = { OUT: 0, DOUBT: 1, Q: 2 };
  const ms = (iso) => { const t = new Date(iso || 0).getTime(); return isFinite(t) ? t : 0; };

  /** "Fri 01:15" in the viewer's own clock. */
  function when(iso) {
    if (!iso) return '';
    try { return new Date(iso).toLocaleString([], { weekday: 'short', hour: '2-digit', minute: '2-digit' }); } catch (_) { return ''; }
  }
  /** "1d 9h", "33h 0m", "45m", "Any moment". */
  function until(iso, now) {
    const d = ms(iso) - (now || Date.now());
    if (d <= 60e3) return 'Any moment';
    const m = Math.floor(d / 60e3), h = Math.floor(m / 60);
    if (h >= 48) return Math.floor(h / 24) + 'd ' + (h % 24) + 'h';
    return h ? h + 'h ' + (m % 60) + 'm' : m + 'm';
  }
  /** NFL kick-off windows, named the way the league's week is talked about,
   *  from the US Eastern kick-off (the schedule's own clock); shown in the
   *  viewer's time. Other sports: one window per start time. */
  function windowOf(iso, sport) {
    // other sports: one window per start time, named by the time itself
    if (sport !== 'nfl') {
      let t = '', d = '';
      try { t = new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }); d = new Date(iso).toLocaleDateString([], { weekday: 'short', day: 'numeric', month: 'short' }); } catch (_) {}
      return { key: String(ms(iso)), label: t || when(iso), day: d };
    }
    let wd = '', h = 0;
    try {
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', hour12: false }).formatToParts(new Date(iso));
      wd = (parts.find(p => p.type === 'weekday') || {}).value || '';
      h = Number((parts.find(p => p.type === 'hour') || {}).value) % 24;
    } catch (_) { return { key: String(ms(iso)), label: when(iso) }; }
    const day = { Thu: 'Thursday', Fri: 'Friday', Sat: 'Saturday', Sun: 'Sunday', Mon: 'Monday', Tue: 'Tuesday', Wed: 'Wednesday' }[wd] || wd;
    if (wd === 'Sun') {
      if (h < 12) return { key: 'sun-am', label: 'Sunday morning' };
      if (h < 15) return { key: 'sun-early', label: 'Sunday early' };
      if (h < 19) return { key: 'sun-late', label: 'Sunday late' };
      return { key: 'sun-night', label: 'Sunday night' };
    }
    if (wd === 'Thu' || wd === 'Mon') return { key: wd, label: day + ' night' };
    return { key: wd + h, label: day };
  }
  /** The number in a line like "DAL -8.5" (the favourite's spread). */
  const spreadOf = (details) => { const m = String(details || '').match(/(-?\d+(?:\.\d+)?)\s*$/); return m ? Math.abs(Number(m[1])) : null; };

  /** Fit the frame to the viewport: every panel a fixed size, the page never
   *  scrolls (the same rule as the board's grid). */
  function fit(el) {
    if (!el || el.__psFit) return;
    el.__psFit = true;
    let ro = null;
    const set = () => {
      if (!document.contains(el)) { window.removeEventListener('resize', set); if (ro) ro.disconnect(); return; }
      const r = el.getBoundingClientRect();
      // end where the scoreboard rail ends: its own guess at the bottom gap
      // ran 14px past the rail and 2px off the page (v2 run 1, SPACE-3 / FIT-9)
      const rail = document.querySelector('.ls-dash-body.is-rail > .ls-scoreboard-frame');
      const rb = rail && rail.offsetParent ? rail.getBoundingClientRect().bottom : 0;
      // (the 560px floor stays for a board with no rail; beside one it ran a
      // 720px-high laptop 2px off the page - its lists scroll in their panels)
      const h = rb > r.top + 200 ? rb - r.top : Math.max(560, window.innerHeight - (r.top + window.scrollY) - 22);
      el.style.height = Math.floor(h) + 'px';
    };
    set();
    requestAnimationFrame(set);
    window.addEventListener('resize', set);
    // the rail settles after this runs (its status line, the header): follow it
    const rail = document.querySelector('.ls-dash-body.is-rail > .ls-scoreboard-frame');
    if (rail && window.ResizeObserver) { ro = new ResizeObserver(set); ro.observe(rail); }
  }

  function scope() {
    return {
      // ── who and what ───────────────────────────────────────────────────
      /** player id -> how many of your lineups hold him */
      get _psHeld() {
        const m = new Map();
        for (const lu of (this.lineupRows || [])) {
          const seen = new Set();
          for (const p of (lu.players || [])) { const k = pid(p); if (k && !seen.has(k)) { seen.add(k); m.set(k, (m.get(k) || 0) + 1); } }
        }
        return m;
      },
      get _psLus() { return (this.lineupRows || []).length; },
      /** game_id -> its pool players */
      get _psByGame() {
        const m = new Map();
        for (const p of (this.allSlatePlayers || [])) {
          const g = String(p.game_id || '');
          if (!g) continue;
          if (!m.has(g)) m.set(g, []);
          m.get(g).push(p);
        }
        return m;
      },
      /** how many of your players are in a game (counted once) */
      _psMineIn(gid) {
        const held = this._psHeld;
        return (this._psByGame.get(String(gid)) || []).filter(p => held.has(pid(p))).length;
      },
      _psOwn(p) { const n = this._psHeld.get(pid(p)) || 0; return n ? n + '/' + this._psLus : ''; },
      get _psSport() { return String(this._sportId || '').toLowerCase(); },
      /** 'kick-off' / 'tip-off' / 'puck drop' / 'first pitch' (SPORT-2) */
      get _psStart() { return window.LSModelUtil.startWord(this._psSport); },
      /** Weather is a thing for outdoor sports only; hockey / basketball get rest instead. */
      get _psOutdoor() { return ['nfl', 'mlb', 'cfb', 'soccer'].includes(this._psSport); },
      /** Teams on the second night of a back-to-back, from /api/slate-brief .rest (by game id). */
      get _psRest() {
        if (typeof this._restFor !== 'function') return [];
        const out = [];
        for (const g of (this._scopeGames || [])) for (const side of ['away', 'home']) {
          if (this._restFor(g, side).b2b) out.push({ g, side, team: g[side + '_team'] });
        }
        return out;
      },

      // ── the windows (all games) ────────────────────────────────────────
      get _psWindows() {
        const out = [], byKey = new Map();
        for (const g of (this._scopeGames || [])) {
          const w = windowOf(g.game_time_utc, this._psSport);
          if (!byKey.has(w.key)) { const row = { key: w.key, label: w.label, time: w.day || when(g.game_time_utc), t: ms(g.game_time_utc), games: [], mine: 0, fixed: !!w.day }; byKey.set(w.key, row); out.push(row); }
          const row = byKey.get(w.key);
          const mine = this._psMineIn(g.game_id);
          row.games.push({ g, id: String(g.game_id), label: g.away_team + ' @ ' + g.home_team, mine });
          row.mine += mine;
          if (ms(g.game_time_utc) < row.t) { row.t = ms(g.game_time_utc); if (!row.fixed) row.time = when(g.game_time_utc); }
        }
        // a window that spans several start times says so ("21:05 / 21:25")
        for (const r of out) {
          const ts = [...new Set(r.games.map(x => ms(x.g.game_time_utc)))].sort((a, b) => a - b);
          if (ts.length > 1 && !r.fixed) r.time = when(new Date(ts[0]).toISOString()) + ' / ' + new Date(ts[ts.length - 1]).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }
        return out.sort((a, b) => a.t - b.t);
      },

      // ── the Brief lines (all games) ────────────────────────────────────
      get _psVegas() {
        const rows = (this._scopeGames || []).map(g => ({ g, o: this._pregameOdds(g) })).filter(x => x.o && x.o.over_under != null);
        if (!rows.length) return null;
        const byTot = rows.slice().sort((a, b) => num(b.o.over_under) - num(a.o.over_under));
        const fav = rows.map(x => ({ ...x, s: spreadOf(x.o.details) })).filter(x => x.s != null).sort((a, b) => b.s - a.s)[0];
        // a shared top (or bottom) total is said as a tie, not one game of five (NUMBERS-9)
        const at = (v) => rows.filter(x => num(x.o.over_under) === num(v)).length;
        const hi = byTot[0], lo = byTot[byTot.length - 1];
        return { hi, lo, hiN: at(hi.o.over_under), loN: at(lo.o.over_under), fav, n: rows.length, of: (this._scopeGames || []).length };
      },
      get _psWeather() {
        const t = this._briefTile ? this._briefTile('weather') : null;
        if (t && t.locked) return { locked: true, count: t.count || 0 };
        const games = (this._scopeGames || []).map(g => ({ g, w: this._pregameWx(g) })).filter(x => x.w);
        if (!games.length) return null;
        const watch = games.filter(({ w }) => w.roof !== 'dome' && ((w.gust || 0) >= 20 || (w.wind_speed || 0) >= 15 || (w.precipitation || 0) >= 40))
          .sort((a, b) => ((b.w.gust || b.w.wind_speed || 0) + (b.w.precipitation || 0) / 2) - ((a.w.gust || a.w.wind_speed || 0) + (a.w.precipitation || 0) / 2));
        const indoors = games.filter(({ w }) => w.roof === 'dome').length;
        // only what earns the game its place: gusts / wind past the line, rain past 40%
        const say = (w) => [
          (w.gust || 0) >= 20 ? 'gusts ' + Math.round(w.gust) + ' mph' : ((w.wind_speed || 0) >= 15 ? 'wind ' + Math.round(w.wind_speed) + ' mph' : ''),
          (w.precipitation || 0) >= 40 ? Math.round(w.precipitation) + '% rain' : '',
        ].filter(Boolean).join(', ')
          // a retractable roof may be shut on the day: said, not hidden (SPORT-6)
          + (w.roof === 'retractable' ? ' (roof)' : '');
        return { watch: watch.slice(0, 2).map(({ g, w }) => ({ g, text: say(w) })), more: Math.max(0, watch.length - 2), indoors };
      },
      get _psHeads() { return this._scopeHeads || { n: 0 }; },

      // ── flagged ─────────────────────────────────────────────────────────
      _psFlagged(gid) {
        const held = this._psHeld;
        const pool = gid ? (this._psByGame.get(String(gid)) || []) : (this.allSlatePlayers || []);
        return pool.filter(p => FLAG[p.lineup_status])
          .map(p => ({ id: pid(p), name: p.name, team: p.team, pos: p.pos, salary: num(p.salary), flag: FLAG[p.lineup_status], n: held.get(pid(p)) || 0 }))
          .sort((a, b) => (b.n - a.n) || (b.salary - a.salary) || (FLAG_ORDER[a.flag] - FLAG_ORDER[b.flag]));   // yours first, then by salary
      },
      get _psFlags() { return this._psFlagged(this._scope); },
      get _psFlagCounts() {
        const c = { OUT: 0, DOUBT: 0, Q: 0 };
        for (const f of this._psFlagged(null)) c[f.flag]++;
        return c;
      },

      // ── news ────────────────────────────────────────────────────────────
      get _psNews() {
        const list = (this._newsIn ? this._newsIn(this._scope) : []) || [];
        // yours first, then newest
        return list.slice().sort((a, b) => ((this._briefMine(b) ? 1 : 0) - (this._briefMine(a) ? 1 : 0)) || (ms(b.published) - ms(a.published)));
      },
      _psNewsGame(n) {
        for (const p of (n.players || [])) {
          const g = this._scope ? null : (this._scopeGames || []).find(x => this._inGame(p, String(x.game_id)));
          if (g) return g.away_team + ' @ ' + g.home_team;
        }
        return '';
      },

      // ── the four tiles ──────────────────────────────────────────────────
      get _psTiles() {
        void this._timerNow;   // the countdowns tick
        const now = Date.now(), games = this._scopeGames || [], g = this._scopeGame;
        if (g) {
          const o = this._pregameOdds(g), held = this._psHeld;
          const mine = (this._psByGame.get(String(g.game_id)) || []).filter(p => held.has(pid(p)))
            .sort((a, b) => (held.get(pid(b)) - held.get(pid(a))) || (num(b.salary) - num(a.salary)));
          const fl = this._psFlagged(g.game_id), w = windowOf(g.game_time_utc, this._psSport);
          const totals = games.map(x => this._pregameOdds(x)).filter(x => x && x.over_under != null).map(x => num(x.over_under)).sort((a, b) => b - a);
          // a rank only means something when the totals differ (hockey's are all 6.5)
          const rank = o && o.over_under != null && totals[0] !== totals[totals.length - 1] ? totals.indexOf(num(o.over_under)) + 1 : 0;
          return [
            { k: this._psStart.charAt(0).toUpperCase() + this._psStart.slice(1), v: when(g.game_time_utc), f: w.label + ' · in ' + until(g.game_time_utc, now) },
            o && o.over_under != null
              ? { k: 'Total', v: String(o.over_under), f: (o.details || '') + (rank && totals.length > 1 ? ' · ' + (rank === 1 ? 'highest' : ordinal(rank) + ' highest') + ' on the slate' : '') }
              : { k: 'Total', v: '–', f: 'no line posted yet', dim: true },
            this._psLus
              ? { k: 'Your players', v: String(mine.length), f: mine.length ? mine.slice(0, 2).map(p => window.LSModelUtil.short(p) + ' in ' + this._psOwn(p)).join(' · ') : 'none of yours in this game', dim: !mine.length }
              : { k: 'Players', v: String((this._psByGame.get(String(g.game_id)) || []).length), f: 'in the pool for this game' },
            { k: 'Flagged', v: String(fl.length), f: fl.length ? fl.slice(0, 2).map(f => window.LSModelUtil.short(f) + ' ' + f.flag).join(' · ') : 'full strength', tone: fl.some(f => f.flag === 'OUT') ? 'out' : (fl.length ? 'warn' : '') },
          ];
        }
        const first = games[0];
        const c = this._psFlagCounts, nFlag = c.OUT + c.DOUBT + c.Q;
        if (!this._psLus) {
          return [
            { k: window.LSModelUtil.firstStart(this._psSport), v: first ? until(first.game_time_utc, now) : '–', f: first ? first.away_team + ' @ ' + first.home_team + ' · ' + when(first.game_time_utc) : '' },
            { k: 'Games', v: String(games.length), f: this._psWindows.length + (this._psWindows.length === 1 ? ' window' : ' windows') },
            { k: 'Flagged', v: String(nFlag), f: [c.OUT ? c.OUT + ' out' : '', c.DOUBT ? c.DOUBT + ' doubtful' : '', c.Q ? c.Q + ' questionable' : ''].filter(Boolean).join(' · ') || 'nobody flagged yet', tone: nFlag ? 'warn' : '' },
            { k: 'Your lineups', v: '0', f: 'add one to see your night', dim: true, cta: true },
          ];
        }
        const held = this._psHeld, pool = this.allSlatePlayers || [];
        const minePool = pool.filter(p => held.has(pid(p)));
        const firstMine = minePool.slice().sort((a, b) => {
          const ga = games.find(x => String(x.game_id) === String(a.game_id)), gb = games.find(x => String(x.game_id) === String(b.game_id));
          return (ms(ga && ga.game_time_utc) - ms(gb && gb.game_time_utc)) || ((held.get(pid(b)) || 0) - (held.get(pid(a)) || 0));
        })[0];
        const fg = firstMine && games.find(x => String(x.game_id) === String(firstMine.game_id));
        const slots = (this.lineupRows || []).reduce((s, lu) => s + (lu.players || []).length, 0);
        const myFlags = this._psFlagged(null).filter(f => f.n);
        const top = minePool.slice().sort((a, b) => (held.get(pid(b)) - held.get(pid(a))) || (num(b.salary) - num(a.salary)))[0];
        return [
          { k: 'Your first player', v: fg ? until(fg.game_time_utc, now) : '–', f: firstMine ? window.LSModelUtil.short(firstMine) + ' · ' + fg.away_team + ' @ ' + fg.home_team : 'no game found yet' },
          { k: 'Your players', v: String(minePool.length), f: 'in ' + this._psLus + (this._psLus === 1 ? ' lineup' : ' lineups') + ' · ' + slots + ' slots' },
          { k: 'Flagged in yours', v: String(myFlags.length), f: myFlags.length ? myFlags.slice(0, 2).map(f => window.LSModelUtil.short(f) + ' ' + f.flag + ' in ' + f.n + '/' + this._psLus).join(' · ') : 'all clear', tone: myFlags.some(f => f.flag === 'OUT') ? 'out' : (myFlags.length ? 'warn' : 'good') },
          { k: 'Top exposure', v: top ? Math.round(100 * held.get(pid(top)) / this._psLus) + '%' : '–', f: top ? top.name + ' · ' + held.get(pid(top)) + ' of ' + this._psLus : '' },
        ];
      },

      // ── one game ────────────────────────────────────────────────────────
      get _psGame() {
        const g = this._scopeGame;
        if (!g) return null;
        const o = this._pregameOdds(g), wx = this._pregameWx(g), impl = (this._impl ? this._impl(g) : []) || [];
        const top = Math.max(1, ...impl.map(r => num(r.total)));
        const held = this._psHeld;
        const players = (this._psByGame.get(String(g.game_id)) || []).filter(p => num(p.salary) > 0)
          .sort((a, b) => num(b.salary) - num(a.salary))
          .map(p => ({ id: pid(p), name: p.name, team: p.team, pos: p.pos, salary: num(p.salary), avg: num(p.baseline),
                       value: num(p.baseline) > 0 && num(p.salary) > 0 ? num(p.baseline) / (num(p.salary) / 1000) : 0,
                       own: held.get(pid(p)) ? held.get(pid(p)) + '/' + this._psLus : '', flag: FLAG[p.lineup_status] || '' }));
        return {
          g, odds: o, wx, players,
          impl: impl.slice().sort((a, b) => num(b.total) - num(a.total)).map(r => ({ team: r.team, total: num(r.total), pct: Math.round(100 * num(r.total) / top) })),
          rec: { away: this._pregameRec(g, 'away'), home: this._pregameRec(g, 'home') },
          venue: (wx && wx.venue_name) || '',
        };
      },

      // ── the clubs: crest, full name, colour ────────────────────────────
      // Read from the slate's own payload (the game's logo, the pool's
      // team_logo, teams.primary_color) by the slate's own team code - the
      // same maps the scoreboard draws from; nothing is matched across feeds.
      _psLogo(g, side) { return (g && g[side + '_logo']) || this._psLogoOf(g && g[side + '_team']); },
      _psLogoOf(abbr) { return ((this._teamLogos || {})[String(abbr || '').toUpperCase()]) || ''; },
      _psName(abbr) { return (typeof teamFullName === 'function' ? teamFullName(this._psSport, abbr) : '') || abbr || ''; },
      /** "Tampa Bay" / "Buccaneers" - the header sets the club's name the way
       *  a broadcast does, city over nickname. A name with no city (or an
       *  abbreviation, when the name is unknown) goes whole in the big line. */
      _psCity(abbr) { const n = this._psName(abbr), i = n.lastIndexOf(' '); return i > 0 ? n.slice(0, i) : ''; },
      _psNick(abbr) { const n = this._psName(abbr), i = n.lastIndexOf(' '); return i > 0 ? n.slice(i + 1) : n; },
      _psColor(abbr) { return typeof this.teamColor === 'function' ? this.teamColor(abbr) : ''; },
      /** "DAL -8.5 · 47.5" once a line is posted, else ''. */
      _psLine(g) { const o = this._pregameOdds(g); return o ? [o.details, o.over_under != null ? 'o/u ' + o.over_under : ''].filter(Boolean).join(' · ') : ''; },

      // ── helpers the template uses ───────────────────────────────────────
      _psWhen: when,
      _psMoney(v) { return v ? '$' + (v / 1000).toFixed(1) + 'K' : '–'; },
      _psPick(gid) { this._scopeSet(gid); },
    };
  }

  function ordinal(n) { const s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }

  return { scope, fit, windowOf, when, until, spreadOf };
})();

/* ==== static/js/widgets/lab_charts.js ==== */
;
/* widgets/lab_charts.js — five Lab charts (Xav 2026-10-05: "build them all"),
 * for The Lab and for anyone's own dashboard:
 *
 *   value_map        Value Map - every player on the slate, salary x points,
 *                    yours lit, with 2x / 3x / 4x value lines.
 *   points_timeline  When the Points Came - each lineup's scoring jumps across
 *                    the night, a dot per jump sized by points.
 *   lineup_build     Lineup Build - one lineup's score as a waterfall, player
 *                    by player, against the Dream Team.
 *   lineup_overlap   Lineup Overlap - your lineups against each other, shaded
 *                    by how many players they share.
 *   exposure_grid    Exposure Grid - your players x your lineups, each cell
 *                    coloured by the points that player brought there.
 *
 * The data shaping is pure (LSLabCharts.*, tests/js/lab_charts.test.js); the
 * widgets are ECharts panels on LSChart.panelBase (redrawn on lastUpdated).
 * Joins by player id. */
window.LSLabCharts = (function () {
  const { num, pid, isDst, full, short, andList, nameOf, toMs } = window.LSModelUtil;   // shared helpers (model_util.js)
  const last = short;   // the shared last-name helper (audit run 3, CODE-12)
  const ranked = (lineups) => (lineups || []).map((lu, i) => ({ lu, i, id: String(lu.id), name: nameOf(lu, i), live: num(lu.live_total) }))
    .sort((a, b) => (b.live - a.live) || (a.i - b.i));

  /** Value Map: everyone who has played, salary against points; yours flagged. */
  function valueMap(pool, lineups) {
    const mine = {};
    for (const lu of lineups || []) for (const p of lu.players || []) { const k = pid(p); if (k) mine[k] = (mine[k] || 0) + 1; }
    const seen = new Set(), pts = [];
    for (const p of pool || []) {
      const k = pid(p), sal = num(p.salary);
      if (!k || seen.has(k) || sal <= 0 || p.game_phase === 'not_started') continue;
      seen.add(k);
      pts.push({ id: k, name: full(p), short: last(p), team: String(p.team || '').toUpperCase(), pos: String(p.pos || ''),
                 sal, pts: num(p.live_fpts), n: mine[k] || 0 });
    }
    const dollars = pts.some(p => p.sal >= 1000);
    const per = (p) => p.pts / (dollars ? p.sal / 1000 : p.sal);
    const best = pts.filter(p => p.n && p.pts > 0).sort((a, b) => per(b) - per(a))[0] || null;
    return { points: pts, dollars, best: best ? { ...best, value: per(best) } : null,
             maxSal: Math.max(1, ...pts.map(p => p.sal)), maxPts: Math.max(1, ...pts.map(p => p.pts)) };
  }

  /** When the Points Came: per lineup, the jumps between trajectory frames. */
  function timeline(history, lineups, maxLanes) {
    const lanes = ranked(lineups).slice(0, maxLanes || 8);
    const frames = (history || []).filter(f => f && f.t != null && f.totals).map(f => ({ t: toMs(f.t), totals: f.totals }))
      .filter(f => isFinite(f.t)).sort((a, b) => a.t - b.t);
    const dots = [];
    lanes.forEach((x, row) => {
      let prev = null;
      for (const f of frames) {
        if (!(x.id in f.totals)) continue;
        const v = num(f.totals[x.id]);
        if (prev != null && v - prev >= 0.5) dots.push({ row, lane: x.name, t: f.t, gain: v - prev, total: v });
        prev = v;
      }
    });
    const big = dots.slice().sort((a, b) => b.gain - a.gain)[0] || null;
    return { lanes: lanes.map(x => x.name), dots, biggest: big };
  }

  /** Lineup Build: one lineup's players as a waterfall, biggest first. */
  function build(lineup, dreamScore) {
    const ps = ((lineup && lineup.players) || []).map(p => ({ name: full(p), short: last(p), pts: num(p.live_fpts), pos: String(p.slot || p.pos || '') }))
      .sort((a, b) => b.pts - a.pts);
    let run = 0;
    const steps = ps.map(p => { const base = p.pts >= 0 ? run : run + p.pts; run += p.pts; return { ...p, base, top: run }; });
    return { steps, total: run, dream: num(dreamScore) };
  }

  /** Lineup Overlap: how many players each pair of lineups shares. */
  function overlap(lineups, max) {
    const lus = ranked(lineups).slice(0, max || 12);
    const sets = lus.map(x => new Set((x.lu.players || []).map(pid).filter(Boolean)));
    const cells = [];
    let bestPair = null;
    for (let i = 0; i < lus.length; i++) for (let j = 0; j < lus.length; j++) {
      let n = 0;
      for (const k of sets[i]) if (sets[j].has(k)) n++;
      cells.push([j, i, n]);
      if (i < j && (!bestPair || n > bestPair.n)) bestPair = { a: lus[i].name, b: lus[j].name, n, of: Math.max(sets[i].size, sets[j].size) };
    }
    return { names: lus.map(x => x.name), sizes: sets.map(s => s.size), cells, most: bestPair };
  }

  /** Exposure Grid: your most-used players down the side, your lineups across. */
  function exposure(lineups, maxPlayers, maxLineups) {
    const lus = ranked(lineups).slice(0, maxLineups || 10);
    const use = new Map();
    for (const x of ranked(lineups)) for (const p of x.lu.players || []) {
      const k = pid(p);
      if (!k) continue;
      const u = use.get(k) || { p, n: 0 };
      u.n += 1; use.set(k, u);
    }
    const players = [...use.values()].sort((a, b) => (b.n - a.n) || (num(b.p.live_fpts) - num(a.p.live_fpts))).slice(0, maxPlayers || 14);
    const cells = [];
    players.forEach((u, row) => lus.forEach((x, col) => {
      const hit = (x.lu.players || []).find(p => pid(p) === pid(u.p));
      if (hit) cells.push([col, row, num(hit.live_fpts)]);
    }));
    return { players: players.map(u => full(u.p) + ' (' + u.n + ')'), lineups: lus.map(x => x.name), cells,
             max: Math.max(1, ...cells.map(c => c[2])) };
  }

  /** Score Distribution as a ladder (Xav 2026-10-16: the bars were "sausages",
   *  lab design A): every lineup where it stands now and where it is heading,
   *  on one track from nil to the Dream Team. The heading is the pace estimate
   *  (your projections, else the DK average - model_util.lineupPace). */
  function ladder(lineups, dreamScore) {
    const rows = ranked(lineups).map(x => {
      const ps = x.lu.players || [], pc = window.LSModelUtil.lineupPace(ps);
      return { id: x.id, name: x.name, live: x.live, est: Math.max(x.live, pc ? pc.est : num(x.lu.est_total)),
               toPlay: ps.filter(p => p.game_phase === 'not_started').length,
               playing: ps.filter(p => p.game_phase && p.game_phase !== 'not_started' && p.game_phase !== 'finished').length };
    });
    const dream = Math.max(0, num(dreamScore));
    return { rows, best: rows[0] || null, dream, top: Math.max(1, dream, ...rows.map(r => r.est)) };
  }

  /** Stack markers that would touch: each value (best first) takes the lowest
   *  row where nothing already sits within `gap` of it - a swarm, never a pile. */
  function stack(values, gap) {
    const placed = [];
    return values.map(v => {
      let lvl = 0;
      while (placed.some(p => p.lvl === lvl && Math.abs(p.v - v) < gap)) lvl++;
      placed.push({ v, lvl });
      return lvl;
    });
  }

  return { valueMap, timeline, build, overlap, exposure, ladder, stack, _full: full, _last: last };
})();

(function () {
  if (!window.LSWidgets) return;              // the data shaping above loads alone in tests
  const { num, pid, isDst, full, short, andList, nameOf, toMs } = window.LSModelUtil;   // shared helpers (model_util.js)
  const tip = (t) => ({ backgroundColor: t.tooltip.backgroundColor, borderColor: t.tooltip.borderColor, borderWidth: 1,
                        textStyle: t.tooltip.textStyle, extraCssText: t.tooltip.extraCssText });
  const axis = (t, extra) => Object.assign({ axisLabel: { color: t.axisLabel, fontSize: 10 }, axisLine: { show: false }, axisTick: { show: false },
                                             splitLine: { lineStyle: { color: t.splitLine } } }, extra || {});
  const EMPTY = { backgroundColor: 'transparent', xAxis: { show: false }, yAxis: { show: false }, series: [] };
  const C = () => window.LSLabCharts;
  const clock = (ms) => { const d = new Date(ms); return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0'); };

  window.LSWidgets.register({
    id: 'value_map', slot: 'panel', title: 'Value Map', sportScope: '*', bestAt: 'any',
    description: 'Every player on the slate: salary against points, yours lit, with 2x / 3x / 4x value lines.',
    help: 'Each dot is a player who has played: across is salary, up is live points. Yours are lit (bigger the more lineups they are in). The faint diagonals are 2, 3 and 4 pts/$1K - above a line, a player has beaten that price. Hover for the name.',
    minCells: { w: 4, h: 3 }, defaultCells: { w: 6, h: 5 },
    factory: () => ({
      ...LSChart.panelBase(),
      /** Anyone on the map yet - a player counts once his game has started.
       *  Before then the chart was a blank panel (v2 run 1, SPACE-19). */
      get _vmAny() { return (this.allSlatePlayers || []).some(p => p.game_phase && p.game_phase !== 'not_started' && num(p.salary) > 0); },
      _option() {
        const t = LSChart.theme(), dark = LSChart.isDark();
        const m = C().valueMap(this.allSlatePlayers || [], this.lineupRows || []);
        if (!m.points.length) return EMPTY;
        const k = m.dollars ? 1000 : 1, xa = window.LSModelUtil.niceAxis(m.maxSal * 1.02, 4), xMax = xa.max;
        const ya = window.LSModelUtil.niceAxis(m.maxPts * 1.04, 4);
        const line = (x) => [[0, 0], [xMax, x * xMax / k]];
        const other = m.points.filter(p => !p.n), mine = m.points.filter(p => p.n);
        const lbl = new Set(mine.slice().sort((a, b) => b.pts / b.sal - a.pts / a.sal).slice(0, 5).map(p => p.id));
        const fs = (v) => this._fmtScore(v);
        const money = (v) => (m.dollars ? '$' + Math.round(v).toLocaleString('en-US') : v);
        return {
          backgroundColor: 'transparent',
          // right: room for the top guide's "4 pts/$1K" (it was cut to "4 p")
          grid: { left: 6, right: 58, top: 14, bottom: 6, containLabel: true },
          tooltip: { ...tip(t), trigger: 'item', formatter: (p) => {
            const d = p.data && p.data.r; if (!d) return '';
            return '<b>' + d.name + '</b> <span style="color:' + t.labelDim + '">' + [d.team, d.pos].filter(Boolean).join(' · ') + '</span><br/>'
              + fs(d.pts) + ' at ' + money(d.sal) + ' · <b>' + (d.pts / (d.sal / k)).toFixed(2) + (m.dollars ? ' pts/$1K' : ' per unit') + '</b>'
              + (d.n ? '<br/><span style="color:' + t.emeraldDim + '">In ' + d.n + ' of your lineups</span>' : ''); } },
          xAxis: axis(t, { type: 'value', max: xMax, interval: xa.interval, axisLabel: { color: t.axisLabel, fontSize: 10, formatter: (v) => (m.dollars ? (v ? '$' + (v / 1000) + 'K' : '') : v) } }),   // "$7.8K" like the rest of the board; no "$0k" at the origin (NUMBERS-12)
          yAxis: axis(t, { type: 'value', min: 0, max: ya.max, interval: ya.interval }),   // from 0: a -10 floor read as negative points
          animationDuration: 600, animationDurationUpdate: 400,
          series: [
            ...[2, 3, 4].map(x => ({ type: 'line', data: line(x), symbol: 'none', silent: true, z: 1,
              lineStyle: { color: dark ? 'rgba(148,163,184,0.28)' : 'rgba(15,23,42,0.16)', type: 'dashed', width: 1 },
              // the top guide carries the unit once ("4 pts/$1K"); the others
              // read as the same scale (audit run 3, NUM-30)
              endLabel: { show: true, formatter: m.dollars ? (x === 4 ? '4 pts/$1K' : String(x)) : x + 'x', color: t.labelDim, fontSize: 10 } })),
            { type: 'scatter', z: 2, symbolSize: 6, itemStyle: { color: dark ? 'rgba(148,163,184,0.35)' : 'rgba(100,116,139,0.30)' },
              data: other.map(r => ({ value: [r.sal, r.pts], r })) },
            // labelLayout: two names never print over each other ("Wilson" +
            // "Cousins" read "Wilcensins" - audit run 1, TYPE-9 / SPACE-14).
            { type: 'scatter', z: 3, labelLayout: { hideOverlap: true }, itemStyle: { color: t.emerald, borderColor: '#fff', borderWidth: 1, shadowBlur: 8, shadowColor: t.emerald + '88' },
              data: mine.map(r => ({ value: [r.sal, r.pts], r, symbolSize: 9 + Math.min(10, r.n * 2),
                label: { show: lbl.has(r.id), formatter: r.short, position: 'top', color: t.label, fontSize: 10, fontWeight: 700 } })) },
          ],
        };
      },
    }),
  });

  // Score Distribution (Xav 2026-10-07; the Ladder since 2026-10-16 - the
  // bars read as "sausages"): one track from nil to the Dream Team, every
  // lineup a marker where it stands with a faint trail to where it is
  // heading. Lineups that would touch stack into a swarm; up to 8 carry their
  // name (4 on a narrow panel), past that only your best does and the rest
  // answer on hover. The same chart for 1 lineup or 150.
  window.LSWidgets.register({
    id: 'score_distribution', slot: 'panel', title: 'Score Distribution', sportScope: '*', bestAt: 'any',
    description: 'Your lineups on one track to the Dream Team: where each stands, and where it is heading.',
    help: 'One track from nil to the Dream Team (the gold line). Each marker is a lineup at its live score, the filled one your best; the faint trail runs to where it is heading - your projections, else the DraftKings average, for the players still to play. Lineups close together stack up, so a crowd reads at a glance. Hover a marker for its name, score and players left.',
    minCells: { w: 4, h: 3 }, defaultCells: { w: 6, h: 5 },
    factory: () => ({
      ...LSChart.panelBase(),
      _option() {
        const t = LSChart.theme();
        const m = C().ladder(this.lineupRows || [], this.dreamTeamScore);
        if (!m.rows.length) return EMPTY;
        const fs = (v) => this._fmtScore(v);
        const gold = LSChart.cssVar('--bc-gold', '') || LSChart.cssVar('--ls-star-hi', '#fcd34d');
        const W = (this._chart && this._chart.getWidth()) || 600, H = (this._chart && this._chart.getHeight()) || 220;
        const xa = window.LSModelUtil.niceAxis(m.top * 1.04, 4), xMax = xa.max;
        const GRID = { left: 14, right: 18, top: 22, bottom: 24 };   // top: the Dream label sits above the plot
        const plotW = Math.max(120, W - GRID.left - GRID.right), plotH = Math.max(60, H - GRID.top - GRID.bottom);
        const n = m.rows.length;
        // names on every marker only while they fit - past that the best alone
        const named = n <= (W < 420 ? 4 : 8);
        let r = n > 40 ? 5 : n > 8 ? 7 : 9;
        const gapPx = named ? 128 : r * 2.1;
        const lvls = C().stack(m.rows.map(x => x.live), gapPx * xMax / plotW);
        const rows = Math.max(...lvls) + 1;
        // the swarm shrinks to fit the panel rather than spill over its top
        const TRACK = 10, room = plotH - TRACK - 14 - (named || n > 1 ? 18 : 4);
        let step = named ? r * 2 + 22 : r * 2.1;
        if (rows * step > room) { const k = room / (rows * step); r = Math.max(2.5, r * k); step *= k; }
        const yOf = (lvl) => TRACK + 12 + r + lvl * step;
        const pct = (v) => (m.dream > 0 ? Math.round(v / m.dream * 100) + '%' : '');
        const trails = n <= 40;
        const halo = LSChart.cssVar('--bc-panel', '') || (LSChart.isDark() ? '#0f172a' : '#ffffff');
        const dot = m.rows.map((x, i) => {
          const best = i === 0, label = named || best;
          return { value: [x.live, yOf(lvls[i])], x, symbolSize: r * 2,
                   itemStyle: { color: best ? t.emerald : t.emerald + '2e', borderColor: t.emerald, borderWidth: best ? 0 : 1.5,
                                shadowBlur: best ? 10 : 0, shadowColor: t.emerald + '88' },
                   // the best alone in a swarm reads to its right - the ground ahead of
                   // your top score is the one place no other marker sits
                   label: { show: label, position: named ? 'top' : 'right', distance: named ? 4 : 8, color: t.label, fontSize: 11, fontWeight: 700,
                            formatter: (named ? '' : 'Best · ') + x.name + ' · ' + fs(x.live),
                            // a halo in the panel's colour: the name crosses its own trail
                            textBorderColor: halo, textBorderWidth: 3 } };
        });
        return {
          backgroundColor: 'transparent',
          grid: GRID,
          tooltip: { ...tip(t), trigger: 'item', formatter: (p) => {
            const x = p.data && p.data.x; if (!x) return '';
            const left = x.toPlay || x.playing ? [x.toPlay ? x.toPlay + ' yet to play' : '', x.playing ? x.playing + ' playing' : ''].filter(Boolean).join(' · ') : 'Everyone has played';
            return '<b>' + x.name + '</b><br/>' + fs(x.live) + (m.dream > 0 ? ' · ' + pct(x.live) + ' of the Dream Team' : '')
              + (x.est > x.live + 0.005 ? '<br/>Heading for <b>' + fs(x.est) + '</b>' : '')
              + '<br/><span style="color:' + t.labelDim + '">' + left + '</span>'; } },
          xAxis: axis(t, { type: 'value', min: 0, max: xMax, interval: xa.interval, splitLine: { show: false },
                           axisLabel: { color: t.axisLabel, fontSize: 10, hideOverlap: true, formatter: (v) => Math.round(v) } }),
          yAxis: { type: 'value', min: 0, max: plotH, show: false },
          animationDurationUpdate: 700, animationEasingUpdate: 'cubicOut',
          // a fixed five series every draw: panelBase merges, so a series that
          // came and went would linger
          series: [
            { type: 'line', silent: true, symbol: 'none', z: 1, data: [[0, TRACK], [xMax, TRACK]],
              lineStyle: { width: 8, cap: 'round', color: LSChart.isDark() ? 'rgba(148,163,184,0.16)' : 'rgba(15,23,42,0.07)' } },
            { type: 'line', silent: true, symbol: 'none', z: 2, data: [[0, TRACK], [m.best.live, TRACK]],
              lineStyle: { width: 8, cap: 'round', color: t.emerald + '66' },
              markLine: m.dream > 0 ? { symbol: 'none', silent: true, lineStyle: { color: gold, type: 'dashed', width: 2 },
                label: { formatter: 'Dream ' + fs(m.dream), color: gold, fontSize: 11, fontWeight: 800, position: 'end', distance: 4 },
                data: [{ xAxis: m.dream }] } : { data: [] } },
            { type: 'lines', coordinateSystem: 'cartesian2d', silent: true, z: 3,
              lineStyle: { color: t.emerald, opacity: 0.24, width: Math.max(2, r / 2.2), cap: 'round' },
              data: trails ? m.rows.map((x, i) => ({ coords: [[x.live, yOf(lvls[i])], [x.est, yOf(lvls[i])]] })).filter(d => d.coords[1][0] > d.coords[0][0]) : [] },
            { type: 'scatter', silent: true, z: 3, symbolSize: Math.max(4, r * 0.9),
              itemStyle: { color: 'transparent', borderColor: t.emerald, borderWidth: 1.5, borderType: 'dashed', opacity: 0.6 },
              data: n <= 12 ? m.rows.map((x, i) => [x.est, yOf(lvls[i])]).filter((d, i) => d[0] > m.rows[i].live + 0.005) : [] },
            { type: 'scatter', z: 4, labelLayout: { hideOverlap: true }, data: dot,
              emphasis: { scale: 1.25, itemStyle: { shadowBlur: 12, shadowColor: t.emerald } } },
          ],
        };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'points_timeline', slot: 'panel', title: 'When the Points Came', sportScope: '*', bestAt: 'multi',
    description: 'Each lineup across the night, a dot for every scoring jump, sized by the points - one big moment, or a steady grind.',
    help: 'One row per lineup (your top 8). Every dot is a jump in that lineup\'s score between two moments of the night; the bigger the dot, the bigger the jump. Hover for the time and the points. It is the story behind the Trajectory line.',
    minCells: { w: 4, h: 3 }, defaultCells: { w: 6, h: 4 },
    factory: () => ({
      ...LSChart.panelBase(),
      _option() {
        const t = LSChart.theme();
        const hist = (this.lineupHistory && this.lineupHistory.length >= 2) ? this.lineupHistory : (this._lineupHistory || []);
        const m = C().timeline(hist, this.lineupRows || [], 8);
        if (!m.dots.length) return EMPTY;
        const maxG = Math.max(1, ...m.dots.map(d => d.gain));
        const fs = (v) => this._fmtScore(v);
        return {
          backgroundColor: 'transparent',
          grid: { left: 6, right: 16, top: 10, bottom: 6, containLabel: true },
          tooltip: { ...tip(t), trigger: 'item', formatter: (p) => { const d = p.data.d;
            return '<b>' + d.lane + '</b><br/>+' + fs(d.gain) + ' by ' + clock(d.t) + '<br/><span style="color:' + t.labelDim + '">' + fs(d.total) + ' then</span>'; } },
          xAxis: axis(t, { type: 'time', axisLabel: { color: t.axisLabel, fontSize: 10, formatter: (v) => clock(v) }, splitLine: { show: false } }),
          yAxis: axis(t, { type: 'category', data: m.lanes, inverse: true, axisLabel: { color: t.label, fontSize: 11, fontWeight: 600, width: 90, overflow: 'truncate' } }),
          series: [{ type: 'scatter', data: m.dots.map(d => ({ value: [d.t, d.row], d, symbolSize: 6 + 22 * Math.sqrt(d.gain / maxG) })),
                     itemStyle: { color: t.emerald, opacity: 0.75, borderColor: t.emerald, borderWidth: 1 },
                     emphasis: { itemStyle: { opacity: 1, shadowBlur: 10, shadowColor: t.emerald } } }],
        };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'lineup_build', slot: 'panel', title: 'Lineup Build', sportScope: '*', bestAt: 'any',
    description: 'One lineup\'s score as a waterfall, player by player, against the Dream Team.',
    help: 'Your score built up one player at a time, biggest first, ending at the total; the gold line is the Dream Team. Click the lineup name to step through your lineups.',
    minCells: { w: 4, h: 3 }, defaultCells: { w: 6, h: 4 },
    factory: () => ({
      ...LSChart.panelBase(),
      _pick: 0,
      /** Lineups best first; the one on show. */
      get _lus() { return [...(this.lineupRows || [])].sort((a, b) => num(b.live_total) - num(a.live_total)); },
      get _cur() { const l = this._lus; return l.length ? l[this._pick % l.length] : null; },
      _next() { this._pick = (this._pick + 1) % Math.max(1, this._lus.length); this._draw(); },
      _option() {
        const t = LSChart.theme();
        const lu = this._cur;
        if (!lu) return EMPTY;
        const m = C().build(lu, this.dreamTeamScore || 0);
        const fs = (v) => this._fmtScore(v);
        const gold = LSChart.cssVar('--ls-star-hi', '#fcd34d');
        return {
          backgroundColor: 'transparent',
          grid: { left: 6, right: 16, top: 18, bottom: 6, containLabel: true },
          tooltip: { ...tip(t), trigger: 'axis', axisPointer: { type: 'shadow' }, formatter: (ps) => {
            const s = m.steps[ps[0].dataIndex]; return s ? '<b>' + s.name + '</b> ' + s.pos + '<br/>+' + fs(s.pts) + ' → ' + fs(s.top) : ''; } },
          xAxis: axis(t, { type: 'category', data: m.steps.map(s => s.short), axisLabel: { color: t.label, fontSize: 10, fontWeight: 600, interval: 0, rotate: m.steps.length > 7 ? 30 : 0 }, splitLine: { show: false } }),
          yAxis: axis(t, { type: 'value', ...(({ max, interval }) => ({ max, interval }))(window.LSModelUtil.niceAxis(Math.max(m.total, m.dream) * 1.04, 4)) }),
          animationDurationUpdate: 500,
          series: [
            { type: 'bar', stack: 'w', silent: true, itemStyle: { color: 'transparent' }, data: m.steps.map(s => s.base) },
            { type: 'bar', stack: 'w', barMaxWidth: 34,
              itemStyle: { borderRadius: [5, 5, 0, 0] },
              label: { show: true, position: 'top', color: t.label, fontSize: 10, fontWeight: 700, formatter: (p) => fs(m.steps[p.dataIndex].pts) },
              data: m.steps.map((s, i) => ({ value: Math.abs(s.pts), itemStyle: { color: s.pts < 0 ? '#ef4444' : (i === 0 ? t.emerald : t.emerald + 'b3') } })),
              markLine: m.dream > 0 ? { symbol: 'none', silent: true, lineStyle: { color: gold, type: 'dashed', width: 2 },
                label: { formatter: 'Dream Team ' + fs(m.dream), color: gold, fontSize: 10, position: 'insideEndTop' }, data: [{ yAxis: m.dream }] } : undefined },
          ],
        };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'lineup_overlap', slot: 'panel', title: 'Lineup Overlap', sportScope: '*', bestAt: 'multi',
    description: 'Your lineups against each other, shaded by how many players they share - how spread your entries really are.',
    help: 'Each square is two of your lineups (your top 12): the number is how many players they share, the darker the more. The diagonal is each lineup\'s own size. A pale grid is a spread portfolio; a dark one is the same bet several times.',
    minCells: { w: 4, h: 3 }, defaultCells: { w: 5, h: 4 },
    factory: () => ({
      ...LSChart.panelBase(),
      _option() {
        const t = LSChart.theme(), dark = LSChart.isDark();
        const m = C().overlap(this.lineupRows || [], 12);
        if (m.names.length < 2) return EMPTY;
        const maxN = Math.max(1, ...m.sizes);
        return {
          backgroundColor: 'transparent',
          grid: { left: 6, right: 10, top: 6, bottom: 6, containLabel: true },
          tooltip: { ...tip(t), formatter: (p) => { const [x, y, n] = p.data; return x === y ? '<b>' + m.names[y] + '</b><br/>' + n + ' players'
            : '<b>' + m.names[y] + '</b> and <b>' + m.names[x] + '</b><br/>share ' + n + ' of ' + Math.max(m.sizes[x], m.sizes[y]); } },
          xAxis: { type: 'category', data: m.names, axisLabel: { color: t.label, fontSize: 10, rotate: 35, interval: 0 }, axisLine: { show: false }, axisTick: { show: false }, splitArea: { show: false } },
          yAxis: { type: 'category', data: m.names, inverse: true, axisLabel: { color: t.label, fontSize: 10, fontWeight: 600, interval: 0 }, axisLine: { show: false }, axisTick: { show: false } },
          visualMap: { show: false, min: 0, max: maxN, inRange: { color: [dark ? '#0f1820' : '#f1f5f4', t.emerald] } },
          // a strong cell is the accent itself: its number takes the ink that
          // reads on it (the diagonal's "9" vanished on bright emerald)
          series: [{ type: 'heatmap', data: m.cells.map(c => (c[2] / (maxN || 1) > 0.6 ? { value: c, label: { color: dark ? '#04130c' : '#ffffff' } } : c)), label: { show: true, color: t.label, fontSize: 11, fontWeight: 700 },
                     itemStyle: { borderColor: dark ? '#0b1218' : '#fff', borderWidth: 2, borderRadius: 4 } }],
        };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'exposure_grid', slot: 'panel', title: 'Exposure Grid', sportScope: '*', bestAt: 'multi',
    description: 'Your players down the side, your lineups across, each cell coloured by the points that player brought there.',
    help: 'Rows are your most-used players (how many lineups in brackets), columns your top 10 lineups. A coloured cell means the player is in that lineup; the brighter, the more they have scored. It shows where you doubled up and how it is paying.',
    minCells: { w: 4, h: 3 }, defaultCells: { w: 6, h: 5 },
    factory: () => ({
      ...LSChart.panelBase(),
      _option() {
        const t = LSChart.theme(), dark = LSChart.isDark();
        const m = C().exposure(this.lineupRows || [], 14, 10);
        if (!m.cells.length) return EMPTY;
        const fs = (v) => this._fmtScore(v);
        return {
          backgroundColor: 'transparent',
          grid: { left: 6, right: 10, top: 6, bottom: 6, containLabel: true },
          tooltip: { ...tip(t), formatter: (p) => { const [x, y, v] = p.data; return '<b>' + m.players[y] + '</b><br/>' + m.lineups[x] + ': ' + fs(v); } },
          xAxis: { type: 'category', data: m.lineups, axisLabel: { color: t.label, fontSize: 10, rotate: 35, interval: 0 }, axisLine: { show: false }, axisTick: { show: false } },
          yAxis: { type: 'category', data: m.players, inverse: true, axisLabel: { color: t.label, fontSize: 10, fontWeight: 600, interval: 0, width: 140, overflow: 'truncate' }, axisLine: { show: false }, axisTick: { show: false } },
          visualMap: { show: false, min: 0, max: m.max, inRange: { color: [dark ? '#1b2731' : '#dcefe7', t.emerald] } },
          series: [{ type: 'heatmap', data: m.cells.map(c => (c[2] / (m.max || 1) > 0.6 ? { value: c, label: { color: dark ? '#04130c' : '#ffffff' } } : c)), label: { show: true, color: t.label, fontSize: 9, formatter: (p) => Math.round(p.value ? p.value[2] : p.data[2]) },
                     itemStyle: { borderColor: dark ? '#0b1218' : '#fff', borderWidth: 2, borderRadius: 3 } }],
        };
      },
    }),
  });
})();

/* ==== static/js/widgets/nfl_bonus_watch.js ==== */
;
/* widgets/nfl_bonus_watch.js — NFL Bonus Watch.
 *
 * Yardage bonuses are UNIQUE to football scoring: 100 rushing, 100 receiving,
 * 300 passing, each worth a flat +3 on DK. They're discrete, dramatic and
 * completely invisible today — a player sitting on 87 receiving yards is one
 * catch from three free points and nothing on the board says so.
 *
 * The direct analogue of MLB's Home Run Watch: a countdown to a scoring event
 * you can feel coming. Earned bonuses stay listed (banked, greyed) so the
 * panel reads as a full ledger rather than only a to-do list.
 */
window.LSWidgets.register({
  id:          'nfl_bonus_watch',
  // Broadcast's dock: quiet until one of mine is on a bonus chase.
  quiet:       (s) => ((s._rows || []).length ? '' : 'Nobody near a bonus yet'),
  description: 'Who is closing on a 100-yard rushing / receiving or 300-yard passing bonus.',
  help:        'Yardage bonuses are worth a flat +3 each and only exist in football. This is the countdown: how far each of your players is from the next one, closest first. Banked bonuses drop to the bottom so you can see what you have already collected.',
  slot:        'panel',
  title:       'Bonus Watch',
  sportScope:  ['nfl', 'cfb'],
  factory:     () => ({
    /* stat, threshold, the flag the provider sets once earned, and a label -
     * one list, the sport's (static/js/sports/nfl.js bonusDefs). */
    get _defs() {
      return ((window.SPORT_REGISTRY || {}).nfl || {}).bonusDefs || [];
    },

    /** Unique players across my lineups (deduped by id, never by name). */
    get _mine() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const k = window.LSModelUtil.pid(p);
          if (k && !seen.has(k)) seen.set(k, p);
        }
      }
      return [...seen.values()];
    },

    /** One row per (player × bonus) that is either earned or genuinely in
     *  play. A player with 4 rushing yards isn't "chasing" 100 — showing him
     *  would bury the two who actually are — so a row only appears once he's
     *  at least a third of the way there. */
    get _rows() {
      const out = [];
      for (const p of this._mine) {
        const st = p.stats || {};
        for (const d of this._defs) {
          const yds = +(st[d.stat] || 0);
          // Over the line is banked, flag or not: Brady at 349/300 read "0 to
          // go" as a live chase until the provider set it (audit run 1, LIVE-4).
          const earned = !!st[d.flag] || yds >= d.at;
          if (!earned && yds < d.at / 3) continue;
          out.push({
            key: window.LSModelUtil.pid(p) + ':' + d.stat,
            name: p.name, team: p.team, pos: p.pos,
            label: d.label, yds, at: d.at, earned,
            to_go: Math.max(0, d.at - yds),
            pct: Math.max(0, Math.min(100, (yds / d.at) * 100)),
            done: p.game_phase === 'finished',
          });
        }
      }
      // Live chases first (closest to the line), banked bonuses last. With
      // nothing left to chase (the final whistle), what you banked leads -
      // misses first read as the night's story (audit run 1, PREM-14).
      const chasing = out.some(r => !r.earned && !r.done);
      return out.sort((a, b) => {
        if (a.earned !== b.earned) return (a.earned ? 1 : -1) * (chasing ? 1 : -1);
        if (a.done !== b.done) return a.done ? 1 : -1;
        return a.to_go - b.to_go;
      });
    },

    get _chasing() { return this._rows.filter(r => !r.earned && !r.done).length; },
    get _banked()  { return this._rows.filter(r => r.earned).length; },
    /** Finished short of the line - so the foot's counts add up (audit run 2, NUM-31). */
    get _missed()  { return this._rows.filter(r => !r.earned && r.done).length; },

    // The board's version, grouped by bonus (Xav 2026-10-12): "100 rushing
    // yards · +3", "100 receiving yards", "300 passing yards", each with its
    // chases closest first (widgets/_bonus_groups.html).
    get _bwRows() {
      const own = this._inCountMap || {}, nLu = (this.activeLineupRows || this.lineupRows || []).length;
      const TITLE = { rush_yds: 'rushing yards', rec_yds: 'receiving yards', pass_yds: 'passing yards' };
      const byKey = new Map(this._mine.map(p => [window.LSModelUtil.pid(p), p]));
      return this._rows.map(r => {
        const pid = r.key.split(':')[0], n = own[pid] || 0, stat = r.key.split(':')[1];
        return { key: r.key, group: stat, title: r.at + ' ' + (TITLE[stat] || r.label), sub: '+3', bonus: r.earned ? '3' : '',
                 name: r.name, team: r.team, own: nLu > 1 && n ? 'in ' + n + '/' + nLu : '',
                 have: r.yds, at: r.at, togo: r.to_go, pips: 0, pct: Math.round(r.pct),
                 state: r.earned ? 'banked' : (r.done ? 'missed' : 'chase'), _p: byKey.get(pid) };
      });
    },
    get _bwFlat()   { return window.LSModelUtil.bonusFlat(this._bwRows); },
    get _bwCounts() { return window.LSModelUtil.bonusCounts(this._bwRows); },
  }),
});

/* ==== static/js/widgets/nfl_qb_room.js ==== */
;
/* widgets/nfl_qb_room.js — NFL QB Room.
 *
 * The Pitcher Pulse analogue: one card per quarterback you own. QB is the
 * highest-leverage position in football DFS — the biggest scores and the
 * biggest single-player swings — so it earns a dedicated surface rather than
 * a row in a table.
 *
 * Shows the full line (pass/rush/turnovers), the run at the 300-yard bonus,
 * and marks interceptions in red because they're the only negative a QB
 * routinely posts.
 */
window.LSWidgets.register({
  id:          'nfl_qb_room',
  description: 'One card per quarterback in your lineups — full line, turnovers and the run at 300 yards.',
  help:        'Your quarterbacks at a glance: passing and rushing lines, interceptions (the only stat that costs you), and how far each is from the 300-yard bonus. Sorted by live points, so whoever is carrying your slate sits on top.',
  slot:        'panel',
  title:       'QB Room',
  sportScope:  ['nfl', 'cfb'],
  factory:     () => ({
    get _qbs() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          if (String(p.pos || '').toUpperCase() !== 'QB') continue;
          const k = window.LSModelUtil.pid(p);
          if (!seen.has(k)) seen.set(k, p);
        }
      }
      return [...seen.values()]
        .map(p => {
          const st = p.stats || {};
          const py = +(st.pass_yds || 0);
          return {
            key: window.LSModelUtil.pid(p),
            name: p.name, team: p.team,
            fpts: +(p.live_fpts || 0),
            pass_yds: py, pass_td: +(st.pass_td || 0), ints: +(st.pass_int || 0),
            rush_yds: +(st.rush_yds || 0), rush_td: +(st.rush_td || 0),
            bonus: !!st.pass_300_bonus,
            to300: Math.max(0, 300 - py),
            pct300: Math.max(0, Math.min(100, (py / 300) * 100)),
            live: !!p.is_on_court,
            done: p.game_phase === 'finished',
          };
        })
        .sort((a, b) => b.fpts - a.fpts);
    },
  }),
});

/* ==== static/js/widgets/nfl_dst_bracket.js ==== */
;
/* widgets/nfl_dst_bracket.js — NFL D/ST Bracket.
 *
 * Points-allowed is scored in TIERS, not linearly: 0 allowed is +10, 1-6 is
 * +7, 7-13 is +4 and so on down to -4. So a single touchdown can cost a
 * defense three points in one play — and nothing on the board tells you how
 * close you are to the cliff.
 *
 * This is that cliff, made visible: current tier, points banked from it, and
 * exactly how many more points concede the next drop. The bracket table comes
 * from the payload (payload.pa_brackets), never hardcoded — the scoring rules
 * live in the DB and the client must not fork them.
 */
window.LSWidgets.register({
  id:          'nfl_dst_bracket',
  description: 'Your defenses: points allowed, the tier they are in, and how close the next drop is.',
  help:        'Points allowed is scored in tiers, so one touchdown can cost your defense three points at a stroke. This shows the tier each of your D/STs is currently in and how many more points tip it into the next one down. Turns amber when a defense is within a touchdown of dropping.',
  slot:        'panel',
  title:       'D/ST Bracket',
  sportScope:  ['nfl', 'cfb'],
  factory:     () => ({
    get _brackets() {
      return (this.pa_brackets || []).slice()
        .sort((a, b) => (a.min_val || 0) - (b.min_val || 0));
    },

    _tierFor(pa) {
      return this._brackets.find(b =>
        pa >= (b.min_val ?? 0) && pa <= (b.max_val ?? 999)) || null;
    },
    /** The tier immediately worse than the current one. */
    _nextTier(pa) {
      const bs = this._brackets;
      const i = bs.findIndex(b => pa >= (b.min_val ?? 0) && pa <= (b.max_val ?? 999));
      return (i >= 0 && i + 1 < bs.length) ? bs[i + 1] : null;
    },

    get _rows() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          if (String(p.pos || '').toUpperCase() !== 'DST') continue;
          const k = window.LSModelUtil.pid(p);
          if (!seen.has(k)) seen.set(k, p);
        }
      }
      return [...seen.values()].map(p => {
        const st = p.stats || {};
        // Absent pre-kickoff by design (the provider only emits it once the
        // game is under way), so treat missing as "not yet" rather than 0.
        const started = st.dst_pts_allowed !== undefined && st.dst_pts_allowed !== null;
        const pa = +(st.dst_pts_allowed || 0);
        const tier = started ? this._tierFor(pa) : null;
        const next = started ? this._nextTier(pa) : null;
        const room = next ? Math.max(0, (next.min_val ?? 0) - pa) : null;
        return {
          key: window.LSModelUtil.pid(p),
          name: p.name, team: p.team,
          fpts: +(p.live_fpts || 0),
          started, pa,
          tier_pts: tier ? +tier.points : null,
          next_pts: next ? +next.points : null,
          room,                                   // points until the next drop
          // A touchdown is 6-8; inside that and the cliff is one score away.
          edge: room !== null && room <= 7,
          sacks: +(st.dst_sack || 0), ints: +(st.dst_int || 0),
          frec: +(st.dst_fumble_rec || 0), tds: +(st.dst_return_td || 0),
          done: p.game_phase === 'finished',
        };
      }).sort((a, b) => b.fpts - a.fpts);
    },
  }),
});

/* ==== static/js/widgets/nfl_game_script.js ==== */
;
/* widgets/nfl_game_script.js — NFL Game Script.
 *
 * Football scoring is dictated by the scoreboard in a way baseball's isn't. A
 * team 20 points ahead runs the ball and kills the clock — murder for the
 * losing side's RB, a gift for their WRs in garbage time. "Game script" is the
 * term of art for exactly this, and every NFL DFS player thinks in it.
 *
 * So: each live game, the margin, and which of YOUR players are on which side
 * of it — with the blowouts called out, since those are the ones quietly
 * deciding your night.
 */
window.LSWidgets.register({
  id:          'nfl_game_script',
  description: 'Score margin per game and which of your players are on the right or wrong side of it.',
  help:        'A big lead changes how a team plays: the leader runs the clock out (good for their RBs, bad for everyone else) while the trailing side throws (garbage-time points for their receivers). This shows the margin in each game and where your players sit — blowouts flagged, because that is where the script is really biting.',
  slot:        'panel',
  title:       'Game Script',
  sportScope:  ['nfl', 'cfb'],
  factory:     () => ({
    _mineOn(teamAbbr) {
      const t = String(teamAbbr || '').toUpperCase();
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          if (String(p.team || '').toUpperCase() !== t) continue;
          const k = window.LSModelUtil.pid(p);
          if (!seen.has(k)) seen.set(k, p);
        }
      }
      return [...seen.values()].sort((a, b) => (b.live_fpts || 0) - (a.live_fpts || 0));
    },

    get _rows() {
      const games = (this.allGames || []).filter(g =>
        (this.effStatus ? this.effStatus(g) : g.status) >= 2);
      return games.map(g => {
        const hs = +(g.home_score || 0), as = +(g.away_score || 0);
        const margin = Math.abs(hs - as);
        const leader = hs === as ? '' : (hs > as ? g.home_team : g.away_team);
        const trailer = hs === as ? '' : (hs > as ? g.away_team : g.home_team);
        const lead = leader ? this._mineOn(leader) : [];
        const trail = trailer ? this._mineOn(trailer) : [];
        return {
          game_id: g.game_id,
          matchup: (g.away_team || '') + ' @ ' + (g.home_team || ''),
          score: as + '-' + hs,
          margin, leader, trailer,
          // A two-score game is where coaches start changing behaviour.
          blowout: margin >= 17,
          tight: margin <= 8,
          lead, trail,
          involved: lead.length + trail.length,
          final: (this.effStatus ? this.effStatus(g) : g.status) >= 3,
        };
      }).sort((a, b) => (b.involved - a.involved) || (b.margin - a.margin));
    },
  }),
});

/* ==== static/js/widgets/nfl_category_leaders.js ==== */
;
/* widgets/nfl_category_leaders.js — NFL Category Leaders.
 *
 * ESPN's "Game Leaders" panel, rebuilt for DFS. Theirs answers "who leads
 * this game?"; ours answers the question that actually costs you money:
 * "who leads the SLATE in each category — and do I own them?"
 *
 * The NFL sibling of MLB's Category Dominance. For each category it shows the
 * slate leader, flags them when they're yours, and when they aren't, shows
 * YOUR best alongside with the gap. Where you're behind is where the slate is
 * being won without you.
 */
window.LSWidgets.register({
  id:          'nfl_category_leaders',
  description: 'Slate leader in each category — passing, rushing, receiving, TDs, sacks — and whether you own them.',
  help:        'Who is topping each category across the whole slate, and whether that player is in your lineups. When the leader is not yours, your best in that category shows underneath with the gap — that gap is where the slate is being won without you.',
  slot:        'panel',
  title:       'Category Leaders',
  sportScope:  ['nfl', 'cfb'],
  factory:     () => ({
    get _cats() {
      return [
        { key: 'pass_yds', label: 'Passing yards',   fmt: v => v + ' yds' },
        { key: 'rush_yds', label: 'Rushing yards',   fmt: v => v + ' yds' },
        { key: 'rec_yds',  label: 'Receiving yards', fmt: v => v + ' yds' },
        { key: '_tds',     label: 'Touchdowns',      fmt: v => v + (v === 1 ? ' TD' : ' TDs') },
        { key: 'dst_sack', label: 'Sacks',           fmt: v => v + (v === 1 ? ' sack' : ' sacks') },
      ];
    },

    /** player_id set for everyone in my lineups — the "is it mine" test,
     *  done by id so a name collision can't false-positive. */
    get _myIds() {
      const s = new Set();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          if (p.player_id) s.add(String(p.player_id));
        }
      }
      return s;
    },

    _val(p, key) {
      const st = p.stats || {};
      if (key === '_tds') {
        return (+(st.pass_td || 0)) + (+(st.rush_td || 0)) +
               (+(st.rec_td || 0)) + (+(st.return_td || 0)) + (+(st.dst_return_td || 0));
      }
      return +(st[key] || 0);
    },

    get _rows() {
      const pool = this.allSlatePlayers || [];
      const mine = this._myIds;
      return this._cats.map(c => {
        let leader = null, best = null;
        for (const p of pool) {
          const v = this._val(p, c.key);
          if (v <= 0) continue;
          if (!leader || v > leader.v) leader = { p, v };
          if (mine.has(String(p.player_id)) && (!best || v > best.v)) best = { p, v };
        }
        const leaderIsMine = !!(leader && mine.has(String(leader.p.player_id)));
        return {
          key: c.key, label: c.label,
          fmt: c.fmt,
          leader, best, leaderIsMine,
          // Only worth showing your own line when it ISN'T already the leader.
          showMine: !!best && !leaderIsMine,
          gap: (best && leader) ? Math.max(0, leader.v - best.v) : null,
        };
      }).filter(r => r.leader);            // nothing recorded yet -> no row
    },

    get _owned() { return this._rows.filter(r => r.leaderIsMine).length; },
  }),
});

/* ==== static/js/widgets/kpi/nfl_my_tds.js ==== */
;
/* widgets/kpi/nfl_my_tds.js — My TDs. Football's currency, counted.
 * The `my_bombs` (home runs) analogue: one number that says how your night
 * is really going, because touchdowns are where NFL scores come from. */
window.LSWidgets.register({
  id:          'kpi_nfl_my_tds',
  description: 'Touchdowns your players were part of, across all lineups - thrown, run, caught, returned.',
  help:        'Every touchdown your players were part of - passing, rushing, receiving, returns and defensive. A pass TD counts for the quarterback and for the catcher if you have both. Each player once, however many lineups hold him.',
  slot:        'kpi',
  title:       'TDs Involved',
  sportScope:  ['nfl', 'cfb'],
  factory:     () => ({
    get _unique() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const k = window.LSModelUtil.pid(p);
          if (!seen.has(k)) seen.set(k, p);
        }
      }
      return [...seen.values()];
    },
    get _tds() {
      return this._unique.reduce((n, p) => {
        const st = p.stats || {};
        return n + (+(st.pass_td || 0)) + (+(st.rush_td || 0)) + (+(st.rec_td || 0))
                 + (+(st.return_td || 0)) + (+(st.dst_return_td || 0));
      }, 0);
    },
    /** The most recent scorer, for the foot line. */
    get _topScorer() {
      const withTd = this._unique
        .map(p => {
          const st = p.stats || {};
          return { p, n: (+(st.pass_td || 0)) + (+(st.rush_td || 0)) + (+(st.rec_td || 0))
                        + (+(st.return_td || 0)) + (+(st.dst_return_td || 0)) };
        })
        .filter(x => x.n > 0)
        .sort((a, b) => b.n - a.n);
      if (!withTd.length) return null;
      // A tie is said as a tie: "Walker III · 2 of them" was the first of six
      // players on 2 (Broadcast audit run 1, NUM-16).
      const tied = withTd.filter(x => x.n === withTd[0].n).length;
      return Object.assign({}, withTd[0], { tied });
    },
  }),
});

/* ==== static/js/widgets/kpi/nfl_pts_allowed.js ==== */
;
/* widgets/kpi/nfl_pts_allowed.js — Points Allowed.
 * Total conceded by your defenses. The one NFL number where LOW is good, so
 * it's coloured in reverse: emerald while your D/STs are holding, red once
 * they're leaking. */
window.LSWidgets.register({
  id:          'kpi_nfl_pts_allowed',
  description: 'Total points conceded by the defenses in your lineups.',
  help:        'What your D/STs have given up so far. Low is good here — points allowed is scored in tiers, so every touchdown conceded can knock your defense down a bracket. Shows a dash until their games actually kick off.',
  slot:        'kpi',
  title:       'Pts Allowed',
  sportScope:  ['nfl', 'cfb'],
  factory:     () => ({
    get _dsts() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          if (String(p.pos || '').toUpperCase() !== 'DST') continue;
          const k = window.LSModelUtil.pid(p);
          if (!seen.has(k)) seen.set(k, p);
        }
      }
      // Pre-kickoff the provider omits dst_pts_allowed entirely (so the
      // "0 allowed = +10" bracket can't pay out early) — treat those as
      // not-yet-playing rather than shutouts.
      return [...seen.values()].filter(p =>
        (p.stats || {}).dst_pts_allowed !== undefined &&
        (p.stats || {}).dst_pts_allowed !== null);
    },
    get _started() { return this._dsts.length > 0; },
    get _total() {
      return this._dsts.reduce((n, p) => n + (+((p.stats || {}).dst_pts_allowed || 0)), 0);
    },
    get _n() { return this._dsts.length; },
    /** Emerald while holding, red once leaking — inverted vs every other tile. */
    get _leaking() { return this._n > 0 && (this._total / this._n) >= 21; },
  }),
});

/* ==== static/js/widgets/kpi/pregame_kpis.js ==== */
;
/* widgets/kpi/pregame_kpis.js — the before-kick-off KPIs.
 *
 * A board's live KPIs read "–" and 0.00 until the first game starts, so the
 * strip is a row of blanks for the hours a player spends looking at it before
 * the slate (Xav's pre-game screenshot, 2026-09-29). These three answer the
 * questions that matter before kick-off instead: when does it start, who is
 * my night riding on, and is anyone I own flagged. The Broadcast board swaps
 * them in through its layout's `pregame_kpis` until a game goes live
 * (live_v2/index.js _kpiList); any board can use them.
 *
 * Every player join is by player id; each player counts once however many
 * lineups hold him. */
(function () {
  // Unique players across my lineups, with how many lineups hold each.
  function owned(rows) {
    const m = new Map();
    for (const lu of (rows || [])) {
      const inLu = new Set();
      for (const p of (lu.players || [])) {
        const k = window.LSModelUtil.pid(p);
        if (!k || inLu.has(k)) continue;
        inLu.add(k);
        const e = m.get(k);
        if (e) e.n += 1; else m.set(k, { p, n: 1 });
      }
    }
    return [...m.values()];
  }

  window.LSWidgets.register({
    id:          'kpi_kickoff',
    description: 'When the first game on the slate starts, in your time.',
    help:        'The day and time the first game starts, in your own time zone, and which game it is.',
    slot:        'kpi',
    title:       'First kick-off',
    sportScope:  '*',
    factory:     () => ({
      // the slate's own sport: _sportId is not set where this tile mounts, so
      // NHL / NBA read "First kick-off" (Broadcast audit v2 run 2, PREM-8)
      get _koLabel() {
        const sl = this.selectedSlate || {};
        return window.LSModelUtil.firstStart(sl.sport_id || (sl.sport && sl.sport.id) || this._sportId);
      },
      get _upcoming() {
        return (this.allGames || [])
          .filter(g => (g.status ?? 1) < 2 && g.game_time_utc)
          .map(g => ({ g, t: new Date(g.game_time_utc).getTime() }))
          .filter(x => !isNaN(x.t))
          .sort((a, b) => a.t - b.t);
      },
      get _ko() {
        const up = this._upcoming;
        if (!up.length) return null;
        const first = up[0].t;
        // The start TIME, with its day: The Action's director already counts
        // down to it, and the Wire did too - one countdown, not three (v2
        // run 1, PREM-9 / UX-13). The day keeps a midnight start from
        // reading "00:00" like a clock that ran out (LIVE-15).
        const value = new Date(first).toLocaleString([], { weekday: 'short', hour: '2-digit', minute: '2-digit' });
        const g = up[0].g, atFirst = up.filter(x => x.t === first).length;
        const n = up.length;
        // "6 games · 10 games on the slate" said games twice (run 2, UX-7)
        const foot = (atFirst > 1 ? atFirst + ' start then' : (g.away_team || '') + ' @ ' + (g.home_team || ''))
          + ' · ' + n + (n === 1 ? ' game' : ' games') + ' on the slate';
        return { value, foot };
      },
    }),
  });

  window.LSWidgets.register({
    id:          'kpi_most_owned',
    description: 'Your top exposure: the player in the most of your lineups - who your night rides on.',
    help:        'Your most-owned player and the share of your lineups that hold him. Counted by player, so the same player in twelve lineups is 12 of however many you entered.',
    slot:        'kpi',
    // "Most owned" is the FIELD's ownership in DFS; this is your exposure (NUMBERS-3)
    title:       'Top exposure',
    sportScope:  '*',
    factory:     () => ({
      get _top() {
        const rows = this.lineupRows || [];
        if (!rows.length) return null;
        const all = owned(rows).sort((a, b) => b.n - a.n
          || (Number(b.p.salary) || 0) - (Number(a.p.salary) || 0));
        if (!all.length) return null;
        const t = all[0];
        // a tie is said as a tie, not one name picked from 18 (NUMBERS-3)
        const tied = all.filter(x => x.n === t.n);
        const of = t.n + ' of ' + rows.length;
        return {
          pct:  Math.round(100 * t.n / rows.length) + '%',
          foot: tied.length > 3 ? tied.length + ' players at ' + of
              : tied.length > 1 ? tied.map(x => window.LSModelUtil.short(x.p)).join(', ') + ' · ' + of
              : (t.p.name || '') + ' · ' + of,
        };
      },
    }),
  });

  // DK's O / Q / D arrive as injured / possible / doubtful (scrape_dk_slates).
  const FLAG = { injured: 'O', doubtful: 'D', possible: 'Q' };
  const ORDER = { O: 0, D: 1, Q: 2 };

  window.LSWidgets.register({
    id:          'kpi_team_news',
    description: 'How many of your players the platform lists as out, doubtful or questionable.',
    help:        "Your players flagged O, D or Q in the platform's own injury report, worst first. Counted once per player, however many lineups hold him.",
    slot:        'kpi',
    title:       'Team news',
    sportScope:  '*',
    factory:     () => ({
      get _flagged() {
        return owned(this.lineupRows)
          .map(x => ({ ...x, f: FLAG[x.p.lineup_status] }))
          .filter(x => x.f)
          .sort((a, b) => ORDER[a.f] - ORDER[b.f] || b.n - a.n);
      },
      get _newsFoot() {
        const f = this._flagged;
        if (!f.length) return 'Nobody you own is flagged';
        const last = (n) => String(n || '').trim().split(/\s+/).pop();
        return f.slice(0, 2).map(x => last(x.p.name) + ' ' + x.f).join(' · ')
          + (f.length > 2 ? ' +' + (f.length - 2) : '');
      },
    }),
  });
})();

/* ==== static/js/widgets/_nhl.js ==== */
;
/* widgets/_nhl.js — shared reads for the NHL KPIs and panels.
 *
 * Every NHL widget asks the same few questions of the dashboard host: which
 * players are mine, which game is a player in, which SIDE of it is he on, and
 * what does DK pay as a bonus. One home for the answers, so the eleven widgets
 * can't drift apart on any of them.
 *
 * Sides are joined by id (player.team_id against the game's home/away_team_id)
 * with the label only as the fallback behind it - never a bare abbrev match
 * (tests/js/no_abbrev_joins.test.js). The +3 bonuses are read from the slate's
 * scoring rules, not written down here: a `<stat>_<n>_bonus` rule names its own
 * threshold, so a platform that pays different bonuses (or none) just works.
 */
// Players join by id - the LiveSlate player_id, else the platform's own id -
// never by name (audit v2 W1, CODE-14: these read `player_id || p.name`).
const _nhlPid = (p) => window.LSModelUtil.pid(p);

window.LSNhl = {
  /** Unique players across my lineups, each with how many lineups hold him. */
  mine(host) {
    const seen = new Map();
    for (const lu of (host.lineupRows || [])) {
      const inThis = new Set();
      for (const p of (lu.players || [])) {
        const k = _nhlPid(p);
        if (!k || inThis.has(k)) continue;
        inThis.add(k);
        const cur = seen.get(k);
        if (cur) cur.lineups += 1;
        else seen.set(k, { p, lineups: 1 });
      }
    }
    return [...seen.values()];
  },

  /** How many of my lineups hold at least one of these players. */
  lineupsWith(host, players) {
    const ids = new Set(players.map(_nhlPid).filter(Boolean));
    return (host.lineupRows || []).filter(lu => (lu.players || [])
      .some(p => ids.has(_nhlPid(p)))).length;
  },

  game(host, p) {
    const gid = String(p.game_id || '');
    return gid ? (host.allGames || []).find(g => String(g.game_id) === gid) || null : null;
  },

  /** 'home' | 'away' | '' - by team id first, the label only if ids are missing. */
  side(p, g) {
    if (!g) return '';
    if (p.team_id != null && g.home_team_id != null) {
      if (p.team_id === g.home_team_id) return 'home';
      if (p.team_id === g.away_team_id) return 'away';
      return '';
    }
    const t = String(p.team || '').toUpperCase();
    if (t && t === String(g.home_team || '').toUpperCase()) return 'home';
    if (t && t === String(g.away_team || '').toUpperCase()) return 'away';
    return '';
  },

  isGoalie(p) {
    // Position first: every player's stats carry every schema key (a skater
    // has save: 0), so "has a save key" made skaters goalies (2026-10-08).
    const pos = String(p.pos || p.position || '').toUpperCase();
    if (pos) return pos === 'G' || pos === 'GK';
    const s = p.stats || {};
    return (+s.save || 0) > 0 || (+s.goals_ag || 0) > 0;
  },

  live(host, p) {
    const g = this.game(host, p);
    return !!g && (typeof host.effStatus === 'function' ? host.effStatus(g) : g.status) === 2;
  },

  /** DK's +3 bonuses from the scoring rules:
   *  [{key, stat, at, pts, grp, label}] - stat is the live key it counts. */
  bonusDefs(host) {
    const rules = host.scoringRulesByPos || {};
    const LABEL = { sog: 'Shots on goal', blk: 'Blocked shots', pts: 'Points', sv: 'Saves' };
    const out = [];
    for (const grp of ['skater', 'goalie']) {
      for (const [key, w] of Object.entries(rules[grp] || {})) {
        const m = /^([a-z]+)_(\d+)_bonus$/.exec(key);
        if (m && w) out.push({ key, stat: m[1], at: +m[2], pts: +w, grp, label: LABEL[m[1]] || m[1] });
      }
    }
    const ht = (rules.skater || {}).hat_trick;
    if (ht) out.push({ key: 'hat_trick', stat: 'goal', at: 3, pts: +ht, grp: 'skater', label: 'Hat trick' });
    return out;
  },

  /** The live count a bonus is measured on. */
  count(p, stat) {
    const st = p.stats || {};
    if (stat === 'pts') return (+(st.goal || 0)) + (+(st.assist || 0));
    if (stat === 'sv') return +(st.save || 0);
    return +(st[stat] || 0);
  },

  weight(host, grp, stat) {
    return +(((host.scoringRulesByPos || {})[grp] || {})[stat] || 0);
  },

  clock(g) {
    const s = Math.max(0, Math.floor((g && g.clock_secs) || 0));
    return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
  },

  period(g) {
    const p = (g && g.period) || 0;
    if (g && g.live_state && g.live_state.period_type === 'SO') return 'SO';
    return p > 3 ? (p - 3 > 1 ? (p - 3) + 'OT' : 'OT') : 'P' + p;
  },
};

/* ==== static/js/widgets/nhl_panels.js ==== */
;
/* widgets/nhl_panels.js — the six NHL panels (Xav-approved mock 2026-09-29).
 * Shared reads (my players, sides by team id, DK bonus rules, stacks) live in
 * widgets/_nhl.js. Everything is framed in DraftKings points. */

/* Goalie Pulse — a card per goalie: points, saves, GA, the 35-save race, and
 * what is still at stake (win, shutout, an empty-net goal against). */
window.LSWidgets.register({
  id:          'nhl_goalie_pulse',
  description: 'A card per goalie in your lineups: points, saves, the 35-save race and what is still at stake.',
  help:        "Goalies are the biggest single swing in a DK hockey lineup: +6 for a win, +4 for a shutout, +3 at 35 saves, -3.5 a goal. Each card shows what yours have banked and what is still live - the shutout crosses out with the first goal, and an empty net against his team is flagged as a risk.",
  slot:        'panel',
  title:       'Goalie Pulse',
  sportScope:  ['nhl'],
  factory:     () => ({
    get _cards() {
      const out = [];
      for (const { p, lineups } of LSNhl.mine(this)) {
        if (!LSNhl.isGoalie(p)) continue;
        const g = LSNhl.game(this, p), st = p.stats || {};
        const side = LSNhl.side(p, g), live = !!g && this.effStatus(g) === 2;
        const ls = (g && g.live_state) || {};
        const sv = +(st.save || 0), ga = +(st.goals_ag || 0);
        const mine = side === 'home' ? g && g.home_score : g && g.away_score;
        const theirs = side === 'home' ? g && g.away_score : g && g.home_score;
        const elapsed = g ? Math.min(1, (((g.period || 1) - 1) * 1200 + (1200 - (g.clock_secs || 0))) / 3600) : 0;
        const pace = live && elapsed > 0.1 ? Math.round(sv / elapsed) : null;
        out.push({
          key: window.LSModelUtil.pid(p), p, lineups, g, live, sv, ga,
          pct: sv + ga > 0 ? (sv / (sv + ga)).toFixed(3).replace(/^0/, '') : '',
          at35: Math.min(100, sv / 35 * 100), pace,
          state: g ? (live ? LSNhl.period(g) + ' ' + LSNhl.clock(g) : this.effStatus(g) === 3 ? 'Final' : 'Not started')
                     + (g.away_team ? ' · ' + g.away_team + ' ' + (g.away_score || 0) + '–' + (g.home_score || 0) + ' ' + g.home_team : '') : '',
          win:  live ? ((mine || 0) > (theirs || 0) ? 'live' : 'behind') : (st.win ? 'won' : 'no'),
          shut: st.shutout ? 'won' : (ga ? 'gone' : (live ? 'live' : 'no')),
          sv35: st.sv_35_bonus ? 'won' : (live ? 'live' : 'no'),
          enRisk: live && !!ls.en_side && ls.en_side !== side,
          wWin: LSNhl.weight(this, 'goalie', 'win'), wSO: LSNhl.weight(this, 'goalie', 'shutout'),
          w35: LSNhl.weight(this, 'goalie', 'sv_35_bonus'), wGA: LSNhl.weight(this, 'goalie', 'goals_ag'),
        });
      }
      return out.sort((a, b) => (b.p.live_fpts || 0) - (a.p.live_fpts || 0));
    },
  }),
});

/* Bonus Watch — every +3 in play for my players, closest first. */
window.LSWidgets.register({
  id:          'nhl_bonus_watch',
  // Broadcast's dock: quiet until one of mine is on a +3 chase.
  quiet:       (s) => ((s._rows || []).length ? '' : 'Nobody near a +3 yet'),
  description: 'Every +3 bonus your players are chasing - 5 shots, 3 blocks, 3 points, 35 saves, a hat trick - closest first.',
  help:        'DraftKings pays +3 for each of these, once. This is the countdown for your players: how close each one is, nearest first, with the bonuses already banked tonight at the bottom. Thresholds come from the slate\'s own scoring rules.',
  slot:        'panel',
  title:       'Bonus Watch',
  sportScope:  ['nhl'],
  factory:     () => ({
    get _rows() {
      const defs = LSNhl.bonusDefs(this), out = [];
      for (const { p } of LSNhl.mine(this)) {
        const goalie = LSNhl.isGoalie(p), st = p.stats || {};
        const g = LSNhl.game(this, p), live = !!g && this.effStatus(g) === 2;
        for (const d of defs) {
          if ((d.grp === 'goalie') !== goalie) continue;
          const have = LSNhl.count(p, d.stat), earned = !!st[d.key];
          // In play = at least half-way there (a hat trick needs one goal).
          if (!earned && (!live || have < Math.max(1, Math.ceil(d.at / 2)))) continue;
          out.push({ key: window.LSModelUtil.pid(p) + ':' + d.key, p, d, have, earned,
                     togo: Math.max(0, d.at - have), pips: d.at <= 5 ? d.at : 0 });
        }
      }
      return out.sort((a, b) => (a.earned - b.earned) || (a.togo - b.togo));
    },
    get _chasing() { return this._rows.filter(r => !r.earned); },
    get _banked()  { return this._rows.filter(r => r.earned); },
    // The board's Bonus Watch, grouped by bonus (Xav 2026-10-12): one header
    // per +3 ("5 shots on goal · +3"), its chases closest first.
    get _bwRows() {
      const defs = LSNhl.bonusDefs(this), out = [];
      const own = this._inCountMap || {}, nLu = (this.activeLineupRows || this.lineupRows || []).length;
      const TITLE = { sog: 'shots on goal', blk: 'blocked shots', pts: 'points', sv: 'saves' };
      for (const { p } of LSNhl.mine(this)) {
        const goalie = LSNhl.isGoalie(p), st = p.stats || {};
        const g = LSNhl.game(this, p), s = g ? this.effStatus(g) : 0;
        for (const d of defs) {
          if ((d.grp === 'goalie') !== goalie) continue;
          const have = LSNhl.count(p, d.stat), earned = !!st[d.key];
          const half = have >= Math.max(1, Math.ceil(d.at / 2));
          const done = !earned && s >= 3 && half;
          if (!earned && !done && !(s === 2 && half)) continue;
          const pid = window.LSModelUtil.pid(p), n = own[pid] || 0;
          const pts = Number(d.pts) ? (Number.isInteger(Number(d.pts)) ? String(Number(d.pts)) : Number(d.pts).toFixed(2)) : '';
          out.push({ key: pid + ':' + d.key, group: d.key,
                     title: d.stat === 'goal' ? 'Hat trick' : d.at + ' ' + (TITLE[d.stat] || d.label.toLowerCase()),
                     sub: pts ? '+' + pts : '', bonus: earned ? pts : '',
                     name: p.name, team: p.team, own: nLu > 1 && n ? 'in ' + n + '/' + nLu : '',
                     have, at: d.at, togo: Math.max(0, d.at - have), pips: d.at <= 5 ? d.at : 0,
                     pct: Math.min(100, Math.round(have / d.at * 100)),
                     state: earned ? 'banked' : (done ? 'missed' : 'chase') });
        }
      }
      return out;
    },
    get _bwFlat()   { return window.LSModelUtil.bonusFlat(this._bwRows); },
    get _bwCounts() { return window.LSModelUtil.bonusCounts(this._bwRows); },
  }),
});

/* Power Play — live power plays: who is in the box, which of mine are up or down. */
window.LSWidgets.register({
  id:          'nhl_power_play',
  description: 'Live power plays: the clock, who is in the box, and which of your players are up a man or short.',
  help:        "Every power play in progress on your slate. Your players on the team with the advantage are where the next goal is likeliest; your players on the short-handed side can still score a short-handed point (+2 on DK). It's by team: the NHL feed doesn't say who is on the ice.",
  slot:        'panel',
  title:       'Power Play',
  sportScope:  ['nhl'],
  factory:     () => ({
    get _pps() {
      const mine = LSNhl.mine(this).filter(x => !LSNhl.isGoalie(x.p));
      const out = [];
      for (const g of (this.allGames || [])) {
        const ls = g.live_state || {};
        if (g.sport_id !== 'nhl' || this.effStatus(g) !== 2 || !ls.pp_side) continue;
        const up = [], down = [];
        for (const x of mine) {
          if (String(x.p.game_id) !== String(g.game_id)) continue;
          const s = LSNhl.side(x.p, g);
          if (s === ls.pp_side) up.push(x); else if (s) down.push(x);
        }
        const short = ls.pp_side === 'home' ? 'away' : 'home';
        const box = ls[short === 'home' ? 'pen_home' : 'pen_away'] || [];
        out.push({
          key: g.game_id, g,
          team: ls.pp_side === 'home' ? g.home_team : g.away_team,
          shortTeam: short === 'home' ? g.home_team : g.away_team,
          secs: ls.pp_secs || 0, box, up, down,
          kind: box.length > 1 ? '5-on-3' : 'On the power play',
          // Distinct lineups holding any of them - three players in the same
          // lineup is one lineup on the power play, not three.
          lineupsUp: LSNhl.lineupsWith(this, up.map(x => x.p)),
        });
      }
      return out.sort((a, b) => (b.up.length - a.up.length) || (a.secs - b.secs));
    },
    get _wSH() { return LSNhl.weight(this, 'skater', 'sh_point'); },
  }),
});

/* Empty Net Watch — a goalie is pulled: my upside and my risk. */
window.LSWidgets.register({
  id:          'nhl_empty_net',
  description: 'When a goalie is pulled: which of your players can tie it, score into the empty net, or give one up.',
  help:        "Late in a close game the trailing team pulls its goalie for an extra skater. That minute swings DK scores both ways: your skaters on the trailing team can tie it, your skaters on the leading team can score into the empty net, and your goalie facing six skaters can concede. Only shows while a goalie is out.",
  slot:        'panel',
  title:       'Empty Net Watch',
  sportScope:  ['nhl'],
  factory:     () => ({
    get _nets() {
      const mine = LSNhl.mine(this);
      const out = [];
      for (const g of (this.allGames || [])) {
        const ls = g.live_state || {};
        if (g.sport_id !== 'nhl' || this.effStatus(g) !== 2 || !ls.en_side) continue;
        const pulled = ls.en_side, other = pulled === 'home' ? 'away' : 'home';
        const pick = (side, goalie) => mine.filter(x => String(x.p.game_id) === String(g.game_id)
          && LSNhl.side(x.p, g) === side && LSNhl.isGoalie(x.p) === goalie).map(x => x.p);
        const pm = pulled === 'home' ? g.home_score : g.away_score, om = pulled === 'home' ? g.away_score : g.home_score;
        out.push({
          key: g.game_id, g,
          team: pulled === 'home' ? g.home_team : g.away_team,
          down: (om || 0) - (pm || 0),
          tiers: pick(pulled, false), enScorers: pick(other, false), goalies: pick(other, true),
        });
      }
      return out;
    },
    get _wGoal()   { return LSNhl.weight(this, 'skater', 'goal'); },
    get _wAssist() { return LSNhl.weight(this, 'skater', 'assist'); },
    get _wGA()     { return LSNhl.weight(this, 'goalie', 'goals_ag'); },
    _names(ps) { return ps.map(p => LSModelUtil.short(p)).join(', '); },
  }),
});

/* ==== static/js/widgets/kpi/nhl_kpis.js ==== */
;
/* widgets/kpi/nhl_kpis.js — the five NHL KPI tiles (Xav-approved mock 2026-09-29).
 * Each is the one-number form of an NHL panel; the shared reads live in
 * widgets/_nhl.js. All framed in DraftKings points. */

/* Goalie Pulse — my goalies' points now, and what is still live for them. */
window.LSWidgets.register({
  id:          'kpi_nhl_goalie_pulse',
  description: "Your goalies' points now, plus the win, shutout and 35-save bonus still in play.",
  help:        "What your goalies have banked (saves, goals against) and what they can still earn tonight: the win, the shutout and the 35-save bonus. Only counts what's genuinely live - a shutout drops out with the first goal against, a win with the lead.",
  slot:        'kpi',
  title:       'Goalie Pulse',
  sportScope:  ['nhl'],
  factory:     () => ({
    get _goalies() { return LSNhl.mine(this).filter(x => LSNhl.isGoalie(x.p)).map(x => x.p); },
    get _pts() { return this._goalies.reduce((s, p) => s + (+(p.live_fpts || 0)), 0); },
    /** Points still possible: win if his side leads, shutout at 0 GA, 35 saves not yet. */
    get _live() {
      let v = 0;
      for (const p of this._goalies) {
        const g = LSNhl.game(this, p);
        if (!g || this.effStatus(g) !== 2) continue;
        const side = LSNhl.side(p, g), st = p.stats || {};
        const mine = side === 'home' ? g.home_score : g.away_score;
        const theirs = side === 'home' ? g.away_score : g.home_score;
        if (side && (mine || 0) > (theirs || 0)) v += LSNhl.weight(this, 'goalie', 'win');
        if (!(+(st.goals_ag || 0))) v += LSNhl.weight(this, 'goalie', 'shutout');
        if (!st.sv_35_bonus) v += LSNhl.weight(this, 'goalie', 'sv_35_bonus');
      }
      return v;
    },
    get _lead() {
      return this._goalies.slice().sort((a, b) => (b.live_fpts || 0) - (a.live_fpts || 0))[0] || null;
    },
  }),
});

/* Bonuses — the +3s your players have banked, are chasing (live and at
   least half-way) and missed (finished half-way or more); each player once.
   NHL's version of the NFL tile, beside Bonus Watch on My Players. */
window.LSWidgets.register({
  id:          'kpi_nhl_bonuses',
  description: 'The +3 bonuses your players have banked, are chasing and missed.',
  help:        "DraftKings pays +3 for 5 shots on goal, 3 blocked shots, 3 points and 35 saves (and a hat trick). Banked = reached; chasing = live and at least half-way; missed = finished half-way or more. Each of your players counted once.",
  slot:        'kpi',
  title:       'Bonuses',
  sportScope:  ['nhl'],
  factory:     () => ({
    get _b() {
      const defs = LSNhl.bonusDefs(this);
      let banked = 0, chasing = 0, missed = 0;
      for (const { p } of LSNhl.mine(this)) {
        const goalie = LSNhl.isGoalie(p), st = p.stats || {};
        const g = LSNhl.game(this, p), ph = g ? this.effStatus(g) : 1;
        for (const d of defs) {
          if ((d.grp === 'goalie') !== goalie) continue;
          const have = LSNhl.count(p, d.stat);
          if (st[d.key] || have >= d.at) { banked++; continue; }
          if (have < Math.max(1, Math.ceil(d.at / 2))) continue;
          if (ph >= 3) missed++; else if (ph === 2) chasing++;
        }
      }
      return { banked, chasing, missed };
    },
  }),
});

/* Goals & Points — DK points from goals and assists, and their share. */
window.LSWidgets.register({
  id:          'kpi_nhl_goals_points',
  description: 'DraftKings points your players have banked from goals and assists.',
  help:        "Goals (+8.5) and assists (+5) are most of a hockey score. This is what they've earned your players tonight, and how much of your total that is - the rest is shots, blocks and your goalies.",
  slot:        'kpi',
  title:       'Goals & Assists',
  sportScope:  ['nhl'],
  factory:     () => ({
    get _tot() {
      let g = 0, a = 0, all = 0;
      for (const { p } of LSNhl.mine(this)) {
        const st = p.stats || {};
        g += +(st.goal || 0); a += +(st.assist || 0); all += +(p.live_fpts || 0);
      }
      const pts = g * LSNhl.weight(this, 'skater', 'goal') + a * LSNhl.weight(this, 'skater', 'assist');
      return { g, a, pts, share: all > 0 ? Math.round(pts / all * 100) : 0 };
    },
  }),
});

/* ==== static/js/widgets/kpi/on_field.js ==== */
;
/* widgets/kpi/on_field.js — NFL: how many of your players are ON THE FIELD.
 *
 * Football's answer to "who's on court". Until the provider started emitting
 * drive possession (2026-08-13) every NFL player looked permanently active, so
 * this number was unknowable. Now: a skill player counts while HIS team has
 * the ball, a D/ST while the opponent does.
 *
 * Reads is_on_court off the pool rows, which the provider sets — so the tile,
 * the player-grid dots and the scoreboard's ball all move together.
 */
window.LSWidgets.register({
  id:          'kpi_on_field',
  description: 'How many of your players are on the field right now.',
  help:        'Your players actually out there this snap — skill players while their team has the ball, your D/ST while the opponent does. A low number mid-quarter just means your guys are on the sideline; it says nothing about how they are scoring.',
  slot:        'kpi',
  title:       'On Field',
  sportScope:  ['nfl', 'cfb'],
  factory:     () => ({
    /** Unique players across my lineups, deduped by id. */
    get _unique() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const k = window.LSModelUtil.pid(p);
          if (!seen.has(k)) seen.set(k, p);
        }
      }
      return [...seen.values()];
    },
    get _onField() { return this._unique.filter(p => p.is_on_court).length; },
    get _total()   { return this._unique.length; },
    /** Live games only — pre-slate this tile should read as "nothing yet"
     *  rather than a confident 0 of 9. */
    get _anyLive() {
      return (this.allGames || []).some(g => (g.status || 0) === 2);
    },
    /** Is anyone of mine marked on the field? The demo (and any provider
     *  without snap data) sends is_on_court false for everyone, and a
     *  confident "0" sat beside cards with possession arrows (audit run 1,
     *  LIVE-5). With nobody marked, the tile says it has nothing to count
     *  rather than claiming zero. */
    get _hasFeed() {
      return this._unique.some(p => p.game_phase === 'playing' && p.is_on_court === true);
    },
  }),
});

/* ==== static/js/widgets/_nba.js ==== */
;
/* widgets/_nba.js — shared NBA helpers for the NBA widgets (Double Watch, the
 * Doubles / Double Chasers / On Court KPIs). Same role as _nhl.js for hockey.
 *
 * The NBA-only scoring event is the DOUBLE: 10+ in two of points, rebounds,
 * assists, steals, blocks is a double-double, three is a triple-double. On
 * DraftKings they pay +1.5 and +3 (a triple-double earns both). The values are
 * read from the slate's own scoring rules, never hardcoded - FanDuel pays no
 * double bonus at all, so on a FanDuel slate the widgets show no value.
 *
 * Joins by player id / game id, never by name. */
window.LSNba = {
  CATS: [['pts', 'pts', 'points'], ['reb', 'reb', 'rebounds'], ['ast', 'ast', 'assists'],
         ['stl', 'stl', 'steals'], ['blk', 'blk', 'blocks']],

  /** My players, once each: [{p, n}] - n = how many of my lineups hold him. */
  mine(host) {
    const m = new Map();
    for (const lu of (host.lineupRows || [])) {
      const seen = new Set();
      for (const p of (lu.players || [])) {
        const k = String(p.player_id || '');
        if (!k || seen.has(k)) continue;
        seen.add(k);
        const e = m.get(k);
        if (e) e.n += 1; else m.set(k, { p, n: 1 });
      }
    }
    return [...m.values()];
  },

  game(host, p) {
    return (host.allGames || []).find(g => String(g.game_id) === String(p.game_id)) || null;
  },

  live(host, p) {
    const g = this.game(host, p);
    return !!g && (typeof host.effStatus === 'function' ? host.effStatus(g) : g.status) === 2;
  },

  /** {dd, td} bonus values from the slate's rules (0 when the platform pays none). */
  bonus(host) {
    const out = { dd: 0, td: 0 };
    const groups = host.scoringRulesByPos || {};
    for (const [grp, rules] of Object.entries(groups)) {
      if (grp.startsWith('_') || !rules || typeof rules !== 'object') continue;
      if (rules.dd_bonus) out.dd = +rules.dd_bonus;
      if (rules.td_bonus) out.td = +rules.td_bonus;
    }
    const flat = host.scoringRules || {};
    if (!out.dd && flat.dd_bonus) out.dd = +flat.dd_bonus;
    if (!out.td && flat.td_bonus) out.td = +flat.td_bonus;
    return out;
  },

  /** Where a player stands on doubles:
   *  { line: [{k, short, v}] (his five categories, biggest first),
   *    tens, dd, td,
   *    next: null | { kind: 'dd'|'td', need, missing: [{short, long, togo}] } }
   *  `need` is the total still to find across the categories that would make
   *  the next double (the two - or three - biggest of his line). */
  doubles(p) {
    const st = p.stats || {};
    const line = this.CATS.map(([k, short, long]) => ({ k, short, long, v: +(st[k] || 0) }))
      .sort((a, b) => b.v - a.v);
    const tens = line.filter(c => c.v >= 10).length;
    const out = { line, tens, dd: tens >= 2, td: tens >= 3, next: null };
    if (tens >= 3) return out;
    const want = tens >= 2 ? 3 : 2;
    const missing = line.slice(0, want).filter(c => c.v < 10)
      .map(c => ({ short: c.short, long: c.long, togo: 10 - c.v }));
    out.next = { kind: want === 3 ? 'td' : 'dd', need: missing.reduce((t, c) => t + c.togo, 0), missing };
    return out;
  },

  /** MINUTES RISK - in the NBA, minutes ARE points. Two things take them away:
   *  foul trouble (six fouls and he is out) and a blowout (starters sit when a
   *  game is decided, whichever side is winning). For one of my players in a
   *  live game: [] or [{kind: 'fouls'|'blowout'|'out', level: 'danger'|'warn', text}].
   *    fouls:   5 = one from out; 4 before the last six minutes; 3 in the first half.
   *    blowout: a 20-point game in Q4 or overtime, 25+ in the second half of Q3.
   *    out:     fouled out - the minutes are already gone. */
  minutesRisk(host, p) {
    const g = this.game(host, p);
    if (!g) return [];
    const st = (typeof host.effStatus === 'function' ? host.effStatus(g) : g.status);
    const pf = +((p.stats || {}).pf || 0);
    if (pf >= 6) return [{ kind: 'out', level: 'danger', text: 'Fouled out' }];
    if (st !== 2) return [];
    const per = +(g.period || 0), secs = +(g.clock_secs || 0);
    const out = [];
    if (pf >= 5) out.push({ kind: 'fouls', level: 'danger', text: '5 fouls · one from out' });
    else if (pf >= 4 && (per < 4 || secs > 360)) out.push({ kind: 'fouls', level: 'warn', text: '4 fouls' + (per ? ' in Q' + Math.min(per, 4) : '') });
    else if (pf >= 3 && per <= 2 && !g.halftime) out.push({ kind: 'fouls', level: 'warn', text: '3 fouls in the first half' });
    const margin = Math.abs(+(g.home_score || 0) - +(g.away_score || 0));
    if ((per >= 4 && margin >= 20) || (per === 3 && secs <= 360 && margin >= 25)) {
      out.push({ kind: 'blowout', level: margin >= 25 || (per >= 4 && secs <= 360) ? 'danger' : 'warn',
                 text: margin + '-point game · starters may sit' });
    }
    return out;
  },

  /** My players with minutes at risk, worst first: [{p, n, risks}]. */
  atRisk(host) {
    const rank = { danger: 0, warn: 1 };
    return this.mine(host).map(x => ({ ...x, risks: this.minutesRisk(host, x.p) }))
      .filter(x => x.risks.length)
      .sort((a, b) => Math.min(...a.risks.map(r => rank[r.level])) - Math.min(...b.risks.map(r => rank[r.level]))
                   || +(b.p.live_fpts || 0) - +(a.p.live_fpts || 0));
  },

  /** GAME STACKS - basketball stacks by GAME, not team: a high-scoring,
   *  close game pays players on BOTH sides. Groups my players by game id;
   *  a stack is 2+ of them together in at least one lineup.
   *  [{game, label, players, lineups, total}] best first. */
  gameStacks(host) {
    const groups = new Map();
    for (const x of this.mine(host)) {
      const k = String(x.p.game_id || '');
      if (!k) continue;
      if (!groups.has(k)) groups.set(k, []);
      groups.get(k).push(x.p);
    }
    const lineups = host.lineupRows || [];
    const out = [];
    for (const [gid, players] of groups) {
      if (players.length < 2) continue;
      const ids = new Set(players.map(p => String(p.player_id)));
      const together = lineups.filter(lu => (lu.players || []).filter(p => ids.has(String(p.player_id))).length >= 2).length;
      if (!together) continue;                       // never together in one lineup
      const g = (host.allGames || []).find(x => String(x.game_id) === gid) || {};
      const sorted = players.slice().sort((a, b) => +(b.live_fpts || 0) - +(a.live_fpts || 0));
      out.push({ game: g, label: (g.away_team || '?') + ' @ ' + (g.home_team || '?'), players: sorted, lineups: together,
                 total: sorted.reduce((t, p) => t + +(p.live_fpts || 0), 0) });
    }
    return out.sort((a, b) => b.total - a.total);
  },

  /** "2 reb" / "2 reb · 1 ast" - what is still missing, short form. */
  missingText(next) {
    return next ? next.missing.map(c => c.togo + ' ' + c.short).join(' · ') : '';
  },

  /** "25 pts · 12 reb · 11 ast" - the categories that count, biggest first. */
  lineText(d, n = 3) {
    return d.line.slice(0, n).filter(c => c.v > 0).map(c => c.v + ' ' + c.short).join(' · ');
  },
};

/* ==== static/js/widgets/nba_panels.js ==== */
;
/* widgets/nba_panels.js — NBA panels (2026-27 launch, Xav 2026-10-04).
 *
 * Double Watch: basketball's Bonus Watch. A double-double (+1.5 on DK) or a
 * triple-double (+3, on top) is the one scoring event only basketball has, and
 * it is invisible on a box score until it lands - a player on 18 pts and 8
 * rebounds is two boards from free points and nothing on the board says so.
 * Closest first; doubles already banked tonight at the foot. Values come from
 * the slate's own scoring rules (LSNba.bonus), so a FanDuel slate shows none. */
window.LSWidgets.register({
  id:          'nba_double_watch',
  // Broadcast's dock: quiet until one of mine is near a double.
  quiet:       (s) => ((s._chasing || []).length || (s._banked || []).length ? '' : 'Nobody near a double-double yet'),
  description: 'Who is closing on a double-double or triple-double, and the doubles already banked tonight.',
  help:        'Ten or more in two of points, rebounds, assists, steals and blocks is a double-double; three is a triple-double. On DraftKings they pay +1.5 and +3, and a triple-double earns both. This is the countdown for your players in live games, nearest first, with what is still missing.',
  slot:        'panel',
  title:       'Double Watch',
  sportScope:  ['nba', 'wnba'],
  factory:     () => ({
    get _bonus() { return LSNba.bonus(this); },
    /** Players in a live game within 4 of their next double. */
    get _chasing() {
      const out = [];
      for (const { p, n } of LSNba.mine(this)) {
        if (!LSNba.live(this, p)) continue;
        const d = LSNba.doubles(p);
        if (!d.next || d.next.need > 4) continue;
        out.push({ key: String(p.player_id), p, n, d,
                   what: d.next.kind === 'td' ? 'Triple-double' : 'Double-double',
                   gain: d.next.kind === 'td' ? this._bonus.td : this._bonus.dd });
      }
      return out.sort((a, b) => a.d.next.need - b.d.next.need || b.d.tens - a.d.tens);
    },
    /** Doubles already in the book tonight - live or final. */
    get _banked() {
      const out = [];
      for (const { p, n } of LSNba.mine(this)) {
        const d = LSNba.doubles(p);
        if (!d.dd) continue;
        const b = this._bonus;
        out.push({ key: String(p.player_id), p, n, d, label: d.td ? 'TD' : 'DD',
                   gain: d.td ? b.dd + b.td : b.dd });
      }
      return out.sort((a, b) => b.d.tens - a.d.tens);
    },
    // Broadcast's side panel (Xav 2026-10-08, NBA to the NFL standard): the
    // Bonus Watch's rows - chasing (live, within 6), then banked, then the ones
    // that finished within 3 and missed. Simple / Analytical keep the list.
    get _bcRows() {
      const out = [];
      for (const { p } of LSNba.mine(this)) {
        const g = LSNba.game(this, p);
        const st = g ? (typeof this.effStatus === 'function' ? this.effStatus(g) : g.status) : 0;
        const d = LSNba.doubles(p);
        const want = d.td ? 3 : (d.dd ? 3 : 2);
        const have = d.line.slice(0, want).reduce((t, c) => t + Math.min(10, c.v), 0);
        const pct = Math.round(have / (10 * want) * 100);
        const base = { name: p.name, team: p.team, nums: LSNba.lineText(d) };
        // the bonus each banked double is worth, as NFL's badge says (NUMBERS-11)
        const _bn = (v) => (Number(v) ? (Number.isInteger(Number(v)) ? String(Number(v)) : Number(v).toFixed(2)) : '');
        if (d.dd) {
          out.push({ ...base, key: p.player_id + ':dd', label: 'Double-double', earned: true, done: false, togo: 0, pct: 100, bonus: _bn(this._bonus && this._bonus.dd) });
          if (d.td) out.push({ ...base, key: p.player_id + ':td', label: 'Triple-double', earned: true, done: false, togo: 0, pct: 100, bonus: _bn(this._bonus && this._bonus.td) });
        }
        if (!d.next) continue;
        const what = d.next.kind === 'td' ? 'Triple-double' : 'Double-double';
        if (st === 2 && d.next.need <= 6) {
          out.push({ ...base, key: p.player_id + ':' + d.next.kind, label: what, earned: false, done: false,
                     togo: d.next.need, miss: LSNba.missingText(d.next), pct });
        } else if (st >= 3 && d.next.need <= 3) {
          out.push({ ...base, key: p.player_id + ':' + d.next.kind, label: what, earned: false, done: true,
                     togo: d.next.need, miss: LSNba.missingText(d.next), pct });
        }
      }
      const rank = (r) => (r.earned ? 1 : (r.done ? 2 : 0));
      return out.sort((a, b) => (rank(a) - rank(b)) || (a.togo - b.togo));
    },
    // Grouped by bonus, like the NFL and NHL Bonus Watch (Xav 2026-10-12):
    // "Double-double · +1.5", "Triple-double · +3" (widgets/_bonus_groups.html).
    get _bwRows() {
      const own = this._inCountMap || {}, nLu = (this.activeLineupRows || this.lineupRows || []).length;
      const b = this._bonus || {};
      const pts = (v) => (Number(v) ? '+' + (Number.isInteger(Number(v)) ? String(Number(v)) : Number(v).toFixed(2)) : '');
      return this._bcRows.map(r => {
        const pid = r.key.split(':')[0], kind = r.key.split(':')[1], n = own[pid] || 0;
        return { key: r.key, group: kind, title: r.label, sub: pts(kind === 'td' ? b.td : b.dd), bonus: r.bonus,
                 name: r.name, team: r.team, own: nLu > 1 && n ? 'in ' + n + '/' + nLu : '',
                 have: 0, at: 0, togo: r.togo, pips: 0, pct: r.pct, line: r.nums || '0 pts',
                 state: r.earned ? 'banked' : (r.done ? 'missed' : 'chase') };
      });
    },
    get _bwFlat()   { return window.LSModelUtil.bonusFlat(this._bwRows); },
    get _bwCounts() { return window.LSModelUtil.bonusCounts(this._bwRows); },
  }),
});

/* Minutes Risk: in the NBA minutes ARE points. Your players losing them right
 * now - foul trouble (six is out) or a blowout (starters sit when a game is
 * decided) - worst first, with the game state beside each. LSNba.minutesRisk. */
window.LSWidgets.register({
  id:          'nba_minutes_risk',
  quiet:       (s) => ((s._rows || []).length ? '' : 'No minutes at risk'),
  description: 'Your players losing minutes right now: foul trouble or a blowout.',
  help:        'In the NBA, minutes are points. Six fouls and a player is out of the game, so foul trouble is flagged early (3 in the first half, 4 before the last six minutes, 5 at any time). A 20-point game in the fourth quarter usually means the starters sit, whichever side is winning.',
  slot:        'panel',
  title:       'Minutes Risk',
  sportScope:  ['nba', 'wnba'],
  factory:     () => ({
    get _rows() {
      return LSNba.atRisk(this).map(x => {
        const g = LSNba.game(this, x.p) || {};
        return { key: String(x.p.player_id), p: x.p, n: x.n, risks: x.risks, state: g.status_text || '' };
      });
    },
  }),
});

/* Game Stacks: your players grouped by GAME (both sides of a shootout pay),
 * best first, each player's share of the stack. LSNba.gameStacks. */
window.LSWidgets.register({
  id:          'nba_game_stacks',
  quiet:       (s) => ((s._stacks || []).length ? '' : 'No game stacks'),
  description: 'Your game stacks - two or more of your players from the same game in a lineup - and what they are scoring combined.',
  help:        "Basketball stacks by game, not team: a fast, close game pays players on both sides. These are your stacks by game, best first, with each player's share and the game state.",
  slot:        'panel',
  title:       'Game Stacks',
  sportScope:  ['nba', 'wnba'],
  factory:     () => ({
    get _stacks() { return LSNba.gameStacks(this).slice(0, 5); },
    _share(st, p) { return st.total > 0 ? Math.max(2, (p.live_fpts || 0) / st.total * 100) : 0; },
  }),
});

/* ==== static/js/widgets/kpi/nba_kpis.js ==== */
;
/* widgets/kpi/nba_kpis.js — NBA KPIs (2026-27 launch, Xav 2026-10-04).
 * Read LSNba (widgets/_nba.js); values from the slate's own scoring rules. */

/* DOUBLES: the double-doubles and triple-doubles your players have banked. */
window.LSWidgets.register({
  id:          'kpi_nba_doubles',
  description: 'Double-doubles and triple-doubles your players have banked tonight.',
  help:        'Ten or more in two of points, rebounds, assists, steals and blocks is a double-double; three is a triple-double. Counted once per player, however many of your lineups hold him.',
  slot:        'kpi',
  title:       'Doubles',
  sportScope:  ['nba', 'wnba'],
  factory:     () => ({
    get _rows() {
      return LSNba.mine(this).map(x => ({ ...x, d: LSNba.doubles(x.p) })).filter(x => x.d.dd)
        .sort((a, b) => b.d.tens - a.d.tens);
    },
    get _count() { return this._rows.length; },
    get _triples() { return this._rows.filter(x => x.d.td).length; },
    get _names() {
      return this._rows.map(x => LSModelUtil.short(x.p) + (x.d.td ? ' (TD)' : '')).join(', ');
    },
  }),
});

/* ON COURT: the NFL "On Field" tile's logic, worded for basketball. The feed's
   on-court flag (ESPN's `active`) is reliable and suppressed pre-tip. */
window.LSWidgets.register({
  id:          'kpi_nba_on_court',
  description: 'How many of your players are on the court right now.',
  help:        'Your players actually on the floor at this moment, from the league feed. A low number just means your guys are resting; it says nothing about how they are scoring.',
  slot:        'kpi',
  title:       'On Court',
  sportScope:  ['nba', 'wnba'],
  factory:     () => window.LSWidgets.get('kpi_on_field').factory(),
});

/* MINUTES RISK: how many of your players are losing minutes right now. */
window.LSWidgets.register({
  id:          'kpi_nba_minutes_risk',
  description: 'How many of your players are in foul trouble or in a blowout right now.',
  help:        'In the NBA, minutes are points. Counts your players in foul trouble (3 in the first half, 4 before the last six minutes, 5 at any time, or fouled out) or in a 20-point fourth quarter, when starters usually sit.',
  slot:        'kpi',
  title:       'Minutes Risk',
  sportScope:  ['nba', 'wnba'],
  factory:     () => ({
    get _rows()   { return LSNba.atRisk(this); },
    get _count()  { return this._rows.length; },
    get _danger() { return this._rows.some(x => x.risks.some(r => r.level === 'danger')); },
    get _names() {
      return this._rows.map(x => LSModelUtil.short(x.p) + ' (' + x.risks[0].text.split(' ·')[0] + ')').join(', ');
    },
  }),
});

/* ==== static/js/widgets/kpi/avg_live.js ==== */
;
/* widgets/kpi/avg_live.js — KPI tile: average live points across my lineups.
 * Reads parent dashboard().avgLive (set on each SSE tick via data.avg_live).
 */
window.LSWidgets.register({
  id:         'kpi_avg_live',
  description: 'Average live points across all of your lineups.',
  slot:       'kpi',
  title:      'Avg Live',
  sportScope: '*',
  factory:    () => ({}),
});

/* ==== static/js/widgets/kpi/best_est.js ==== */
;
/* widgets/kpi/best_est.js — best projected final among my lineups.
 * Reads parent dashboard().bestEst (set via data.best_est on SSE tick).
 */
window.LSWidgets.register({
  id:                  'kpi_best_est',
  description: 'Highest projected end-of-slate score among your lineups. Requires projections.',
  slot:                'kpi',
  title:               'Best Est. Final',
  sportScope:          '*',
  // Hides from picker + dashboard when the user has no projections —
  // est_final = live_fpts + (proj * remaining_frac), so without
  // projections the number is just live_fpts and the tile adds nothing
  // over kpi_top_scorer or the live KPI.
  requiresProjections: true,
  factory:    () => ({}),
});

/* ==== static/js/widgets/kpi/pct_pace.js ==== */
;
/* widgets/kpi/pct_pace.js — Lineups ahead vs behind pace.
 *
 * Was a single-lineup '% of pace for best lineup' metric, which broke
 * down for multi-lineup users (one cherry-picked number that ignored
 * the rest). Now shows the COUNT of lineups currently beating their
 * paced projection vs the count trailing it — meaningful for users
 * with anywhere from 1 to 1000 lineups.
 *
 * paced_proj = projection * fraction_of_game_elapsed, capped at 1.
 * Lineups whose paced_proj is 0 (no live game yet OR no projections
 * on any of their players) are excluded from both counts — they're
 * neither ahead nor behind, just not rated yet.
 */
window.LSWidgets.register({
  id:                  'kpi_pct_pace',
  description: 'How many of your lineups are ahead vs. behind their expected score so far - your projections, else the DraftKings average.',
  slot:                'kpi',
  title:               'Pace Split',
  sportScope:          '*',
  factory:    () => ({
    /** "Expected by now" for a lineup: its paced projection, or - with no
     *  projections - the DraftKings average paced the same way (the server's
     *  pace_basis / paced_avg). Live that is "ahead / behind pace"; at the
     *  final whistle "expected by now" is the whole expectation, so the same
     *  tile reads "beat / missed" with no switch (Xav 2026-10-07). */
    _exp(lu) {
      if ((lu.paced_proj || 0) > 0) return +lu.paced_proj;
      if (lu.pace_basis === 'avg' && (lu.paced_avg || 0) > 0) return +lu.paced_avg;
      return 0;
    },
    get _basis() {
      const rows = this.lineupRows || [];
      return rows.some(lu => (lu.paced_proj || 0) > 0) ? 'proj' : (rows.some(lu => lu.pace_basis === 'avg') ? 'avg' : '');
    },
    get _aheadCount() {
      return (this.lineupRows || []).filter(lu => this._exp(lu) > 0 && (lu.live_total || 0) > this._exp(lu)).length;
    },
    get _behindCount() {
      return (this.lineupRows || []).filter(lu => this._exp(lu) > 0 && (lu.live_total || 0) <= this._exp(lu)).length;
    },
    get _done() { const gs = this.allGames || []; return gs.length > 0 && gs.every(g => this.effStatus(g) >= 3); },
    /** Total lineups currently rateable. Sum of the two above. Used
     *  to show '— ratings' / 'no lineups rated yet' empty state. */
    get _ratedCount() {
      return this._aheadCount + this._behindCount;
    },
  }),
});

/* ==== static/js/widgets/kpi/top_scorer.js ==== */
;
/* widgets/kpi/top_scorer.js — slate-wide top scorer (the #1 player on the
 * slate by live FPts). Different from topContributor which is the top
 * scorer in MY lineups; this is the SLATE leader.
 */
window.LSWidgets.register({
  id:         'kpi_top_scorer',
  description: 'Highest-scoring player on the entire slate right now.',
  slot:       'kpi',
  title:      'Top Scorer',
  sportScope: '*',
  factory:    () => ({
    get _topScorer() {
      let best = null;
      for (const p of (this.allSlatePlayers || [])) {
        if ((p.live_fpts || 0) > 0 && (!best || (p.live_fpts || 0) > (best.live_fpts || 0))) {
          best = p;
        }
      }
      return best;
    },
  }),
});

/* ==== static/js/widgets/kpi/best_value.js ==== */
;
/* widgets/kpi/best_value.js — slate-wide best value KPI tile.
 *
 * Rescued from the retired Highlights ticker (Xav 2026-06-14): the one
 * fact nothing else surfaced. Highest live points per $1k salary across
 * the slate right now — the value play cashing. Sport-agnostic (every
 * salaried sport has it).
 */
window.LSWidgets.register({
  id:         'kpi_best_value',
  description: 'Best points-per-$1k on the slate right now (live FPts ÷ salary).',
  slot:       'kpi',
  title:      'Best Value',
  sportScope: '*',
  factory:    () => ({
    get _bestValue() {
      let best = null, bestRatio = 0;
      for (const p of (this.allSlatePlayers || [])) {
        const sal = p.salary || 0, live = p.live_fpts || 0;
        if (sal > 0 && live > 0) {
          const ratio = live / (sal / 1000);
          if (ratio > bestRatio) { bestRatio = ratio; best = { ...p, _ratio: ratio }; }
        }
      }
      return best;
    },
  }),
});

/* ==== static/js/widgets/kpi/my_best_value.js ==== */
;
/* widgets/kpi/my_best_value.js - your best value: the player in YOUR
 * lineups scoring the most live FPts per $1K of salary. kpi_best_value's
 * mine-only twin: on My Players and The Podium a slate-wide value play you
 * never rostered was the wrong answer (Xav 2026-10-06). Joins by player id.
 */
window.LSWidgets.register({
  id:         'kpi_my_best_value',
  description: 'Your best points-per-$1K right now - only players in your lineups.',
  slot:       'kpi',
  title:      'My Best Value',
  sportScope: '*',
  factory:    () => ({
    get _myBestValue() {
      const mine = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const id = String(p.player_id || p.external_player_id || '');
          if (id) mine.set(id, (mine.get(id) || 0) + 1);
        }
      }
      let best = null, bestRatio = 0;
      for (const p of (this.allSlatePlayers || [])) {
        const id = String(p.player_id || p.external_player_id || '');
        if (!mine.has(id)) continue;
        const sal = p.salary || 0, live = p.live_fpts || 0;
        if (sal > 0 && live > 0) {
          const ratio = live / (sal / 1000);
          if (ratio > bestRatio) { bestRatio = ratio; best = { ...p, _ratio: ratio, _n: mine.get(id) }; }
        }
      }
      return best;
    },
  }),
});

/* ==== static/js/widgets/kpi/slate_kpis.js ==== */
;
/* widgets/kpi/slate_kpis.js - the Broadcast board's new KPI tiles (Xav
 * 2026-10-07: four per tab, no repeats, nothing that needs projections
 * without a fallback, nothing that switches meaning mid-slate).
 *
 *   kpi_dream_total        The Action  - the Dream Team's total
 *   kpi_best_qb_receiver   The Action  - the slate's best QB + same-team receiver
 *   kpi_unique_players     My Lineups  - how many different players you used
 *   kpi_bonuses            My Players  - yardage bonuses banked / missed / chasing
 *   kpi_dream_owned        The Lab     - Dream Team players in your lineups (ring)
 *   kpi_position_mix       The Lab     - your points by position (stacked bar)
 *   kpi_momentum           The Lab     - when your points came: gain per time band (bars)
 *
 * Players join by id, never by name. A stack is a QB plus his OWN team's
 * receivers / backs in the SAME lineup.
 */
(function () {
  const num = (v) => { const n = Number(v); return isFinite(n) ? n : 0; };
  const pid = (p) => String((p && (p.player_id || p.external_player_id)) || '');
  const POS = (p) => String((p && p.pos) || '').toUpperCase();

  window.LSWidgets.register({
    id: 'kpi_dream_total', slot: 'kpi', title: 'Dream Team', sportScope: '*',
    description: "The Dream Team's total - the best lineup anyone could have built from this slate.",
    help: "The perfect lineup for this slate under the platform's rules, and what it has scored. The bar everyone is chasing.",
    factory: () => ({
      get _dt() { return num(this.dreamTeamScore); },
      get _n() { return (this.dreamTeam || []).length; },
    }),
  });

  // The Podium is the slate's night, not yours (Xav 2026-10-10): with Dream
  // Team and Best Value, these two make its strip - nothing about lineups.
  window.LSWidgets.register({
    id: 'kpi_biggest_game', slot: 'kpi', title: 'Biggest Game', sportScope: '*',
    description: 'The game that produced the most fantasy points, both teams, and its score.',
    help: "Every player in a game, both teams, added up: the game that gave the slate the most fantasy points. Joined by game id.",
    factory: () => ({
      get _bg() {
        const by = new Map();
        for (const p of (this.allSlatePlayers || [])) if (p.game_id != null) by.set(String(p.game_id), (by.get(String(p.game_id)) || 0) + num(p.live_fpts));
        let best = null;
        for (const g of (this.allGames || [])) {
          const v = by.get(String(g.game_id)) || 0;
          if (v > 0 && (!best || v > best.v)) best = { v, g };
        }
        if (!best) return null;
        const g = best.g, st = typeof this.effStatus === 'function' ? this.effStatus(g) : num(g.status);
        return { v: best.v, label: String(g.away_team || '') + ' @ ' + String(g.home_team || ''),
                 score: st >= 2 ? num(g.away_score) + '-' + num(g.home_score) : '' };
      },
    }),
  });

  // The Slate's own tile once Dream Team and Best Value went to The Podium
  // (Xav 2026-10-10): what the whole slate has produced, climbing as it plays.
  window.LSWidgets.register({
    id: 'kpi_slate_points', slot: 'kpi', title: 'Slate Points', sportScope: '*',
    description: 'Every fantasy point the slate has produced so far, all players, all games.',
    help: 'Every player on the slate, added up - what the night has produced so far, and in how many games.',
    factory: () => ({
      get _sp() {
        const ps = this.allSlatePlayers || [];
        const v = ps.reduce((t, p) => t + num(p.live_fpts), 0);
        const gs = this.allGames || [];
        const st = (g) => (typeof this.effStatus === 'function' ? this.effStatus(g) : num(g.status));
        return { v, games: gs.length, started: gs.filter(g => st(g) >= 2).length };
      },
    }),
  });

  // The Podium's two (Xav 2026-10-10): price against return at the top end,
  // and the team whose players had the night.
  window.LSWidgets.register({
    id: 'kpi_biggest_flop', slot: 'kpi', title: 'Biggest Flop', sportScope: '*',
    description: "Of the slate's ten most expensive players, the one who returned the least per $1K.",
    help: "The ten highest salaries on the slate who played, and the one whose points per $1,000 of salary were lowest - the chalk that let people down. A player who did not play is left out.",
    factory: () => ({
      get _flop() {
        const seen = new Set(), ps = [];
        for (const p of (this.allSlatePlayers || [])) {
          const id = pid(p);
          if (!id || seen.has(id) || p.dnp || !(num(p.salary) > 0)) continue;
          if (p.game_phase !== 'finished' && p.game_phase !== 'playing') continue;
          seen.add(id); ps.push(p);
        }
        const top = ps.sort((a, b) => num(b.salary) - num(a.salary)).slice(0, 10);
        if (!top.length) return null;
        const f = top.slice().sort((a, b) => (num(a.live_fpts) / num(a.salary)) - (num(b.live_fpts) / num(b.salary)))[0];
        const per = num(f.live_fpts) / (num(f.salary) / 1000);
        return { p: f, pts: num(f.live_fpts), sal: num(f.salary), per, perTxt: per.toFixed(2) };   // a ratio, not a score: always 2 decimals
      },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_team_night', slot: 'kpi', title: 'Team of the Night', sportScope: '*',
    description: "The team whose players scored the most fantasy points between them, and its top three.",
    help: "Every player on one team, added up - the team that produced the most fantasy points on the slate, with the three who did most of it. Teams by id.",
    factory: () => ({
      get _tn() {
        const by = new Map(), seen = new Set();
        for (const p of (this.allSlatePlayers || [])) {
          const id = pid(p), k = String(p.team_id || p.team || '');
          if (!id || !k || seen.has(id)) continue;
          seen.add(id);
          const e = by.get(k) || { team: String(p.team || '').toUpperCase(), v: 0, ps: [] };
          e.v += num(p.live_fpts); e.ps.push(p); by.set(k, e);
        }
        const best = [...by.values()].sort((a, b) => b.v - a.v)[0];
        if (!best || !(best.v > 0)) return null;
        const who = best.ps.filter(p => num(p.live_fpts) > 0).sort((a, b) => num(b.live_fpts) - num(a.live_fpts)).slice(0, 3)
          .map(p => window.LSModelUtil.short(p)).join(', ');
        return { team: best.team, v: best.v, who };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_dream_cost', slot: 'kpi', title: 'Perfect Lineup Cost', sportScope: '*',
    description: "What the Dream Team costs in salary, against the platform's cap.",
    help: "The salaries of the nine (or however many) players in the perfect lineup, added up, against the salary cap - how close the best lineup came to spending it all.",
    factory: () => ({
      get _cost() {
        const dt = this.dreamTeam || [];
        const s = dt.reduce((t, p) => t + num(p.salary), 0);
        return dt.length && s > 0 ? { s, cap: num(this.salaryCap) } : null;
      },
      _money(v) { return '$' + Math.round(num(v)).toLocaleString('en-US'); },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_best_qb_receiver', slot: 'kpi', title: 'Best QB Stack', sportScope: ['nfl', 'cfb'],
    description: "The slate's best quarterback and same-team receiver pair, whoever owns them.",
    help: "Across the whole slate: a quarterback plus one of his own team's receivers, tight ends or backs - the classic two-man stack - and their combined score.",
    factory: () => ({
      // LSStacks' best 2-man stack on the slate (audit v2 W1, CODE-15: this
      // was a fourth stack definition, teammates matched by team code).
      get _pair() {
        const rows = window.LSStacks ? window.LSStacks.byTeam(this.allSlatePlayers || [], this._sportId || 'nfl') : [];
        const best = rows.map(r => r.s[2]).filter(Boolean).sort((a, b) => b.total - a.total)[0];
        return best && best.total > 0 ? { qb: best.qb, mate: best.mates[0], total: best.total, team: best.team } : null;
      },
    }),
  });

  // THE SLATE's fourth tile on NHL (Xav 2026-10-07): the slate's best 3-man
  // stack - the team's three best skaters (widgets/stack_model.js).
  window.LSWidgets.register({
    id: 'kpi_slate_best_stack', slot: 'kpi', title: 'Best 3-Man Stack', sportScope: ['nhl', 'mlb'],
    description: "The slate's best three teammates - the classic stack (NHL skaters, MLB hitters).",
    help: 'Across the whole slate: the three best players from one team and their combined score, whoever owns them. NHL goalies and MLB pitchers never count.',
    factory: () => ({
      get _st() {
        const rows = window.LSStacks ? window.LSStacks.byTeam(this.allSlatePlayers || [], this._sportId) : [];
        const best = rows.map(r => r.s[3]).filter(Boolean).sort((a, b) => b.total - a.total)[0];
        return best && best.total > 0 ? best : null;
      },
    }),
  });

  // THE PODIUM's fourth tile on NHL: YOUR best 3-man stack, inside one
  // lineup - the same model as Your Stacks below it and the slate's tile.
  window.LSWidgets.register({
    id: 'kpi_my_best_stack3', slot: 'kpi', title: 'My Best 3-Man Stack', sportScope: ['nhl', 'nba', 'mlb'],
    description: 'Your best three skaters from one team in the same lineup.',
    help: 'Across your lineups: the best three skaters from one team that share a lineup (goalies never count), and which lineup holds them.',
    // each sport's own words - hockey's "skaters / goalies" on NBA and MLB
    // boards (audit v2 run 3, SPORT-9)
    descriptionBySport: { nba: 'Your best three teammates in the same lineup.', mlb: 'Your best three hitters from one team in the same lineup.' },
    helpBySport: {
      nba: 'Across your lineups: the best three players from one team that share a lineup, and which lineup holds them.',
      mlb: 'Across your lineups: the best three hitters from one team that share a lineup (pitchers never count), and which lineup holds them.',
    },
    factory: () => ({
      get _st() {
        if (!window.LSStacks) return null;
        const c = window.LSStacks.yours(this.lineupRows || [], this.allSlatePlayers || [], this._sportId).find(x => x.k === 3);
        return c && c.best ? c.best : null;
      },
    }),
  });

  // THE SLATE's fourth tile on NBA (Xav 2026-10-08): the best three players
  // from one GAME, both teams - a close, fast game pays both sides.
  window.LSWidgets.register({
    id: 'kpi_slate_best_game', slot: 'kpi', title: 'Best Game Stack', sportScope: ['nba'],
    description: "The slate's best three players from one game, both teams.",
    help: 'Across the whole slate: the three best players from the same game, whichever side they play for, and their combined score.',
    factory: () => ({
      get _gs() {
        const b = window.LSStacks ? window.LSStacks.bestGame(this.allSlatePlayers || [], 3) : null;
        if (!b || !(b.total > 0)) return null;
        const g = (this.allGames || []).find(x => String(x.game_id) === b.game_id) || {};
        return { ...b, label: String(g.away_team || '').toUpperCase() + ' @ ' + String(g.home_team || '').toUpperCase() };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_unique_players', slot: 'kpi', title: 'Unique Players', sportScope: '*',
    description: 'How many different players your lineups use.',
    help: 'Every player across all your lineups, counted once - how spread your night is. Few unique players means heavy overlap between lineups.',
    factory: () => ({
      get _u() {
        const ids = new Set(); let slots = 0;
        for (const lu of (this.lineupRows || [])) for (const p of (lu.players || [])) { slots++; const k = pid(p); if (k) ids.add(k); }
        return { n: ids.size, slots, lus: (this.lineupRows || []).length };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_bonuses', slot: 'kpi', title: 'Bonuses', sportScope: ['nfl', 'cfb'],
    description: 'Yardage bonuses your players have banked, missed and are still chasing.',
    help: 'DraftKings pays +3 for 100 rushing, 100 receiving or 300 passing yards. Banked = reached; chasing = live and at least a third of the way; missed = finished short. Each player counted once.',
    factory: () => ({
      get _b() {
        const defs = ((window.SPORT_REGISTRY || {}).nfl || {}).bonusDefs || [];
        const seen = new Set(); let banked = 0, missed = 0, chasing = 0;
        for (const lu of (this.lineupRows || [])) for (const p of (lu.players || [])) {
          const k = pid(p); if (!k || seen.has(k)) continue; seen.add(k);
          const st = p.stats || {};
          for (const d of defs) {
            const v = num(st[d.stat]);
            if (st[d.flag] || v >= d.at) banked++;
            else if (v >= d.at / 3) { if (p.game_phase === 'finished') missed++; else chasing++; }
          }
        }
        return { banked, missed, chasing };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_dream_owned', slot: 'kpi', title: 'Dream Team Owned', sportScope: '*',
    description: 'How many Dream Team players are in at least one of your lineups.',
    help: "Of the perfect lineup's players, how many you rostered somewhere. Joined by player id.",
    factory: () => ({
      get _o() {
        const mine = new Set();
        for (const lu of (this.lineupRows || [])) for (const p of (lu.players || [])) { const k = pid(p); if (k) mine.add(k); }
        const dt = this.dreamTeam || [];
        const have = dt.filter(p => mine.has(pid(p))).length;
        return { have, of: dt.length, pct: dt.length ? have / dt.length : 0 };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_position_mix', slot: 'kpi', title: 'Position Mix', sportScope: ['nfl', 'cfb', 'nhl', 'nba', 'mlb'],
    description: "Your lineups' points by position.",
    help: "Where your lineups' points came from, position by position - every lineup slot as it scored there, so a player in three of your lineups counts in all three, as Top Contributors does.",
    factory: () => ({
      get _mix() {
        const sp = String(this._sportId || '').toLowerCase();
        const nhl = sp === 'nhl', nba = sp === 'nba', mlb = sp === 'mlb';
        const order = nhl ? ['C', 'W', 'D', 'G'] : nba ? ['PG', 'SG', 'SF', 'PF', 'C']
                    : mlb ? ['P', 'C', '1B', '2B', '3B', 'SS', 'OF'] : ['QB', 'RB', 'WR', 'TE', 'DST'];
        // NBA: a dual-position player ("PG/SG") counts at the first spot listed
        const norm = (ps) => (nhl ? ({ LW: 'W', RW: 'W', F: 'W', GK: 'G' }[ps] || ps)
                            : nba ? (({ G: 'PG', F: 'SF' })[ps.split('/')[0]] || ps.split('/')[0])
                            : mlb ? (({ SP: 'P', RP: 'P', LF: 'OF', CF: 'OF', RF: 'OF' })[ps.split('/')[0]] || ps.split('/')[0])
                                  : ((ps === 'D' || ps === 'DEF' || ps === 'D/ST') ? 'DST' : ps));
        // "Your points" = your lineups' points, every lineup slot as it scored
        // there - the same basis as Top Contributors on this tab (audit v2 W1,
        // NUMBERS-6: this counted each player once while the panel beside it
        // counted his lineups, two answers to "% of your points").
        const by = Object.fromEntries(order.map(k => [k, 0]));
        for (const lu of (this.lineupRows || [])) for (const p of (lu.players || [])) {
          if (!pid(p)) continue;
          const ps = norm(POS(p));
          if (ps in by) by[ps] += Math.max(0, num(p.live_fpts));
        }
        const total = order.reduce((t, k) => t + by[k], 0);
        const NAME = nhl ? { C: 'Centres', W: 'Wingers', D: 'Defence', G: 'Goalies' }
                   : nba ? { PG: 'Point guards', SG: 'Shooting guards', SF: 'Small forwards', PF: 'Power forwards', C: 'Centres' }
                   : mlb ? { P: 'Pitchers', C: 'Catchers', '1B': 'First basemen', '2B': 'Second basemen', '3B': 'Third basemen', SS: 'Shortstops', OF: 'Outfielders' }
                   // NFL in words too - "WR bring 41%" (Broadcast audit v2, SPORT-10)
                   : { QB: 'Quarterbacks', RB: 'Running backs', WR: 'Wide receivers', TE: 'Tight ends', DST: 'Defences' };
        const rows = order.map(k => ({ k, name: NAME[k] || k, pts: by[k], pct: total ? by[k] / total * 100 : 0 }));
        const top = [...rows].sort((a, b) => b.pts - a.pts)[0];
        return { rows, total, top };
      },
    }),
  });

  // MOMENTUM (Xav 2026-10-07, replacing Stacks): when your points came. The
  // night cut into equal time bands - 15 min on a Sunday, shorter on a short
  // slate, never more than 16 bars - each bar what your average lineup gained
  // in it (the average, never points x lineups). The tallest is the peak.
  // seconds first: the demo replays a game in under a minute
  const BANDS = [5e3, 10e3, 15e3, 30e3, ...[1, 2, 5, 10, 15, 30, 60, 120].map(m => m * 60e3)];
  window.LSWidgets.register({
    id: 'kpi_momentum', slot: 'kpi', title: 'Momentum', sportScope: '*',
    description: 'When your points came: what your average lineup gained in each part of the night.',
    help: 'The night in equal time bands; each bar is what your average lineup scored in that band, and the brightest is your best spell. Read from the same scoring history as the Trajectory.',
    factory: () => ({
      get _mo() {
        const empty = { bars: [], peak: '', band: '' };
        const sh = this.lineupHistory || [];
        const { pts, elapsed } = window.LSModelUtil.avgSeries(this.lineupRows, sh.length >= 2 ? sh : (this._lineupHistory || []));
        if (pts.length < 2) return empty;
        const first = pts[0][0], span = pts[pts.length - 1][0] - first;
        if (!(span > 0)) return empty;
        const band = BANDS.find(b => span / b <= 16) || BANDS[BANDS.length - 1];
        // bands on the clock (9:00, 9:15 ...), not from the first sample (9:03)
        const off = elapsed ? 0 : new Date(first).getTimezoneOffset() * 60e3;
        const t0 = elapsed ? 0 : Math.floor((first - off) / band) * band + off;
        const n = Math.max(1, Math.ceil((pts[pts.length - 1][0] - t0) / band));
        const gain = new Array(n).fill(0);
        let j = 0, prev = pts[0][1];
        for (let k = 0; k < n; k++) {
          const end = t0 + (k + 1) * band;
          let v = prev;
          while (j < pts.length && pts[j][0] <= end) { v = pts[j][1]; j++; }
          gain[k] = Math.max(0, v - prev);   // a stat correction is not momentum
          prev = v;
        }
        const max = Math.max(...gain);
        if (!(max > 0)) return { ...empty, bars: gain.map((g, i) => ({ i, h: 0, peak: false })) };
        const top = gain.indexOf(max);
        const two = (x) => String(x).padStart(2, '0');
        const at = t0 + top * band;
        const peak = elapsed
          ? Math.floor(at / 60e3) + ':' + two(Math.round((at % 60e3) / 1000))
          : new Date(at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        return {
          bars: gain.map((g, i) => ({ i, h: Math.round(g / max * 100), peak: i === top })),
          peak,
          band: band < 60e3 ? (band / 1e3) + ' s' : (band < 3600e3 ? (band / 60e3) + ' min' : (band / 3600e3) + ' h'),
        };
      },
    }),
  });
})();

/* ==== static/js/widgets/kpi/live_kpis.js ==== */
;
/* widgets/kpi/live_kpis.js - The Action's strip: right now (Xav 2026-10-07,
 * when the slate tiles moved to The Slate). Four tiles about your night as
 * it happens, each with a final-whistle reading so the strip never goes
 * blank at the end:
 *
 *   kpi_playing_now  your players in a game right now, of all of yours
 *   kpi_live_pace    your average lineup against what it should have by now
 *   kpi_last15       what your average lineup scored in the last 15 minutes
 *   kpi_next_up      the next kick-off and how many of yours it brings
 *
 * Players join by id, games by game_id. "Your average lineup" is the mean
 * over your lineups - never points x lineups.
 */
(function () {
  const U = () => window.LSModelUtil;
  const num = (v) => { const n = Number(v); return isFinite(n) ? n : 0; };
  // Memoised on the rows array (replaced every push): a KPI getter re-walking
  // 150 lineups x 9 players on every read was ~1s of each 15s (Phase 10).
  const _mine = new WeakMap();
  const mine = (rows) => {
    if (rows && _mine.has(rows)) return _mine.get(rows);
    const seen = new Map();
    for (const lu of (rows || [])) for (const p of (lu.players || [])) {
      const k = U().pid(p);
      if (k && !seen.has(k)) seen.set(k, p);
    }
    const out = [...seen.values()];
    if (rows) _mine.set(rows, out);
    return out;
  };
  const final = (h) => { const gs = h.allGames || []; return gs.length > 0 && gs.every(g => h.effStatus(g) >= 3); };

  window.LSWidgets.register({
    id: 'kpi_playing_now', slot: 'kpi', title: 'Playing Now', sportScope: '*',
    description: 'How many of your players are in a game right now, of all your players.',
    help: 'Your players whose game is on right now, counted once however many lineups hold them, out of every player you rostered. The foot says how many are still to play and how many are done.',
    factory: () => ({
      get _pn() {
        const ps = mine(this.lineupRows);
        const on = ps.filter(p => p.game_phase === 'playing').length;
        const wait = ps.filter(p => p.game_phase === 'not_started').length;
        // who did not play is not "played" (run 2, SPORT-2)
        return { on, wait, done: ps.length - on - wait, all: ps.length, final: final(this), dnp: ps.filter(p => p.dnp).length };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_live_pace', slot: 'kpi', title: 'Pace', sportScope: '*',
    description: 'Your average lineup against what it should have by now - your projections, else the DraftKings average.',
    help: "What your average lineup has, minus what it was expected to have by now: each player's projection (else his DraftKings average) scaled by how far through his game he is. At the final whistle it is the whole expectation: beat or missed.",
    factory: () => ({
      get _lp() {
        const rows = this.lineupRows || [];
        let d = 0, n = 0, proj = false;
        for (const lu of rows) {
          const k = U().lineupPace(lu.players);
          if (!k) continue;
          d += k.delta; n++;
          if (k.src === 'proj') proj = true;
        }
        if (!n) return null;
        return { delta: d / n, up: d >= 0, src: proj ? 'your projections' : 'DK average', final: final(this) };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_last15', slot: 'kpi', title: 'Last 15 Min', sportScope: '*',
    description: 'What your average lineup scored in the last 15 minutes; at the end, your best 15 minutes of the night.',
    help: 'The live edge of Momentum: your average lineup now, minus your average lineup 15 minutes ago. Once every game is final it shows your best 15-minute spell and when it started.',
    factory: () => ({
      get _l15() {
        const sh = this.lineupHistory || [];
        const { pts, elapsed } = U().avgSeries(this.lineupRows, sh.length >= 2 ? sh : (this._lineupHistory || []));
        if (pts.length < 2) return null;
        const t1 = pts[pts.length - 1][0], span = t1 - pts[0][0];
        // a demo replays a game in under a minute: its "15 minutes" is a sixth of the replay
        const win = elapsed ? Math.max(5e3, span / 6) : 15 * 60e3;
        const at = (t) => { let v = pts[0][1]; for (const q of pts) { if (q[0] > t) break; v = q[1]; } return v; };
        const isFinal = final(this);
        if (!isFinal) return { v: Math.max(0, pts[pts.length - 1][1] - at(t1 - win)), final: false, demo: elapsed };
        let best = 0, when = pts[0][0];
        for (const q of pts) {
          const g = at(q[0] + win) - q[1];
          if (g > best) { best = g; when = q[0]; }
        }
        const label = elapsed
          ? Math.floor(when / 60e3) + ':' + String(Math.round((when % 60e3) / 1000)).padStart(2, '0')
          : new Date(when).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        return { v: best, final: true, when: label, demo: elapsed };
      },
    }),
  });

  window.LSWidgets.register({
    id: 'kpi_next_up', slot: 'kpi', title: 'Next Up', sportScope: '*',
    description: 'The next kick-off and how many of your players it brings.',
    help: 'Counts down to the next game still to start and how many of your players are in it (counted once). When every game has started it says how many are live; at the end, how many are final.',
    factory: () => ({
      get _nu() {
        const gs = this.allGames || [];
        if (!gs.length) return null;
        const st = (g) => this.effStatus(g);
        const up = gs.filter(g => st(g) < 2 && g.game_time_utc)
          .map(g => ({ g, t: new Date(g.game_time_utc).getTime() })).filter(x => !isNaN(x.t)).sort((a, b) => a.t - b.t);
        if (!up.length) {
          const live = gs.filter(g => st(g) === 2).length;
          return live ? { kind: 'live', live, n: gs.length } : { kind: 'final', n: gs.length };
        }
        const first = up[0].t;
        const next = up.filter(x => x.t === first).map(x => String(x.g.game_id));
        const yours = mine(this.lineupRows).filter(p => next.includes(String(p.game_id))).length;
        const ms = first - (this._timerNow || Date.now());
        let value;
        if (ms <= 60e3) value = 'Any moment';
        else if (ms < 24 * 3600e3) { const h = Math.floor(ms / 3600e3), m = Math.floor((ms % 3600e3) / 60e3); value = h ? h + 'h ' + m + 'm' : m + 'm'; }
        else value = new Date(first).toLocaleString([], { weekday: 'short', hour: 'numeric', minute: '2-digit' });
        const g0 = up[0].g;
        const what = next.length > 1 ? next.length + ' games' : String(g0.away_team || '').toUpperCase() + ' @ ' + String(g0.home_team || '').toUpperCase();
        return { kind: 'next', value, what, yours };
      },
    }),
  });
})();

/* ==== static/js/widgets/kpi/dream_gap.js ==== */
;
/* widgets/kpi/dream_gap.js — Gap to Dream Team KPI.
 *
 * Shows the delta between the user's best lineup and the optimal
 * (Dream Team) lineup. Negative = lineup is behind; positive = lineup
 * is ahead of the dream team (rare — means the dream team had a player
 * fail to start, or the user happened to roster a hot bench player the
 * ILP didn't pick).
 *
 * Reads deltaToDream from the parent dashboard() controller (defined in
 * live_v2/index.js). null when no lineups OR no dream team computed
 * yet — the template shows a dash in that state.
 *
 * Wildcard sportScope — every sport supports Dream Team via ILP, so
 * this tile works anywhere.
 */
window.LSWidgets.register({
  id:         'kpi_dream_gap',
  description: 'Points between your best lineup and the Dream Team.',
  slot:       'kpi',
  title:      'Gap to Dream',
  sportScope: '*',
  factory:    () => ({
    get _delta() {
      return (typeof this.deltaToDream === 'number') ? this.deltaToDream : null;
    },
  }),
});

/* ==== static/js/widgets/kpi/mlb_my_ks.js ==== */
;
/* widgets/kpi/mlb_my_ks.js — MLB: sum of strikeouts across my pitchers.
 *
 * Dedupes (a pitcher in 3 lineups counts once). Lives in the KPI strip
 * for MLB slates only — opt in via + KPI picker.
 */
window.LSWidgets.register({
  id:         'kpi_mlb_my_ks',
  description: 'Total strikeouts thrown by every starting pitcher in your lineups.',
  slot:       'kpi',
  title:      'My Ks',
  sportScope: ['mlb'],
  factory:    () => ({
    get _myKs() {
      const seen = new Set();
      let sum = 0;
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const pos = (p.pos || '').toUpperCase();
          if (!['SP', 'RP', 'P'].includes(pos)) continue;
          const key = window.LSModelUtil.pid(p);
          if (!key || seen.has(key)) continue;
          seen.add(key);
          sum += (p.stats?.so || 0);
        }
      }
      return sum;
    },
    get _pitcherCount() {
      const seen = new Set();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const pos = (p.pos || '').toUpperCase();
          if (!['SP', 'RP', 'P'].includes(pos)) continue;
          const key = window.LSModelUtil.pid(p);
          if (key) seen.add(key);
        }
      }
      return seen.size;
    },
  }),
});

/* ==== static/js/widgets/kpi/tier_standings.js ==== */
;
/* widgets/kpi/tier_standings.js — DK Tiers: how many tiers you're winning.
 *
 * The at-a-glance companion to the Tier Breakdown panel. For each tier you own a
 * pick in, you "win" the tier when your pick is its live leader (the optimal /
 * Dream-Team member). Value = tiers won / tiers played; foot = total points off
 * optimal across the tiers you're not leading. Only meaningful on a tiers slate
 * (players carry a `tier`); empty elsewhere. Mirrors tier_breakdown's math.
 */
window.LSWidgets.register({
  id:         'kpi_tier_standings',
  description: 'How many DK tiers you are winning — your pick vs the tier leader, at a glance.',
  slot:       'kpi',
  title:      'Tier Standings',
  sportScope: '*',
  formatScope: ['tiers'],   // tier construct only exists on DK Tiers slates
  factory:    () => ({
    _key(p) { return window.LSModelUtil.pid(p); },
    get _tierStanding() {
      const leaders = {};
      for (const p of (this.allSlatePlayers || [])) {
        if (p.tier == null) continue;
        if (!leaders[p.tier] || (p.live_fpts || 0) > (leaders[p.tier].live_fpts || 0)) leaders[p.tier] = p;
      }
      const mine = {}, seen = new Set();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          if (p.tier == null) continue;
          const k = this._key(p);
          if (seen.has(k)) continue;
          seen.add(k);
          if (!mine[p.tier] || (p.live_fpts || 0) > (mine[p.tier].live_fpts || 0)) mine[p.tier] = p;
        }
      }
      let won = 0, total = 0, gap = 0;
      for (const t of Object.keys(mine)) {
        const leader = leaders[t], pick = mine[t];
        total += 1;
        if (leader && this._key(pick) === this._key(leader)) won += 1;
        else if (leader) gap += Math.max(0, (leader.live_fpts || 0) - (pick.live_fpts || 0));
      }
      return { won, total, gap };
    },
    get _tiersWon()   { return this._tierStanding.won; },
    get _tiersTotal() { return this._tierStanding.total; },
    get _wonOfTotal() {
      const s = this._tierStanding;
      return s.total ? `${s.won}/${s.total}` : '–';
    },
    get _tierGap() { return this._tierStanding.gap; },
  }),
});

/* ==== static/js/widgets/kpi/my_best_player.js ==== */
;
/* widgets/kpi/my_best_player.js — user-scoped MVP KPI.
 *
 * Mirror of kpi_top_scorer (slate-wide leader) but scoped to YOUR
 * rostered players. Solo user sees their lineup's MVP; multi-lineup
 * user sees the highest-scoring player they rostered anywhere. Reads
 * `_myBestPlayer` getter from the parent dashboard() controller.
 */
window.LSWidgets.register({
  id:         'kpi_my_best_player',
  description: 'Your highest-scoring player across all of your lineups.',
  slot:       'kpi',
  title:      'My Top Score',   // the single top score; "carried you" is the share (UX-4)
  sportScope: '*',
  factory:    () => ({}),
  requires:   [],
  bestAt:     'any',
});

/* ==== static/js/widgets/kpi/my_best_lineup.js ==== */
;
/* widgets/kpi/my_best_lineup.js — top lineup by live points.
 *
 * Solo (1 lineup) → redundant with Avg Live, hence bestAt: 'multi'.
 * Multi (5+ lineups) → answers "how is my best entry doing?" at a
 * glance, with rank context in the foot. Reads `_myBestLineup`
 * getter from the parent dashboard() controller.
 */
window.LSWidgets.register({
  id:         'kpi_my_best_lineup',
  description: 'Live total of your top-performing lineup.',
  slot:       'kpi',
  title:      'My Best Lineup',
  sportScope: '*',
  factory:    () => ({}),
  requires:   [],
  bestAt:     'multi',
});

/* ==== static/js/widgets/kpi/mlb_my_bombs.js ==== */
;
/* widgets/kpi/mlb_my_bombs.js — MLB My Bombs KPI tile.
 *
 * Counts HRs across all my lineups, deduplicated by player. Reads
 * `_mlbMyBombs` getter from the parent dashboard() controller (live.js).
 *
 * Scale-friendly: 1 lineup with 1 HR = 1; 100 lineups across a 14-game
 * slate = could climb to 20+. The count is the story at any volume.
 */
window.LSWidgets.register({
  id:         'kpi_mlb_my_bombs',
  description: 'Total home runs hit by any player in your lineups.',
  slot:       'kpi',
  title:      'My Bombs',
  sportScope: ['mlb'],
  factory:    () => ({}),
  requires:   ['lineups'],
  bestAt:     'any',
});

/* ==== static/js/widgets/kpi/mlb_cooking.js ==== */
;
/* widgets/kpi/mlb_cooking.js — MLB Cooking KPI tile.
 *
 * Count of my hitters with 2+ hits (the "going off" threshold) +
 * current FPts leader among them. Reads `_mlbCooking` getter from
 * the parent dashboard() controller (live.js).
 *
 * Positive-side complement to Sweat Meter: when bats are hot, this
 * number celebrates; when cold, both rest at 0.
 */
window.LSWidgets.register({
  id:         'kpi_mlb_cooking',
  description: 'Count of your hitters with 2+ hits in their game - the going-off threshold.',
  slot:       'kpi',
  title:      'Cooking',
  sportScope: ['mlb'],
  factory:    () => ({}),
  requires:   ['lineups', 'hitters'],
  bestAt:     'any',
});

/* ==== static/js/widgets/kpi/mlb_sweat_meter.js ==== */
;
/* widgets/kpi/mlb_sweat_meter.js — MLB Sweat Meter KPI tile.
 *
 * Counts down through the slate: % of my unique players still in
 * unfinished games. ~100% at slate start, 0% when last game finals.
 * Reads `_mlbSweatMeter` getter from the parent dashboard()
 * controller (live.js).
 *
 * Scale: most meaningful at 5+ lineups where the % feels like a real
 * fraction. At 1 lineup it's binary-ish (10 players, all in same
 * game → either 100% or 0%). bestAt='multi'.
 */
window.LSWidgets.register({
  id:         'kpi_mlb_sweat_meter',
  description: 'Percentage of your unique players still in unfinished games. Counts down through the night.',
  slot:       'kpi',
  title:      'Sweat',
  sportScope: ['mlb'],
  factory:    () => ({}),
  requires:   ['lineups'],
  bestAt:     'multi',
});

/* ==== static/js/widgets/kpi/mlb_at_bat_watch.js ==== */
;
/* widgets/kpi/mlb_at_bat_watch.js — MLB At-Bat Watch.
 *
 * Surfaces "any of my hitters at bat right now" as a glanceable KPI tile.
 * Pulls from allGames[].live_state (populated by sports/mlb.py's
 * linescore fan-out) and cross-references batter_id / on_deck_id against
 * the player_id of every hitter in my lineups.
 *
 * Two numbers exposed:
 *   _atBatCount    — my hitters currently the active batter (usually 0–1
 *                    across the slate, but multi-lineup slates can see 2+
 *                    when different games line up).
 *   _onDeckCount   — my hitters currently on deck.
 * Plus a short name strip the template renders under the headline.
 */
window.LSWidgets.register({
  id:         'kpi_mlb_at_bat_watch',
  description: 'How many of your hitters are currently at bat or on deck.',
  slot:       'kpi',
  title:      'At-Bat Watch',
  sportScope: ['mlb'],
  factory:    () => ({
    /** game_id → live_state. Same shape used by batter_pulse — duplicated
     *  here rather than hoisted onto the host because the host shouldn't
     *  grow MLB-specific getters every time a sport ships a new widget. */
    get _liveStateByGame() {
      const m = {};
      for (const g of (this.allGames || [])) {
        if (g && g.game_id && g.live_state) m[g.game_id] = g.live_state;
      }
      return m;
    },

    /** Deduplicated set of my hitters with their game's live_state, so we
     *  iterate once and derive all four downstream getters. Returns
     *  [{p, status}] where status ∈ '' | 'at_bat' | 'on_deck'. */
    get _myHittersWithStatus() {
      const seen   = new Map();
      const lsByGame = this._liveStateByGame;
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const pos = (p.pos || '').toUpperCase();
          if (['SP', 'RP', 'P'].includes(pos)) continue;
          const key = window.LSModelUtil.pid(p);
          if (!key || seen.has(key)) continue;
          const ls = lsByGame[p.game_id] || {};
          const pid = String(p.player_id || '');
          let status = '';
          // Join by the server-resolved LiveSlate UUID only — no name-match
          // fallback (the banned brothers/father-son collision bug class);
          // UUIDs resolve server-side for every batter.
          if (pid && pid === ls.batter_uuid)  status = 'at_bat';
          else if (pid && pid === ls.on_deck_uuid) status = 'on_deck';
          seen.set(key, { p, status });
        }
      }
      return [...seen.values()];
    },

    get _atBatCount() {
      return this._myHittersWithStatus.filter(x => x.status === 'at_bat').length;
    },
    get _onDeckCount() {
      return this._myHittersWithStatus.filter(x => x.status === 'on_deck').length;
    },
    get _atBatNames() {
      return this._myHittersWithStatus.filter(x => x.status === 'at_bat').map(x => x.p.name);
    },
    get _onDeckNames() {
      return this._myHittersWithStatus.filter(x => x.status === 'on_deck').map(x => x.p.name);
    },
  }),
});

/* ==== static/js/widgets/kpi/lineup_spread.js ==== */
;
/* widgets/kpi/lineup_spread.js — gap between best + worst lineup.
 *
 * Multi-lineup KPI extracted from the Graphs panel's top strip (Xav
 * 2026-06-06). Single-lineup users see "—" — the metric is meaningless
 * with one lineup, and the registry's best_at:'multi' surfaces a ⓘ
 * scale-mismatch hint on the picker for solo users.
 *
 * Reads `_kpiLineupSpread` getter from the parent dashboard() controller.
 */
window.LSWidgets.register({
  id:         'kpi_lineup_spread',
  description: 'Live-point gap between your best and worst lineups.',
  slot:       'kpi',
  title:      'Lineup Spread',
  sportScope: '*',
  factory:    () => ({}),
  requires:   [],
  bestAt:     'multi',
});

/* ==== static/js/widgets/kpi/hottest_player.js ==== */
;
/* widgets/kpi/hottest_player.js — slate-wide live/proj ratio leader.
 *
 * Extracted from the Graphs panel's 🔥 Hottest tile (Xav 2026-06-06).
 * Distinct from kpi_top_scorer (raw live FPts leader) — this one is
 * the OUTPERFORMER, the player whose live points have most exceeded
 * their projection.
 *
 * Reads `_kpiHottestPlayer` getter from the parent dashboard()
 * controller. Projection-gated via `requires:['projections']`.
 */
window.LSWidgets.register({
  id:         'kpi_hottest_player',
  description: "The slate-wide player furthest ahead of projection right now.",
  slot:       'kpi',
  title:      'Hottest Player',
  sportScope: '*',
  factory:    () => ({}),
  requires:   ['projections'],
  bestAt:     'any',
});

/* ==== static/js/widgets/kpi/vs_dream_team.js ==== */
;
/* widgets/kpi/vs_dream_team.js — graph-KPI: your top lineup's live total
 * as a percent of the live Dream Team total (the "ceiling"). The number
 * answers "how close am I to optimal right now"; the half-gauge gives the
 * at-a-glance visual.
 *
 * Always available — Dream Team runs every snapshot, so this KPI never
 * needs projections or platform baselines. (Xav 2026-06-20 Lab rebuild.)
 */
window.LSWidgets.register({
  id:          'kpi_vs_dream_team',
  description: 'Your top lineup as a % of the live Dream Team total — how close to optimal you are.',
  help:        'How close your best entry is to the perfect lineup right now. 100% means you nailed the optimal; cracking the high 80s on a live slate is elite. Always on — no projections needed.',
  slot:        'kpi',
  title:       'Vs Dream Team',
  sportScope:  '*',
  factory:     () => ({
    /** Top live lineup total — the numerator. */
    get _topLive() {
      const rows = this.lineupRows || [];
      return rows.reduce((m, lu) => Math.max(m, +(lu.live_total || 0)), 0);
    },
    /** Dream Team's live total — the ceiling, computed by the host. */
    get _dtTotal() { return +(this.dreamTeamScore || 0); },
    /** Percentage of ceiling reached (0–100, clamped). null when no DT yet. */
    get _pct() {
      const dt = this._dtTotal;
      if (dt <= 0) return null;
      return Math.max(0, Math.min(100, (this._topLive / dt) * 100));
    },
  }),
});

/* ==== static/js/widgets/kpi/pace_spark.js ==== */
;
/* widgets/kpi/pace_spark.js — graph-KPI: your top lineup's cumulative
 * live total as a tiny sparkline over the night. Answers "which way am
 * I trending" with one glance — a climbing line is good news, flat means
 * stalled, dropping (rare — mostly happens via late roster scratches) is
 * bad. Pure client-side time series via the host's _lineupHistory.
 *
 * (Xav 2026-06-20 Lab rebuild.)
 */
window.LSWidgets.register({
  id:          'kpi_pace_spark',
  description: 'Sparkline of your top lineup’s live total trajectory — climbing, flat, or fading.',
  help:        'The shape tells the story more than the number. A climbing line means your night is still building; a flat tail means your guys are done scoring. Fills in as the slate runs.',
  slot:        'kpi',
  title:       'Pace',
  sportScope:  '*',
  factory:     () => ({
    /** Pick the lineup with the highest current live_total — its history
     *  is what the sparkline traces. Returns the lineup row (or null). */
    get _topLineup() {
      const rows = this.lineupRows || [];
      if (!rows.length) return null;
      return rows.reduce((b, lu) =>
        (lu.live_total || 0) > (b.live_total || 0) ? lu : b, rows[0]);
    },
    /** Series of live totals for the top lineup across recorded ticks. */
    get _series() {
      const top = this._topLineup;
      if (!top) return [];
      const id = String(top.id);
      // Prefer the server-reconstructed trajectory (real, from slate start);
      // fall back to the session sample.
      const sh = this.lineupHistory || [];
      const h = sh.length >= 2 ? sh : (this._lineupHistory || []);
      const pts = h.map(f => (id in (f.totals || {}) ? f.totals[id] : null))
                   .filter(v => v !== null);
      // Always render at least a 0→now line. On a fresh load the host's
      // _lineupHistory hasn't accumulated yet (or this widget's nested
      // scope sees it empty) — without a fallback the sparkline is blank
      // even though we have a live total. Mirror Trajectory's synthesis.
      const tail = pts.length ? pts : [+(top.live_total || 0)];
      return [0, ...tail];
    },
    /** Polyline points string for a 100×24 SVG canvas. */
    get _pathPts() {
      const s = this._series;
      if (s.length < 2) return '';
      const min = 0, max = Math.max(...s) || 1;
      const stepX = 100 / (s.length - 1);
      return s.map((v, i) => {
        const x = (i * stepX).toFixed(1);
        const y = (24 - ((v - min) / (max - min || 1)) * 22 - 1).toFixed(1);
        return `${x},${y}`;
      }).join(' ');
    },
    /** Current cumulative live (top lineup). Big number in the value slot. */
    get _live() { return +((this._topLineup || {}).live_total || 0); },
  }),
});

/* ==== static/js/widgets/kpi/carrying.js ==== */
;
/* widgets/kpi/carrying.js — graph-KPI: the single player carrying you
 * across all your lineups. Name + live FPts contribution + an inline
 * share bar (this player's points as a % of your grand roster total).
 *
 * Different from kpi_my_best_player (which is just "top scorer in any
 * one of your lineups"): CARRYING aggregates across the WHOLE entry
 * pool. In an MME setup it answers "if I subbed out one player, who's
 * the one I really, really can't lose right now?" — the player with the
 * biggest live contribution to your overall pool.
 *
 * (Xav 2026-06-20 Lab rebuild.)
 */
window.LSWidgets.register({
  id:          'kpi_carrying',
  description: 'The player carrying your pool — top contributor by live FPts across all your lineups, with their share of your roster total.',
  help:        'The one player your night rides on. Top scorer pooled across every entry; the bar is their share of your whole roster’s points. If they’re in most of your lineups, you’re heavily exposed — for better or worse.',
  bestAt:      'multi',
  slot:        'kpi',
  title:       'Carrying',
  sportScope:  '*',
  factory:     () => ({
    /** Top contributor row from graphPlayerContributions (or null). */
    get _top() {
      // One definition of "carrying" on every panel (Xav P2, audit run 1
      // NUM-4): the most points across your entries - own points weighted
      // by how many lineups hold the player. The tile still SHOWS own points
      // and "in N/M", never the product. Same pick as Your Players' headline
      // (squad_model) and Top Contributors' takeaway (lab_takeaways).
      const players = ((this.graphPlayerContributions || {}).players) || [];
      let best = null, bw = -Infinity;
      for (const p of players) {
        const w = (+p.total || 0) * Math.max(1, +p.lineupCount || 1);
        if (w > bw || (w === bw && (+p.total || 0) > (+best.total || 0))) { best = p; bw = w; }
      }
      return best && (+best.total || 0) > 0 ? best : null;
    },
    /** Their live FPts contribution (raw). */
    get _pts() { return +((this._top || {}).total || 0); },
    /** Their share of your grand roster total (0–100). 0 if no roster. */
    get _share() { return +((this._top || {}).share || 0); },
    /** How many of your lineups they appear in. */
    get _lineupCount() { return +((this._top || {}).lineupCount || 0); },
    /** Total of your lineups (denominator for the "in X of Y" phrasing). */
    get _totalLineups() { return (this.lineupRows || []).length; },
  }),
});

/* ==== static/js/widgets/kpi/hottest_mine.js ==== */
;
/* widgets/kpi/hottest_mine.js - HOTTEST: your player furthest above his
 * expected score so far.
 *
 * Expected = your projection, else his DraftKings average (the server's
 * `baseline`), times how far through his game he is (`elapsed_frac`). Live
 * that reads "running hot"; at the final whistle elapsed is 1, so the same
 * number reads "beat his expectation the most" - one meaning all night, no
 * switch (Xav 2026-10-07). A player under a quarter of the way through is not
 * rated: two plays are not a trend. Each player counted once, joined by id.
 * (It used to be your top scorer - the My Best Player tile's job.)
 */
window.LSWidgets.register({
  id:          'kpi_hottest_mine',
  description: 'Your player furthest above his expected score so far - your projection, else his DraftKings average.',
  help:        'Live points against what he was expected to have by now (your projection, else his DraftKings average, scaled to how far through his game he is). At the end of the night it is simply who beat his expectation the most.',
  slot:        'kpi',
  title:       'Hottest',
  sportScope:  '*',
  factory:     () => ({
    get _hot() {
      const seen = new Set();
      let best = null;
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const id = String(p.player_id || p.external_player_id || '');
          if (!id || seen.has(id) || p.dnp) continue;   // did not play: not cold, absent (NUMBERS-20)
          seen.add(id);
          const frac = +(p.elapsed_frac || 0);
          const base = (+(p.proj || 0) > 0) ? +p.proj : +(p.baseline || 0);
          if (base <= 0 || frac < 0.25) continue;
          const exp = base * Math.min(1, frac);
          // a floor under 'expected': 1.50 against 0.29 read 511% (v2 run 1, NUMBERS-2)
          if (exp < 2) continue;   // at least 2.00 expected by now
          const live = +(p.live_fpts || 0);
          const pct = live / exp * 100;
          if (!best || pct > best.pct) best = { p, pct, src: (+(p.proj || 0) > 0) ? 'proj' : 'avg', full: frac >= 1 };
        }
      }
      return best;
    },
    /** Any of your players with an expectation at all: without one there is nobody to be hot against. */
    get _hotBase() {
      return (this.lineupRows || []).some(lu => (lu.players || []).some(p => +(p.proj || 0) > 0 || +(p.baseline || 0) > 0));
    },
  }),
});

/* ==== static/js/widgets/kpi/coldest_mine.js ==== */
;
/* widgets/kpi/coldest_mine.js - COLDEST: your player furthest below his
 * expected score so far - Hottest's other end (Xav 2026-10-07, replacing the
 * Bonuses tile, which repeated Bonus Watch beside it).
 *
 * Same expectation as Hottest: your projection, else his DraftKings average,
 * times how far through his game he is. Live it reads "running cold"; at the
 * final whistle, "missed his expectation the most". Under a quarter of the
 * way through is not rated. Each player once, joined by id.
 */
window.LSWidgets.register({
  id:          'kpi_coldest_mine',
  description: 'Your player furthest below his expected score so far - your projection, else his DraftKings average.',
  help:        'Live points against what he was expected to have by now (your projection, else his DraftKings average, scaled to how far through his game he is). At the end of the night it is who fell shortest of his expectation.',
  slot:        'kpi',
  title:       'Coldest',
  sportScope:  '*',
  factory:     () => ({
    get _cold() {
      const seen = new Set();
      let worst = null;
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const id = String(p.player_id || p.external_player_id || '');
          if (!id || seen.has(id) || p.dnp) continue;   // did not play: not cold, absent (NUMBERS-20)
          seen.add(id);
          const frac = +(p.elapsed_frac || 0);
          const base = (+(p.proj || 0) > 0) ? +p.proj : +(p.baseline || 0);
          if (base <= 0 || frac < 0.25) continue;
          const exp = base * Math.min(1, frac);
          // a floor under 'expected': 1.50 against 0.29 read 511% (v2 run 1, NUMBERS-2)
          if (exp < 2) continue;   // at least 2.00 expected by now
          const pct = (+(p.live_fpts || 0)) / exp * 100;
          if (!worst || pct < worst.pct) worst = { p, pct, src: (+(p.proj || 0) > 0) ? 'proj' : 'avg', full: frac >= 1 };
        }
      }
      return worst;
    },
    get _coldBase() {
      return (this.lineupRows || []).some(lu => (lu.players || []).some(p => +(p.proj || 0) > 0 || +(p.baseline || 0) > 0));
    },
  }),
});

/* ==== static/js/widgets/kpi/best_play.js ==== */
;
/* widgets/kpi/best_play.js - YOUR BEST PLAY: the single biggest play of the
 * night by one of your players, from the Wire (Xav 2026-10-10, option 4 for
 * The Action's final strip: it replaces "Games 12/12", one of two tiles that
 * only said the night was over - Broadcast audit v2 run 3, PREM-5).
 *
 * A play, not a total: rows the Wire could only rebuild as a sum ("Total",
 * "Points update", "Several plays") and corrections are skipped. His own
 * points for that play, never multiplied by lineups; "in N of M" says how
 * many of your lineups had him. Joined by player id.
 */
window.LSWidgets.register({
  id:          'kpi_best_play',
  description: 'The biggest single play of the night by one of your players, from the Wire.',
  help:        'Your players’ plays on the Wire tonight, the one worth the most fantasy points. A row the Wire could only rebuild as a sum of several plays does not count.',
  slot:        'kpi',
  title:       'Your Best Play',
  sportScope:  '*',
  factory:     () => ({
    get _bestPlay() {
      const own = this._inCountMap || {};
      const n = (this.activeLineupRows || this.lineupRows || []).length;
      const notAPlay = /^(total|points update|several plays|correction)$/i;
      const seen = new Set();
      let best = null;
      for (const e of [...(this.feed || []), ...(this._wireSeed || [])]) {
        if (!e || seen.has(e.id) || e.is_correction || e.event_type === 'score') continue;
        seen.add(e.id);
        const id = String(e._pid || e.player_id || '');
        const f = Number(e.fpts) || 0;
        if (!id || !own[id] || f <= 0 || notAPlay.test(String(e.label || ''))) continue;
        if (!best || f > best.f) best = { f, e, k: own[id] };
      }
      if (!best) return null;
      return { pts: best.f, name: best.e.name || '', what: String(best.e.label || ''),
               own: n > 1 ? 'in ' + best.k + ' of ' + n : '' };
    },
  }),
});

/* ==== static/js/widgets/kpi/hit_rate.js ==== */
;
/* widgets/kpi/hit_rate.js - HIT RATE: how many of your players beat what they
 * were expected to score (Xav 2026-10-10, option 4 for The Action's final
 * strip: it replaces "Your Players: Done", the other tile that only said the
 * night was over - Broadcast audit v2 run 3, PREM-5).
 *
 * Expected = your projection, else his DraftKings average, the same basis as
 * Hottest / Coldest. Each player once, joined by id; a player who did not play
 * is not a miss, he is left out. Live it counts the players whose games are
 * over; at the final whistle that is everyone.
 */
window.LSWidgets.register({
  id:          'kpi_hit_rate',
  description: 'How many of your players beat their projection, else their DraftKings average.',
  help:        'Each of your players once: did he score more than he was expected to (your projection, else his DraftKings average)? Players who did not play are left out. Counts players whose games are over.',
  slot:        'kpi',
  title:       'Hit Rate',
  sportScope:  '*',
  factory:     () => ({
    get _hitRate() {
      const seen = new Set();
      let hit = 0, all = 0, proj = 0;
      for (const lu of (this.activeLineupRows || this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const id = String(p.player_id || p.external_player_id || '');
          if (!id || seen.has(id) || p.dnp || p.game_phase !== 'finished') continue;
          seen.add(id);
          const hasProj = +(p.proj || 0) > 0;
          const base = hasProj ? +p.proj : +(p.baseline || 0);
          if (base <= 0) continue;
          all += 1; if (hasProj) proj += 1;
          if (+(p.live_fpts || 0) >= base) hit += 1;
        }
      }
      if (!all) return null;
      return { hit, all, basis: proj === all ? 'projection' : (proj ? 'expectation' : 'DK average') };
    },
  }),
});

/* ==== static/js/widgets/pitcher_pulse.js ==== */
;
/* widgets/pitcher_pulse.js — Pitcher Pulse panel (MLB only).
 *
 * Shows one card per pitcher owned across all my lineups. Dedupes (a
 * pitcher in 3 lineups appears once) and sorts by K count desc so the
 * hottest SP is at the top. Reads parent dashboard()'s lineupRows.
 *
 * Per-player fields used:
 *   pos                — 'SP' / 'RP' / 'P'
 *   stats.so           — strikeouts (the headline number)
 *   stats.ip / er / h / bb
 *   stats.quality_start — 1 when ip ≥ 6 AND er ≤ 3 (computed server-side)
 *   oncourt            — true if isCurrentPitcher per the boxscore
 */
window.LSWidgets.register({
  id:           'pitcher_pulse',
  description: 'Live status card for every starting pitcher in your lineups - IP, ER, count, and pitch counts.',
  slot:         'panel',
  title:        'Pitcher Pulse',
  sportScope:   ['mlb'],
  factory:      () => ({
    get _pitchers() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const pos = (p.pos || '').toUpperCase();
          if (!['SP', 'RP', 'P'].includes(pos)) continue;
          const key = window.LSModelUtil.pid(p);   // by id, never by name (audit v2 W1, CODE-14)
          if (!key || seen.has(key)) continue;
          seen.set(key, p);
        }
      }
      // Sort by K desc, then by IP desc as tiebreaker.
      return [...seen.values()].sort((a, b) => {
        const sa = (a.stats?.so || 0), sb = (b.stats?.so || 0);
        if (sa !== sb) return sb - sa;
        return (b.stats?.ip || 0) - (a.stats?.ip || 0);
      });
    },
    // ── Pre-game exposure: show the matchup instead of dead 0.0 stats ──
    get _gameById() {
      const m = {};
      for (const g of (this.allGames || [])) if (g && g.game_id) m[g.game_id] = g;
      return m;
    },
    _isPre(p) { return (p.game_phase || '') === 'not_started'; },
    /** The opposing team abbrev the pitcher faces. */
    _opp(p) {
      const g = this._gameById[p.game_id];
      if (!g) return '';
      // Decided by team_id where both carry one; the LABEL returned is still
      // the game's own text. Compared by abbrev, a pitcher whose spelling
      // differed from the feed's was read as "away" and handed his OWN team as
      // his opponent. Labels remain the fallback for teams with no id yet.
      const isHome = (p.team_id != null && g.home_team_id != null)
        ? p.team_id === g.home_team_id
        : (p.team || '').toUpperCase() === (g.home_team || '').toUpperCase();
      return (isHome ? g.away_team : g.home_team) || '';
    },
    /** First-pitch / pre-game status text from the game (e.g. '7:05 PM ET'). */
    _startText(p) {
      const g = this._gameById[p.game_id];
      return (g && g.status_text) || 'Pre-game';
    },
  }),
  minCells:     { w: 3, h: 2 },
  defaultCells: { w: 4, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/batter_pulse.js ==== */
;
/* widgets/batter_pulse.js — Batter Pulse panel (MLB only).
 *
 * Mirror of pitcher_pulse for the hitting half of my lineup. One card
 * per non-pitcher owned across all my lineups (deduped across lineups).
 * Sort order: HR desc → TB desc → batting order asc. So the biggest
 * fantasy moment of the night surfaces at the top; ties break by total
 * bases then by leadoff-first.
 *
 * Live status is driven by the MLB linescore fan-out — each game on
 * allGames carries live_state.batter_id / live_state.on_deck_id. We
 * cross-reference against p.player_id to flag AT BAT / ON DECK without
 * any name-string matching (brothers / father-son name collisions are
 * a real bug class in MLB).
 *
 * Per-player fields used:
 *   pos              — anything other than 'SP'/'RP'/'P' is a hitter
 *   stats.{single,double,triple,hr,rbi,r,sb,bb,so,ab,bat_order}
 *   game_id          — joined to allGames[].live_state for current AB
 *   player_id        — joined to live_state.batter_id / on_deck_id
 */
window.LSWidgets.register({
  id:           'batter_pulse',
  description: 'Live status card for every hitter in your lineups, including AT BAT / ON DECK alerts.',
  slot:         'panel',
  title:        'Batter Pulse',
  sportScope:   ['mlb'],
  factory:      () => ({
    /** game_id → live_state map, recomputed on every render. Cheap (≤15
     *  MLB games per slate) and avoids stale lookups when allGames
     *  refreshes from the SSE bus mid-render. */
    get _liveStateByGame() {
      const m = {};
      for (const g of (this.allGames || [])) {
        if (g && g.game_id && g.live_state) m[g.game_id] = g.live_state;
      }
      return m;
    },

    get _hitters() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const pos = (p.pos || '').toUpperCase();
          // Skip pitchers — they live on the Pitcher Pulse panel. UTIL
          // and the various position abbreviations all flow through.
          if (['SP', 'RP', 'P'].includes(pos)) continue;
          const key = window.LSModelUtil.pid(p);
          if (!key || seen.has(key)) continue;
          seen.set(key, p);
        }
      }
      return [...seen.values()].sort((a, b) => {
        const ha = (a.stats?.hr || 0), hb = (b.stats?.hr || 0);
        if (ha !== hb) return hb - ha;
        const ta = (a.stats?.tb || 0), tb = (b.stats?.tb || 0);
        if (ta !== tb) return tb - ta;
        // Within ties: leadoff-first feels right (most ABs left in the
        // game). 0 = pinch-hit / no batting order yet → sort last.
        const oa = (a.stats?.bat_order || 99);
        const ob = (b.stats?.bat_order || 99);
        return oa - ob;
      });
    },

    /** Status badge for a card. Returns 'at_bat' | 'on_deck' | '' so the
     *  template can flip styles + show a single pill. Pulled into a
     *  helper because both the card-class binding AND the badge use it. */
    statusFor(p) {
      const ls = this._liveStateByGame[p.game_id];
      if (!ls) return '';
      const pid = String(p.player_id || '');
      // Join by the server-resolved LiveSlate UUID — lineup rows are keyed by
      // player_id (UUID), which the raw statsapi batter_id never equals.
      if (pid && pid === ls.batter_uuid)  return 'at_bat';
      if (pid && pid === ls.on_deck_uuid) return 'on_deck';
      return '';
    },

    /** "1-for-3" style line — H over AB. Hits derived from single + double
     *  + triple + HR (boxscore doesn't ship a precomputed `h` for
     *  batters in our pipeline). 0 when the batter hasn't come up yet. */
    battingLine(p) {
      const s = p.stats || {};
      const h = (s.single || 0) + (s.double || 0) + (s.triple || 0) + (s.hr || 0);
      const ab = s.ab || 0;
      return `${h}-for-${ab}`;
    },
  }),
  minCells:     { w: 3, h: 2 },
  defaultCells: { w: 4, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/confirmed_lineups.js ==== */
;
/* widgets/confirmed_lineups.js — Lineup Check panel (MLB only).
 *
 * The pre-game edge: MLB posts confirmed batting orders ~35 min before first
 * pitch. This surfaces, across ALL your lineups, which of your hitters are:
 *   - confirmed  — a batting slot (1-9) is posted
 *   - pending    — their team's lineup hasn't dropped yet
 *   - out        — their team's lineup IS posted but they're not in it (a late
 *                  scratch), or their game is already underway ← the alert
 *
 * "Team lineup posted" is derived from the full slate pool (this.allSlatePlayers):
 * a team's lineup is live once ANY of its players carries bat_order > 0. Keyed by
 * team_id (never a name/abbrev string — the identity rule). Data source today is
 * statsapi's bat_order; when BDL goes primary, /mlb/v1/lineups emits the same
 * bat_order, so this stays feed-agnostic.
 *
 * Per-player fields used: stats.bat_order, team_id (fallback team), game_id, pos.
 */
window.LSWidgets.register({
  id:          'confirmed_lineups',
  description: 'Pre-game lineup check — which of your hitters are confirmed, not posted yet, or a late scratch.',
  slot:        'panel',
  title:       'Lineup Check',
  sportScope:  ['mlb'],
  factory:     () => ({
    _teamKey(p) { return String((p && (p.team_id ?? p.team)) ?? ''); },

    /** Team keys whose lineup is posted — any pool player has a batting slot. */
    get _postedTeams() {
      const posted = new Set();
      for (const p of (this.allSlatePlayers || [])) {
        if ((p.stats?.bat_order || 0) > 0) posted.add(this._teamKey(p));
      }
      return posted;
    },

    /** Is this player's game already underway / final? Then a missing slot means
     *  out-of-lineup regardless of the posted-set. */
    _gameStarted(p) {
      for (const g of (this.allGames || [])) {
        if (g && g.game_id === p.game_id) return (g.status || 1) >= 2;
      }
      return false;
    },

    /** 'confirmed' | 'pending' | 'out' for one hitter. */
    lineupState(p) {
      if ((p.stats?.bat_order || 0) > 0) return 'confirmed';
      if (this._postedTeams.has(this._teamKey(p)) || this._gameStarted(p)) return 'out';
      return 'pending';
    },
    orderOf(p) { return p.stats?.bat_order || 0; },

    /** Deduped hitters across every lineup, sorted problem-first:
     *  out (scratch) → pending → confirmed by batting order. */
    get _hitters() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const pos = (p.pos || '').toUpperCase();
          if (['SP', 'RP', 'P'].includes(pos)) continue;   // hitters only
          const key = window.LSModelUtil.pid(p);
          if (!key || seen.has(key)) continue;
          seen.set(key, p);
        }
      }
      const rank = { out: 0, pending: 1, confirmed: 2 };
      return [...seen.values()].sort((a, b) => {
        const sa = this.lineupState(a), sb = this.lineupState(b);
        if (rank[sa] !== rank[sb]) return rank[sa] - rank[sb];
        return (this.orderOf(a) || 99) - (this.orderOf(b) || 99);
      });
    },

    /** Header counts across the hitters shown. */
    get _summary() {
      const c = { confirmed: 0, pending: 0, out: 0 };
      for (const p of this._hitters) c[this.lineupState(p)] += 1;
      return c;
    },
  }),
  minCells:     { w: 3, h: 2 },
  defaultCells: { w: 3, h: 4 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/coming_to_bat.js ==== */
;
/* widgets/coming_to_bat.js — Coming to Bat queue (MLB only).
 *
 * The couch-mode "lean forward" panel: a live queue of ONLY your hitters who are
 * AT BAT or ON DECK right now, across every lineup, ordered by urgency (at bat
 * first) then by leverage (bases loaded / RISP first). Each row carries the
 * situation you actually care about — inning, outs, count, runners on — so you
 * see "your guy is up with the bases loaded" the second it happens.
 *
 * Joins to the live game state by the server-resolved LiveSlate UUID
 * (live_state.batter_uuid / on_deck_uuid), never a name string (brothers /
 * father-son collisions are a real MLB bug class).
 *
 * Fields: allGames[].live_state {batter_uuid, on_deck_uuid, balls, strikes,
 * outs, is_top, bases{first,second,third}, pitcher}; game.status_text (inning).
 */
window.LSWidgets.register({
  id:          'coming_to_bat',
  description: 'Live queue of your hitters who are at bat or on deck, ordered by leverage (outs, runners on).',
  slot:        'panel',
  title:       'Coming to Bat',
  sportScope:  ['mlb'],
  factory:     () => ({
    get _gamesByGid() {
      const m = {};
      for (const g of (this.allGames || [])) if (g && g.game_id) m[g.game_id] = g;
      return m;
    },

    _onBase(ls) {
      const b = (ls && ls.bases) || {};
      return (b.first ? 1 : 0) + (b.second ? 1 : 0) + (b.third ? 1 : 0);
    },

    /** Leverage label from the base state. '' when bases are empty. */
    leverage(ls) {
      const b = (ls && ls.bases) || {};
      if (this._onBase(ls) === 3) return 'LOADED';
      if (b.second || b.third)    return 'RISP';
      if (b.first)                return '1 ON';
      return '';
    },
    /** Is this a high-leverage spot (drives the hot styling)? */
    isHot(ls) { const l = this.leverage(ls); return l === 'LOADED' || l === 'RISP'; },

    /** "T7 · 2 out" situation line from the game + live state. */
    situation(g, ls) {
      const inn  = (g && g.status_text) || '';
      const outs = (ls && ls.outs) || 0;
      return `${inn}${inn ? ' · ' : ''}${outs} out`;
    },
    countStr(ls) { return `${(ls && ls.balls) || 0}-${(ls && ls.strikes) || 0}`; },

    /** My hitters currently at bat or on deck — at-bat first, then by leverage. */
    get _queue() {
      const out = [], seen = new Set();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const pos = (p.pos || '').toUpperCase();
          if (['SP', 'RP', 'P'].includes(pos)) continue;      // hitters only
          const key = window.LSModelUtil.pid(p);
          if (!key || seen.has(key)) continue;
          const g  = this._gamesByGid[p.game_id];
          const ls = g && g.live_state;
          if (!ls) continue;
          const pid = String(p.player_id || '');
          let state = '';
          if (pid && pid === ls.batter_uuid)       state = 'at_bat';
          else if (pid && pid === ls.on_deck_uuid)  state = 'on_deck';
          if (!state) continue;
          seen.add(key);
          out.push({ p, g, ls, state });
        }
      }
      const rank = { at_bat: 0, on_deck: 1 };
      return out.sort((a, b) => {
        if (rank[a.state] !== rank[b.state]) return rank[a.state] - rank[b.state];
        return this._onBase(b.ls) - this._onBase(a.ls);   // hotter spot first
      });
    },
  }),
  minCells:     { w: 3, h: 2 },
  defaultCells: { w: 3, h: 3 },
  densityTiers: ['full', 'compact'],
});

/* ==== static/js/widgets/mlb_matchups.js ==== */
;
/* widgets/mlb_matchups.js — "The Matchup" (MLB only).
 *
 * The single biggest missing MLB DFS live surface (MLB audit): your HITTERS
 * grouped by the STARTING PITCHER they face tonight. For each opposing SP:
 * their live line (IP/K/ER), the game state, and your hitters under them —
 * batting-order spot, at-bat/on-deck status, exposure, and live line.
 *
 * Identity joins: opposing SP from live_state's probable
 * pitcher (stable all game), at-bat/on-deck by server-resolved UUID (never name
 * matching). The SP's own stat line is looked up by name WITHIN its game — a
 * display-only convenience, not an identity/scoring join.
 */
window.LSWidgets.register({
  id:           'mlb_matchups',
  description: 'Your hitters grouped by the starting pitcher they face tonight, with live status + the SP’s line.',
  help:         'The DFS matchup view: which SP each of your hitters is up against, their batting-order spot, at-bat/on-deck status, and how that pitcher is doing.',
  slot:         'panel',
  title:        'The Matchup',
  sportScope:   ['mlb'],
  factory:      () => ({
    get _gameById() {
      const m = {};
      for (const g of (this.allGames || [])) if (g && g.game_id) m[g.game_id] = g;
      return m;
    },
    _isPitcher(p) { return ['SP', 'RP', 'P'].includes((p.pos || '').toUpperCase()); },
    /** Deduped HITTERS across my (stake-filtered) lineups. */
    get _myHitters() {
      const seen = new Map();
      for (const lu of (this.lineupRows || [])) {
        for (const p of (lu.players || [])) {
          const k = window.LSModelUtil.pid(p);
          if (!k || seen.has(k) || this._isPitcher(p)) continue;
          seen.set(k, p);
        }
      }
      return [...seen.values()];
    },
    /** The opposing STARTING pitcher for a hitter — the probable SP (stable all
     *  game), from the opposing side of the hitter's game. */
    _oppSP(p) {
      const g = this._gameById[p.game_id];
      if (!g) return '';
      const ls = g.live_state || {};
      // team_id when both sides have one: the hitter's abbrev is the DFS
      // platform's and the game's is the live feed's, and where they disagree
      // this read "away" for a home hitter and showed him the WRONG probable
      // pitcher - a plausible name, which is worse than none. Falls back to the
      // labels when the team has no id yet, which is the behaviour it had.
      const isHome = this._isHome(p, g);
      return (isHome ? ls.away_probable_pitcher : ls.home_probable_pitcher) || this._starterRow(p, g, isHome)?.name || '';
    },
    _isHome(p, g) {
      return (p.team_id != null && g.home_team_id != null)
        ? p.team_id === g.home_team_id
        : (p.team || '').toUpperCase() === (g.home_team || '').toUpperCase();
    },
    /** Once the game is under way or over the feed's probable pitcher can be
     *  gone (it read "TBD" on every finished game - plan Phase 3): the other
     *  side's pitcher with the most innings that day is the starter. By team
     *  id / label, never by name. */
    _starterRow(p, g, isHome) {
      if (this.effStatus(g) < 2) return null;
      const oppId = isHome ? g.away_team_id : g.home_team_id;
      const oppLbl = String((isHome ? g.away_team : g.home_team) || '').toUpperCase();
      const arms = (this.allSlatePlayers || []).filter(x => x.game_id === g.game_id && this._isPitcher(x)
        && (oppId != null && x.team_id != null ? x.team_id === oppId : String(x.team || '').toUpperCase() === oppLbl)
        && +((x.stats || {}).ip || 0) > 0);
      return arms.sort((a, b) => (+b.stats.ip || 0) - (+a.stats.ip || 0))[0] || null;
    },
    /** The SP's own pool row (for their live line) — matched by name within the
     *  game only. Display convenience; null if not in the pool. */
    _spRow(spName, gameId) {
      if (!spName) return null;
      const n = spName.toLowerCase();
      return (this.allSlatePlayers || []).find(p =>
        p.game_id === gameId && this._isPitcher(p) && (p.name || '').toLowerCase() === n) || null;
    },
    _batStatus(p) {
      const g = this._gameById[p.game_id];
      const ls = g && g.live_state;
      if (!ls || this.effStatus(g) !== 2) return '';      // a finished game has no one at bat
      const pid = String(p.player_id || '');
      if (pid && pid === ls.batter_uuid)  return 'at_bat';
      if (pid && pid === ls.on_deck_uuid) return 'on_deck';
      return '';
    },
    _own(p) { return (this._inCountMap || {})[String(p.player_id || p.external_player_id || '')] || 0; },
    _hitLine(p) {
      const s = p.stats || {};
      const h = (s.single || 0) + (s.double || 0) + (s.triple || 0) + (s.hr || 0);
      return h + '-for-' + (s.ab || 0);
    },
    _spLine(row) {
      if (!row) return '';
      const s = row.stats || {};
      return (s.ip ?? 0).toFixed(1) + ' IP · ' + (s.so || 0) + ' K · ' + (s.er || 0) + ' ER';
    },
    /** Game state chip for a group: 'Top 5 · 2 out' live, else pre/final. */
    _gameChip(g) {
      if (!g) return '';
      const st = this.effStatus(g);
      if (st === 3) return 'Final';
      if (st !== 2) return g.status_text || 'Pre-game';
      const ls = g.live_state || {};
      const half = ls.is_top ? 'Top' : 'Bot';
      let s = `${half} ${ls.inning || ''}`.trim();
      if (ls.outs != null) s += ` · ${ls.outs} out`;
      return s;
    },
    /** My hitters grouped by the opposing SP (one group per SP per game),
     *  hitters ordered by batting slot. */
    get _matchups() {
      const groups = new Map();
      for (const p of this._myHitters) {
        const sp  = this._oppSP(p) || 'TBD';      // only before the game: after it the starter is known
        const key = sp + '|' + p.game_id;
        if (!groups.has(key)) {
          const g = this._gameById[p.game_id];
          groups.set(key, { sp, game: g, spRow: this._spRow(sp, p.game_id), hitters: [] });
        }
        groups.get(key).hitters.push(p);
      }
      const out = [...groups.values()];
      for (const grp of out) grp.hitters.sort((a, b) => (a.bat_order || 99) - (b.bat_order || 99));
      // Live games first, then most hitters.
      return out.sort((a, b) =>
        (this.effStatus(b.game || {}) === 2) - (this.effStatus(a.game || {}) === 2)
        || b.hitters.length - a.hitters.length);
    },
  }),
  minCells:     { w: 3, h: 2 },
  defaultCells: { w: 4, h: 5 },
  densityTiers: ['full', 'compact'],
});
